!(function (t) {
  const e = {};
  function r(i) {
    if (e[i]) return e[i].exports;
    const n = (e[i] = { i: i, l: !1, exports: {} });
    return t[i].call(n.exports, n, n.exports, r), (n.l = !0), n.exports;
  }
  (r.m = t),
    (r.c = e),
    (r.d = function (t, e, i) {
      r.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: i });
    }),
    (r.r = function (t) {
      'undefined' != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
        Object.defineProperty(t, '__esModule', { value: !0 });
    }),
    (r.t = function (t, e) {
      if ((1 & e && (t = r(t)), 8 & e)) return t;
      if (4 & e && 'object' == typeof t && t && t.__esModule) return t;
      const i = Object.create(null);
      if ((r.r(i), Object.defineProperty(i, 'default', { enumerable: !0, value: t }), 2 & e && 'string' != typeof t))
        for (const n in t)
          r.d(
            i,
            n,
            function (e) {
              return t[e];
            }.bind(null, n)
          );
      return i;
    }),
    (r.n = function (t) {
      const e =
        t && t.__esModule
          ? function () {
              return t.default;
            }
          : function () {
              return t;
            };
      return r.d(e, 'a', e), e;
    }),
    (r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (r.p = ''),
    r((r.s = 0));
})([
  function (t, e, r) {
    let i,
      n = r(1),
      s = r(2),
      a = r(3),
      o = 50;
    var I = {};
    console.log('version', '2.0.0 - Limited Seek');
    /**
     const l = '//localhost:8000/movies/api/save_viewing_time',
      u = '//localhost:8000/movies/api/read_viewing_time',
      c = '//localhost:8000/movies/api/save_movie_complete.json',
      d = '//localhost:8000/movies/api/read_complete_status.json';
     */
    
    const l = '/api/movie_content/save_viewing_time',
      u = '/api/movie_content/read_viewing_time',
      c = '/api/movie_content/save_movie_complete',
      d = '/api/movie_content/read_complete_status';
    function f(t) {
      (this.lastTimeupdate = 0), (this.threshold = t);
    }
    function h(t) {
      let e = Math.floor(t / 3600),
        r = Math.floor((t % 3600) / 60),
        i = Math.floor(t % 60);
      return e + ':' + (r = r >= 10 ? r : '0' + r) + ':' + (i = i >= 10 ? i : '0' + i);
    }
    function p() {
      return document.fullscreenElement
        ? document.fullscreenElement
        : document.webkitFullscreenElement
          ? document.webkitFullscreenElement
          : document.mozFullScreenElement
            ? document.mozFullScreenElement
            : document.msFullscreenElement
              ? document.msFullscreenElement
              : void 0;
    }
    function v(t) {
      if (t.requestFullscreen) t.requestFullscreen();
      else if (t.webkitRequestFullscreen) t.webkitRequestFullscreen();
      else if (t.webkitEnterFullscreen) t.webkitEnterFullscreen();
      else if (t.mozRequestFullScreen) t.mozRequestFullScreen();
      else {
        if (!t.msRequestFullscreen) return;
        t.msRequestFullscreen();
      }
    }
    function g() {
      document.exitFullscreen
        ? document.exitFullscreen()
        : document.webkitExitFullscreen
          ? document.webkitExitFullscreen()
          : document.mozCancelFullScreen
            ? document.mozCancelFullScreen()
            : document.msExitFullscreen
              ? document.msExitFullscreen()
              : document.cancelFullScreen && document.cancelFullScreen();
    }
    function m(t, e) {
      if (t) {
        let r,
          i = a.get('rsm');
        for (e = Math.floor(e / 60), i = void 0 === i ? [] : i.split(','), r = 0; r < i.length; ) {
          if (i[r].split('=')[0] == t) {
            i.splice(r, 1);
            break;
          }
          r++;
        }
        i.unshift(t + '=' + e + '|' + Math.floor(new Date().getTime() / 1e3)),
          i.splice(o),
          a.set('rsm', i.join(','), { expires: 365, path: '/' });
      }
    }
    function y(t, e) {
      t &&
        n
          .ajax({
            type: 'GET',
            dataType: 'json',
            url: l,
            headers: { 'access-token': a.get('access_token'), client: a.get('client'), uid: a.get('uid') },
            data: { movieid: t, resume_time: e },
          })
          .done(function (t) {})
          .fail(function () {});
    }
    function E(t, e) {
      let r = 0,
        i = 0,
        s = (function (t) {
          let e,
            r,
            i,
            n = null,
            s = a.get('rsm');
          if (!t || void 0 === s) return n;
          for (s = s.split(','), e = 0; e < s.length; ) {
            if (((r = s[e].split('=')[0]), (i = s[e].split('=')[1].split('|')), r == t)) {
              ((n = { resume_time: 0, save_time: null }).resume_time = 60 * parseInt(i[0], 10)),
                i.length >= 2 && i[1] && (n.save_time = parseInt(i[1], 10));
              break;
            }
            e++;
          }
          return n;
        })(t.movieid);
      s && ((r = s.resume_time), (i = s.save_time ? s.save_time : new Date().getTime() / 1e3)),
        t.movieid
          ? (function (t) {
              const e = n.Deferred();
              return (
                n
                  .ajax({
                    type: 'GET',
                    dataType: 'json',
                    url: u,
                    headers: { 'access-token': a.get('access_token'), client: a.get('client'), uid: a.get('uid') },
                    data: { movieid: t },
                  })
                  .done(function (t) {
                    e.resolve(t);
                  })
                  .fail(function () {
                    e.reject();
                  }),
                e.promise()
              );
            })(t.movieid)
              .done(function (n) {
                200 == n.status_code
                  ? Math.floor(new Date(n.save_datetime.replace(/\-/g, '/')).getTime() / 1e3) > i
                    ? ((r = n.resume_time), m(t.movieid, r))
                    : y(t.movieid, r)
                  : 404 == n.status_code && y(t.movieid, r);
                e({ resume_time: r });
              })
              .fail(function () {
                e({ resume_time: r });
              })
          : e({ resume_time: r });
    }
    function T(t) {
      this.htmlTemplate =
        '<div class="cp-videoplayer"><div class="cp-info cp-volume-0"><div class="cp-video-wrapper"><video class="cp-video" webkit-playsinline playsinline></video><div class="cp-video-resume">動画を前回視聴した地点より、再生します。</div><div class="cp-video-overlay"></div></div><div class="cp-controls"><div class="cp-seekbar"><div class="cp-seekbar-progress"></div><div class="cp-seekbar-play"></div><div class="cp-seekbar-thumb"></div><div class="cp-seekbar-tooltip">0:00:00</div></div><div class="cp-buttons"><div class="cp-button cp-back-button"><div class="cp-button-icon cp-back-button-icon"></div><span>－5秒</span></div><div class="cp-button cp-play-button"><div class="cp-button-icon cp-play-button-icon"></div></div><div class="cp-button cp-foward-button"><div class="cp-button-icon cp-foward-button-icon"></div><span>＋5秒</span></div><div class="cp-time"><span class="cp-current-time">0:00:00</span> / <span class="cp-duration">0:00:00</span></div><div class="cp-button cp-loop-button"><div class="cp-button-icon cp-loop-button-icon"></div></div><div class="cp-button cp-volume-button"><div class="cp-button-icon cp-volume-button-icon"></div></div><div class="cp-button cp-speed-button"><div class="cp-button-icon cp-speed-button-icon">1.0</div><span>再生速度</span></div><div class="cp-button cp-fullscreen-button"><div class="cp-button-icon cp-fullscreen-button-icon"></div></div></div></div></div></div>';
      const e = navigator.userAgent;
      if (
        ((this.isiOS = -1 != e.indexOf('iPhone') || -1 != e.indexOf('iPod') || -1 != e.indexOf('iPad')),
        (this.isAndroid = -1 != e.indexOf('Android')),
        (this.isPC = !this.isiOS && !this.isAndroid),
        (this.isSafari = -1 != e.indexOf('Safari') && -1 == e.indexOf('Chrome') && -1 == e.indexOf('Edge')),
        (this.isiPhone = -1 != e.indexOf('iPhone')),
        (this.isAndroidSmartPhone =
          this.isAndroid && -1 != e.indexOf('Mobile') && -1 == e.indexOf('A1_07') && -1 == e.indexOf('SC-01C')),
        (this.isSp = this.isiPhone || this.isAndroidSmartPhone),
        (this.iosVer = null),
        this.isiOS)
      ) {
        const r = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/),
          i = [parseInt(r[1], 10), parseInt(r[2], 10), parseInt(r[3] || 0, 10)];
        this.iosVer = i[0];
      }
      for (const n in ((this.isFirstPlay = !0),
      (this.isSeeking = !1),
      (this.resumeChecked = !1),
      (this.prevPosition = 0),
      (this.firstResumeTime = 0),
      (this.prevServerResumeTime = 0),
      (this.watchingCompleted = !1),
      (this.hasPlaybackError = !1),
      (this.isPlaybackReady = !1),
      (this.playbackErrorTimer = null),
      (this.watchedPosition = 0),
      (this.params = {
        volume: 2,
        speedList: ['1.0', '1.25', '1.5', '1.75', '0.5', '0.75'],
        speedIndex: 0,
        videoType: 'hls',
      }),
      t))
        this.params[n] = t[n];
      this.params.videoType && (this.params.videoType = this.params.videoType.toLowerCase()),
        (this.videoDuration = 0),
        (this.displayVideoDuration = null);
      const s = a.get('player_vol') + '',
        o = a.get('player_rate') + '';
      /^[0-9]+$/.test(s) && parseInt(s, 10) < 4 && (this.params.volume = parseInt(s, 10)),
        /^[0-9]+$/.test(o) &&
          parseInt(o, 10) < this.params.speedList.length &&
          (this.params.speedIndex = parseInt(o, 10));
      this.resizeIntervalId = null,
        this.fullscreenEventName = null,
        this.fullscreenChangeHandler = null,
        this.playbackHandlers = [],
        this.destroyed = !1;
    }
    (f.prototype.init = function () {
      this.lastTimeupdate = new Date().getTime();
      // 自動リフレッシュは解答入力中の画面更新を引き起こすため停止
      /*
      const t = this;
      setInterval(function () {
        const e = new Date().getTime();
        t.lastTimeupdate && e - t.lastTimeupdate > t.threshold && location.reload();
      }, 3e3);
      */
    }),
      (f.prototype.update = function () {
        this.lastTimeupdate = new Date().getTime();
      }),
      (T.prototype._isNotFoundPlaybackError = function (t) {
        const e = [];
        t &&
          (t.response &&
            (void 0 !== t.response.code && e.push(t.response.code),
            void 0 !== t.response.status && e.push(t.response.status)),
          t.networkDetails &&
            (void 0 !== t.networkDetails.code && e.push(t.networkDetails.code),
            void 0 !== t.networkDetails.status && e.push(t.networkDetails.status)),
          t.context &&
            t.context.response &&
            (void 0 !== t.context.response.code && e.push(t.context.response.code),
            void 0 !== t.context.response.status && e.push(t.context.response.status)));
        for (let r = 0; r < e.length; r++) {
          const i = Number(e[r]);
          if (!Number.isNaN(i) && 404 === i) return !0;
        }
        return !1;
      }),
      (T.prototype._showPlaybackError = function (t) {
        if (!this.$container || this.hasPlaybackError) return;
        this.playbackErrorTimer && (clearTimeout(this.playbackErrorTimer), (this.playbackErrorTimer = null));
        this.hasPlaybackError = !0;
        this.video && this.video.pause();
        const e = this.$container.find('.cp-video-wrapper').eq(0);
        let r = e.find('.cp-video-error').eq(0);
        r.length <= 0 && (e.append('<div class="cp-video-error"></div>'), (r = e.find('.cp-video-error').eq(0))),
          r.text(t),
          this.$container.find('.cp-video-overlay').hide(),
          this.$container.find('.cp-video-resume').hide(),
          this.$container.find('.cp-info').removeClass('cp-play').addClass('cp-pause');
      }),
      (T.prototype._handlePlaybackError = function (t) {
        const e = this._isNotFoundPlaybackError(t);
        if (!e && this.isPlaybackReady) return;
        const r = e ? 'この動画は現在、視聴用サーバーへの反映待ちです。反映が完了すると再生できるようになります。' : '動画の再生に失敗しました。';
        const i = e ? 0 : 1200;
        const n = this;
        this.playbackErrorTimer && clearTimeout(this.playbackErrorTimer),
          (this.playbackErrorTimer = setTimeout(function () {
            if (!e && n.isPlaybackReady) return;
            n._showPlaybackError(r);
          }, i));
      }),
      (T.prototype._clearPlaybackError = function () {
        this.hasPlaybackError = !1;
        this.playbackErrorTimer && (clearTimeout(this.playbackErrorTimer), (this.playbackErrorTimer = null));
        if (!this.$container) return;
        this.$container.find('.cp-video-error').remove(), this.$container.find('.cp-video-overlay').show();
      }),
      (T.prototype._presetupControls = function () {
        const t = this;
        this.watchingCompleted ||
          (this.$container.find('.cp-info').addClass('cp-un-completed'),
          this.isSp && this.$container.find('.cp-info').addClass('cp-sp')),
          this.isiOS && this.$container.find('.cp-info').addClass('cp-ios'),
          this.$container
            .find('.cp-video-overlay')
            .eq(0)
            .on('click', function () {
              if (t.hasPlaybackError) return;
              t.video.paused || t.video.ended ? t.video.play() : t.video.pause();
            }),
          this.$container
            .find('.cp-play-button')
            .eq(0)
            .on('click', function () {
              if (t.hasPlaybackError) return;
              t.video.paused || t.video.ended ? t.video.play() : t.video.pause();
            }),
          this.$container
            .find('.cp-loop-button')
            .eq(0)
            .on('click', function () {
              const e = t.$container.find('.cp-loop').length > 0;
              t._setLoop(!e);
            }),
          this.$container
            .find('.cp-speed-button')
            .eq(0)
            .on('click', function () {
              const e = (t.params.speedIndex + 1) % t.params.speedList.length,
                r = t.params.speedList[e];
              (t.video.playbackRate = parseFloat(r)), (t.params.speedIndex = e);
            });
      }),
      (T.prototype._setupControls = function (t) {
        const e = this;
        (this.videoDuration = t),
          null == this.displayVideoDuration && (this.displayVideoDuration = t),
          this.$container
            .find('.cp-back-button')
            .eq(0)
            .on('click', function () {
              let t = e.video.currentTime - 5;
              t < 0 && (t = 0), (e.video.currentTime = t);
            }),
          this.$container
            .find('.cp-foward-button')
            .eq(0)
            .on('click', function () {
              let t = e.video.currentTime + 5;
              t > e.videoDuration && (t = e.videoDuration), (e.video.currentTime = t);
            }),
          this.$container.find('.cp-current-time').html(h(this.video.currentTime)),
          this.$container.find('.cp-duration').html(h(this.displayVideoDuration)),
          this.$container
            .find('.cp-volume-button')
            .eq(0)
            .on('click', function () {
              const t = (e.params.volume + 1) % 4;
              (e.video.volume = (t / 3) * 1), (e.params.volume = t);
            }),
          this.$container.find('.cp-info').addClass('cp-volume-' + this.params.volume),
          this.$container
            .find('.cp-fullscreen-button')
            .eq(0)
            .on('click', function () {
              e.isiOS ? (p() == e.video ? g() : v(e.video)) : p() == e.$container.get(0) ? g() : v(e.$container.get(0));
            });
        let r,
          i = 'ontouchend' in document,
          s = i ? 'touchstart' : 'mousedown',
          a = i ? 'touchmove' : 'mousemove',
          o = i ? 'touchend' : 'mouseup',
          l = e.$container.find('.cp-seekbar').eq(0);
        function u(t) {
          let i =
            ((t.originalEvent.touches && t.originalEvent.touches.length > 0
              ? t.originalEvent.touches[0]
              : t.originalEvent
            ).pageX -
              l.offset().left) /
            l.width();
          i < 0 ? (i = 0) : i > 1 && (i = 1), e._updateSeekBar(i), (r = i);
        }
        function c(t) {
          let r = e.$container.find('.cp-seekbar-tooltip').eq(0),
            i = e.$container.find('.cp-seekbar-progress'),
            n = i.offset().left,
            s = i.offset().left + i.outerWidth() - r.outerWidth(),
            a =
              t.originalEvent.touches && t.originalEvent.touches.length > 0
                ? t.originalEvent.touches[0]
                : t.originalEvent,
            o = a.pageX - r.width() / 2,
            l = ((a.pageX - i.offset().left) / i.width()) * e.videoDuration;
          o < n ? (o = n) : o > s && (o = s),
            l < 0 ? (l = 0) : l > e.displayVideoDuration && (l = e.displayVideoDuration),
            r.offset({ left: o }),
            r.html(h(l));
        }
        l.on(s, function (t) {
          (e.isSeeking = !0),
            u(t),
            n(document).on(a, u),
            n(document).one(o, function () {
              n(document).off(a, u), (e.video.currentTime = r * e.videoDuration), (e.isSeeking = !1);
            });
        }),
          l.on(a, function (t) {
            c(t);
          }),
          this.isPC
            ? (l.on('mouseover', function (t) {
                c(t), l.addClass('hover');
              }),
              l.on('mouseout', function (t) {
                l.removeClass('hover');
              }))
            : (l.on(s, function (t) {
                c(t), l.addClass('hover');
              }),
              l.on(o, function (t) {
                l.removeClass('hover');
              })),
          this._updateSeekBar();
      }),
      (T.prototype._updateSeekBar = function (t) {
        const e = void 0 === t ? this.video.currentTime / this.videoDuration : t;
        this.$container.find('.cp-seekbar-play').css({ width: 100 * e + '%' }),
          this.$container.find('.cp-seekbar-thumb').css({ left: 100 * e + '%' });
      }),
      (T.prototype._resume = function (t) {
        let e = this.firstResumeTime;
        !this.isFirstPlay &&
          this.video.duration > 5 &&
          (this.resumeChecked
            ? ((e = this.video.currentTime),
              Math.abs(e - this.prevPosition) <= 1 &&
                (e >= this.video.duration - 10 && (t = !0),
                t && (e = 0),
                (t || 0 != e) &&
                  (m(this.params.movieid, e),
                  Math.abs(e - this.prevServerResumeTime) >= 300 &&
                    (y(this.params.movieid, e), (this.prevServerResumeTime = e)))))
            : (e > 0 && ((this.video.currentTime = e), (this.watchedPosition = e)),
              n('#' + this.params.target)
                .find('.cp-video-resume')
                .remove(),
              (this.resumeChecked = !0)));
      }),
      (T.prototype._limitedSeek = function () {
        const t = this;
        if (this.resumeChecked && !this.watchingCompleted) {
          const e = this.video.currentTime,
            r = e - this.watchedPosition;
          if (r > 1) this.video.currentTime = this.watchedPosition;
          else if (r > 0) {
            const r = 0.9 * this.video.duration;
            this.watchedPosition <= r &&
              r < e &&
              n
                .ajax({
                  type: 'GET',
                  dataType: 'json',
                  url: c,
                  headers: { 'access-token': a.get('access_token'), client: a.get('client'), uid: a.get('uid') },
                  data: { movieid: this.params.movieid, _: Date.now() },
                })
                .done(function (e) {
                  200 === e.status_code &&
                    (t.$container.find('.cp-info').removeClass('cp-un-completed'), (t.watchingCompleted = !0));
                }),
              (this.watchedPosition = e);
          }
        }
      }),
      (T.prototype._setLoop = function (t) {
        t
          ? this.$container.find('.cp-info').addClass('cp-loop')
          : this.$container.find('.cp-info').removeClass('cp-loop'),
          (!this.isiOS || (null !== this.iosVer && this.iosVer > 9)) && (this.video.loop = t);
      }),
      (T.prototype.destroy = function () {
        if (this.destroyed) return;
        this.destroyed = !0,
          this.playbackErrorTimer && (clearTimeout(this.playbackErrorTimer), (this.playbackErrorTimer = null)),
          this.resizeIntervalId && (clearInterval(this.resizeIntervalId), (this.resizeIntervalId = null)),
          this.fullscreenEventName &&
            this.fullscreenChangeHandler &&
            n(document).off(this.fullscreenEventName, this.fullscreenChangeHandler),
          this.playbackHandlers.length > 0 &&
            this.video &&
            this.playbackHandlers.forEach(
              function (t) {
                t && t.name && t.handler && this.video.removeEventListener(t.name, t.handler);
              }.bind(this)
            ),
          (this.playbackHandlers = []);
        if (this.hls) {
          try {
            this.hls.destroy();
          } catch (t) {}
          this.hls = null;
        }
        if (this.video) {
          try {
            this.video.pause(),
              this.video.removeAttribute('src'),
              this.video.load && this.video.load();
          } catch (t) {}
        }
        this.$container && this.$container.remove(), (this.video = null), (this.$container = null);
        var t = document.getElementById(this.params.target);
        t && (t.innerHTML = ''),
          this.params &&
            this.params.target &&
            I[this.params.target] === this &&
            delete I[this.params.target];
      }),
      (T.prototype.embed = function () {
        var t,
          e = this;
        var isHlsPlayback =
          !(this.isiOS || this.isSafari || 'hls' != this.params.videoType || !s.isSupported());
        function addVideoListener(t, r) {
          return this.video.addEventListener(t, r), this.playbackHandlers.push({ name: t, handler: r });
        }
        var fullscreenEventName = document.fullscreenEnabled
          ? 'fullscreenchange'
          : document.webkitFullscreenEnabled
            ? 'webkitfullscreenchange'
            : document.mozFullScreenEnabled
              ? 'mozfullscreenchange'
              : document.msfullscreenEnabled
                ? 'msfullscreenchange'
                : void 0;
        function r() {
          var r = e.$container.width();
          t != r && (r < 572 ? e.$container.find('.cp-time').hide() : e.$container.find('.cp-time').show()), (t = r);
        }
        n('#' + this.params.target).html(this.htmlTemplate),
          this.firstResumeTime ||
            n('#' + this.params.target)
              .find('.cp-video-resume')
              .remove(),
          (this.$container = n('#' + this.params.target)
            .find('.cp-videoplayer')
            .eq(0)),
          (this.video = n('#' + this.params.target + ' .cp-video').get(0)),
          (this.isPlaybackReady = !1),
          (this.destroyed = !1),
          (this.playbackHandlers = []),
          this._clearPlaybackError(),
          r();
        this.resizeIntervalId && clearInterval(this.resizeIntervalId),
          (this.resizeIntervalId = setInterval(r, 100)),
          (this.fullscreenEventName = fullscreenEventName);
        if (
          (addVideoListener.call(this, 'play', function () {
            e.isPlaybackReady = !0,
            e._clearPlaybackError(),
            e.$container.find('.cp-info').removeClass('cp-pause'),
              e.$container.find('.cp-info').removeClass('cp-play').addClass('cp-play');
          }),
          addVideoListener.call(this, 'pause', function () {
            e.$container.find('.cp-info').removeClass('cp-play'),
              e.$container.find('.cp-info').removeClass('cp-pause').addClass('cp-pause');
          }),
          addVideoListener.call(this, 'ended', function () {
            e.$container.find('.cp-info').removeClass('cp-play'),
              e.$container.find('.cp-info').removeClass('cp-pause').addClass('cp-pause'),
              e._resume(!0);
          }),
          addVideoListener.call(this, 'ratechange', function () {
            e.$container.find('.cp-speed-button-icon').eq(0).text(e.params.speedList[e.params.speedIndex]),
              a.set('player_rate', e.params.speedIndex, { expires: 7, path: '/' });
          }),
          addVideoListener.call(this, 'volumechange', function () {
            var t = e.$container.find('.cp-info').eq(0);
            t.removeClass(function (t, e) {
              return (e.match(/\bcp-volume-\S+/g) || []).join(' ');
            }),
              t.addClass('cp-volume-' + e.params.volume),
              a.set('player_vol', e.params.volume, { expires: 7, path: '/' });
          }),
          addVideoListener.call(this, 'timeupdate', function () {
            if (!e.isSeeking) {
              var t = e.video.currentTime < e.displayVideoDuration ? e.video.currentTime : e.displayVideoDuration;
              e.$container.find('.cp-current-time').html(h(t)),
                e._updateSeekBar(),
                e._resume(),
                e._limitedSeek(),
                (e.prevPosition = e.video.currentTime),
                i.update();
            }
          }),
          !isHlsPlayback &&
            addVideoListener.call(this, 'error', function () {
              e._handlePlaybackError();
            }),
          (this.fullscreenChangeHandler = function (t) {
            if (!e.$container) return;
            t.originalEvent;
            p() == e.$container.get(0)
              ? e.$container.find('.cp-info').addClass('cp-fullscreen')
              : e.$container.find('.cp-info').removeClass('cp-fullscreen'),
              e._updateSeekBar();
          }),
          this.fullscreenEventName &&
            n(document).on(this.fullscreenEventName, this.fullscreenChangeHandler),
          this._presetupControls(),
          this.isPC && 'on' == this.params.auto
            ? (this.video.autoplay = !0)
            : this.$container.find('.cp-info').addClass('cp-pause'),
          this.params.thumb && (this.video.poster = this.params.thumb),
          void 0 != this.params.volume && (this.video.volume = (this.params.volume / 3) * 1),
          'on' == this.params.loop && this._setLoop(!0),
          !isHlsPlayback)
        )
          addVideoListener.call(this, 'canplay', function () {
            e.isPlaybackReady = !0;
            e._clearPlaybackError();
            if (e.isFirstPlay) return (e.isFirstPlay = !1), void e._setupControls(e.video.duration);
          }),
            this.isiOS &&
              this.iosVer <= 9 &&
              ((this.video.loop = !1),
              addVideoListener.call(this, 'ended', function () {
                e.$container.find('.cp-loop').length > 0 && ((e.video.currentTime = 0), e.video.play());
              })),
            (this.video.src = this.params.src);
        else {
          var o;
          if (this.video.autoplay) o = new s();
          else {
            o = new s({ autoStartLoad: !1 });
            var onHlsPlay = function t() {
              e.video.removeEventListener('play', t), e.hls.startLoad();
            };
            addVideoListener.call(this, 'play', onHlsPlay);
          }
          o.on(s.Events.ERROR, function (t, r) {
            if (!r) return;
            if (e._isNotFoundPlaybackError(r)) return void e._handlePlaybackError(r);
            if (r.fatal) return void e._handlePlaybackError(r);
          }),
          o.on(s.Events.MEDIA_ATTACHED, function () {
            o.loadSource(e.params.src),
              o.on(s.Events.LEVEL_LOADED, function (t, r) {
                e.isPlaybackReady = !0;
                e._clearPlaybackError();
                if (e.isFirstPlay) return (e.isFirstPlay = !1), void e._setupControls(r.details.totalduration);
              });
          }),
            o.attachMedia(this.video),
            (this.hls = o);
        }
        if (this.watchingCompleted && void 0 != this.params.speedIndex) {
          var l = this.params.speedIndex % this.params.speedList.length;
          this.video.playbackRate = parseFloat(this.params.speedList[l]);
        }
      });
    window.DestroyVideoPlayer = function (t) {
      t && I[t] && I[t].destroy();
    };
    window.CreateVideoPlayer = function (t) {
      t.movieid
        ? (window.DestroyVideoPlayer(t.target),
          E(t, function (e) {
            i || (i = new f(541e3)).init(),
              n
                .ajax({
                  type: 'GET',
                  dataType: 'json',
                  url: d,
                  headers: { 'access-token': a.get('access_token'), client: a.get('client'), uid: a.get('uid') },
                  data: { movieid: t.movieid, _: Date.now() },
                })
                .done(function (r) {
                  if (200 === r.status_code) {
                    var i = new T(t);
                    (i.firstResumeTime = e.resume_time),
                      (i.prevServerResumeTime = 300 * Math.floor(e.resume_time / 300)),
                      (i.watchingCompleted = r.complete),
                      (I[t.target] = i),
                      i.embed();
                  }
                })
                .fail(function () {
                  console.error('初期化エラーです。');
                });
          }))
        : console.error('movieidは必須です。');
    };
  },
  function (t, e, r) {
    let i;
    /*!
     * jQuery JavaScript Library v3.3.1
     * https://jquery.com/
     *
     * Includes Sizzle.js
     * https://sizzlejs.com/
     *
     * Copyright JS Foundation and other contributors
     * Released under the MIT license
     * https://jquery.org/license
     *
     * Date: 2018-01-20T17:24Z
     */
    /*!
     * jQuery JavaScript Library v3.3.1
     * https://jquery.com/
     *
     * Includes Sizzle.js
     * https://sizzlejs.com/
     *
     * Copyright JS Foundation and other contributors
     * Released under the MIT license
     * https://jquery.org/license
     *
     * Date: 2018-01-20T17:24Z
     */
    !(function (e, r) {
      'use strict';
      'object' == typeof t && 'object' == typeof t.exports
        ? (t.exports = e.document
            ? r(e, !0)
            : function (t) {
                if (!t.document) throw new Error('jQuery requires a window with a document');
                return r(t);
              })
        : r(e);
    })('undefined' != typeof window ? window : this, function (r, n) {
      'use strict';
      const s = [],
        a = r.document,
        o = Object.getPrototypeOf,
        l = s.slice,
        u = s.concat,
        c = s.push,
        d = s.indexOf,
        f = {},
        h = f.toString,
        p = f.hasOwnProperty,
        v = p.toString,
        g = v.call(Object),
        m = {},
        y = function (t) {
          return 'function' == typeof t && 'number' != typeof t.nodeType;
        },
        E = function (t) {
          return null != t && t === t.window;
        },
        T = { type: !0, src: !0, noModule: !0 };
      function b(t, e, r) {
        let i,
          n = (e = e || a).createElement('script');
        if (((n.text = t), r)) for (i in T) r[i] && (n[i] = r[i]);
        e.head.appendChild(n).parentNode.removeChild(n);
      }
      function S(t) {
        return null == t
          ? t + ''
          : 'object' == typeof t || 'function' == typeof t
            ? f[h.call(t)] || 'object'
            : typeof t;
      }
      const L = function (t, e) {
          return new L.fn.init(t, e);
        },
        A = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
      function D(t) {
        const e = !!t && 'length' in t && t.length,
          r = S(t);
        return !y(t) && !E(t) && ('array' === r || 0 === e || ('number' == typeof e && e > 0 && e - 1 in t));
      }
      (L.fn = L.prototype =
        {
          jquery: '3.3.1',
          constructor: L,
          length: 0,
          toArray: function () {
            return l.call(this);
          },
          get: function (t) {
            return null == t ? l.call(this) : t < 0 ? this[t + this.length] : this[t];
          },
          pushStack: function (t) {
            const e = L.merge(this.constructor(), t);
            return (e.prevObject = this), e;
          },
          each: function (t) {
            return L.each(this, t);
          },
          map: function (t) {
            return this.pushStack(
              L.map(this, function (e, r) {
                return t.call(e, r, e);
              })
            );
          },
          slice: function () {
            return this.pushStack(l.apply(this, arguments));
          },
          first: function () {
            return this.eq(0);
          },
          last: function () {
            return this.eq(-1);
          },
          eq: function (t) {
            const e = this.length,
              r = +t + (t < 0 ? e : 0);
            return this.pushStack(r >= 0 && r < e ? [this[r]] : []);
          },
          end: function () {
            return this.prevObject || this.constructor();
          },
          push: c,
          sort: s.sort,
          splice: s.splice,
        }),
        (L.extend = L.fn.extend =
          function () {
            let t,
              e,
              r,
              i,
              n,
              s,
              a = arguments[0] || {},
              o = 1,
              l = arguments.length,
              u = !1;
            for (
              'boolean' == typeof a && ((u = a), (a = arguments[o] || {}), o++),
                'object' == typeof a || y(a) || (a = {}),
                o === l && ((a = this), o--);
              o < l;
              o++
            )
              if (null != (t = arguments[o]))
                for (e in t)
                  (r = a[e]),
                    a !== (i = t[e]) &&
                      (u && i && (L.isPlainObject(i) || (n = Array.isArray(i)))
                        ? (n
                            ? ((n = !1), (s = r && Array.isArray(r) ? r : []))
                            : (s = r && L.isPlainObject(r) ? r : {}),
                          (a[e] = L.extend(u, s, i)))
                        : void 0 !== i && (a[e] = i));
            return a;
          }),
        L.extend({
          expando: 'jQuery' + ('3.3.1' + Math.random()).replace(/\D/g, ''),
          isReady: !0,
          error: function (t) {
            throw new Error(t);
          },
          noop: function () {},
          isPlainObject: function (t) {
            let e, r;
            return (
              !(!t || '[object Object]' !== h.call(t)) &&
              (!(e = o(t)) || ('function' == typeof (r = p.call(e, 'constructor') && e.constructor) && v.call(r) === g))
            );
          },
          isEmptyObject: function (t) {
            let e;
            for (e in t) return !1;
            return !0;
          },
          globalEval: function (t) {
            b(t);
          },
          each: function (t, e) {
            let r,
              i = 0;
            if (D(t)) for (r = t.length; i < r && !1 !== e.call(t[i], i, t[i]); i++);
            else for (i in t) if (!1 === e.call(t[i], i, t[i])) break;
            return t;
          },
          trim: function (t) {
            return null == t ? '' : (t + '').replace(A, '');
          },
          makeArray: function (t, e) {
            const r = e || [];
            return null != t && (D(Object(t)) ? L.merge(r, 'string' == typeof t ? [t] : t) : c.call(r, t)), r;
          },
          inArray: function (t, e, r) {
            return null == e ? -1 : d.call(e, t, r);
          },
          merge: function (t, e) {
            for (var r = +e.length, i = 0, n = t.length; i < r; i++) t[n++] = e[i];
            return (t.length = n), t;
          },
          grep: function (t, e, r) {
            for (var i = [], n = 0, s = t.length, a = !r; n < s; n++) !e(t[n], n) !== a && i.push(t[n]);
            return i;
          },
          map: function (t, e, r) {
            let i,
              n,
              s = 0,
              a = [];
            if (D(t)) for (i = t.length; s < i; s++) null != (n = e(t[s], s, r)) && a.push(n);
            else for (s in t) null != (n = e(t[s], s, r)) && a.push(n);
            return u.apply([], a);
          },
          guid: 1,
          support: m,
        }),
        'function' == typeof Symbol && (L.fn[Symbol.iterator] = s[Symbol.iterator]),
        L.each('Boolean Number String Function Array Date RegExp Object Error Symbol'.split(' '), function (t, e) {
          f['[object ' + e + ']'] = e.toLowerCase();
        });
      const k =
        /*!
         * Sizzle CSS Selector Engine v2.3.3
         * https://sizzlejs.com/
         *
         * Copyright jQuery Foundation and other contributors
         * Released under the MIT license
         * http://jquery.org/license
         *
         * Date: 2016-08-08
         */
        (function (t) {
          let e,
            r,
            i,
            n,
            s,
            a,
            o,
            l,
            u,
            c,
            d,
            f,
            h,
            p,
            v,
            g,
            m,
            y,
            E,
            T = 'sizzle' + 1 * new Date(),
            b = t.document,
            S = 0,
            L = 0,
            A = at(),
            D = at(),
            k = at(),
            C = function (t, e) {
              return t === e && (d = !0), 0;
            },
            x = {}.hasOwnProperty,
            R = [],
            w = R.pop,
            _ = R.push,
            I = R.push,
            O = R.slice,
            P = function (t, e) {
              for (let r = 0, i = t.length; r < i; r++) if (t[r] === e) return r;
              return -1;
            },
            F =
              'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped',
            M = '[\\x20\\t\\r\\n\\f]',
            N = '(?:\\\\.|[\\w-]|[^\0-\\xa0])+',
            B =
              '\\[' +
              M +
              '*(' +
              N +
              ')(?:' +
              M +
              '*([*^$|!~]?=)' +
              M +
              '*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' +
              N +
              '))|)' +
              M +
              '*\\]',
            U =
              ':(' +
              N +
              ')(?:\\(((\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|' +
              B +
              ')*)|.*)\\)|)',
            j = new RegExp(M + '+', 'g'),
            G = new RegExp('^' + M + '+|((?:^|[^\\\\])(?:\\\\.)*)' + M + '+$', 'g'),
            H = new RegExp('^' + M + '*,' + M + '*'),
            K = new RegExp('^' + M + '*([>+~]|' + M + ')' + M + '*'),
            V = new RegExp('=' + M + '*([^\\]\'"]*?)' + M + '*\\]', 'g'),
            q = new RegExp(U),
            W = new RegExp('^' + N + '$'),
            Y = {
              ID: new RegExp('^#(' + N + ')'),
              CLASS: new RegExp('^\\.(' + N + ')'),
              TAG: new RegExp('^(' + N + '|[*])'),
              ATTR: new RegExp('^' + B),
              PSEUDO: new RegExp('^' + U),
              CHILD: new RegExp(
                '^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' +
                  M +
                  '*(even|odd|(([+-]|)(\\d*)n|)' +
                  M +
                  '*(?:([+-]|)' +
                  M +
                  '*(\\d+)|))' +
                  M +
                  '*\\)|)',
                'i'
              ),
              bool: new RegExp('^(?:' + F + ')$', 'i'),
              needsContext: new RegExp(
                '^' +
                  M +
                  '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' +
                  M +
                  '*((?:-\\d)?\\d*)' +
                  M +
                  '*\\)|)(?=[^-]|$)',
                'i'
              ),
            },
            X = /^(?:input|select|textarea|button)$/i,
            z = /^h\d$/i,
            $ = /^[^{]+\{\s*\[native \w/,
            Q = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            J = /[+~]/,
            Z = new RegExp('\\\\([\\da-f]{1,6}' + M + '?|(' + M + ')|.)', 'ig'),
            tt = function (t, e, r) {
              const i = '0x' + e - 65536;
              return i != i || r
                ? e
                : i < 0
                  ? String.fromCharCode(i + 65536)
                  : String.fromCharCode((i >> 10) | 55296, (1023 & i) | 56320);
            },
            et = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
            rt = function (t, e) {
              return e
                ? '\0' === t
                  ? '�'
                  : t.slice(0, -1) + '\\' + t.charCodeAt(t.length - 1).toString(16) + ' '
                : '\\' + t;
            },
            it = function () {
              f();
            },
            nt = yt(
              function (t) {
                return !0 === t.disabled && ('form' in t || 'label' in t);
              },
              { dir: 'parentNode', next: 'legend' }
            );
          try {
            I.apply((R = O.call(b.childNodes)), b.childNodes), R[b.childNodes.length].nodeType;
          } catch (t) {
            I = {
              apply: R.length
                ? function (t, e) {
                    _.apply(t, O.call(e));
                  }
                : function (t, e) {
                    for (var r = t.length, i = 0; (t[r++] = e[i++]); );
                    t.length = r - 1;
                  },
            };
          }
          function st(t, e, i, n) {
            let s,
              o,
              u,
              c,
              d,
              p,
              m,
              y = e && e.ownerDocument,
              S = e ? e.nodeType : 9;
            if (((i = i || []), 'string' != typeof t || !t || (1 !== S && 9 !== S && 11 !== S))) return i;
            if (!n && ((e ? e.ownerDocument || e : b) !== h && f(e), (e = e || h), v)) {
              if (11 !== S && (d = Q.exec(t)))
                if ((s = d[1])) {
                  if (9 === S) {
                    if (!(u = e.getElementById(s))) return i;
                    if (u.id === s) return i.push(u), i;
                  } else if (y && (u = y.getElementById(s)) && E(e, u) && u.id === s) return i.push(u), i;
                } else {
                  if (d[2]) return I.apply(i, e.getElementsByTagName(t)), i;
                  if ((s = d[3]) && r.getElementsByClassName && e.getElementsByClassName)
                    return I.apply(i, e.getElementsByClassName(s)), i;
                }
              if (r.qsa && !k[t + ' '] && (!g || !g.test(t))) {
                if (1 !== S) (y = e), (m = t);
                else if ('object' !== e.nodeName.toLowerCase()) {
                  for (
                    (c = e.getAttribute('id')) ? (c = c.replace(et, rt)) : e.setAttribute('id', (c = T)),
                      o = (p = a(t)).length;
                    o--;

                  )
                    p[o] = '#' + c + ' ' + mt(p[o]);
                  (m = p.join(',')), (y = (J.test(t) && vt(e.parentNode)) || e);
                }
                if (m)
                  try {
                    return I.apply(i, y.querySelectorAll(m)), i;
                  } catch (t) {
                  } finally {
                    c === T && e.removeAttribute('id');
                  }
              }
            }
            return l(t.replace(G, '$1'), e, i, n);
          }
          function at() {
            const t = [];
            return function e(r, n) {
              return t.push(r + ' ') > i.cacheLength && delete e[t.shift()], (e[r + ' '] = n);
            };
          }
          function ot(t) {
            return (t[T] = !0), t;
          }
          function lt(t) {
            let e = h.createElement('fieldset');
            try {
              return !!t(e);
            } catch (t) {
              return !1;
            } finally {
              e.parentNode && e.parentNode.removeChild(e), (e = null);
            }
          }
          function ut(t, e) {
            for (let r = t.split('|'), n = r.length; n--; ) i.attrHandle[r[n]] = e;
          }
          function ct(t, e) {
            let r = e && t,
              i = r && 1 === t.nodeType && 1 === e.nodeType && t.sourceIndex - e.sourceIndex;
            if (i) return i;
            if (r) for (; (r = r.nextSibling); ) if (r === e) return -1;
            return t ? 1 : -1;
          }
          function dt(t) {
            return function (e) {
              return 'input' === e.nodeName.toLowerCase() && e.type === t;
            };
          }
          function ft(t) {
            return function (e) {
              const r = e.nodeName.toLowerCase();
              return ('input' === r || 'button' === r) && e.type === t;
            };
          }
          function ht(t) {
            return function (e) {
              return 'form' in e
                ? e.parentNode && !1 === e.disabled
                  ? 'label' in e
                    ? 'label' in e.parentNode
                      ? e.parentNode.disabled === t
                      : e.disabled === t
                    : e.isDisabled === t || (e.isDisabled !== !t && nt(e) === t)
                  : e.disabled === t
                : 'label' in e && e.disabled === t;
            };
          }
          function pt(t) {
            return ot(function (e) {
              return (
                (e = +e),
                ot(function (r, i) {
                  for (var n, s = t([], r.length, e), a = s.length; a--; ) r[(n = s[a])] && (r[n] = !(i[n] = r[n]));
                })
              );
            });
          }
          function vt(t) {
            return t && void 0 !== t.getElementsByTagName && t;
          }
          for (e in ((r = st.support = {}),
          (s = st.isXML =
            function (t) {
              const e = t && (t.ownerDocument || t).documentElement;
              return !!e && 'HTML' !== e.nodeName;
            }),
          (f = st.setDocument =
            function (t) {
              let e,
                n,
                a = t ? t.ownerDocument || t : b;
              return a !== h && 9 === a.nodeType && a.documentElement
                ? ((p = (h = a).documentElement),
                  (v = !s(h)),
                  b !== h &&
                    (n = h.defaultView) &&
                    n.top !== n &&
                    (n.addEventListener
                      ? n.addEventListener('unload', it, !1)
                      : n.attachEvent && n.attachEvent('onunload', it)),
                  (r.attributes = lt(function (t) {
                    return (t.className = 'i'), !t.getAttribute('className');
                  })),
                  (r.getElementsByTagName = lt(function (t) {
                    return t.appendChild(h.createComment('')), !t.getElementsByTagName('*').length;
                  })),
                  (r.getElementsByClassName = $.test(h.getElementsByClassName)),
                  (r.getById = lt(function (t) {
                    return (p.appendChild(t).id = T), !h.getElementsByName || !h.getElementsByName(T).length;
                  })),
                  r.getById
                    ? ((i.filter.ID = function (t) {
                        const e = t.replace(Z, tt);
                        return function (t) {
                          return t.getAttribute('id') === e;
                        };
                      }),
                      (i.find.ID = function (t, e) {
                        if (void 0 !== e.getElementById && v) {
                          const r = e.getElementById(t);
                          return r ? [r] : [];
                        }
                      }))
                    : ((i.filter.ID = function (t) {
                        const e = t.replace(Z, tt);
                        return function (t) {
                          const r = void 0 !== t.getAttributeNode && t.getAttributeNode('id');
                          return r && r.value === e;
                        };
                      }),
                      (i.find.ID = function (t, e) {
                        if (void 0 !== e.getElementById && v) {
                          let r,
                            i,
                            n,
                            s = e.getElementById(t);
                          if (s) {
                            if ((r = s.getAttributeNode('id')) && r.value === t) return [s];
                            for (n = e.getElementsByName(t), i = 0; (s = n[i++]); )
                              if ((r = s.getAttributeNode('id')) && r.value === t) return [s];
                          }
                          return [];
                        }
                      })),
                  (i.find.TAG = r.getElementsByTagName
                    ? function (t, e) {
                        return void 0 !== e.getElementsByTagName
                          ? e.getElementsByTagName(t)
                          : r.qsa
                            ? e.querySelectorAll(t)
                            : void 0;
                      }
                    : function (t, e) {
                        let r,
                          i = [],
                          n = 0,
                          s = e.getElementsByTagName(t);
                        if ('*' === t) {
                          for (; (r = s[n++]); ) 1 === r.nodeType && i.push(r);
                          return i;
                        }
                        return s;
                      }),
                  (i.find.CLASS =
                    r.getElementsByClassName &&
                    function (t, e) {
                      if (void 0 !== e.getElementsByClassName && v) return e.getElementsByClassName(t);
                    }),
                  (m = []),
                  (g = []),
                  (r.qsa = $.test(h.querySelectorAll)) &&
                    (lt(function (t) {
                      (p.appendChild(t).innerHTML =
                        "<a id='" +
                        T +
                        "'></a><select id='" +
                        T +
                        "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                        t.querySelectorAll("[msallowcapture^='']").length && g.push('[*^$]=' + M + '*(?:\'\'|"")'),
                        t.querySelectorAll('[selected]').length || g.push('\\[' + M + '*(?:value|' + F + ')'),
                        t.querySelectorAll('[id~=' + T + '-]').length || g.push('~='),
                        t.querySelectorAll(':checked').length || g.push(':checked'),
                        t.querySelectorAll('a#' + T + '+*').length || g.push('.#.+[+~]');
                    }),
                    lt(function (t) {
                      t.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                      const e = h.createElement('input');
                      e.setAttribute('type', 'hidden'),
                        t.appendChild(e).setAttribute('name', 'D'),
                        t.querySelectorAll('[name=d]').length && g.push('name' + M + '*[*^$|!~]?='),
                        2 !== t.querySelectorAll(':enabled').length && g.push(':enabled', ':disabled'),
                        (p.appendChild(t).disabled = !0),
                        2 !== t.querySelectorAll(':disabled').length && g.push(':enabled', ':disabled'),
                        t.querySelectorAll('*,:x'),
                        g.push(',.*:');
                    })),
                  (r.matchesSelector = $.test(
                    (y =
                      p.matches ||
                      p.webkitMatchesSelector ||
                      p.mozMatchesSelector ||
                      p.oMatchesSelector ||
                      p.msMatchesSelector)
                  )) &&
                    lt(function (t) {
                      (r.disconnectedMatch = y.call(t, '*')), y.call(t, "[s!='']:x"), m.push('!=', U);
                    }),
                  (g = g.length && new RegExp(g.join('|'))),
                  (m = m.length && new RegExp(m.join('|'))),
                  (e = $.test(p.compareDocumentPosition)),
                  (E =
                    e || $.test(p.contains)
                      ? function (t, e) {
                          const r = 9 === t.nodeType ? t.documentElement : t,
                            i = e && e.parentNode;
                          return (
                            t === i ||
                            !(
                              !i ||
                              1 !== i.nodeType ||
                              !(r.contains
                                ? r.contains(i)
                                : t.compareDocumentPosition && 16 & t.compareDocumentPosition(i))
                            )
                          );
                        }
                      : function (t, e) {
                          if (e) for (; (e = e.parentNode); ) if (e === t) return !0;
                          return !1;
                        }),
                  (C = e
                    ? function (t, e) {
                        if (t === e) return (d = !0), 0;
                        let i = !t.compareDocumentPosition - !e.compareDocumentPosition;
                        return (
                          i ||
                          (1 &
                            (i =
                              (t.ownerDocument || t) === (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1) ||
                          (!r.sortDetached && e.compareDocumentPosition(t) === i)
                            ? t === h || (t.ownerDocument === b && E(b, t))
                              ? -1
                              : e === h || (e.ownerDocument === b && E(b, e))
                                ? 1
                                : c
                                  ? P(c, t) - P(c, e)
                                  : 0
                            : 4 & i
                              ? -1
                              : 1)
                        );
                      }
                    : function (t, e) {
                        if (t === e) return (d = !0), 0;
                        let r,
                          i = 0,
                          n = t.parentNode,
                          s = e.parentNode,
                          a = [t],
                          o = [e];
                        if (!n || !s) return t === h ? -1 : e === h ? 1 : n ? -1 : s ? 1 : c ? P(c, t) - P(c, e) : 0;
                        if (n === s) return ct(t, e);
                        for (r = t; (r = r.parentNode); ) a.unshift(r);
                        for (r = e; (r = r.parentNode); ) o.unshift(r);
                        for (; a[i] === o[i]; ) i++;
                        return i ? ct(a[i], o[i]) : a[i] === b ? -1 : o[i] === b ? 1 : 0;
                      }),
                  h)
                : h;
            }),
          (st.matches = function (t, e) {
            return st(t, null, null, e);
          }),
          (st.matchesSelector = function (t, e) {
            if (
              ((t.ownerDocument || t) !== h && f(t),
              (e = e.replace(V, "='$1']")),
              r.matchesSelector && v && !k[e + ' '] && (!m || !m.test(e)) && (!g || !g.test(e)))
            )
              try {
                const i = y.call(t, e);
                if (i || r.disconnectedMatch || (t.document && 11 !== t.document.nodeType)) return i;
              } catch (t) {}
            return st(e, h, null, [t]).length > 0;
          }),
          (st.contains = function (t, e) {
            return (t.ownerDocument || t) !== h && f(t), E(t, e);
          }),
          (st.attr = function (t, e) {
            (t.ownerDocument || t) !== h && f(t);
            let n = i.attrHandle[e.toLowerCase()],
              s = n && x.call(i.attrHandle, e.toLowerCase()) ? n(t, e, !v) : void 0;
            return void 0 !== s
              ? s
              : r.attributes || !v
                ? t.getAttribute(e)
                : (s = t.getAttributeNode(e)) && s.specified
                  ? s.value
                  : null;
          }),
          (st.escape = function (t) {
            return (t + '').replace(et, rt);
          }),
          (st.error = function (t) {
            throw new Error('Syntax error, unrecognized expression: ' + t);
          }),
          (st.uniqueSort = function (t) {
            let e,
              i = [],
              n = 0,
              s = 0;
            if (((d = !r.detectDuplicates), (c = !r.sortStable && t.slice(0)), t.sort(C), d)) {
              for (; (e = t[s++]); ) e === t[s] && (n = i.push(s));
              for (; n--; ) t.splice(i[n], 1);
            }
            return (c = null), t;
          }),
          (n = st.getText =
            function (t) {
              let e,
                r = '',
                i = 0,
                s = t.nodeType;
              if (s) {
                if (1 === s || 9 === s || 11 === s) {
                  if ('string' == typeof t.textContent) return t.textContent;
                  for (t = t.firstChild; t; t = t.nextSibling) r += n(t);
                } else if (3 === s || 4 === s) return t.nodeValue;
              } else for (; (e = t[i++]); ) r += n(e);
              return r;
            }),
          ((i = st.selectors =
            {
              cacheLength: 50,
              createPseudo: ot,
              match: Y,
              attrHandle: {},
              find: {},
              relative: {
                '>': { dir: 'parentNode', first: !0 },
                ' ': { dir: 'parentNode' },
                '+': { dir: 'previousSibling', first: !0 },
                '~': { dir: 'previousSibling' },
              },
              preFilter: {
                ATTR: function (t) {
                  return (
                    (t[1] = t[1].replace(Z, tt)),
                    (t[3] = (t[3] || t[4] || t[5] || '').replace(Z, tt)),
                    '~=' === t[2] && (t[3] = ' ' + t[3] + ' '),
                    t.slice(0, 4)
                  );
                },
                CHILD: function (t) {
                  return (
                    (t[1] = t[1].toLowerCase()),
                    'nth' === t[1].slice(0, 3)
                      ? (t[3] || st.error(t[0]),
                        (t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ('even' === t[3] || 'odd' === t[3]))),
                        (t[5] = +(t[7] + t[8] || 'odd' === t[3])))
                      : t[3] && st.error(t[0]),
                    t
                  );
                },
                PSEUDO: function (t) {
                  let e,
                    r = !t[6] && t[2];
                  return Y.CHILD.test(t[0])
                    ? null
                    : (t[3]
                        ? (t[2] = t[4] || t[5] || '')
                        : r &&
                          q.test(r) &&
                          (e = a(r, !0)) &&
                          (e = r.indexOf(')', r.length - e) - r.length) &&
                          ((t[0] = t[0].slice(0, e)), (t[2] = r.slice(0, e))),
                      t.slice(0, 3));
                },
              },
              filter: {
                TAG: function (t) {
                  const e = t.replace(Z, tt).toLowerCase();
                  return '*' === t
                    ? function () {
                        return !0;
                      }
                    : function (t) {
                        return t.nodeName && t.nodeName.toLowerCase() === e;
                      };
                },
                CLASS: function (t) {
                  let e = A[t + ' '];
                  return (
                    e ||
                    ((e = new RegExp('(^|' + M + ')' + t + '(' + M + '|$)')) &&
                      A(t, function (t) {
                        return e.test(
                          ('string' == typeof t.className && t.className) ||
                            (void 0 !== t.getAttribute && t.getAttribute('class')) ||
                            ''
                        );
                      }))
                  );
                },
                ATTR: function (t, e, r) {
                  return function (i) {
                    let n = st.attr(i, t);
                    return null == n
                      ? '!=' === e
                      : !e ||
                          ((n += ''),
                          '=' === e
                            ? n === r
                            : '!=' === e
                              ? n !== r
                              : '^=' === e
                                ? r && 0 === n.indexOf(r)
                                : '*=' === e
                                  ? r && n.indexOf(r) > -1
                                  : '$=' === e
                                    ? r && n.slice(-r.length) === r
                                    : '~=' === e
                                      ? (' ' + n.replace(j, ' ') + ' ').indexOf(r) > -1
                                      : '|=' === e && (n === r || n.slice(0, r.length + 1) === r + '-'));
                  };
                },
                CHILD: function (t, e, r, i, n) {
                  const s = 'nth' !== t.slice(0, 3),
                    a = 'last' !== t.slice(-4),
                    o = 'of-type' === e;
                  return 1 === i && 0 === n
                    ? function (t) {
                        return !!t.parentNode;
                      }
                    : function (e, r, l) {
                        let u,
                          c,
                          d,
                          f,
                          h,
                          p,
                          v = s !== a ? 'nextSibling' : 'previousSibling',
                          g = e.parentNode,
                          m = o && e.nodeName.toLowerCase(),
                          y = !l && !o,
                          E = !1;
                        if (g) {
                          if (s) {
                            for (; v; ) {
                              for (f = e; (f = f[v]); )
                                if (o ? f.nodeName.toLowerCase() === m : 1 === f.nodeType) return !1;
                              p = v = 'only' === t && !p && 'nextSibling';
                            }
                            return !0;
                          }
                          if (((p = [a ? g.firstChild : g.lastChild]), a && y)) {
                            for (
                              E =
                                (h =
                                  (u =
                                    (c = (d = (f = g)[T] || (f[T] = {}))[f.uniqueID] || (d[f.uniqueID] = {}))[t] ||
                                    [])[0] === S && u[1]) && u[2],
                                f = h && g.childNodes[h];
                              (f = (++h && f && f[v]) || (E = h = 0) || p.pop());

                            )
                              if (1 === f.nodeType && ++E && f === e) {
                                c[t] = [S, h, E];
                                break;
                              }
                          } else if (
                            (y &&
                              (E = h =
                                (u =
                                  (c = (d = (f = e)[T] || (f[T] = {}))[f.uniqueID] || (d[f.uniqueID] = {}))[t] ||
                                  [])[0] === S && u[1]),
                            !1 === E)
                          )
                            for (
                              ;
                              (f = (++h && f && f[v]) || (E = h = 0) || p.pop()) &&
                              ((o ? f.nodeName.toLowerCase() !== m : 1 !== f.nodeType) ||
                                !++E ||
                                (y && ((c = (d = f[T] || (f[T] = {}))[f.uniqueID] || (d[f.uniqueID] = {}))[t] = [S, E]),
                                f !== e));

                            );
                          return (E -= n) === i || (E % i == 0 && E / i >= 0);
                        }
                      };
                },
                PSEUDO: function (t, e) {
                  let r,
                    n = i.pseudos[t] || i.setFilters[t.toLowerCase()] || st.error('unsupported pseudo: ' + t);
                  return n[T]
                    ? n(e)
                    : n.length > 1
                      ? ((r = [t, t, '', e]),
                        i.setFilters.hasOwnProperty(t.toLowerCase())
                          ? ot(function (t, r) {
                              for (var i, s = n(t, e), a = s.length; a--; ) t[(i = P(t, s[a]))] = !(r[i] = s[a]);
                            })
                          : function (t) {
                              return n(t, 0, r);
                            })
                      : n;
                },
              },
              pseudos: {
                not: ot(function (t) {
                  const e = [],
                    r = [],
                    i = o(t.replace(G, '$1'));
                  return i[T]
                    ? ot(function (t, e, r, n) {
                        for (var s, a = i(t, null, n, []), o = t.length; o--; ) (s = a[o]) && (t[o] = !(e[o] = s));
                      })
                    : function (t, n, s) {
                        return (e[0] = t), i(e, null, s, r), (e[0] = null), !r.pop();
                      };
                }),
                has: ot(function (t) {
                  return function (e) {
                    return st(t, e).length > 0;
                  };
                }),
                contains: ot(function (t) {
                  return (
                    (t = t.replace(Z, tt)),
                    function (e) {
                      return (e.textContent || e.innerText || n(e)).indexOf(t) > -1;
                    }
                  );
                }),
                lang: ot(function (t) {
                  return (
                    W.test(t || '') || st.error('unsupported lang: ' + t),
                    (t = t.replace(Z, tt).toLowerCase()),
                    function (e) {
                      let r;
                      do {
                        if ((r = v ? e.lang : e.getAttribute('xml:lang') || e.getAttribute('lang')))
                          return (r = r.toLowerCase()) === t || 0 === r.indexOf(t + '-');
                      } while ((e = e.parentNode) && 1 === e.nodeType);
                      return !1;
                    }
                  );
                }),
                target: function (e) {
                  const r = t.location && t.location.hash;
                  return r && r.slice(1) === e.id;
                },
                root: function (t) {
                  return t === p;
                },
                focus: function (t) {
                  return t === h.activeElement && (!h.hasFocus || h.hasFocus()) && !!(t.type || t.href || ~t.tabIndex);
                },
                enabled: ht(!1),
                disabled: ht(!0),
                checked: function (t) {
                  const e = t.nodeName.toLowerCase();
                  return ('input' === e && !!t.checked) || ('option' === e && !!t.selected);
                },
                selected: function (t) {
                  return t.parentNode && t.parentNode.selectedIndex, !0 === t.selected;
                },
                empty: function (t) {
                  for (t = t.firstChild; t; t = t.nextSibling) if (t.nodeType < 6) return !1;
                  return !0;
                },
                parent: function (t) {
                  return !i.pseudos.empty(t);
                },
                header: function (t) {
                  return z.test(t.nodeName);
                },
                input: function (t) {
                  return X.test(t.nodeName);
                },
                button: function (t) {
                  const e = t.nodeName.toLowerCase();
                  return ('input' === e && 'button' === t.type) || 'button' === e;
                },
                text: function (t) {
                  let e;
                  return (
                    'input' === t.nodeName.toLowerCase() &&
                    'text' === t.type &&
                    (null == (e = t.getAttribute('type')) || 'text' === e.toLowerCase())
                  );
                },
                first: pt(function () {
                  return [0];
                }),
                last: pt(function (t, e) {
                  return [e - 1];
                }),
                eq: pt(function (t, e, r) {
                  return [r < 0 ? r + e : r];
                }),
                even: pt(function (t, e) {
                  for (let r = 0; r < e; r += 2) t.push(r);
                  return t;
                }),
                odd: pt(function (t, e) {
                  for (let r = 1; r < e; r += 2) t.push(r);
                  return t;
                }),
                lt: pt(function (t, e, r) {
                  for (let i = r < 0 ? r + e : r; --i >= 0; ) t.push(i);
                  return t;
                }),
                gt: pt(function (t, e, r) {
                  for (let i = r < 0 ? r + e : r; ++i < e; ) t.push(i);
                  return t;
                }),
              },
            }).pseudos.nth = i.pseudos.eq),
          { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
            i.pseudos[e] = dt(e);
          for (e in { submit: !0, reset: !0 }) i.pseudos[e] = ft(e);
          function gt() {}
          function mt(t) {
            for (var e = 0, r = t.length, i = ''; e < r; e++) i += t[e].value;
            return i;
          }
          function yt(t, e, r) {
            const i = e.dir,
              n = e.next,
              s = n || i,
              a = r && 'parentNode' === s,
              o = L++;
            return e.first
              ? function (e, r, n) {
                  for (; (e = e[i]); ) if (1 === e.nodeType || a) return t(e, r, n);
                  return !1;
                }
              : function (e, r, l) {
                  let u,
                    c,
                    d,
                    f = [S, o];
                  if (l) {
                    for (; (e = e[i]); ) if ((1 === e.nodeType || a) && t(e, r, l)) return !0;
                  } else
                    for (; (e = e[i]); )
                      if (1 === e.nodeType || a)
                        if (
                          ((c = (d = e[T] || (e[T] = {}))[e.uniqueID] || (d[e.uniqueID] = {})),
                          n && n === e.nodeName.toLowerCase())
                        )
                          e = e[i] || e;
                        else {
                          if ((u = c[s]) && u[0] === S && u[1] === o) return (f[2] = u[2]);
                          if (((c[s] = f), (f[2] = t(e, r, l)))) return !0;
                        }
                  return !1;
                };
          }
          function Et(t) {
            return t.length > 1
              ? function (e, r, i) {
                  for (let n = t.length; n--; ) if (!t[n](e, r, i)) return !1;
                  return !0;
                }
              : t[0];
          }
          function Tt(t, e, r, i, n) {
            for (var s, a = [], o = 0, l = t.length, u = null != e; o < l; o++)
              (s = t[o]) && ((r && !r(s, i, n)) || (a.push(s), u && e.push(o)));
            return a;
          }
          function bt(t, e, r, i, n, s) {
            return (
              i && !i[T] && (i = bt(i)),
              n && !n[T] && (n = bt(n, s)),
              ot(function (s, a, o, l) {
                let u,
                  c,
                  d,
                  f = [],
                  h = [],
                  p = a.length,
                  v =
                    s ||
                    (function (t, e, r) {
                      for (let i = 0, n = e.length; i < n; i++) st(t, e[i], r);
                      return r;
                    })(e || '*', o.nodeType ? [o] : o, []),
                  g = !t || (!s && e) ? v : Tt(v, f, t, o, l),
                  m = r ? (n || (s ? t : p || i) ? [] : a) : g;
                if ((r && r(g, m, o, l), i))
                  for (u = Tt(m, h), i(u, [], o, l), c = u.length; c--; ) (d = u[c]) && (m[h[c]] = !(g[h[c]] = d));
                if (s) {
                  if (n || t) {
                    if (n) {
                      for (u = [], c = m.length; c--; ) (d = m[c]) && u.push((g[c] = d));
                      n(null, (m = []), u, l);
                    }
                    for (c = m.length; c--; ) (d = m[c]) && (u = n ? P(s, d) : f[c]) > -1 && (s[u] = !(a[u] = d));
                  }
                } else (m = Tt(m === a ? m.splice(p, m.length) : m)), n ? n(null, a, m, l) : I.apply(a, m);
              })
            );
          }
          function St(t) {
            for (
              var e,
                r,
                n,
                s = t.length,
                a = i.relative[t[0].type],
                o = a || i.relative[' '],
                l = a ? 1 : 0,
                c = yt(
                  function (t) {
                    return t === e;
                  },
                  o,
                  !0
                ),
                d = yt(
                  function (t) {
                    return P(e, t) > -1;
                  },
                  o,
                  !0
                ),
                f = [
                  function (t, r, i) {
                    const n = (!a && (i || r !== u)) || ((e = r).nodeType ? c(t, r, i) : d(t, r, i));
                    return (e = null), n;
                  },
                ];
              l < s;
              l++
            )
              if ((r = i.relative[t[l].type])) f = [yt(Et(f), r)];
              else {
                if ((r = i.filter[t[l].type].apply(null, t[l].matches))[T]) {
                  for (n = ++l; n < s && !i.relative[t[n].type]; n++);
                  return bt(
                    l > 1 && Et(f),
                    l > 1 && mt(t.slice(0, l - 1).concat({ value: ' ' === t[l - 2].type ? '*' : '' })).replace(G, '$1'),
                    r,
                    l < n && St(t.slice(l, n)),
                    n < s && St((t = t.slice(n))),
                    n < s && mt(t)
                  );
                }
                f.push(r);
              }
            return Et(f);
          }
          return (
            (gt.prototype = i.filters = i.pseudos),
            (i.setFilters = new gt()),
            (a = st.tokenize =
              function (t, e) {
                let r,
                  n,
                  s,
                  a,
                  o,
                  l,
                  u,
                  c = D[t + ' '];
                if (c) return e ? 0 : c.slice(0);
                for (o = t, l = [], u = i.preFilter; o; ) {
                  for (a in ((r && !(n = H.exec(o))) || (n && (o = o.slice(n[0].length) || o), l.push((s = []))),
                  (r = !1),
                  (n = K.exec(o)) &&
                    ((r = n.shift()), s.push({ value: r, type: n[0].replace(G, ' ') }), (o = o.slice(r.length))),
                  i.filter))
                    !(n = Y[a].exec(o)) ||
                      (u[a] && !(n = u[a](n))) ||
                      ((r = n.shift()), s.push({ value: r, type: a, matches: n }), (o = o.slice(r.length)));
                  if (!r) break;
                }
                return e ? o.length : o ? st.error(t) : D(t, l).slice(0);
              }),
            (o = st.compile =
              function (t, e) {
                let r,
                  n = [],
                  s = [],
                  o = k[t + ' '];
                if (!o) {
                  for (e || (e = a(t)), r = e.length; r--; ) (o = St(e[r]))[T] ? n.push(o) : s.push(o);
                  (o = k(
                    t,
                    (function (t, e) {
                      const r = e.length > 0,
                        n = t.length > 0,
                        s = function (s, a, o, l, c) {
                          let d,
                            p,
                            g,
                            m = 0,
                            y = '0',
                            E = s && [],
                            T = [],
                            b = u,
                            L = s || (n && i.find.TAG('*', c)),
                            A = (S += null == b ? 1 : Math.random() || 0.1),
                            D = L.length;
                          for (c && (u = a === h || a || c); y !== D && null != (d = L[y]); y++) {
                            if (n && d) {
                              for (p = 0, a || d.ownerDocument === h || (f(d), (o = !v)); (g = t[p++]); )
                                if (g(d, a || h, o)) {
                                  l.push(d);
                                  break;
                                }
                              c && (S = A);
                            }
                            r && ((d = !g && d) && m--, s && E.push(d));
                          }
                          if (((m += y), r && y !== m)) {
                            for (p = 0; (g = e[p++]); ) g(E, T, a, o);
                            if (s) {
                              if (m > 0) for (; y--; ) E[y] || T[y] || (T[y] = w.call(l));
                              T = Tt(T);
                            }
                            I.apply(l, T), c && !s && T.length > 0 && m + e.length > 1 && st.uniqueSort(l);
                          }
                          return c && ((S = A), (u = b)), E;
                        };
                      return r ? ot(s) : s;
                    })(s, n)
                  )).selector = t;
                }
                return o;
              }),
            (l = st.select =
              function (t, e, r, n) {
                let s,
                  l,
                  u,
                  c,
                  d,
                  f = 'function' == typeof t && t,
                  h = !n && a((t = f.selector || t));
                if (((r = r || []), 1 === h.length)) {
                  if (
                    (l = h[0] = h[0].slice(0)).length > 2 &&
                    'ID' === (u = l[0]).type &&
                    9 === e.nodeType &&
                    v &&
                    i.relative[l[1].type]
                  ) {
                    if (!(e = (i.find.ID(u.matches[0].replace(Z, tt), e) || [])[0])) return r;
                    f && (e = e.parentNode), (t = t.slice(l.shift().value.length));
                  }
                  for (s = Y.needsContext.test(t) ? 0 : l.length; s-- && ((u = l[s]), !i.relative[(c = u.type)]); )
                    if (
                      (d = i.find[c]) &&
                      (n = d(u.matches[0].replace(Z, tt), (J.test(l[0].type) && vt(e.parentNode)) || e))
                    ) {
                      if ((l.splice(s, 1), !(t = n.length && mt(l)))) return I.apply(r, n), r;
                      break;
                    }
                }
                return (f || o(t, h))(n, e, !v, r, !e || (J.test(t) && vt(e.parentNode)) || e), r;
              }),
            (r.sortStable = T.split('').sort(C).join('') === T),
            (r.detectDuplicates = !!d),
            f(),
            (r.sortDetached = lt(function (t) {
              return 1 & t.compareDocumentPosition(h.createElement('fieldset'));
            })),
            lt(function (t) {
              return (t.innerHTML = "<a href='#'></a>"), '#' === t.firstChild.getAttribute('href');
            }) ||
              ut('type|href|height|width', function (t, e, r) {
                if (!r) return t.getAttribute(e, 'type' === e.toLowerCase() ? 1 : 2);
              }),
            (r.attributes &&
              lt(function (t) {
                return (
                  (t.innerHTML = '<input/>'),
                  t.firstChild.setAttribute('value', ''),
                  '' === t.firstChild.getAttribute('value')
                );
              })) ||
              ut('value', function (t, e, r) {
                if (!r && 'input' === t.nodeName.toLowerCase()) return t.defaultValue;
              }),
            lt(function (t) {
              return null == t.getAttribute('disabled');
            }) ||
              ut(F, function (t, e, r) {
                let i;
                if (!r)
                  return !0 === t[e] ? e.toLowerCase() : (i = t.getAttributeNode(e)) && i.specified ? i.value : null;
              }),
            st
          );
        })(r);
      (L.find = k),
        (L.expr = k.selectors),
        (L.expr[':'] = L.expr.pseudos),
        (L.uniqueSort = L.unique = k.uniqueSort),
        (L.text = k.getText),
        (L.isXMLDoc = k.isXML),
        (L.contains = k.contains),
        (L.escapeSelector = k.escape);
      const C = function (t, e, r) {
          for (var i = [], n = void 0 !== r; (t = t[e]) && 9 !== t.nodeType; )
            if (1 === t.nodeType) {
              if (n && L(t).is(r)) break;
              i.push(t);
            }
          return i;
        },
        x = function (t, e) {
          for (var r = []; t; t = t.nextSibling) 1 === t.nodeType && t !== e && r.push(t);
          return r;
        },
        R = L.expr.match.needsContext;
      function w(t, e) {
        return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase();
      }
      const _ = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
      function I(t, e, r) {
        return y(e)
          ? L.grep(t, function (t, i) {
              return !!e.call(t, i, t) !== r;
            })
          : e.nodeType
            ? L.grep(t, function (t) {
                return (t === e) !== r;
              })
            : 'string' != typeof e
              ? L.grep(t, function (t) {
                  return d.call(e, t) > -1 !== r;
                })
              : L.filter(e, t, r);
      }
      (L.filter = function (t, e, r) {
        const i = e[0];
        return (
          r && (t = ':not(' + t + ')'),
          1 === e.length && 1 === i.nodeType
            ? L.find.matchesSelector(i, t)
              ? [i]
              : []
            : L.find.matches(
                t,
                L.grep(e, function (t) {
                  return 1 === t.nodeType;
                })
              )
        );
      }),
        L.fn.extend({
          find: function (t) {
            let e,
              r,
              i = this.length,
              n = this;
            if ('string' != typeof t)
              return this.pushStack(
                L(t).filter(function () {
                  for (e = 0; e < i; e++) if (L.contains(n[e], this)) return !0;
                })
              );
            for (r = this.pushStack([]), e = 0; e < i; e++) L.find(t, n[e], r);
            return i > 1 ? L.uniqueSort(r) : r;
          },
          filter: function (t) {
            return this.pushStack(I(this, t || [], !1));
          },
          not: function (t) {
            return this.pushStack(I(this, t || [], !0));
          },
          is: function (t) {
            return !!I(this, 'string' == typeof t && R.test(t) ? L(t) : t || [], !1).length;
          },
        });
      let O,
        P = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
      ((L.fn.init = function (t, e, r) {
        let i, n;
        if (!t) return this;
        if (((r = r || O), 'string' == typeof t)) {
          if (
            !(i = '<' === t[0] && '>' === t[t.length - 1] && t.length >= 3 ? [null, t, null] : P.exec(t)) ||
            (!i[1] && e)
          )
            return !e || e.jquery ? (e || r).find(t) : this.constructor(e).find(t);
          if (i[1]) {
            if (
              ((e = e instanceof L ? e[0] : e),
              L.merge(this, L.parseHTML(i[1], e && e.nodeType ? e.ownerDocument || e : a, !0)),
              _.test(i[1]) && L.isPlainObject(e))
            )
              for (i in e) y(this[i]) ? this[i](e[i]) : this.attr(i, e[i]);
            return this;
          }
          return (n = a.getElementById(i[2])) && ((this[0] = n), (this.length = 1)), this;
        }
        return t.nodeType
          ? ((this[0] = t), (this.length = 1), this)
          : y(t)
            ? void 0 !== r.ready
              ? r.ready(t)
              : t(L)
            : L.makeArray(t, this);
      }).prototype = L.fn),
        (O = L(a));
      const F = /^(?:parents|prev(?:Until|All))/,
        M = { children: !0, contents: !0, next: !0, prev: !0 };
      function N(t, e) {
        for (; (t = t[e]) && 1 !== t.nodeType; );
        return t;
      }
      L.fn.extend({
        has: function (t) {
          const e = L(t, this),
            r = e.length;
          return this.filter(function () {
            for (let t = 0; t < r; t++) if (L.contains(this, e[t])) return !0;
          });
        },
        closest: function (t, e) {
          let r,
            i = 0,
            n = this.length,
            s = [],
            a = 'string' != typeof t && L(t);
          if (!R.test(t))
            for (; i < n; i++)
              for (r = this[i]; r && r !== e; r = r.parentNode)
                if (r.nodeType < 11 && (a ? a.index(r) > -1 : 1 === r.nodeType && L.find.matchesSelector(r, t))) {
                  s.push(r);
                  break;
                }
          return this.pushStack(s.length > 1 ? L.uniqueSort(s) : s);
        },
        index: function (t) {
          return t
            ? 'string' == typeof t
              ? d.call(L(t), this[0])
              : d.call(this, t.jquery ? t[0] : t)
            : this[0] && this[0].parentNode
              ? this.first().prevAll().length
              : -1;
        },
        add: function (t, e) {
          return this.pushStack(L.uniqueSort(L.merge(this.get(), L(t, e))));
        },
        addBack: function (t) {
          return this.add(null == t ? this.prevObject : this.prevObject.filter(t));
        },
      }),
        L.each(
          {
            parent: function (t) {
              const e = t.parentNode;
              return e && 11 !== e.nodeType ? e : null;
            },
            parents: function (t) {
              return C(t, 'parentNode');
            },
            parentsUntil: function (t, e, r) {
              return C(t, 'parentNode', r);
            },
            next: function (t) {
              return N(t, 'nextSibling');
            },
            prev: function (t) {
              return N(t, 'previousSibling');
            },
            nextAll: function (t) {
              return C(t, 'nextSibling');
            },
            prevAll: function (t) {
              return C(t, 'previousSibling');
            },
            nextUntil: function (t, e, r) {
              return C(t, 'nextSibling', r);
            },
            prevUntil: function (t, e, r) {
              return C(t, 'previousSibling', r);
            },
            siblings: function (t) {
              return x((t.parentNode || {}).firstChild, t);
            },
            children: function (t) {
              return x(t.firstChild);
            },
            contents: function (t) {
              return w(t, 'iframe')
                ? t.contentDocument
                : (w(t, 'template') && (t = t.content || t), L.merge([], t.childNodes));
            },
          },
          function (t, e) {
            L.fn[t] = function (r, i) {
              let n = L.map(this, e, r);
              return (
                'Until' !== t.slice(-5) && (i = r),
                i && 'string' == typeof i && (n = L.filter(i, n)),
                this.length > 1 && (M[t] || L.uniqueSort(n), F.test(t) && n.reverse()),
                this.pushStack(n)
              );
            };
          }
        );
      const B = /[^\x20\t\r\n\f]+/g;
      function U(t) {
        return t;
      }
      function j(t) {
        throw t;
      }
      function G(t, e, r, i) {
        let n;
        try {
          t && y((n = t.promise))
            ? n.call(t).done(e).fail(r)
            : t && y((n = t.then))
              ? n.call(t, e, r)
              : e.apply(void 0, [t].slice(i));
        } catch (t) {
          r.apply(void 0, [t]);
        }
      }
      (L.Callbacks = function (t) {
        t =
          'string' == typeof t
            ? (function (t) {
                const e = {};
                return (
                  L.each(t.match(B) || [], function (t, r) {
                    e[r] = !0;
                  }),
                  e
                );
              })(t)
            : L.extend({}, t);
        var e,
          r,
          i,
          n,
          s = [],
          a = [],
          o = -1,
          l = function () {
            for (n = n || t.once, i = e = !0; a.length; o = -1)
              for (r = a.shift(); ++o < s.length; )
                !1 === s[o].apply(r[0], r[1]) && t.stopOnFalse && ((o = s.length), (r = !1));
            t.memory || (r = !1), (e = !1), n && (s = r ? [] : '');
          },
          u = {
            add: function () {
              return (
                s &&
                  (r && !e && ((o = s.length - 1), a.push(r)),
                  (function e(r) {
                    L.each(r, function (r, i) {
                      y(i) ? (t.unique && u.has(i)) || s.push(i) : i && i.length && 'string' !== S(i) && e(i);
                    });
                  })(arguments),
                  r && !e && l()),
                this
              );
            },
            remove: function () {
              return (
                L.each(arguments, function (t, e) {
                  for (var r; (r = L.inArray(e, s, r)) > -1; ) s.splice(r, 1), r <= o && o--;
                }),
                this
              );
            },
            has: function (t) {
              return t ? L.inArray(t, s) > -1 : s.length > 0;
            },
            empty: function () {
              return s && (s = []), this;
            },
            disable: function () {
              return (n = a = []), (s = r = ''), this;
            },
            disabled: function () {
              return !s;
            },
            lock: function () {
              return (n = a = []), r || e || (s = r = ''), this;
            },
            locked: function () {
              return !!n;
            },
            fireWith: function (t, r) {
              return n || ((r = [t, (r = r || []).slice ? r.slice() : r]), a.push(r), e || l()), this;
            },
            fire: function () {
              return u.fireWith(this, arguments), this;
            },
            fired: function () {
              return !!i;
            },
          };
        return u;
      }),
        L.extend({
          Deferred: function (t) {
            var e = [
                ['notify', 'progress', L.Callbacks('memory'), L.Callbacks('memory'), 2],
                ['resolve', 'done', L.Callbacks('once memory'), L.Callbacks('once memory'), 0, 'resolved'],
                ['reject', 'fail', L.Callbacks('once memory'), L.Callbacks('once memory'), 1, 'rejected'],
              ],
              i = 'pending',
              n = {
                state: function () {
                  return i;
                },
                always: function () {
                  return s.done(arguments).fail(arguments), this;
                },
                catch: function (t) {
                  return n.then(null, t);
                },
                pipe: function () {
                  let t = arguments;
                  return L.Deferred(function (r) {
                    L.each(e, function (e, i) {
                      const n = y(t[i[4]]) && t[i[4]];
                      s[i[1]](function () {
                        const t = n && n.apply(this, arguments);
                        t && y(t.promise)
                          ? t.promise().progress(r.notify).done(r.resolve).fail(r.reject)
                          : r[i[0] + 'With'](this, n ? [t] : arguments);
                      });
                    }),
                      (t = null);
                  }).promise();
                },
                then: function (t, i, n) {
                  let s = 0;
                  function a(t, e, i, n) {
                    return function () {
                      var o = this,
                        l = arguments,
                        u = function () {
                          let r, u;
                          if (!(t < s)) {
                            if ((r = i.apply(o, l)) === e.promise()) throw new TypeError('Thenable self-resolution');
                            (u = r && ('object' == typeof r || 'function' == typeof r) && r.then),
                              y(u)
                                ? n
                                  ? u.call(r, a(s, e, U, n), a(s, e, j, n))
                                  : (s++, u.call(r, a(s, e, U, n), a(s, e, j, n), a(s, e, U, e.notifyWith)))
                                : (i !== U && ((o = void 0), (l = [r])), (n || e.resolveWith)(o, l));
                          }
                        },
                        c = n
                          ? u
                          : function () {
                              try {
                                u();
                              } catch (r) {
                                L.Deferred.exceptionHook && L.Deferred.exceptionHook(r, c.stackTrace),
                                  t + 1 >= s && (i !== j && ((o = void 0), (l = [r])), e.rejectWith(o, l));
                              }
                            };
                      t
                        ? c()
                        : (L.Deferred.getStackHook && (c.stackTrace = L.Deferred.getStackHook()), r.setTimeout(c));
                    };
                  }
                  return L.Deferred(function (r) {
                    e[0][3].add(a(0, r, y(n) ? n : U, r.notifyWith)),
                      e[1][3].add(a(0, r, y(t) ? t : U)),
                      e[2][3].add(a(0, r, y(i) ? i : j));
                  }).promise();
                },
                promise: function (t) {
                  return null != t ? L.extend(t, n) : n;
                },
              },
              s = {};
            return (
              L.each(e, function (t, r) {
                const a = r[2],
                  o = r[5];
                (n[r[1]] = a.add),
                  o &&
                    a.add(
                      function () {
                        i = o;
                      },
                      e[3 - t][2].disable,
                      e[3 - t][3].disable,
                      e[0][2].lock,
                      e[0][3].lock
                    ),
                  a.add(r[3].fire),
                  (s[r[0]] = function () {
                    return s[r[0] + 'With'](this === s ? void 0 : this, arguments), this;
                  }),
                  (s[r[0] + 'With'] = a.fireWith);
              }),
              n.promise(s),
              t && t.call(s, s),
              s
            );
          },
          when: function (t) {
            let e = arguments.length,
              r = e,
              i = Array(r),
              n = l.call(arguments),
              s = L.Deferred(),
              a = function (t) {
                return function (r) {
                  (i[t] = this), (n[t] = arguments.length > 1 ? l.call(arguments) : r), --e || s.resolveWith(i, n);
                };
              };
            if (e <= 1 && (G(t, s.done(a(r)).resolve, s.reject, !e), 'pending' === s.state() || y(n[r] && n[r].then)))
              return s.then();
            for (; r--; ) G(n[r], a(r), s.reject);
            return s.promise();
          },
        });
      const H = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
      (L.Deferred.exceptionHook = function (t, e) {
        r.console &&
          r.console.warn &&
          t &&
          H.test(t.name) &&
          r.console.warn('jQuery.Deferred exception: ' + t.message, t.stack, e);
      }),
        (L.readyException = function (t) {
          r.setTimeout(function () {
            throw t;
          });
        });
      const K = L.Deferred();
      function V() {
        a.removeEventListener('DOMContentLoaded', V), r.removeEventListener('load', V), L.ready();
      }
      (L.fn.ready = function (t) {
        return (
          K.then(t).catch(function (t) {
            L.readyException(t);
          }),
          this
        );
      }),
        L.extend({
          isReady: !1,
          readyWait: 1,
          ready: function (t) {
            (!0 === t ? --L.readyWait : L.isReady) ||
              ((L.isReady = !0), (!0 !== t && --L.readyWait > 0) || K.resolveWith(a, [L]));
          },
        }),
        (L.ready.then = K.then),
        'complete' === a.readyState || ('loading' !== a.readyState && !a.documentElement.doScroll)
          ? r.setTimeout(L.ready)
          : (a.addEventListener('DOMContentLoaded', V), r.addEventListener('load', V));
      const q = function (t, e, r, i, n, s, a) {
          let o = 0,
            l = t.length,
            u = null == r;
          if ('object' === S(r)) for (o in ((n = !0), r)) q(t, e, o, r[o], !0, s, a);
          else if (
            void 0 !== i &&
            ((n = !0),
            y(i) || (a = !0),
            u &&
              (a
                ? (e.call(t, i), (e = null))
                : ((u = e),
                  (e = function (t, e, r) {
                    return u.call(L(t), r);
                  }))),
            e)
          )
            for (; o < l; o++) e(t[o], r, a ? i : i.call(t[o], o, e(t[o], r)));
          return n ? t : u ? e.call(t) : l ? e(t[0], r) : s;
        },
        W = /^-ms-/,
        Y = /-([a-z])/g;
      function X(t, e) {
        return e.toUpperCase();
      }
      function z(t) {
        return t.replace(W, 'ms-').replace(Y, X);
      }
      const $ = function (t) {
        return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType;
      };
      function Q() {
        this.expando = L.expando + Q.uid++;
      }
      (Q.uid = 1),
        (Q.prototype = {
          cache: function (t) {
            let e = t[this.expando];
            return (
              e ||
                ((e = {}),
                $(t) &&
                  (t.nodeType
                    ? (t[this.expando] = e)
                    : Object.defineProperty(t, this.expando, { value: e, configurable: !0 }))),
              e
            );
          },
          set: function (t, e, r) {
            let i,
              n = this.cache(t);
            if ('string' == typeof e) n[z(e)] = r;
            else for (i in e) n[z(i)] = e[i];
            return n;
          },
          get: function (t, e) {
            return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][z(e)];
          },
          access: function (t, e, r) {
            return void 0 === e || (e && 'string' == typeof e && void 0 === r)
              ? this.get(t, e)
              : (this.set(t, e, r), void 0 !== r ? r : e);
          },
          remove: function (t, e) {
            let r,
              i = t[this.expando];
            if (void 0 !== i) {
              if (void 0 !== e) {
                r = (e = Array.isArray(e) ? e.map(z) : (e = z(e)) in i ? [e] : e.match(B) || []).length;
                for (; r--; ) delete i[e[r]];
              }
              (void 0 === e || L.isEmptyObject(i)) &&
                (t.nodeType ? (t[this.expando] = void 0) : delete t[this.expando]);
            }
          },
          hasData: function (t) {
            const e = t[this.expando];
            return void 0 !== e && !L.isEmptyObject(e);
          },
        });
      const J = new Q(),
        Z = new Q(),
        tt = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        et = /[A-Z]/g;
      function rt(t, e, r) {
        let i;
        if (void 0 === r && 1 === t.nodeType)
          if (((i = 'data-' + e.replace(et, '-$&').toLowerCase()), 'string' == typeof (r = t.getAttribute(i)))) {
            try {
              r = (function (t) {
                return (
                  'true' === t ||
                  ('false' !== t && ('null' === t ? null : t === +t + '' ? +t : tt.test(t) ? JSON.parse(t) : t))
                );
              })(r);
            } catch (t) {}
            Z.set(t, e, r);
          } else r = void 0;
        return r;
      }
      L.extend({
        hasData: function (t) {
          return Z.hasData(t) || J.hasData(t);
        },
        data: function (t, e, r) {
          return Z.access(t, e, r);
        },
        removeData: function (t, e) {
          Z.remove(t, e);
        },
        _data: function (t, e, r) {
          return J.access(t, e, r);
        },
        _removeData: function (t, e) {
          J.remove(t, e);
        },
      }),
        L.fn.extend({
          data: function (t, e) {
            let r,
              i,
              n,
              s = this[0],
              a = s && s.attributes;
            if (void 0 === t) {
              if (this.length && ((n = Z.get(s)), 1 === s.nodeType && !J.get(s, 'hasDataAttrs'))) {
                for (r = a.length; r--; )
                  a[r] && 0 === (i = a[r].name).indexOf('data-') && ((i = z(i.slice(5))), rt(s, i, n[i]));
                J.set(s, 'hasDataAttrs', !0);
              }
              return n;
            }
            return 'object' == typeof t
              ? this.each(function () {
                  Z.set(this, t);
                })
              : q(
                  this,
                  function (e) {
                    let r;
                    if (s && void 0 === e)
                      return void 0 !== (r = Z.get(s, t)) ? r : void 0 !== (r = rt(s, t)) ? r : void 0;
                    this.each(function () {
                      Z.set(this, t, e);
                    });
                  },
                  null,
                  e,
                  arguments.length > 1,
                  null,
                  !0
                );
          },
          removeData: function (t) {
            return this.each(function () {
              Z.remove(this, t);
            });
          },
        }),
        L.extend({
          queue: function (t, e, r) {
            let i;
            if (t)
              return (
                (e = (e || 'fx') + 'queue'),
                (i = J.get(t, e)),
                r && (!i || Array.isArray(r) ? (i = J.access(t, e, L.makeArray(r))) : i.push(r)),
                i || []
              );
          },
          dequeue: function (t, e) {
            e = e || 'fx';
            let r = L.queue(t, e),
              i = r.length,
              n = r.shift(),
              s = L._queueHooks(t, e);
            'inprogress' === n && ((n = r.shift()), i--),
              n &&
                ('fx' === e && r.unshift('inprogress'),
                delete s.stop,
                n.call(
                  t,
                  function () {
                    L.dequeue(t, e);
                  },
                  s
                )),
              !i && s && s.empty.fire();
          },
          _queueHooks: function (t, e) {
            const r = e + 'queueHooks';
            return (
              J.get(t, r) ||
              J.access(t, r, {
                empty: L.Callbacks('once memory').add(function () {
                  J.remove(t, [e + 'queue', r]);
                }),
              })
            );
          },
        }),
        L.fn.extend({
          queue: function (t, e) {
            let r = 2;
            return (
              'string' != typeof t && ((e = t), (t = 'fx'), r--),
              arguments.length < r
                ? L.queue(this[0], t)
                : void 0 === e
                  ? this
                  : this.each(function () {
                      const r = L.queue(this, t, e);
                      L._queueHooks(this, t), 'fx' === t && 'inprogress' !== r[0] && L.dequeue(this, t);
                    })
            );
          },
          dequeue: function (t) {
            return this.each(function () {
              L.dequeue(this, t);
            });
          },
          clearQueue: function (t) {
            return this.queue(t || 'fx', []);
          },
          promise: function (t, e) {
            let r,
              i = 1,
              n = L.Deferred(),
              s = this,
              a = this.length,
              o = function () {
                --i || n.resolveWith(s, [s]);
              };
            for ('string' != typeof t && ((e = t), (t = void 0)), t = t || 'fx'; a--; )
              (r = J.get(s[a], t + 'queueHooks')) && r.empty && (i++, r.empty.add(o));
            return o(), n.promise(e);
          },
        });
      const it = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        nt = new RegExp('^(?:([+-])=|)(' + it + ')([a-z%]*)$', 'i'),
        st = ['Top', 'Right', 'Bottom', 'Left'],
        at = function (t, e) {
          return (
            'none' === (t = e || t).style.display ||
            ('' === t.style.display && L.contains(t.ownerDocument, t) && 'none' === L.css(t, 'display'))
          );
        },
        ot = function (t, e, r, i) {
          let n,
            s,
            a = {};
          for (s in e) (a[s] = t.style[s]), (t.style[s] = e[s]);
          for (s in ((n = r.apply(t, i || [])), e)) t.style[s] = a[s];
          return n;
        };
      function lt(t, e, r, i) {
        let n,
          s,
          a = 20,
          o = i
            ? function () {
                return i.cur();
              }
            : function () {
                return L.css(t, e, '');
              },
          l = o(),
          u = (r && r[3]) || (L.cssNumber[e] ? '' : 'px'),
          c = (L.cssNumber[e] || ('px' !== u && +l)) && nt.exec(L.css(t, e));
        if (c && c[3] !== u) {
          for (l /= 2, u = u || c[3], c = +l || 1; a--; )
            L.style(t, e, c + u), (1 - s) * (1 - (s = o() / l || 0.5)) <= 0 && (a = 0), (c /= s);
          (c *= 2), L.style(t, e, c + u), (r = r || []);
        }
        return (
          r &&
            ((c = +c || +l || 0),
            (n = r[1] ? c + (r[1] + 1) * r[2] : +r[2]),
            i && ((i.unit = u), (i.start = c), (i.end = n))),
          n
        );
      }
      const ut = {};
      function ct(t) {
        let e,
          r = t.ownerDocument,
          i = t.nodeName,
          n = ut[i];
        return (
          n ||
          ((e = r.body.appendChild(r.createElement(i))),
          (n = L.css(e, 'display')),
          e.parentNode.removeChild(e),
          'none' === n && (n = 'block'),
          (ut[i] = n),
          n)
        );
      }
      function dt(t, e) {
        for (var r, i, n = [], s = 0, a = t.length; s < a; s++)
          (i = t[s]).style &&
            ((r = i.style.display),
            e
              ? ('none' === r && ((n[s] = J.get(i, 'display') || null), n[s] || (i.style.display = '')),
                '' === i.style.display && at(i) && (n[s] = ct(i)))
              : 'none' !== r && ((n[s] = 'none'), J.set(i, 'display', r)));
        for (s = 0; s < a; s++) null != n[s] && (t[s].style.display = n[s]);
        return t;
      }
      L.fn.extend({
        show: function () {
          return dt(this, !0);
        },
        hide: function () {
          return dt(this);
        },
        toggle: function (t) {
          return 'boolean' == typeof t
            ? t
              ? this.show()
              : this.hide()
            : this.each(function () {
                at(this) ? L(this).show() : L(this).hide();
              });
        },
      });
      const ft = /^(?:checkbox|radio)$/i,
        ht = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i,
        pt = /^$|^module$|\/(?:java|ecma)script/i,
        vt = {
          option: [1, "<select multiple='multiple'>", '</select>'],
          thead: [1, '<table>', '</table>'],
          col: [2, '<table><colgroup>', '</colgroup></table>'],
          tr: [2, '<table><tbody>', '</tbody></table>'],
          td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],
          _default: [0, '', ''],
        };
      function gt(t, e) {
        let r;
        return (
          (r =
            void 0 !== t.getElementsByTagName
              ? t.getElementsByTagName(e || '*')
              : void 0 !== t.querySelectorAll
                ? t.querySelectorAll(e || '*')
                : []),
          void 0 === e || (e && w(t, e)) ? L.merge([t], r) : r
        );
      }
      function mt(t, e) {
        for (let r = 0, i = t.length; r < i; r++) J.set(t[r], 'globalEval', !e || J.get(e[r], 'globalEval'));
      }
      (vt.optgroup = vt.option), (vt.tbody = vt.tfoot = vt.colgroup = vt.caption = vt.thead), (vt.th = vt.td);
      const yt = /<|&#?\w+;/;
      function Et(t, e, r, i, n) {
        for (var s, a, o, l, u, c, d = e.createDocumentFragment(), f = [], h = 0, p = t.length; h < p; h++)
          if ((s = t[h]) || 0 === s)
            if ('object' === S(s)) L.merge(f, s.nodeType ? [s] : s);
            else if (yt.test(s)) {
              for (
                a = a || d.appendChild(e.createElement('div')),
                  o = (ht.exec(s) || ['', ''])[1].toLowerCase(),
                  l = vt[o] || vt._default,
                  a.innerHTML = l[1] + L.htmlPrefilter(s) + l[2],
                  c = l[0];
                c--;

              )
                a = a.lastChild;
              L.merge(f, a.childNodes), ((a = d.firstChild).textContent = '');
            } else f.push(e.createTextNode(s));
        for (d.textContent = '', h = 0; (s = f[h++]); )
          if (i && L.inArray(s, i) > -1) n && n.push(s);
          else if (((u = L.contains(s.ownerDocument, s)), (a = gt(d.appendChild(s), 'script')), u && mt(a), r))
            for (c = 0; (s = a[c++]); ) pt.test(s.type || '') && r.push(s);
        return d;
      }
      !(function () {
        const t = a.createDocumentFragment().appendChild(a.createElement('div')),
          e = a.createElement('input');
        e.setAttribute('type', 'radio'),
          e.setAttribute('checked', 'checked'),
          e.setAttribute('name', 't'),
          t.appendChild(e),
          (m.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked),
          (t.innerHTML = '<textarea>x</textarea>'),
          (m.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue);
      })();
      const Tt = a.documentElement,
        bt = /^key/,
        St = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        Lt = /^([^.]*)(?:\.(.+)|)/;
      function At() {
        return !0;
      }
      function Dt() {
        return !1;
      }
      function kt() {
        try {
          return a.activeElement;
        } catch (t) {}
      }
      function Ct(t, e, r, i, n, s) {
        let a, o;
        if ('object' == typeof e) {
          for (o in ('string' != typeof r && ((i = i || r), (r = void 0)), e)) Ct(t, o, r, i, e[o], s);
          return t;
        }
        if (
          (null == i && null == n
            ? ((n = r), (i = r = void 0))
            : null == n && ('string' == typeof r ? ((n = i), (i = void 0)) : ((n = i), (i = r), (r = void 0))),
          !1 === n)
        )
          n = Dt;
        else if (!n) return t;
        return (
          1 === s &&
            ((a = n),
            ((n = function (t) {
              return L().off(t), a.apply(this, arguments);
            }).guid = a.guid || (a.guid = L.guid++))),
          t.each(function () {
            L.event.add(this, e, n, i, r);
          })
        );
      }
      (L.event = {
        global: {},
        add: function (t, e, r, i, n) {
          let s,
            a,
            o,
            l,
            u,
            c,
            d,
            f,
            h,
            p,
            v,
            g = J.get(t);
          if (g)
            for (
              r.handler && ((r = (s = r).handler), (n = s.selector)),
                n && L.find.matchesSelector(Tt, n),
                r.guid || (r.guid = L.guid++),
                (l = g.events) || (l = g.events = {}),
                (a = g.handle) ||
                  (a = g.handle =
                    function (e) {
                      return void 0 !== L && L.event.triggered !== e.type
                        ? L.event.dispatch.apply(t, arguments)
                        : void 0;
                    }),
                u = (e = (e || '').match(B) || ['']).length;
              u--;

            )
              (h = v = (o = Lt.exec(e[u]) || [])[1]),
                (p = (o[2] || '').split('.').sort()),
                h &&
                  ((d = L.event.special[h] || {}),
                  (h = (n ? d.delegateType : d.bindType) || h),
                  (d = L.event.special[h] || {}),
                  (c = L.extend(
                    {
                      type: h,
                      origType: v,
                      data: i,
                      handler: r,
                      guid: r.guid,
                      selector: n,
                      needsContext: n && L.expr.match.needsContext.test(n),
                      namespace: p.join('.'),
                    },
                    s
                  )),
                  (f = l[h]) ||
                    (((f = l[h] = []).delegateCount = 0),
                    (d.setup && !1 !== d.setup.call(t, i, p, a)) || (t.addEventListener && t.addEventListener(h, a))),
                  d.add && (d.add.call(t, c), c.handler.guid || (c.handler.guid = r.guid)),
                  n ? f.splice(f.delegateCount++, 0, c) : f.push(c),
                  (L.event.global[h] = !0));
        },
        remove: function (t, e, r, i, n) {
          let s,
            a,
            o,
            l,
            u,
            c,
            d,
            f,
            h,
            p,
            v,
            g = J.hasData(t) && J.get(t);
          if (g && (l = g.events)) {
            for (u = (e = (e || '').match(B) || ['']).length; u--; )
              if (((h = v = (o = Lt.exec(e[u]) || [])[1]), (p = (o[2] || '').split('.').sort()), h)) {
                for (
                  d = L.event.special[h] || {},
                    f = l[(h = (i ? d.delegateType : d.bindType) || h)] || [],
                    o = o[2] && new RegExp('(^|\\.)' + p.join('\\.(?:.*\\.|)') + '(\\.|$)'),
                    a = s = f.length;
                  s--;

                )
                  (c = f[s]),
                    (!n && v !== c.origType) ||
                      (r && r.guid !== c.guid) ||
                      (o && !o.test(c.namespace)) ||
                      (i && i !== c.selector && ('**' !== i || !c.selector)) ||
                      (f.splice(s, 1), c.selector && f.delegateCount--, d.remove && d.remove.call(t, c));
                a &&
                  !f.length &&
                  ((d.teardown && !1 !== d.teardown.call(t, p, g.handle)) || L.removeEvent(t, h, g.handle),
                  delete l[h]);
              } else for (h in l) L.event.remove(t, h + e[u], r, i, !0);
            L.isEmptyObject(l) && J.remove(t, 'handle events');
          }
        },
        dispatch: function (t) {
          let e,
            r,
            i,
            n,
            s,
            a,
            o = L.event.fix(t),
            l = new Array(arguments.length),
            u = (J.get(this, 'events') || {})[o.type] || [],
            c = L.event.special[o.type] || {};
          for (l[0] = o, e = 1; e < arguments.length; e++) l[e] = arguments[e];
          if (((o.delegateTarget = this), !c.preDispatch || !1 !== c.preDispatch.call(this, o))) {
            for (a = L.event.handlers.call(this, o, u), e = 0; (n = a[e++]) && !o.isPropagationStopped(); )
              for (o.currentTarget = n.elem, r = 0; (s = n.handlers[r++]) && !o.isImmediatePropagationStopped(); )
                (o.rnamespace && !o.rnamespace.test(s.namespace)) ||
                  ((o.handleObj = s),
                  (o.data = s.data),
                  void 0 !== (i = ((L.event.special[s.origType] || {}).handle || s.handler).apply(n.elem, l)) &&
                    !1 === (o.result = i) &&
                    (o.preventDefault(), o.stopPropagation()));
            return c.postDispatch && c.postDispatch.call(this, o), o.result;
          }
        },
        handlers: function (t, e) {
          let r,
            i,
            n,
            s,
            a,
            o = [],
            l = e.delegateCount,
            u = t.target;
          if (l && u.nodeType && !('click' === t.type && t.button >= 1))
            for (; u !== this; u = u.parentNode || this)
              if (1 === u.nodeType && ('click' !== t.type || !0 !== u.disabled)) {
                for (s = [], a = {}, r = 0; r < l; r++)
                  void 0 === a[(n = (i = e[r]).selector + ' ')] &&
                    (a[n] = i.needsContext ? L(n, this).index(u) > -1 : L.find(n, this, null, [u]).length),
                    a[n] && s.push(i);
                s.length && o.push({ elem: u, handlers: s });
              }
          return (u = this), l < e.length && o.push({ elem: u, handlers: e.slice(l) }), o;
        },
        addProp: function (t, e) {
          Object.defineProperty(L.Event.prototype, t, {
            enumerable: !0,
            configurable: !0,
            get: y(e)
              ? function () {
                  if (this.originalEvent) return e(this.originalEvent);
                }
              : function () {
                  if (this.originalEvent) return this.originalEvent[t];
                },
            set: function (e) {
              Object.defineProperty(this, t, { enumerable: !0, configurable: !0, writable: !0, value: e });
            },
          });
        },
        fix: function (t) {
          return t[L.expando] ? t : new L.Event(t);
        },
        special: {
          load: { noBubble: !0 },
          focus: {
            trigger: function () {
              if (this !== kt() && this.focus) return this.focus(), !1;
            },
            delegateType: 'focusin',
          },
          blur: {
            trigger: function () {
              if (this === kt() && this.blur) return this.blur(), !1;
            },
            delegateType: 'focusout',
          },
          click: {
            trigger: function () {
              if ('checkbox' === this.type && this.click && w(this, 'input')) return this.click(), !1;
            },
            _default: function (t) {
              return w(t.target, 'a');
            },
          },
          beforeunload: {
            postDispatch: function (t) {
              void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result);
            },
          },
        },
      }),
        (L.removeEvent = function (t, e, r) {
          t.removeEventListener && t.removeEventListener(e, r);
        }),
        (L.Event = function (t, e) {
          if (!(this instanceof L.Event)) return new L.Event(t, e);
          t && t.type
            ? ((this.originalEvent = t),
              (this.type = t.type),
              (this.isDefaultPrevented =
                t.defaultPrevented || (void 0 === t.defaultPrevented && !1 === t.returnValue) ? At : Dt),
              (this.target = t.target && 3 === t.target.nodeType ? t.target.parentNode : t.target),
              (this.currentTarget = t.currentTarget),
              (this.relatedTarget = t.relatedTarget))
            : (this.type = t),
            e && L.extend(this, e),
            (this.timeStamp = (t && t.timeStamp) || Date.now()),
            (this[L.expando] = !0);
        }),
        (L.Event.prototype = {
          constructor: L.Event,
          isDefaultPrevented: Dt,
          isPropagationStopped: Dt,
          isImmediatePropagationStopped: Dt,
          isSimulated: !1,
          preventDefault: function () {
            const t = this.originalEvent;
            (this.isDefaultPrevented = At), t && !this.isSimulated && t.preventDefault();
          },
          stopPropagation: function () {
            const t = this.originalEvent;
            (this.isPropagationStopped = At), t && !this.isSimulated && t.stopPropagation();
          },
          stopImmediatePropagation: function () {
            const t = this.originalEvent;
            (this.isImmediatePropagationStopped = At),
              t && !this.isSimulated && t.stopImmediatePropagation(),
              this.stopPropagation();
          },
        }),
        L.each(
          {
            altKey: !0,
            bubbles: !0,
            cancelable: !0,
            changedTouches: !0,
            ctrlKey: !0,
            detail: !0,
            eventPhase: !0,
            metaKey: !0,
            pageX: !0,
            pageY: !0,
            shiftKey: !0,
            view: !0,
            char: !0,
            charCode: !0,
            key: !0,
            keyCode: !0,
            button: !0,
            buttons: !0,
            clientX: !0,
            clientY: !0,
            offsetX: !0,
            offsetY: !0,
            pointerId: !0,
            pointerType: !0,
            screenX: !0,
            screenY: !0,
            targetTouches: !0,
            toElement: !0,
            touches: !0,
            which: function (t) {
              const e = t.button;
              return null == t.which && bt.test(t.type)
                ? null != t.charCode
                  ? t.charCode
                  : t.keyCode
                : !t.which && void 0 !== e && St.test(t.type)
                  ? 1 & e
                    ? 1
                    : 2 & e
                      ? 3
                      : 4 & e
                        ? 2
                        : 0
                  : t.which;
            },
          },
          L.event.addProp
        ),
        L.each(
          { mouseenter: 'mouseover', mouseleave: 'mouseout', pointerenter: 'pointerover', pointerleave: 'pointerout' },
          function (t, e) {
            L.event.special[t] = {
              delegateType: e,
              bindType: e,
              handle: function (t) {
                let r,
                  i = t.relatedTarget,
                  n = t.handleObj;
                return (
                  (i && (i === this || L.contains(this, i))) ||
                    ((t.type = n.origType), (r = n.handler.apply(this, arguments)), (t.type = e)),
                  r
                );
              },
            };
          }
        ),
        L.fn.extend({
          on: function (t, e, r, i) {
            return Ct(this, t, e, r, i);
          },
          one: function (t, e, r, i) {
            return Ct(this, t, e, r, i, 1);
          },
          off: function (t, e, r) {
            let i, n;
            if (t && t.preventDefault && t.handleObj)
              return (
                (i = t.handleObj),
                L(t.delegateTarget).off(
                  i.namespace ? i.origType + '.' + i.namespace : i.origType,
                  i.selector,
                  i.handler
                ),
                this
              );
            if ('object' == typeof t) {
              for (n in t) this.off(n, e, t[n]);
              return this;
            }
            return (
              (!1 !== e && 'function' != typeof e) || ((r = e), (e = void 0)),
              !1 === r && (r = Dt),
              this.each(function () {
                L.event.remove(this, t, r, e);
              })
            );
          },
        });
      const xt = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
        Rt = /<script|<style|<link/i,
        wt = /checked\s*(?:[^=]|=\s*.checked.)/i,
        _t = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
      function It(t, e) {
        return (w(t, 'table') && w(11 !== e.nodeType ? e : e.firstChild, 'tr') && L(t).children('tbody')[0]) || t;
      }
      function Ot(t) {
        return (t.type = (null !== t.getAttribute('type')) + '/' + t.type), t;
      }
      function Pt(t) {
        return 'true/' === (t.type || '').slice(0, 5) ? (t.type = t.type.slice(5)) : t.removeAttribute('type'), t;
      }
      function Ft(t, e) {
        let r, i, n, s, a, o, l, u;
        if (1 === e.nodeType) {
          if (J.hasData(t) && ((s = J.access(t)), (a = J.set(e, s)), (u = s.events)))
            for (n in (delete a.handle, (a.events = {}), u))
              for (r = 0, i = u[n].length; r < i; r++) L.event.add(e, n, u[n][r]);
          Z.hasData(t) && ((o = Z.access(t)), (l = L.extend({}, o)), Z.set(e, l));
        }
      }
      function Mt(t, e) {
        const r = e.nodeName.toLowerCase();
        'input' === r && ft.test(t.type)
          ? (e.checked = t.checked)
          : ('input' !== r && 'textarea' !== r) || (e.defaultValue = t.defaultValue);
      }
      function Nt(t, e, r, i) {
        e = u.apply([], e);
        let n,
          s,
          a,
          o,
          l,
          c,
          d = 0,
          f = t.length,
          h = f - 1,
          p = e[0],
          v = y(p);
        if (v || (f > 1 && 'string' == typeof p && !m.checkClone && wt.test(p)))
          return t.each(function (n) {
            const s = t.eq(n);
            v && (e[0] = p.call(this, n, s.html())), Nt(s, e, r, i);
          });
        if (
          f &&
          ((s = (n = Et(e, t[0].ownerDocument, !1, t, i)).firstChild), 1 === n.childNodes.length && (n = s), s || i)
        ) {
          for (o = (a = L.map(gt(n, 'script'), Ot)).length; d < f; d++)
            (l = n), d !== h && ((l = L.clone(l, !0, !0)), o && L.merge(a, gt(l, 'script'))), r.call(t[d], l, d);
          if (o)
            for (c = a[a.length - 1].ownerDocument, L.map(a, Pt), d = 0; d < o; d++)
              (l = a[d]),
                pt.test(l.type || '') &&
                  !J.access(l, 'globalEval') &&
                  L.contains(c, l) &&
                  (l.src && 'module' !== (l.type || '').toLowerCase()
                    ? L._evalUrl && L._evalUrl(l.src)
                    : b(l.textContent.replace(_t, ''), c, l));
        }
        return t;
      }
      function Bt(t, e, r) {
        for (var i, n = e ? L.filter(e, t) : t, s = 0; null != (i = n[s]); s++)
          r || 1 !== i.nodeType || L.cleanData(gt(i)),
            i.parentNode && (r && L.contains(i.ownerDocument, i) && mt(gt(i, 'script')), i.parentNode.removeChild(i));
        return t;
      }
      L.extend({
        htmlPrefilter: function (t) {
          return t.replace(xt, '<$1></$2>');
        },
        clone: function (t, e, r) {
          let i,
            n,
            s,
            a,
            o = t.cloneNode(!0),
            l = L.contains(t.ownerDocument, t);
          if (!(m.noCloneChecked || (1 !== t.nodeType && 11 !== t.nodeType) || L.isXMLDoc(t)))
            for (a = gt(o), i = 0, n = (s = gt(t)).length; i < n; i++) Mt(s[i], a[i]);
          if (e)
            if (r) for (s = s || gt(t), a = a || gt(o), i = 0, n = s.length; i < n; i++) Ft(s[i], a[i]);
            else Ft(t, o);
          return (a = gt(o, 'script')).length > 0 && mt(a, !l && gt(t, 'script')), o;
        },
        cleanData: function (t) {
          for (var e, r, i, n = L.event.special, s = 0; void 0 !== (r = t[s]); s++)
            if ($(r)) {
              if ((e = r[J.expando])) {
                if (e.events) for (i in e.events) n[i] ? L.event.remove(r, i) : L.removeEvent(r, i, e.handle);
                r[J.expando] = void 0;
              }
              r[Z.expando] && (r[Z.expando] = void 0);
            }
        },
      }),
        L.fn.extend({
          detach: function (t) {
            return Bt(this, t, !0);
          },
          remove: function (t) {
            return Bt(this, t);
          },
          text: function (t) {
            return q(
              this,
              function (t) {
                return void 0 === t
                  ? L.text(this)
                  : this.empty().each(function () {
                      (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (this.textContent = t);
                    });
              },
              null,
              t,
              arguments.length
            );
          },
          append: function () {
            return Nt(this, arguments, function (t) {
              (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || It(this, t).appendChild(t);
            });
          },
          prepend: function () {
            return Nt(this, arguments, function (t) {
              if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                const e = It(this, t);
                e.insertBefore(t, e.firstChild);
              }
            });
          },
          before: function () {
            return Nt(this, arguments, function (t) {
              this.parentNode && this.parentNode.insertBefore(t, this);
            });
          },
          after: function () {
            return Nt(this, arguments, function (t) {
              this.parentNode && this.parentNode.insertBefore(t, this.nextSibling);
            });
          },
          empty: function () {
            for (var t, e = 0; null != (t = this[e]); e++)
              1 === t.nodeType && (L.cleanData(gt(t, !1)), (t.textContent = ''));
            return this;
          },
          clone: function (t, e) {
            return (
              (t = null != t && t),
              (e = null == e ? t : e),
              this.map(function () {
                return L.clone(this, t, e);
              })
            );
          },
          html: function (t) {
            return q(
              this,
              function (t) {
                let e = this[0] || {},
                  r = 0,
                  i = this.length;
                if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
                if ('string' == typeof t && !Rt.test(t) && !vt[(ht.exec(t) || ['', ''])[1].toLowerCase()]) {
                  t = L.htmlPrefilter(t);
                  try {
                    for (; r < i; r++)
                      1 === (e = this[r] || {}).nodeType && (L.cleanData(gt(e, !1)), (e.innerHTML = t));
                    e = 0;
                  } catch (t) {}
                }
                e && this.empty().append(t);
              },
              null,
              t,
              arguments.length
            );
          },
          replaceWith: function () {
            const t = [];
            return Nt(
              this,
              arguments,
              function (e) {
                const r = this.parentNode;
                L.inArray(this, t) < 0 && (L.cleanData(gt(this)), r && r.replaceChild(e, this));
              },
              t
            );
          },
        }),
        L.each(
          {
            appendTo: 'append',
            prependTo: 'prepend',
            insertBefore: 'before',
            insertAfter: 'after',
            replaceAll: 'replaceWith',
          },
          function (t, e) {
            L.fn[t] = function (t) {
              for (var r, i = [], n = L(t), s = n.length - 1, a = 0; a <= s; a++)
                (r = a === s ? this : this.clone(!0)), L(n[a])[e](r), c.apply(i, r.get());
              return this.pushStack(i);
            };
          }
        );
      const Ut = new RegExp('^(' + it + ')(?!px)[a-z%]+$', 'i'),
        jt = function (t) {
          let e = t.ownerDocument.defaultView;
          return (e && e.opener) || (e = r), e.getComputedStyle(t);
        },
        Gt = new RegExp(st.join('|'), 'i');
      function Ht(t, e, r) {
        let i,
          n,
          s,
          a,
          o = t.style;
        return (
          (r = r || jt(t)) &&
            ('' !== (a = r.getPropertyValue(e) || r[e]) || L.contains(t.ownerDocument, t) || (a = L.style(t, e)),
            !m.pixelBoxStyles() &&
              Ut.test(a) &&
              Gt.test(e) &&
              ((i = o.width),
              (n = o.minWidth),
              (s = o.maxWidth),
              (o.minWidth = o.maxWidth = o.width = a),
              (a = r.width),
              (o.width = i),
              (o.minWidth = n),
              (o.maxWidth = s))),
          void 0 !== a ? a + '' : a
        );
      }
      function Kt(t, e) {
        return {
          get: function () {
            if (!t()) return (this.get = e).apply(this, arguments);
            delete this.get;
          },
        };
      }
      !(function () {
        function t() {
          if (c) {
            (u.style.cssText = 'position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0'),
              (c.style.cssText =
                'position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%'),
              Tt.appendChild(u).appendChild(c);
            const t = r.getComputedStyle(c);
            (i = '1%' !== t.top),
              (l = 12 === e(t.marginLeft)),
              (c.style.right = '60%'),
              (o = 36 === e(t.right)),
              (n = 36 === e(t.width)),
              (c.style.position = 'absolute'),
              (s = 36 === c.offsetWidth || 'absolute'),
              Tt.removeChild(u),
              (c = null);
          }
        }
        function e(t) {
          return Math.round(parseFloat(t));
        }
        var i,
          n,
          s,
          o,
          l,
          u = a.createElement('div'),
          c = a.createElement('div');
        c.style &&
          ((c.style.backgroundClip = 'content-box'),
          (c.cloneNode(!0).style.backgroundClip = ''),
          (m.clearCloneStyle = 'content-box' === c.style.backgroundClip),
          L.extend(m, {
            boxSizingReliable: function () {
              return t(), n;
            },
            pixelBoxStyles: function () {
              return t(), o;
            },
            pixelPosition: function () {
              return t(), i;
            },
            reliableMarginLeft: function () {
              return t(), l;
            },
            scrollboxSize: function () {
              return t(), s;
            },
          }));
      })();
      const Vt = /^(none|table(?!-c[ea]).+)/,
        qt = /^--/,
        Wt = { position: 'absolute', visibility: 'hidden', display: 'block' },
        Yt = { letterSpacing: '0', fontWeight: '400' },
        Xt = ['Webkit', 'Moz', 'ms'],
        zt = a.createElement('div').style;
      function $t(t) {
        let e = L.cssProps[t];
        return (
          e ||
            (e = L.cssProps[t] =
              (function (t) {
                if (t in zt) return t;
                for (let e = t[0].toUpperCase() + t.slice(1), r = Xt.length; r--; ) if ((t = Xt[r] + e) in zt) return t;
              })(t) || t),
          e
        );
      }
      function Qt(t, e, r) {
        const i = nt.exec(e);
        return i ? Math.max(0, i[2] - (r || 0)) + (i[3] || 'px') : e;
      }
      function Jt(t, e, r, i, n, s) {
        let a = 'width' === e ? 1 : 0,
          o = 0,
          l = 0;
        if (r === (i ? 'border' : 'content')) return 0;
        for (; a < 4; a += 2)
          'margin' === r && (l += L.css(t, r + st[a], !0, n)),
            i
              ? ('content' === r && (l -= L.css(t, 'padding' + st[a], !0, n)),
                'margin' !== r && (l -= L.css(t, 'border' + st[a] + 'Width', !0, n)))
              : ((l += L.css(t, 'padding' + st[a], !0, n)),
                'padding' !== r
                  ? (l += L.css(t, 'border' + st[a] + 'Width', !0, n))
                  : (o += L.css(t, 'border' + st[a] + 'Width', !0, n)));
        return (
          !i &&
            s >= 0 &&
            (l += Math.max(0, Math.ceil(t['offset' + e[0].toUpperCase() + e.slice(1)] - s - l - o - 0.5))),
          l
        );
      }
      function Zt(t, e, r) {
        let i = jt(t),
          n = Ht(t, e, i),
          s = 'border-box' === L.css(t, 'boxSizing', !1, i),
          a = s;
        if (Ut.test(n)) {
          if (!r) return n;
          n = 'auto';
        }
        return (
          (a = a && (m.boxSizingReliable() || n === t.style[e])),
          ('auto' === n || (!parseFloat(n) && 'inline' === L.css(t, 'display', !1, i))) &&
            ((n = t['offset' + e[0].toUpperCase() + e.slice(1)]), (a = !0)),
          (n = parseFloat(n) || 0) + Jt(t, e, r || (s ? 'border' : 'content'), a, i, n) + 'px'
        );
      }
      function te(t, e, r, i, n) {
        return new te.prototype.init(t, e, r, i, n);
      }
      L.extend({
        cssHooks: {
          opacity: {
            get: function (t, e) {
              if (e) {
                const r = Ht(t, 'opacity');
                return '' === r ? '1' : r;
              }
            },
          },
        },
        cssNumber: {
          animationIterationCount: !0,
          columnCount: !0,
          fillOpacity: !0,
          flexGrow: !0,
          flexShrink: !0,
          fontWeight: !0,
          lineHeight: !0,
          opacity: !0,
          order: !0,
          orphans: !0,
          widows: !0,
          zIndex: !0,
          zoom: !0,
        },
        cssProps: {},
        style: function (t, e, r, i) {
          if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
            let n,
              s,
              a,
              o = z(e),
              l = qt.test(e),
              u = t.style;
            if ((l || (e = $t(o)), (a = L.cssHooks[e] || L.cssHooks[o]), void 0 === r))
              return a && 'get' in a && void 0 !== (n = a.get(t, !1, i)) ? n : u[e];
            'string' === (s = typeof r) && (n = nt.exec(r)) && n[1] && ((r = lt(t, e, n)), (s = 'number')),
              null != r &&
                r == r &&
                ('number' === s && (r += (n && n[3]) || (L.cssNumber[o] ? '' : 'px')),
                m.clearCloneStyle || '' !== r || 0 !== e.indexOf('background') || (u[e] = 'inherit'),
                (a && 'set' in a && void 0 === (r = a.set(t, r, i))) || (l ? u.setProperty(e, r) : (u[e] = r)));
          }
        },
        css: function (t, e, r, i) {
          let n,
            s,
            a,
            o = z(e);
          return (
            qt.test(e) || (e = $t(o)),
            (a = L.cssHooks[e] || L.cssHooks[o]) && 'get' in a && (n = a.get(t, !0, r)),
            void 0 === n && (n = Ht(t, e, i)),
            'normal' === n && e in Yt && (n = Yt[e]),
            '' === r || r ? ((s = parseFloat(n)), !0 === r || isFinite(s) ? s || 0 : n) : n
          );
        },
      }),
        L.each(['height', 'width'], function (t, e) {
          L.cssHooks[e] = {
            get: function (t, r, i) {
              if (r)
                return !Vt.test(L.css(t, 'display')) || (t.getClientRects().length && t.getBoundingClientRect().width)
                  ? Zt(t, e, i)
                  : ot(t, Wt, function () {
                      return Zt(t, e, i);
                    });
            },
            set: function (t, r, i) {
              let n,
                s = jt(t),
                a = 'border-box' === L.css(t, 'boxSizing', !1, s),
                o = i && Jt(t, e, i, a, s);
              return (
                a &&
                  m.scrollboxSize() === s.position &&
                  (o -= Math.ceil(
                    t['offset' + e[0].toUpperCase() + e.slice(1)] - parseFloat(s[e]) - Jt(t, e, 'border', !1, s) - 0.5
                  )),
                o && (n = nt.exec(r)) && 'px' !== (n[3] || 'px') && ((t.style[e] = r), (r = L.css(t, e))),
                Qt(0, r, o)
              );
            },
          };
        }),
        (L.cssHooks.marginLeft = Kt(m.reliableMarginLeft, function (t, e) {
          if (e)
            return (
              (parseFloat(Ht(t, 'marginLeft')) ||
                t.getBoundingClientRect().left -
                  ot(t, { marginLeft: 0 }, function () {
                    return t.getBoundingClientRect().left;
                  })) + 'px'
            );
        })),
        L.each({ margin: '', padding: '', border: 'Width' }, function (t, e) {
          (L.cssHooks[t + e] = {
            expand: function (r) {
              for (var i = 0, n = {}, s = 'string' == typeof r ? r.split(' ') : [r]; i < 4; i++)
                n[t + st[i] + e] = s[i] || s[i - 2] || s[0];
              return n;
            },
          }),
            'margin' !== t && (L.cssHooks[t + e].set = Qt);
        }),
        L.fn.extend({
          css: function (t, e) {
            return q(
              this,
              function (t, e, r) {
                let i,
                  n,
                  s = {},
                  a = 0;
                if (Array.isArray(e)) {
                  for (i = jt(t), n = e.length; a < n; a++) s[e[a]] = L.css(t, e[a], !1, i);
                  return s;
                }
                return void 0 !== r ? L.style(t, e, r) : L.css(t, e);
              },
              t,
              e,
              arguments.length > 1
            );
          },
        }),
        (L.Tween = te),
        (te.prototype = {
          constructor: te,
          init: function (t, e, r, i, n, s) {
            (this.elem = t),
              (this.prop = r),
              (this.easing = n || L.easing._default),
              (this.options = e),
              (this.start = this.now = this.cur()),
              (this.end = i),
              (this.unit = s || (L.cssNumber[r] ? '' : 'px'));
          },
          cur: function () {
            const t = te.propHooks[this.prop];
            return t && t.get ? t.get(this) : te.propHooks._default.get(this);
          },
          run: function (t) {
            let e,
              r = te.propHooks[this.prop];
            return (
              this.options.duration
                ? (this.pos = e = L.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration))
                : (this.pos = e = t),
              (this.now = (this.end - this.start) * e + this.start),
              this.options.step && this.options.step.call(this.elem, this.now, this),
              r && r.set ? r.set(this) : te.propHooks._default.set(this),
              this
            );
          },
        }),
        (te.prototype.init.prototype = te.prototype),
        (te.propHooks = {
          _default: {
            get: function (t) {
              let e;
              return 1 !== t.elem.nodeType || (null != t.elem[t.prop] && null == t.elem.style[t.prop])
                ? t.elem[t.prop]
                : (e = L.css(t.elem, t.prop, '')) && 'auto' !== e
                  ? e
                  : 0;
            },
            set: function (t) {
              L.fx.step[t.prop]
                ? L.fx.step[t.prop](t)
                : 1 !== t.elem.nodeType || (null == t.elem.style[L.cssProps[t.prop]] && !L.cssHooks[t.prop])
                  ? (t.elem[t.prop] = t.now)
                  : L.style(t.elem, t.prop, t.now + t.unit);
            },
          },
        }),
        (te.propHooks.scrollTop = te.propHooks.scrollLeft =
          {
            set: function (t) {
              t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now);
            },
          }),
        (L.easing = {
          linear: function (t) {
            return t;
          },
          swing: function (t) {
            return 0.5 - Math.cos(t * Math.PI) / 2;
          },
          _default: 'swing',
        }),
        (L.fx = te.prototype.init),
        (L.fx.step = {});
      let ee,
        re,
        ie = /^(?:toggle|show|hide)$/,
        ne = /queueHooks$/;
      function se() {
        re &&
          (!1 === a.hidden && r.requestAnimationFrame ? r.requestAnimationFrame(se) : r.setTimeout(se, L.fx.interval),
          L.fx.tick());
      }
      function ae() {
        return (
          r.setTimeout(function () {
            ee = void 0;
          }),
          (ee = Date.now())
        );
      }
      function oe(t, e) {
        let r,
          i = 0,
          n = { height: t };
        for (e = e ? 1 : 0; i < 4; i += 2 - e) n['margin' + (r = st[i])] = n['padding' + r] = t;
        return e && (n.opacity = n.width = t), n;
      }
      function le(t, e, r) {
        for (var i, n = (ue.tweeners[e] || []).concat(ue.tweeners['*']), s = 0, a = n.length; s < a; s++)
          if ((i = n[s].call(r, e, t))) return i;
      }
      function ue(t, e, r) {
        var i,
          n,
          s = 0,
          a = ue.prefilters.length,
          o = L.Deferred().always(function () {
            delete l.elem;
          }),
          l = function () {
            if (n) return !1;
            for (
              var e = ee || ae(),
                r = Math.max(0, u.startTime + u.duration - e),
                i = 1 - (r / u.duration || 0),
                s = 0,
                a = u.tweens.length;
              s < a;
              s++
            )
              u.tweens[s].run(i);
            return (
              o.notifyWith(t, [u, i, r]), i < 1 && a ? r : (a || o.notifyWith(t, [u, 1, 0]), o.resolveWith(t, [u]), !1)
            );
          },
          u = o.promise({
            elem: t,
            props: L.extend({}, e),
            opts: L.extend(!0, { specialEasing: {}, easing: L.easing._default }, r),
            originalProperties: e,
            originalOptions: r,
            startTime: ee || ae(),
            duration: r.duration,
            tweens: [],
            createTween: function (e, r) {
              const i = L.Tween(t, u.opts, e, r, u.opts.specialEasing[e] || u.opts.easing);
              return u.tweens.push(i), i;
            },
            stop: function (e) {
              let r = 0,
                i = e ? u.tweens.length : 0;
              if (n) return this;
              for (n = !0; r < i; r++) u.tweens[r].run(1);
              return e ? (o.notifyWith(t, [u, 1, 0]), o.resolveWith(t, [u, e])) : o.rejectWith(t, [u, e]), this;
            },
          }),
          c = u.props;
        for (
          !(function (t, e) {
            let r, i, n, s, a;
            for (r in t)
              if (
                ((n = e[(i = z(r))]),
                (s = t[r]),
                Array.isArray(s) && ((n = s[1]), (s = t[r] = s[0])),
                r !== i && ((t[i] = s), delete t[r]),
                (a = L.cssHooks[i]) && ('expand' in a))
              )
                for (r in ((s = a.expand(s)), delete t[i], s)) (r in t) || ((t[r] = s[r]), (e[r] = n));
              else e[i] = n;
          })(c, u.opts.specialEasing);
          s < a;
          s++
        )
          if ((i = ue.prefilters[s].call(u, t, c, u.opts)))
            return y(i.stop) && (L._queueHooks(u.elem, u.opts.queue).stop = i.stop.bind(i)), i;
        return (
          L.map(c, le, u),
          y(u.opts.start) && u.opts.start.call(t, u),
          u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always),
          L.fx.timer(L.extend(l, { elem: t, anim: u, queue: u.opts.queue })),
          u
        );
      }
      (L.Animation = L.extend(ue, {
        tweeners: {
          '*': [
            function (t, e) {
              const r = this.createTween(t, e);
              return lt(r.elem, t, nt.exec(e), r), r;
            },
          ],
        },
        tweener: function (t, e) {
          y(t) ? ((e = t), (t = ['*'])) : (t = t.match(B));
          for (var r, i = 0, n = t.length; i < n; i++)
            (r = t[i]), (ue.tweeners[r] = ue.tweeners[r] || []), ue.tweeners[r].unshift(e);
        },
        prefilters: [
          function (t, e, r) {
            let i,
              n,
              s,
              a,
              o,
              l,
              u,
              c,
              d = 'width' in e || 'height' in e,
              f = this,
              h = {},
              p = t.style,
              v = t.nodeType && at(t),
              g = J.get(t, 'fxshow');
            for (i in (r.queue ||
              (null == (a = L._queueHooks(t, 'fx')).unqueued &&
                ((a.unqueued = 0),
                (o = a.empty.fire),
                (a.empty.fire = function () {
                  a.unqueued || o();
                })),
              a.unqueued++,
              f.always(function () {
                f.always(function () {
                  a.unqueued--, L.queue(t, 'fx').length || a.empty.fire();
                });
              })),
            e))
              if (((n = e[i]), ie.test(n))) {
                if ((delete e[i], (s = s || 'toggle' === n), n === (v ? 'hide' : 'show'))) {
                  if ('show' !== n || !g || void 0 === g[i]) continue;
                  v = !0;
                }
                h[i] = (g && g[i]) || L.style(t, i);
              }
            if ((l = !L.isEmptyObject(e)) || !L.isEmptyObject(h))
              for (i in (d &&
                1 === t.nodeType &&
                ((r.overflow = [p.overflow, p.overflowX, p.overflowY]),
                null == (u = g && g.display) && (u = J.get(t, 'display')),
                'none' === (c = L.css(t, 'display')) &&
                  (u ? (c = u) : (dt([t], !0), (u = t.style.display || u), (c = L.css(t, 'display')), dt([t]))),
                ('inline' === c || ('inline-block' === c && null != u)) &&
                  'none' === L.css(t, 'float') &&
                  (l ||
                    (f.done(function () {
                      p.display = u;
                    }),
                    null == u && ((c = p.display), (u = 'none' === c ? '' : c))),
                  (p.display = 'inline-block'))),
              r.overflow &&
                ((p.overflow = 'hidden'),
                f.always(function () {
                  (p.overflow = r.overflow[0]), (p.overflowX = r.overflow[1]), (p.overflowY = r.overflow[2]);
                })),
              (l = !1),
              h))
                l ||
                  (g ? 'hidden' in g && (v = g.hidden) : (g = J.access(t, 'fxshow', { display: u })),
                  s && (g.hidden = !v),
                  v && dt([t], !0),
                  f.done(function () {
                    for (i in (v || dt([t]), J.remove(t, 'fxshow'), h)) L.style(t, i, h[i]);
                  })),
                  (l = le(v ? g[i] : 0, i, f)),
                  i in g || ((g[i] = l.start), v && ((l.end = l.start), (l.start = 0)));
          },
        ],
        prefilter: function (t, e) {
          e ? ue.prefilters.unshift(t) : ue.prefilters.push(t);
        },
      })),
        (L.speed = function (t, e, r) {
          const i =
            t && 'object' == typeof t
              ? L.extend({}, t)
              : { complete: r || (!r && e) || (y(t) && t), duration: t, easing: (r && e) || (e && !y(e) && e) };
          return (
            L.fx.off
              ? (i.duration = 0)
              : 'number' != typeof i.duration &&
                (i.duration in L.fx.speeds
                  ? (i.duration = L.fx.speeds[i.duration])
                  : (i.duration = L.fx.speeds._default)),
            (null != i.queue && !0 !== i.queue) || (i.queue = 'fx'),
            (i.old = i.complete),
            (i.complete = function () {
              y(i.old) && i.old.call(this), i.queue && L.dequeue(this, i.queue);
            }),
            i
          );
        }),
        L.fn.extend({
          fadeTo: function (t, e, r, i) {
            return this.filter(at).css('opacity', 0).show().end().animate({ opacity: e }, t, r, i);
          },
          animate: function (t, e, r, i) {
            const n = L.isEmptyObject(t),
              s = L.speed(e, r, i),
              a = function () {
                const e = ue(this, L.extend({}, t), s);
                (n || J.get(this, 'finish')) && e.stop(!0);
              };
            return (a.finish = a), n || !1 === s.queue ? this.each(a) : this.queue(s.queue, a);
          },
          stop: function (t, e, r) {
            const i = function (t) {
              const e = t.stop;
              delete t.stop, e(r);
            };
            return (
              'string' != typeof t && ((r = e), (e = t), (t = void 0)),
              e && !1 !== t && this.queue(t || 'fx', []),
              this.each(function () {
                let e = !0,
                  n = null != t && t + 'queueHooks',
                  s = L.timers,
                  a = J.get(this);
                if (n) a[n] && a[n].stop && i(a[n]);
                else for (n in a) a[n] && a[n].stop && ne.test(n) && i(a[n]);
                for (n = s.length; n--; )
                  s[n].elem !== this ||
                    (null != t && s[n].queue !== t) ||
                    (s[n].anim.stop(r), (e = !1), s.splice(n, 1));
                (!e && r) || L.dequeue(this, t);
              })
            );
          },
          finish: function (t) {
            return (
              !1 !== t && (t = t || 'fx'),
              this.each(function () {
                let e,
                  r = J.get(this),
                  i = r[t + 'queue'],
                  n = r[t + 'queueHooks'],
                  s = L.timers,
                  a = i ? i.length : 0;
                for (r.finish = !0, L.queue(this, t, []), n && n.stop && n.stop.call(this, !0), e = s.length; e--; )
                  s[e].elem === this && s[e].queue === t && (s[e].anim.stop(!0), s.splice(e, 1));
                for (e = 0; e < a; e++) i[e] && i[e].finish && i[e].finish.call(this);
                delete r.finish;
              })
            );
          },
        }),
        L.each(['toggle', 'show', 'hide'], function (t, e) {
          const r = L.fn[e];
          L.fn[e] = function (t, i, n) {
            return null == t || 'boolean' == typeof t ? r.apply(this, arguments) : this.animate(oe(e, !0), t, i, n);
          };
        }),
        L.each(
          {
            slideDown: oe('show'),
            slideUp: oe('hide'),
            slideToggle: oe('toggle'),
            fadeIn: { opacity: 'show' },
            fadeOut: { opacity: 'hide' },
            fadeToggle: { opacity: 'toggle' },
          },
          function (t, e) {
            L.fn[t] = function (t, r, i) {
              return this.animate(e, t, r, i);
            };
          }
        ),
        (L.timers = []),
        (L.fx.tick = function () {
          let t,
            e = 0,
            r = L.timers;
          for (ee = Date.now(); e < r.length; e++) (t = r[e])() || r[e] !== t || r.splice(e--, 1);
          r.length || L.fx.stop(), (ee = void 0);
        }),
        (L.fx.timer = function (t) {
          L.timers.push(t), L.fx.start();
        }),
        (L.fx.interval = 13),
        (L.fx.start = function () {
          re || ((re = !0), se());
        }),
        (L.fx.stop = function () {
          re = null;
        }),
        (L.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
        (L.fn.delay = function (t, e) {
          return (
            (t = (L.fx && L.fx.speeds[t]) || t),
            (e = e || 'fx'),
            this.queue(e, function (e, i) {
              const n = r.setTimeout(e, t);
              i.stop = function () {
                r.clearTimeout(n);
              };
            })
          );
        }),
        (function () {
          let t = a.createElement('input'),
            e = a.createElement('select').appendChild(a.createElement('option'));
          (t.type = 'checkbox'),
            (m.checkOn = '' !== t.value),
            (m.optSelected = e.selected),
            ((t = a.createElement('input')).value = 't'),
            (t.type = 'radio'),
            (m.radioValue = 't' === t.value);
        })();
      let ce,
        de = L.expr.attrHandle;
      L.fn.extend({
        attr: function (t, e) {
          return q(this, L.attr, t, e, arguments.length > 1);
        },
        removeAttr: function (t) {
          return this.each(function () {
            L.removeAttr(this, t);
          });
        },
      }),
        L.extend({
          attr: function (t, e, r) {
            let i,
              n,
              s = t.nodeType;
            if (3 !== s && 8 !== s && 2 !== s)
              return void 0 === t.getAttribute
                ? L.prop(t, e, r)
                : ((1 === s && L.isXMLDoc(t)) ||
                    (n = L.attrHooks[e.toLowerCase()] || (L.expr.match.bool.test(e) ? ce : void 0)),
                  void 0 !== r
                    ? null === r
                      ? void L.removeAttr(t, e)
                      : n && 'set' in n && void 0 !== (i = n.set(t, r, e))
                        ? i
                        : (t.setAttribute(e, r + ''), r)
                    : n && 'get' in n && null !== (i = n.get(t, e))
                      ? i
                      : null == (i = L.find.attr(t, e))
                        ? void 0
                        : i);
          },
          attrHooks: {
            type: {
              set: function (t, e) {
                if (!m.radioValue && 'radio' === e && w(t, 'input')) {
                  const r = t.value;
                  return t.setAttribute('type', e), r && (t.value = r), e;
                }
              },
            },
          },
          removeAttr: function (t, e) {
            let r,
              i = 0,
              n = e && e.match(B);
            if (n && 1 === t.nodeType) for (; (r = n[i++]); ) t.removeAttribute(r);
          },
        }),
        (ce = {
          set: function (t, e, r) {
            return !1 === e ? L.removeAttr(t, r) : t.setAttribute(r, r), r;
          },
        }),
        L.each(L.expr.match.bool.source.match(/\w+/g), function (t, e) {
          const r = de[e] || L.find.attr;
          de[e] = function (t, e, i) {
            let n,
              s,
              a = e.toLowerCase();
            return i || ((s = de[a]), (de[a] = n), (n = null != r(t, e, i) ? a : null), (de[a] = s)), n;
          };
        });
      const fe = /^(?:input|select|textarea|button)$/i,
        he = /^(?:a|area)$/i;
      function pe(t) {
        return (t.match(B) || []).join(' ');
      }
      function ve(t) {
        return (t.getAttribute && t.getAttribute('class')) || '';
      }
      function ge(t) {
        return Array.isArray(t) ? t : ('string' == typeof t && t.match(B)) || [];
      }
      L.fn.extend({
        prop: function (t, e) {
          return q(this, L.prop, t, e, arguments.length > 1);
        },
        removeProp: function (t) {
          return this.each(function () {
            delete this[L.propFix[t] || t];
          });
        },
      }),
        L.extend({
          prop: function (t, e, r) {
            let i,
              n,
              s = t.nodeType;
            if (3 !== s && 8 !== s && 2 !== s)
              return (
                (1 === s && L.isXMLDoc(t)) || ((e = L.propFix[e] || e), (n = L.propHooks[e])),
                void 0 !== r
                  ? n && 'set' in n && void 0 !== (i = n.set(t, r, e))
                    ? i
                    : (t[e] = r)
                  : n && 'get' in n && null !== (i = n.get(t, e))
                    ? i
                    : t[e]
              );
          },
          propHooks: {
            tabIndex: {
              get: function (t) {
                const e = L.find.attr(t, 'tabindex');
                return e ? parseInt(e, 10) : fe.test(t.nodeName) || (he.test(t.nodeName) && t.href) ? 0 : -1;
              },
            },
          },
          propFix: { for: 'htmlFor', class: 'className' },
        }),
        m.optSelected ||
          (L.propHooks.selected = {
            get: function (t) {
              const e = t.parentNode;
              return e && e.parentNode && e.parentNode.selectedIndex, null;
            },
            set: function (t) {
              const e = t.parentNode;
              e && (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex);
            },
          }),
        L.each(
          [
            'tabIndex',
            'readOnly',
            'maxLength',
            'cellSpacing',
            'cellPadding',
            'rowSpan',
            'colSpan',
            'useMap',
            'frameBorder',
            'contentEditable',
          ],
          function () {
            L.propFix[this.toLowerCase()] = this;
          }
        ),
        L.fn.extend({
          addClass: function (t) {
            let e,
              r,
              i,
              n,
              s,
              a,
              o,
              l = 0;
            if (y(t))
              return this.each(function (e) {
                L(this).addClass(t.call(this, e, ve(this)));
              });
            if ((e = ge(t)).length)
              for (; (r = this[l++]); )
                if (((n = ve(r)), (i = 1 === r.nodeType && ' ' + pe(n) + ' '))) {
                  for (a = 0; (s = e[a++]); ) i.indexOf(' ' + s + ' ') < 0 && (i += s + ' ');
                  n !== (o = pe(i)) && r.setAttribute('class', o);
                }
            return this;
          },
          removeClass: function (t) {
            let e,
              r,
              i,
              n,
              s,
              a,
              o,
              l = 0;
            if (y(t))
              return this.each(function (e) {
                L(this).removeClass(t.call(this, e, ve(this)));
              });
            if (!arguments.length) return this.attr('class', '');
            if ((e = ge(t)).length)
              for (; (r = this[l++]); )
                if (((n = ve(r)), (i = 1 === r.nodeType && ' ' + pe(n) + ' '))) {
                  for (a = 0; (s = e[a++]); ) for (; i.indexOf(' ' + s + ' ') > -1; ) i = i.replace(' ' + s + ' ', ' ');
                  n !== (o = pe(i)) && r.setAttribute('class', o);
                }
            return this;
          },
          toggleClass: function (t, e) {
            const r = typeof t,
              i = 'string' === r || Array.isArray(t);
            return 'boolean' == typeof e && i
              ? e
                ? this.addClass(t)
                : this.removeClass(t)
              : y(t)
                ? this.each(function (r) {
                    L(this).toggleClass(t.call(this, r, ve(this), e), e);
                  })
                : this.each(function () {
                    let e, n, s, a;
                    if (i)
                      for (n = 0, s = L(this), a = ge(t); (e = a[n++]); )
                        s.hasClass(e) ? s.removeClass(e) : s.addClass(e);
                    else
                      (void 0 !== t && 'boolean' !== r) ||
                        ((e = ve(this)) && J.set(this, '__className__', e),
                        this.setAttribute &&
                          this.setAttribute('class', e || !1 === t ? '' : J.get(this, '__className__') || ''));
                  });
          },
          hasClass: function (t) {
            let e,
              r,
              i = 0;
            for (e = ' ' + t + ' '; (r = this[i++]); )
              if (1 === r.nodeType && (' ' + pe(ve(r)) + ' ').indexOf(e) > -1) return !0;
            return !1;
          },
        });
      const me = /\r/g;
      L.fn.extend({
        val: function (t) {
          let e,
            r,
            i,
            n = this[0];
          return arguments.length
            ? ((i = y(t)),
              this.each(function (r) {
                let n;
                1 === this.nodeType &&
                  (null == (n = i ? t.call(this, r, L(this).val()) : t)
                    ? (n = '')
                    : 'number' == typeof n
                      ? (n += '')
                      : Array.isArray(n) &&
                        (n = L.map(n, function (t) {
                          return null == t ? '' : t + '';
                        })),
                  ((e = L.valHooks[this.type] || L.valHooks[this.nodeName.toLowerCase()]) &&
                    'set' in e &&
                    void 0 !== e.set(this, n, 'value')) ||
                    (this.value = n));
              }))
            : n
              ? (e = L.valHooks[n.type] || L.valHooks[n.nodeName.toLowerCase()]) &&
                'get' in e &&
                void 0 !== (r = e.get(n, 'value'))
                ? r
                : 'string' == typeof (r = n.value)
                  ? r.replace(me, '')
                  : null == r
                    ? ''
                    : r
              : void 0;
        },
      }),
        L.extend({
          valHooks: {
            option: {
              get: function (t) {
                const e = L.find.attr(t, 'value');
                return null != e ? e : pe(L.text(t));
              },
            },
            select: {
              get: function (t) {
                let e,
                  r,
                  i,
                  n = t.options,
                  s = t.selectedIndex,
                  a = 'select-one' === t.type,
                  o = a ? null : [],
                  l = a ? s + 1 : n.length;
                for (i = s < 0 ? l : a ? s : 0; i < l; i++)
                  if (
                    ((r = n[i]).selected || i === s) &&
                    !r.disabled &&
                    (!r.parentNode.disabled || !w(r.parentNode, 'optgroup'))
                  ) {
                    if (((e = L(r).val()), a)) return e;
                    o.push(e);
                  }
                return o;
              },
              set: function (t, e) {
                for (var r, i, n = t.options, s = L.makeArray(e), a = n.length; a--; )
                  ((i = n[a]).selected = L.inArray(L.valHooks.option.get(i), s) > -1) && (r = !0);
                return r || (t.selectedIndex = -1), s;
              },
            },
          },
        }),
        L.each(['radio', 'checkbox'], function () {
          (L.valHooks[this] = {
            set: function (t, e) {
              if (Array.isArray(e)) return (t.checked = L.inArray(L(t).val(), e) > -1);
            },
          }),
            m.checkOn ||
              (L.valHooks[this].get = function (t) {
                return null === t.getAttribute('value') ? 'on' : t.value;
              });
        }),
        (m.focusin = 'onfocusin' in r);
      const ye = /^(?:focusinfocus|focusoutblur)$/,
        Ee = function (t) {
          t.stopPropagation();
        };
      L.extend(L.event, {
        trigger: function (t, e, i, n) {
          let s,
            o,
            l,
            u,
            c,
            d,
            f,
            h,
            v = [i || a],
            g = p.call(t, 'type') ? t.type : t,
            m = p.call(t, 'namespace') ? t.namespace.split('.') : [];
          if (
            ((o = h = l = i = i || a),
            3 !== i.nodeType &&
              8 !== i.nodeType &&
              !ye.test(g + L.event.triggered) &&
              (g.indexOf('.') > -1 && ((g = (m = g.split('.')).shift()), m.sort()),
              (c = g.indexOf(':') < 0 && 'on' + g),
              ((t = t[L.expando] ? t : new L.Event(g, 'object' == typeof t && t)).isTrigger = n ? 2 : 3),
              (t.namespace = m.join('.')),
              (t.rnamespace = t.namespace ? new RegExp('(^|\\.)' + m.join('\\.(?:.*\\.|)') + '(\\.|$)') : null),
              (t.result = void 0),
              t.target || (t.target = i),
              (e = null == e ? [t] : L.makeArray(e, [t])),
              (f = L.event.special[g] || {}),
              n || !f.trigger || !1 !== f.trigger.apply(i, e)))
          ) {
            if (!n && !f.noBubble && !E(i)) {
              for (u = f.delegateType || g, ye.test(u + g) || (o = o.parentNode); o; o = o.parentNode)
                v.push(o), (l = o);
              l === (i.ownerDocument || a) && v.push(l.defaultView || l.parentWindow || r);
            }
            for (s = 0; (o = v[s++]) && !t.isPropagationStopped(); )
              (h = o),
                (t.type = s > 1 ? u : f.bindType || g),
                (d = (J.get(o, 'events') || {})[t.type] && J.get(o, 'handle')) && d.apply(o, e),
                (d = c && o[c]) &&
                  d.apply &&
                  $(o) &&
                  ((t.result = d.apply(o, e)), !1 === t.result && t.preventDefault());
            return (
              (t.type = g),
              n ||
                t.isDefaultPrevented() ||
                (f._default && !1 !== f._default.apply(v.pop(), e)) ||
                !$(i) ||
                (c &&
                  y(i[g]) &&
                  !E(i) &&
                  ((l = i[c]) && (i[c] = null),
                  (L.event.triggered = g),
                  t.isPropagationStopped() && h.addEventListener(g, Ee),
                  i[g](),
                  t.isPropagationStopped() && h.removeEventListener(g, Ee),
                  (L.event.triggered = void 0),
                  l && (i[c] = l))),
              t.result
            );
          }
        },
        simulate: function (t, e, r) {
          const i = L.extend(new L.Event(), r, { type: t, isSimulated: !0 });
          L.event.trigger(i, null, e);
        },
      }),
        L.fn.extend({
          trigger: function (t, e) {
            return this.each(function () {
              L.event.trigger(t, e, this);
            });
          },
          triggerHandler: function (t, e) {
            const r = this[0];
            if (r) return L.event.trigger(t, e, r, !0);
          },
        }),
        m.focusin ||
          L.each({ focus: 'focusin', blur: 'focusout' }, function (t, e) {
            const r = function (t) {
              L.event.simulate(e, t.target, L.event.fix(t));
            };
            L.event.special[e] = {
              setup: function () {
                const i = this.ownerDocument || this,
                  n = J.access(i, e);
                n || i.addEventListener(t, r, !0), J.access(i, e, (n || 0) + 1);
              },
              teardown: function () {
                const i = this.ownerDocument || this,
                  n = J.access(i, e) - 1;
                n ? J.access(i, e, n) : (i.removeEventListener(t, r, !0), J.remove(i, e));
              },
            };
          });
      let Te = r.location,
        be = Date.now(),
        Se = /\?/;
      L.parseXML = function (t) {
        let e;
        if (!t || 'string' != typeof t) return null;
        try {
          e = new r.DOMParser().parseFromString(t, 'text/xml');
        } catch (t) {
          e = void 0;
        }
        return (e && !e.getElementsByTagName('parsererror').length) || L.error('Invalid XML: ' + t), e;
      };
      const Le = /\[\]$/,
        Ae = /\r?\n/g,
        De = /^(?:submit|button|image|reset|file)$/i,
        ke = /^(?:input|select|textarea|keygen)/i;
      function Ce(t, e, r, i) {
        let n;
        if (Array.isArray(e))
          L.each(e, function (e, n) {
            r || Le.test(t) ? i(t, n) : Ce(t + '[' + ('object' == typeof n && null != n ? e : '') + ']', n, r, i);
          });
        else if (r || 'object' !== S(e)) i(t, e);
        else for (n in e) Ce(t + '[' + n + ']', e[n], r, i);
      }
      (L.param = function (t, e) {
        let r,
          i = [],
          n = function (t, e) {
            const r = y(e) ? e() : e;
            i[i.length] = encodeURIComponent(t) + '=' + encodeURIComponent(null == r ? '' : r);
          };
        if (Array.isArray(t) || (t.jquery && !L.isPlainObject(t)))
          L.each(t, function () {
            n(this.name, this.value);
          });
        else for (r in t) Ce(r, t[r], e, n);
        return i.join('&');
      }),
        L.fn.extend({
          serialize: function () {
            return L.param(this.serializeArray());
          },
          serializeArray: function () {
            return this.map(function () {
              const t = L.prop(this, 'elements');
              return t ? L.makeArray(t) : this;
            })
              .filter(function () {
                const t = this.type;
                return (
                  this.name &&
                  !L(this).is(':disabled') &&
                  ke.test(this.nodeName) &&
                  !De.test(t) &&
                  (this.checked || !ft.test(t))
                );
              })
              .map(function (t, e) {
                const r = L(this).val();
                return null == r
                  ? null
                  : Array.isArray(r)
                    ? L.map(r, function (t) {
                        return { name: e.name, value: t.replace(Ae, '\r\n') };
                      })
                    : { name: e.name, value: r.replace(Ae, '\r\n') };
              })
              .get();
          },
        });
      const xe = /%20/g,
        Re = /#.*$/,
        we = /([?&])_=[^&]*/,
        _e = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        Ie = /^(?:GET|HEAD)$/,
        Oe = /^\/\//,
        Pe = {},
        Fe = {},
        Me = '*/'.concat('*'),
        Ne = a.createElement('a');
      function Be(t) {
        return function (e, r) {
          'string' != typeof e && ((r = e), (e = '*'));
          let i,
            n = 0,
            s = e.toLowerCase().match(B) || [];
          if (y(r))
            for (; (i = s[n++]); )
              '+' === i[0] ? ((i = i.slice(1) || '*'), (t[i] = t[i] || []).unshift(r)) : (t[i] = t[i] || []).push(r);
        };
      }
      function Ue(t, e, r, i) {
        const n = {},
          s = t === Fe;
        function a(o) {
          let l;
          return (
            (n[o] = !0),
            L.each(t[o] || [], function (t, o) {
              const u = o(e, r, i);
              return 'string' != typeof u || s || n[u] ? (s ? !(l = u) : void 0) : (e.dataTypes.unshift(u), a(u), !1);
            }),
            l
          );
        }
        return a(e.dataTypes[0]) || (!n['*'] && a('*'));
      }
      function je(t, e) {
        let r,
          i,
          n = L.ajaxSettings.flatOptions || {};
        for (r in e) void 0 !== e[r] && ((n[r] ? t : i || (i = {}))[r] = e[r]);
        return i && L.extend(!0, t, i), t;
      }
      (Ne.href = Te.href),
        L.extend({
          active: 0,
          lastModified: {},
          etag: {},
          ajaxSettings: {
            url: Te.href,
            type: 'GET',
            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Te.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
            accepts: {
              '*': Me,
              text: 'text/plain',
              html: 'text/html',
              xml: 'application/xml, text/xml',
              json: 'application/json, text/javascript',
            },
            contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
            responseFields: { xml: 'responseXML', text: 'responseText', json: 'responseJSON' },
            converters: { '* text': String, 'text html': !0, 'text json': JSON.parse, 'text xml': L.parseXML },
            flatOptions: { url: !0, context: !0 },
          },
          ajaxSetup: function (t, e) {
            return e ? je(je(t, L.ajaxSettings), e) : je(L.ajaxSettings, t);
          },
          ajaxPrefilter: Be(Pe),
          ajaxTransport: Be(Fe),
          ajax: function (t, e) {
            'object' == typeof t && ((e = t), (t = void 0)), (e = e || {});
            var i,
              n,
              s,
              o,
              l,
              u,
              c,
              d,
              f,
              h,
              p = L.ajaxSetup({}, e),
              v = p.context || p,
              g = p.context && (v.nodeType || v.jquery) ? L(v) : L.event,
              m = L.Deferred(),
              y = L.Callbacks('once memory'),
              E = p.statusCode || {},
              T = {},
              b = {},
              S = 'canceled',
              A = {
                readyState: 0,
                getResponseHeader: function (t) {
                  let e;
                  if (c) {
                    if (!o) for (o = {}; (e = _e.exec(s)); ) o[e[1].toLowerCase()] = e[2];
                    e = o[t.toLowerCase()];
                  }
                  return null == e ? null : e;
                },
                getAllResponseHeaders: function () {
                  return c ? s : null;
                },
                setRequestHeader: function (t, e) {
                  return null == c && ((t = b[t.toLowerCase()] = b[t.toLowerCase()] || t), (T[t] = e)), this;
                },
                overrideMimeType: function (t) {
                  return null == c && (p.mimeType = t), this;
                },
                statusCode: function (t) {
                  let e;
                  if (t)
                    if (c) A.always(t[A.status]);
                    else for (e in t) E[e] = [E[e], t[e]];
                  return this;
                },
                abort: function (t) {
                  const e = t || S;
                  return i && i.abort(e), D(0, e), this;
                },
              };
            if (
              (m.promise(A),
              (p.url = ((t || p.url || Te.href) + '').replace(Oe, Te.protocol + '//')),
              (p.type = e.method || e.type || p.method || p.type),
              (p.dataTypes = (p.dataType || '*').toLowerCase().match(B) || ['']),
              null == p.crossDomain)
            ) {
              u = a.createElement('a');
              try {
                (u.href = p.url),
                  (u.href = u.href),
                  (p.crossDomain = Ne.protocol + '//' + Ne.host != u.protocol + '//' + u.host);
              } catch (t) {
                p.crossDomain = !0;
              }
            }
            if (
              (p.data && p.processData && 'string' != typeof p.data && (p.data = L.param(p.data, p.traditional)),
              Ue(Pe, p, e, A),
              c)
            )
              return A;
            for (f in ((d = L.event && p.global) && 0 == L.active++ && L.event.trigger('ajaxStart'),
            (p.type = p.type.toUpperCase()),
            (p.hasContent = !Ie.test(p.type)),
            (n = p.url.replace(Re, '')),
            p.hasContent
              ? p.data &&
                p.processData &&
                0 === (p.contentType || '').indexOf('application/x-www-form-urlencoded') &&
                (p.data = p.data.replace(xe, '+'))
              : ((h = p.url.slice(n.length)),
                p.data &&
                  (p.processData || 'string' == typeof p.data) &&
                  ((n += (Se.test(n) ? '&' : '?') + p.data), delete p.data),
                !1 === p.cache && ((n = n.replace(we, '$1')), (h = (Se.test(n) ? '&' : '?') + '_=' + be++ + h)),
                (p.url = n + h)),
            p.ifModified &&
              (L.lastModified[n] && A.setRequestHeader('If-Modified-Since', L.lastModified[n]),
              L.etag[n] && A.setRequestHeader('If-None-Match', L.etag[n])),
            ((p.data && p.hasContent && !1 !== p.contentType) || e.contentType) &&
              A.setRequestHeader('Content-Type', p.contentType),
            A.setRequestHeader(
              'Accept',
              p.dataTypes[0] && p.accepts[p.dataTypes[0]]
                ? p.accepts[p.dataTypes[0]] + ('*' !== p.dataTypes[0] ? ', ' + Me + '; q=0.01' : '')
                : p.accepts['*']
            ),
            p.headers))
              A.setRequestHeader(f, p.headers[f]);
            if (p.beforeSend && (!1 === p.beforeSend.call(v, A, p) || c)) return A.abort();
            if (((S = 'abort'), y.add(p.complete), A.done(p.success), A.fail(p.error), (i = Ue(Fe, p, e, A)))) {
              if (((A.readyState = 1), d && g.trigger('ajaxSend', [A, p]), c)) return A;
              p.async &&
                p.timeout > 0 &&
                (l = r.setTimeout(function () {
                  A.abort('timeout');
                }, p.timeout));
              try {
                (c = !1), i.send(T, D);
              } catch (t) {
                if (c) throw t;
                D(-1, t);
              }
            } else D(-1, 'No Transport');
            function D(t, e, a, o) {
              let u,
                f,
                h,
                T,
                b,
                S = e;
              c ||
                ((c = !0),
                l && r.clearTimeout(l),
                (i = void 0),
                (s = o || ''),
                (A.readyState = t > 0 ? 4 : 0),
                (u = (t >= 200 && t < 300) || 304 === t),
                a &&
                  (T = (function (t, e, r) {
                    for (var i, n, s, a, o = t.contents, l = t.dataTypes; '*' === l[0]; )
                      l.shift(), void 0 === i && (i = t.mimeType || e.getResponseHeader('Content-Type'));
                    if (i)
                      for (n in o)
                        if (o[n] && o[n].test(i)) {
                          l.unshift(n);
                          break;
                        }
                    if (l[0] in r) s = l[0];
                    else {
                      for (n in r) {
                        if (!l[0] || t.converters[n + ' ' + l[0]]) {
                          s = n;
                          break;
                        }
                        a || (a = n);
                      }
                      s = s || a;
                    }
                    if (s) return s !== l[0] && l.unshift(s), r[s];
                  })(p, A, a)),
                (T = (function (t, e, r, i) {
                  let n,
                    s,
                    a,
                    o,
                    l,
                    u = {},
                    c = t.dataTypes.slice();
                  if (c[1]) for (a in t.converters) u[a.toLowerCase()] = t.converters[a];
                  for (s = c.shift(); s; )
                    if (
                      (t.responseFields[s] && (r[t.responseFields[s]] = e),
                      !l && i && t.dataFilter && (e = t.dataFilter(e, t.dataType)),
                      (l = s),
                      (s = c.shift()))
                    )
                      if ('*' === s) s = l;
                      else if ('*' !== l && l !== s) {
                        if (!(a = u[l + ' ' + s] || u['* ' + s]))
                          for (n in u)
                            if ((o = n.split(' '))[1] === s && (a = u[l + ' ' + o[0]] || u['* ' + o[0]])) {
                              !0 === a ? (a = u[n]) : !0 !== u[n] && ((s = o[0]), c.unshift(o[1]));
                              break;
                            }
                        if (!0 !== a)
                          if (a && t.throws) e = a(e);
                          else
                            try {
                              e = a(e);
                            } catch (t) {
                              return { state: 'parsererror', error: a ? t : 'No conversion from ' + l + ' to ' + s };
                            }
                      }
                  return { state: 'success', data: e };
                })(p, T, A, u)),
                u
                  ? (p.ifModified &&
                      ((b = A.getResponseHeader('Last-Modified')) && (L.lastModified[n] = b),
                      (b = A.getResponseHeader('etag')) && (L.etag[n] = b)),
                    204 === t || 'HEAD' === p.type
                      ? (S = 'nocontent')
                      : 304 === t
                        ? (S = 'notmodified')
                        : ((S = T.state), (f = T.data), (u = !(h = T.error))))
                  : ((h = S), (!t && S) || ((S = 'error'), t < 0 && (t = 0))),
                (A.status = t),
                (A.statusText = (e || S) + ''),
                u ? m.resolveWith(v, [f, S, A]) : m.rejectWith(v, [A, S, h]),
                A.statusCode(E),
                (E = void 0),
                d && g.trigger(u ? 'ajaxSuccess' : 'ajaxError', [A, p, u ? f : h]),
                y.fireWith(v, [A, S]),
                d && (g.trigger('ajaxComplete', [A, p]), --L.active || L.event.trigger('ajaxStop')));
            }
            return A;
          },
          getJSON: function (t, e, r) {
            return L.get(t, e, r, 'json');
          },
          getScript: function (t, e) {
            return L.get(t, void 0, e, 'script');
          },
        }),
        L.each(['get', 'post'], function (t, e) {
          L[e] = function (t, r, i, n) {
            return (
              y(r) && ((n = n || i), (i = r), (r = void 0)),
              L.ajax(L.extend({ url: t, type: e, dataType: n, data: r, success: i }, L.isPlainObject(t) && t))
            );
          };
        }),
        (L._evalUrl = function (t) {
          return L.ajax({ url: t, type: 'GET', dataType: 'script', cache: !0, async: !1, global: !1, throws: !0 });
        }),
        L.fn.extend({
          wrapAll: function (t) {
            let e;
            return (
              this[0] &&
                (y(t) && (t = t.call(this[0])),
                (e = L(t, this[0].ownerDocument).eq(0).clone(!0)),
                this[0].parentNode && e.insertBefore(this[0]),
                e
                  .map(function () {
                    for (var t = this; t.firstElementChild; ) t = t.firstElementChild;
                    return t;
                  })
                  .append(this)),
              this
            );
          },
          wrapInner: function (t) {
            return y(t)
              ? this.each(function (e) {
                  L(this).wrapInner(t.call(this, e));
                })
              : this.each(function () {
                  const e = L(this),
                    r = e.contents();
                  r.length ? r.wrapAll(t) : e.append(t);
                });
          },
          wrap: function (t) {
            const e = y(t);
            return this.each(function (r) {
              L(this).wrapAll(e ? t.call(this, r) : t);
            });
          },
          unwrap: function (t) {
            return (
              this.parent(t)
                .not('body')
                .each(function () {
                  L(this).replaceWith(this.childNodes);
                }),
              this
            );
          },
        }),
        (L.expr.pseudos.hidden = function (t) {
          return !L.expr.pseudos.visible(t);
        }),
        (L.expr.pseudos.visible = function (t) {
          return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
        }),
        (L.ajaxSettings.xhr = function () {
          try {
            return new r.XMLHttpRequest();
          } catch (t) {}
        });
      let Ge = { 0: 200, 1223: 204 },
        He = L.ajaxSettings.xhr();
      (m.cors = !!He && 'withCredentials' in He),
        (m.ajax = He = !!He),
        L.ajaxTransport(function (t) {
          let e, i;
          if (m.cors || (He && !t.crossDomain))
            return {
              send: function (n, s) {
                let a,
                  o = t.xhr();
                if ((o.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields))
                  for (a in t.xhrFields) o[a] = t.xhrFields[a];
                for (a in (t.mimeType && o.overrideMimeType && o.overrideMimeType(t.mimeType),
                t.crossDomain || n['X-Requested-With'] || (n['X-Requested-With'] = 'XMLHttpRequest'),
                n))
                  o.setRequestHeader(a, n[a]);
                (e = function (t) {
                  return function () {
                    e &&
                      ((e = i = o.onload = o.onerror = o.onabort = o.ontimeout = o.onreadystatechange = null),
                      'abort' === t
                        ? o.abort()
                        : 'error' === t
                          ? 'number' != typeof o.status
                            ? s(0, 'error')
                            : s(o.status, o.statusText)
                          : s(
                              Ge[o.status] || o.status,
                              o.statusText,
                              'text' !== (o.responseType || 'text') || 'string' != typeof o.responseText
                                ? { binary: o.response }
                                : { text: o.responseText },
                              o.getAllResponseHeaders()
                            ));
                  };
                }),
                  (o.onload = e()),
                  (i = o.onerror = o.ontimeout = e('error')),
                  void 0 !== o.onabort
                    ? (o.onabort = i)
                    : (o.onreadystatechange = function () {
                        4 === o.readyState &&
                          r.setTimeout(function () {
                            e && i();
                          });
                      }),
                  (e = e('abort'));
                try {
                  o.send((t.hasContent && t.data) || null);
                } catch (t) {
                  if (e) throw t;
                }
              },
              abort: function () {
                e && e();
              },
            };
        }),
        L.ajaxPrefilter(function (t) {
          t.crossDomain && (t.contents.script = !1);
        }),
        L.ajaxSetup({
          accepts: {
            script: 'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript',
          },
          contents: { script: /\b(?:java|ecma)script\b/ },
          converters: {
            'text script': function (t) {
              return L.globalEval(t), t;
            },
          },
        }),
        L.ajaxPrefilter('script', function (t) {
          void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = 'GET');
        }),
        L.ajaxTransport('script', function (t) {
          let e, r;
          if (t.crossDomain)
            return {
              send: function (i, n) {
                (e = L('<script>')
                  .prop({ charset: t.scriptCharset, src: t.url })
                  .on(
                    'load error',
                    (r = function (t) {
                      e.remove(), (r = null), t && n('error' === t.type ? 404 : 200, t.type);
                    })
                  )),
                  a.head.appendChild(e[0]);
              },
              abort: function () {
                r && r();
              },
            };
        });
      const Ke = [],
        Ve = /(=)\?(?=&|$)|\?\?/;
      L.ajaxSetup({
        jsonp: 'callback',
        jsonpCallback: function () {
          const t = Ke.pop() || L.expando + '_' + be++;
          return (this[t] = !0), t;
        },
      }),
        L.ajaxPrefilter('json jsonp', function (t, e, i) {
          let n,
            s,
            a,
            o =
              !1 !== t.jsonp &&
              (Ve.test(t.url)
                ? 'url'
                : 'string' == typeof t.data &&
                  0 === (t.contentType || '').indexOf('application/x-www-form-urlencoded') &&
                  Ve.test(t.data) &&
                  'data');
          if (o || 'jsonp' === t.dataTypes[0])
            return (
              (n = t.jsonpCallback = y(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
              o
                ? (t[o] = t[o].replace(Ve, '$1' + n))
                : !1 !== t.jsonp && (t.url += (Se.test(t.url) ? '&' : '?') + t.jsonp + '=' + n),
              (t.converters['script json'] = function () {
                return a || L.error(n + ' was not called'), a[0];
              }),
              (t.dataTypes[0] = 'json'),
              (s = r[n]),
              (r[n] = function () {
                a = arguments;
              }),
              i.always(function () {
                void 0 === s ? L(r).removeProp(n) : (r[n] = s),
                  t[n] && ((t.jsonpCallback = e.jsonpCallback), Ke.push(n)),
                  a && y(s) && s(a[0]),
                  (a = s = void 0);
              }),
              'script'
            );
        }),
        (m.createHTMLDocument = (function () {
          const t = a.implementation.createHTMLDocument('').body;
          return (t.innerHTML = '<form></form><form></form>'), 2 === t.childNodes.length;
        })()),
        (L.parseHTML = function (t, e, r) {
          return 'string' != typeof t
            ? []
            : ('boolean' == typeof e && ((r = e), (e = !1)),
              e ||
                (m.createHTMLDocument
                  ? (((i = (e = a.implementation.createHTMLDocument('')).createElement('base')).href = a.location.href),
                    e.head.appendChild(i))
                  : (e = a)),
              (n = _.exec(t)),
              (s = !r && []),
              n
                ? [e.createElement(n[1])]
                : ((n = Et([t], e, s)), s && s.length && L(s).remove(), L.merge([], n.childNodes)));
          let i, n, s;
        }),
        (L.fn.load = function (t, e, r) {
          let i,
            n,
            s,
            a = this,
            o = t.indexOf(' ');
          return (
            o > -1 && ((i = pe(t.slice(o))), (t = t.slice(0, o))),
            y(e) ? ((r = e), (e = void 0)) : e && 'object' == typeof e && (n = 'POST'),
            a.length > 0 &&
              L.ajax({ url: t, type: n || 'GET', dataType: 'html', data: e })
                .done(function (t) {
                  (s = arguments), a.html(i ? L('<div>').append(L.parseHTML(t)).find(i) : t);
                })
                .always(
                  r &&
                    function (t, e) {
                      a.each(function () {
                        r.apply(this, s || [t.responseText, e, t]);
                      });
                    }
                ),
            this
          );
        }),
        L.each(['ajaxStart', 'ajaxStop', 'ajaxComplete', 'ajaxError', 'ajaxSuccess', 'ajaxSend'], function (t, e) {
          L.fn[e] = function (t) {
            return this.on(e, t);
          };
        }),
        (L.expr.pseudos.animated = function (t) {
          return L.grep(L.timers, function (e) {
            return t === e.elem;
          }).length;
        }),
        (L.offset = {
          setOffset: function (t, e, r) {
            let i,
              n,
              s,
              a,
              o,
              l,
              u = L.css(t, 'position'),
              c = L(t),
              d = {};
            'static' === u && (t.style.position = 'relative'),
              (o = c.offset()),
              (s = L.css(t, 'top')),
              (l = L.css(t, 'left')),
              ('absolute' === u || 'fixed' === u) && (s + l).indexOf('auto') > -1
                ? ((a = (i = c.position()).top), (n = i.left))
                : ((a = parseFloat(s) || 0), (n = parseFloat(l) || 0)),
              y(e) && (e = e.call(t, r, L.extend({}, o))),
              null != e.top && (d.top = e.top - o.top + a),
              null != e.left && (d.left = e.left - o.left + n),
              'using' in e ? e.using.call(t, d) : c.css(d);
          },
        }),
        L.fn.extend({
          offset: function (t) {
            if (arguments.length)
              return void 0 === t
                ? this
                : this.each(function (e) {
                    L.offset.setOffset(this, t, e);
                  });
            let e,
              r,
              i = this[0];
            return i
              ? i.getClientRects().length
                ? ((e = i.getBoundingClientRect()),
                  (r = i.ownerDocument.defaultView),
                  { top: e.top + r.pageYOffset, left: e.left + r.pageXOffset })
                : { top: 0, left: 0 }
              : void 0;
          },
          position: function () {
            if (this[0]) {
              let t,
                e,
                r,
                i = this[0],
                n = { top: 0, left: 0 };
              if ('fixed' === L.css(i, 'position')) e = i.getBoundingClientRect();
              else {
                for (
                  e = this.offset(), r = i.ownerDocument, t = i.offsetParent || r.documentElement;
                  t && (t === r.body || t === r.documentElement) && 'static' === L.css(t, 'position');

                )
                  t = t.parentNode;
                t &&
                  t !== i &&
                  1 === t.nodeType &&
                  (((n = L(t).offset()).top += L.css(t, 'borderTopWidth', !0)),
                  (n.left += L.css(t, 'borderLeftWidth', !0)));
              }
              return {
                top: e.top - n.top - L.css(i, 'marginTop', !0),
                left: e.left - n.left - L.css(i, 'marginLeft', !0),
              };
            }
          },
          offsetParent: function () {
            return this.map(function () {
              for (var t = this.offsetParent; t && 'static' === L.css(t, 'position'); ) t = t.offsetParent;
              return t || Tt;
            });
          },
        }),
        L.each({ scrollLeft: 'pageXOffset', scrollTop: 'pageYOffset' }, function (t, e) {
          const r = 'pageYOffset' === e;
          L.fn[t] = function (i) {
            return q(
              this,
              function (t, i, n) {
                let s;
                if ((E(t) ? (s = t) : 9 === t.nodeType && (s = t.defaultView), void 0 === n)) return s ? s[e] : t[i];
                s ? s.scrollTo(r ? s.pageXOffset : n, r ? n : s.pageYOffset) : (t[i] = n);
              },
              t,
              i,
              arguments.length
            );
          };
        }),
        L.each(['top', 'left'], function (t, e) {
          L.cssHooks[e] = Kt(m.pixelPosition, function (t, r) {
            if (r) return (r = Ht(t, e)), Ut.test(r) ? L(t).position()[e] + 'px' : r;
          });
        }),
        L.each({ Height: 'height', Width: 'width' }, function (t, e) {
          L.each({ padding: 'inner' + t, content: e, '': 'outer' + t }, function (r, i) {
            L.fn[i] = function (n, s) {
              const a = arguments.length && (r || 'boolean' != typeof n),
                o = r || (!0 === n || !0 === s ? 'margin' : 'border');
              return q(
                this,
                function (e, r, n) {
                  let s;
                  return E(e)
                    ? 0 === i.indexOf('outer')
                      ? e['inner' + t]
                      : e.document.documentElement['client' + t]
                    : 9 === e.nodeType
                      ? ((s = e.documentElement),
                        Math.max(
                          e.body['scroll' + t],
                          s['scroll' + t],
                          e.body['offset' + t],
                          s['offset' + t],
                          s['client' + t]
                        ))
                      : void 0 === n
                        ? L.css(e, r, o)
                        : L.style(e, r, n, o);
                },
                e,
                a ? n : void 0,
                a
              );
            };
          });
        }),
        L.each(
          'blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu'.split(
            ' '
          ),
          function (t, e) {
            L.fn[e] = function (t, r) {
              return arguments.length > 0 ? this.on(e, null, t, r) : this.trigger(e);
            };
          }
        ),
        L.fn.extend({
          hover: function (t, e) {
            return this.mouseenter(t).mouseleave(e || t);
          },
        }),
        L.fn.extend({
          bind: function (t, e, r) {
            return this.on(t, null, e, r);
          },
          unbind: function (t, e) {
            return this.off(t, null, e);
          },
          delegate: function (t, e, r, i) {
            return this.on(e, t, r, i);
          },
          undelegate: function (t, e, r) {
            return 1 === arguments.length ? this.off(t, '**') : this.off(e, t || '**', r);
          },
        }),
        (L.proxy = function (t, e) {
          let r, i, n;
          if (('string' == typeof e && ((r = t[e]), (e = t), (t = r)), y(t)))
            return (
              (i = l.call(arguments, 2)),
              ((n = function () {
                return t.apply(e || this, i.concat(l.call(arguments)));
              }).guid = t.guid =
                t.guid || L.guid++),
              n
            );
        }),
        (L.holdReady = function (t) {
          t ? L.readyWait++ : L.ready(!0);
        }),
        (L.isArray = Array.isArray),
        (L.parseJSON = JSON.parse),
        (L.nodeName = w),
        (L.isFunction = y),
        (L.isWindow = E),
        (L.camelCase = z),
        (L.type = S),
        (L.now = Date.now),
        (L.isNumeric = function (t) {
          const e = L.type(t);
          return ('number' === e || 'string' === e) && !isNaN(t - parseFloat(t));
        }),
        void 0 ===
          (i = function () {
            return L;
          }.apply(e, [])) || (t.exports = i);
      const qe = r.jQuery,
        We = r.$;
      return (
        (L.noConflict = function (t) {
          return r.$ === L && (r.$ = We), t && r.jQuery === L && (r.jQuery = qe), L;
        }),
        n || (r.jQuery = r.$ = L),
        L
      );
    });
  },
  function (t, e, r) {
    'undefined' != typeof window &&
      (function (e, r) {
        t.exports = r();
      })(0, function () {
        return (function (t) {
          const e = {};
          function r(i) {
            if (e[i]) return e[i].exports;
            const n = (e[i] = { i: i, l: !1, exports: {} });
            return t[i].call(n.exports, n, n.exports, r), (n.l = !0), n.exports;
          }
          return (
            (r.m = t),
            (r.c = e),
            (r.d = function (t, e, i) {
              r.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: i });
            }),
            (r.r = function (t) {
              'undefined' != typeof Symbol &&
                Symbol.toStringTag &&
                Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
                Object.defineProperty(t, '__esModule', { value: !0 });
            }),
            (r.t = function (t, e) {
              if ((1 & e && (t = r(t)), 8 & e)) return t;
              if (4 & e && 'object' == typeof t && t && t.__esModule) return t;
              const i = Object.create(null);
              if (
                (r.r(i),
                Object.defineProperty(i, 'default', { enumerable: !0, value: t }),
                2 & e && 'string' != typeof t)
              )
                for (const n in t)
                  r.d(
                    i,
                    n,
                    function (e) {
                      return t[e];
                    }.bind(null, n)
                  );
              return i;
            }),
            (r.n = function (t) {
              const e =
                t && t.__esModule
                  ? function () {
                      return t.default;
                    }
                  : function () {
                      return t;
                    };
              return r.d(e, 'a', e), e;
            }),
            (r.o = function (t, e) {
              return Object.prototype.hasOwnProperty.call(t, e);
            }),
            (r.p = '/dist/'),
            r((r.s = './src/hls.ts'))
          );
        })({
          './node_modules/eventemitter3/index.js':
            /*!*********************************************!*\
  !*** ./node_modules/eventemitter3/index.js ***!
  \*********************************************/
            /*! no static exports found */ function (t, e, r) {
              'use strict';
              let i = Object.prototype.hasOwnProperty,
                n = '~';
              function s() {}
              function a(t, e, r, i, s) {
                if ('function' != typeof r) throw new TypeError('The listener must be a function');
                const a = new (function (t, e, r) {
                    (this.fn = t), (this.context = e), (this.once = r || !1);
                  })(r, i || t, s),
                  o = n ? n + e : e;
                return (
                  t._events[o]
                    ? t._events[o].fn
                      ? (t._events[o] = [t._events[o], a])
                      : t._events[o].push(a)
                    : ((t._events[o] = a), t._eventsCount++),
                  t
                );
              }
              function o(t, e) {
                0 == --t._eventsCount ? (t._events = new s()) : delete t._events[e];
              }
              function l() {
                (this._events = new s()), (this._eventsCount = 0);
              }
              Object.create && ((s.prototype = Object.create(null)), new s().__proto__ || (n = !1)),
                (l.prototype.eventNames = function () {
                  let t,
                    e,
                    r = [];
                  if (0 === this._eventsCount) return r;
                  for (e in (t = this._events)) i.call(t, e) && r.push(n ? e.slice(1) : e);
                  return Object.getOwnPropertySymbols ? r.concat(Object.getOwnPropertySymbols(t)) : r;
                }),
                (l.prototype.listeners = function (t) {
                  const e = n ? n + t : t,
                    r = this._events[e];
                  if (!r) return [];
                  if (r.fn) return [r.fn];
                  for (var i = 0, s = r.length, a = new Array(s); i < s; i++) a[i] = r[i].fn;
                  return a;
                }),
                (l.prototype.listenerCount = function (t) {
                  const e = n ? n + t : t,
                    r = this._events[e];
                  return r ? (r.fn ? 1 : r.length) : 0;
                }),
                (l.prototype.emit = function (t, e, r, i, s, a) {
                  const o = n ? n + t : t;
                  if (!this._events[o]) return !1;
                  let l,
                    u,
                    c = this._events[o],
                    d = arguments.length;
                  if (c.fn) {
                    switch ((c.once && this.removeListener(t, c.fn, void 0, !0), d)) {
                      case 1:
                        return c.fn.call(c.context), !0;
                      case 2:
                        return c.fn.call(c.context, e), !0;
                      case 3:
                        return c.fn.call(c.context, e, r), !0;
                      case 4:
                        return c.fn.call(c.context, e, r, i), !0;
                      case 5:
                        return c.fn.call(c.context, e, r, i, s), !0;
                      case 6:
                        return c.fn.call(c.context, e, r, i, s, a), !0;
                    }
                    for (u = 1, l = new Array(d - 1); u < d; u++) l[u - 1] = arguments[u];
                    c.fn.apply(c.context, l);
                  } else {
                    let f,
                      h = c.length;
                    for (u = 0; u < h; u++)
                      switch ((c[u].once && this.removeListener(t, c[u].fn, void 0, !0), d)) {
                        case 1:
                          c[u].fn.call(c[u].context);
                          break;
                        case 2:
                          c[u].fn.call(c[u].context, e);
                          break;
                        case 3:
                          c[u].fn.call(c[u].context, e, r);
                          break;
                        case 4:
                          c[u].fn.call(c[u].context, e, r, i);
                          break;
                        default:
                          if (!l) for (f = 1, l = new Array(d - 1); f < d; f++) l[f - 1] = arguments[f];
                          c[u].fn.apply(c[u].context, l);
                      }
                  }
                  return !0;
                }),
                (l.prototype.on = function (t, e, r) {
                  return a(this, t, e, r, !1);
                }),
                (l.prototype.once = function (t, e, r) {
                  return a(this, t, e, r, !0);
                }),
                (l.prototype.removeListener = function (t, e, r, i) {
                  const s = n ? n + t : t;
                  if (!this._events[s]) return this;
                  if (!e) return o(this, s), this;
                  const a = this._events[s];
                  if (a.fn) a.fn !== e || (i && !a.once) || (r && a.context !== r) || o(this, s);
                  else {
                    for (var l = 0, u = [], c = a.length; l < c; l++)
                      (a[l].fn !== e || (i && !a[l].once) || (r && a[l].context !== r)) && u.push(a[l]);
                    u.length ? (this._events[s] = 1 === u.length ? u[0] : u) : o(this, s);
                  }
                  return this;
                }),
                (l.prototype.removeAllListeners = function (t) {
                  let e;
                  return (
                    t
                      ? ((e = n ? n + t : t), this._events[e] && o(this, e))
                      : ((this._events = new s()), (this._eventsCount = 0)),
                    this
                  );
                }),
                (l.prototype.off = l.prototype.removeListener),
                (l.prototype.addListener = l.prototype.on),
                (l.prefixed = n),
                (l.EventEmitter = l),
                (t.exports = l);
            },
          './node_modules/url-toolkit/src/url-toolkit.js':
            /*!*****************************************************!*\
  !*** ./node_modules/url-toolkit/src/url-toolkit.js ***!
  \*****************************************************/
            /*! no static exports found */ function (t, e, r) {
              !(function (e) {
                var r =
                    /^((?:[a-zA-Z0-9+\-.]+:)?)(\/\/[^\/?#]*)?((?:[^\/?#]*\/)*[^;?#]*)?(;[^?#]*)?(\?[^#]*)?(#[^]*)?$/,
                  i = /^([^\/?#]*)([^]*)$/,
                  n = /(?:\/|^)\.(?=\/)/g,
                  s = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g,
                  a = {
                    buildAbsoluteURL: function (t, e, r) {
                      if (((r = r || {}), (t = t.trim()), !(e = e.trim()))) {
                        if (!r.alwaysNormalize) return t;
                        const n = a.parseURL(t);
                        if (!n) throw new Error('Error trying to parse base URL.');
                        return (n.path = a.normalizePath(n.path)), a.buildURLFromParts(n);
                      }
                      const s = a.parseURL(e);
                      if (!s) throw new Error('Error trying to parse relative URL.');
                      if (s.scheme)
                        return r.alwaysNormalize ? ((s.path = a.normalizePath(s.path)), a.buildURLFromParts(s)) : e;
                      const o = a.parseURL(t);
                      if (!o) throw new Error('Error trying to parse base URL.');
                      if (!o.netLoc && o.path && '/' !== o.path[0]) {
                        const l = i.exec(o.path);
                        (o.netLoc = l[1]), (o.path = l[2]);
                      }
                      o.netLoc && !o.path && (o.path = '/');
                      const u = {
                        scheme: o.scheme,
                        netLoc: s.netLoc,
                        path: null,
                        params: s.params,
                        query: s.query,
                        fragment: s.fragment,
                      };
                      if (!s.netLoc && ((u.netLoc = o.netLoc), '/' !== s.path[0]))
                        if (s.path) {
                          const c = o.path,
                            d = c.substring(0, c.lastIndexOf('/') + 1) + s.path;
                          u.path = a.normalizePath(d);
                        } else (u.path = o.path), s.params || ((u.params = o.params), s.query || (u.query = o.query));
                      return (
                        null === u.path && (u.path = r.alwaysNormalize ? a.normalizePath(s.path) : s.path),
                        a.buildURLFromParts(u)
                      );
                    },
                    parseURL: function (t) {
                      const e = r.exec(t);
                      return e
                        ? {
                            scheme: e[1] || '',
                            netLoc: e[2] || '',
                            path: e[3] || '',
                            params: e[4] || '',
                            query: e[5] || '',
                            fragment: e[6] || '',
                          }
                        : null;
                    },
                    normalizePath: function (t) {
                      for (
                        t = t.split('').reverse().join('').replace(n, '');
                        t.length !== (t = t.replace(s, '')).length;

                      );
                      return t.split('').reverse().join('');
                    },
                    buildURLFromParts: function (t) {
                      return t.scheme + t.netLoc + t.path + t.params + t.query + t.fragment;
                    },
                  };
                t.exports = a;
              })();
            },
          './node_modules/webworkify-webpack/index.js':
            /*!**************************************************!*\
  !*** ./node_modules/webworkify-webpack/index.js ***!
  \**************************************************/
            /*! no static exports found */ function (t, e, r) {
              function i(t) {
                const e = {};
                function r(i) {
                  if (e[i]) return e[i].exports;
                  const n = (e[i] = { i: i, l: !1, exports: {} });
                  return t[i].call(n.exports, n, n.exports, r), (n.l = !0), n.exports;
                }
                (r.m = t),
                  (r.c = e),
                  (r.i = function (t) {
                    return t;
                  }),
                  (r.d = function (t, e, i) {
                    r.o(t, e) || Object.defineProperty(t, e, { configurable: !1, enumerable: !0, get: i });
                  }),
                  (r.r = function (t) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                  }),
                  (r.n = function (t) {
                    const e =
                      t && t.__esModule
                        ? function () {
                            return t.default;
                          }
                        : function () {
                            return t;
                          };
                    return r.d(e, 'a', e), e;
                  }),
                  (r.o = function (t, e) {
                    return Object.prototype.hasOwnProperty.call(t, e);
                  }),
                  (r.p = '/'),
                  (r.oe = function (t) {
                    throw (console.error(t), t);
                  });
                const i = r((r.s = ENTRY_MODULE));
                return i.default || i;
              }
              const n = '[\\.|\\-|\\+|\\w|/|@]+',
                s = '\\(\\s*(/\\*.*?\\*/)?\\s*.*?(' + n + ').*?\\)';
              function a(t) {
                return (t + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
              }
              function o(t) {
                return !isNaN(1 * t);
              }
              function l(t, e, i) {
                const l = {};
                l[i] = [];
                const u = e.toString(),
                  c = u.match(/^function\s?\w*\(\w+,\s*\w+,\s*(\w+)\)/);
                if (!c) return l;
                for (var d, f = c[1], h = new RegExp('(\\\\n|\\W)' + a(f) + s, 'g'); (d = h.exec(u)); )
                  'dll-reference' !== d[3] && l[i].push(d[3]);
                for (
                  h = new RegExp('\\(' + a(f) + '\\("(dll-reference\\s(' + n + '))"\\)\\)' + s, 'g');
                  (d = h.exec(u));

                )
                  t[d[2]] || (l[i].push(d[1]), (t[d[2]] = r(d[1]).m)), (l[d[2]] = l[d[2]] || []), l[d[2]].push(d[4]);
                for (let p = Object.keys(l), v = 0; v < p.length; v++)
                  for (let g = 0; g < l[p[v]].length; g++) o(l[p[v]][g]) && (l[p[v]][g] = 1 * l[p[v]][g]);
                return l;
              }
              function u(t) {
                return Object.keys(t).reduce(function (e, r) {
                  return e || t[r].length > 0;
                }, !1);
              }
              t.exports = function (t, e) {
                e = e || {};
                let n = { main: r.m },
                  s = e.all
                    ? { main: Object.keys(n.main) }
                    : (function (t, e) {
                        for (var r = { main: [e] }, i = { main: [] }, n = { main: {} }; u(r); )
                          for (let s = Object.keys(r), a = 0; a < s.length; a++) {
                            const o = s[a],
                              c = r[o].pop();
                            if (((n[o] = n[o] || {}), !n[o][c] && t[o][c])) {
                              (n[o][c] = !0), (i[o] = i[o] || []), i[o].push(c);
                              for (let d = l(t, t[o][c], o), f = Object.keys(d), h = 0; h < f.length; h++)
                                (r[f[h]] = r[f[h]] || []), (r[f[h]] = r[f[h]].concat(d[f[h]]));
                            }
                          }
                        return i;
                      })(n, t),
                  a = '';
                Object.keys(s)
                  .filter(function (t) {
                    return 'main' !== t;
                  })
                  .forEach(function (t) {
                    for (var e = 0; s[t][e]; ) e++;
                    s[t].push(e),
                      (n[t][e] =
                        '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })'),
                      (a =
                        a +
                        'var ' +
                        t +
                        ' = (' +
                        i.toString().replace('ENTRY_MODULE', JSON.stringify(e)) +
                        ')({' +
                        s[t]
                          .map(function (e) {
                            return JSON.stringify(e) + ': ' + n[t][e].toString();
                          })
                          .join(',') +
                        '});\n');
                  }),
                  (a =
                    a +
                    'new ((' +
                    i.toString().replace('ENTRY_MODULE', JSON.stringify(t)) +
                    ')({' +
                    s.main
                      .map(function (t) {
                        return JSON.stringify(t) + ': ' + n.main[t].toString();
                      })
                      .join(',') +
                    '}))(self);');
                const o = new window.Blob([a], { type: 'text/javascript' });
                if (e.bare) return o;
                const c = (window.URL || window.webkitURL || window.mozURL || window.msURL).createObjectURL(o),
                  d = new window.Worker(c);
                return (d.objectURL = c), d;
              };
            },
          './src/config.ts':
            /*!***********************!*\
            !*** ./src/config.ts ***!
            \***********************/
            /*! exports provided: hlsDefaultConfig, mergeConfig, enableStreamingMode */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'hlsDefaultConfig', function () {
                  return L;
                }),
                r.d(e, 'mergeConfig', function () {
                  return A;
                }),
                r.d(e, 'enableStreamingMode', function () {
                  return D;
                });
              const i = r(/*! ./controller/abr-controller */ './src/controller/abr-controller.ts'),
                n = r(/*! ./controller/audio-stream-controller */ './src/controller/audio-stream-controller.ts'),
                s = r(/*! ./controller/audio-track-controller */ './src/controller/audio-track-controller.ts'),
                a = r(/*! ./controller/subtitle-stream-controller */ './src/controller/subtitle-stream-controller.ts'),
                o = r(/*! ./controller/subtitle-track-controller */ './src/controller/subtitle-track-controller.ts'),
                l = r(/*! ./controller/buffer-controller */ './src/controller/buffer-controller.ts'),
                u = r(/*! ./controller/timeline-controller */ './src/controller/timeline-controller.ts'),
                c = r(/*! ./controller/cap-level-controller */ './src/controller/cap-level-controller.ts'),
                d = r(/*! ./controller/fps-controller */ './src/controller/fps-controller.ts'),
                f = r(/*! ./controller/eme-controller */ './src/controller/eme-controller.ts'),
                h = r(/*! ./controller/cmcd-controller */ './src/controller/cmcd-controller.ts'),
                p = r(/*! ./utils/xhr-loader */ './src/utils/xhr-loader.ts'),
                v = r(/*! ./utils/fetch-loader */ './src/utils/fetch-loader.ts'),
                g = r(/*! ./utils/cues */ './src/utils/cues.ts'),
                m = r(/*! ./utils/mediakeys-helper */ './src/utils/mediakeys-helper.ts'),
                y = r(/*! ./utils/logger */ './src/utils/logger.ts');
              function E() {
                return (E =
                  Object.assign ||
                  function (t) {
                    for (let e = 1; e < arguments.length; e++) {
                      const r = arguments[e];
                      for (const i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
                    }
                    return t;
                  }).apply(this, arguments);
              }
              function T(t, e) {
                const r = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                  let i = Object.getOwnPropertySymbols(t);
                  e &&
                    (i = i.filter(function (e) {
                      return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })),
                    r.push.apply(r, i);
                }
                return r;
              }
              function b(t) {
                for (let e = 1; e < arguments.length; e++) {
                  var r = null != arguments[e] ? arguments[e] : {};
                  e % 2
                    ? T(Object(r), !0).forEach(function (e) {
                        S(t, e, r[e]);
                      })
                    : Object.getOwnPropertyDescriptors
                      ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r))
                      : T(Object(r)).forEach(function (e) {
                          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                        });
                }
                return t;
              }
              function S(t, e, r) {
                return (
                  e in t
                    ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 })
                    : (t[e] = r),
                  t
                );
              }
              var L = b(
                b(
                  {
                    autoStartLoad: !0,
                    startPosition: -1,
                    defaultAudioCodec: void 0,
                    debug: !1,
                    capLevelOnFPSDrop: !1,
                    capLevelToPlayerSize: !1,
                    initialLiveManifestSize: 1,
                    maxBufferLength: 30,
                    backBufferLength: 1 / 0,
                    maxBufferSize: 6e7,
                    maxBufferHole: 0.1,
                    highBufferWatchdogPeriod: 2,
                    nudgeOffset: 0.1,
                    nudgeMaxRetry: 3,
                    maxFragLookUpTolerance: 0.25,
                    liveSyncDurationCount: 3,
                    liveMaxLatencyDurationCount: 1 / 0,
                    liveSyncDuration: void 0,
                    liveMaxLatencyDuration: void 0,
                    maxLiveSyncPlaybackRate: 1,
                    liveDurationInfinity: !1,
                    liveBackBufferLength: null,
                    maxMaxBufferLength: 600,
                    enableWorker: !1,
                    enableSoftwareAES: !0,
                    manifestLoadingTimeOut: 1e4,
                    manifestLoadingMaxRetry: 1,
                    manifestLoadingRetryDelay: 1e3,
                    manifestLoadingMaxRetryTimeout: 64e3,
                    startLevel: void 0,
                    levelLoadingTimeOut: 1e4,
                    levelLoadingMaxRetry: 4,
                    levelLoadingRetryDelay: 1e3,
                    levelLoadingMaxRetryTimeout: 64e3,
                    fragLoadingTimeOut: 2e4,
                    fragLoadingMaxRetry: 6,
                    fragLoadingRetryDelay: 1e3,
                    fragLoadingMaxRetryTimeout: 64e3,
                    startFragPrefetch: !1,
                    fpsDroppedMonitoringPeriod: 5e3,
                    fpsDroppedMonitoringThreshold: 0.2,
                    appendErrorMaxRetry: 3,
                    loader: p.default,
                    fLoader: void 0,
                    pLoader: void 0,
                    xhrSetup: void 0,
                    licenseXhrSetup: void 0,
                    licenseResponseCallback: void 0,
                    abrController: i.default,
                    bufferController: l.default,
                    capLevelController: c.default,
                    fpsController: d.default,
                    stretchShortVideoTrack: !1,
                    maxAudioFramesDrift: 1,
                    forceKeyFrameOnDiscontinuity: !0,
                    abrEwmaFastLive: 3,
                    abrEwmaSlowLive: 9,
                    abrEwmaFastVoD: 3,
                    abrEwmaSlowVoD: 9,
                    abrEwmaDefaultEstimate: 5e5,
                    abrBandWidthFactor: 0.95,
                    abrBandWidthUpFactor: 0.7,
                    abrMaxWithRealBitrate: !1,
                    maxStarvationDelay: 4,
                    maxLoadingDelay: 4,
                    minAutoBitrate: 0,
                    emeEnabled: !1,
                    widevineLicenseUrl: void 0,
                    drmSystemOptions: {},
                    requestMediaKeySystemAccessFunc: m.requestMediaKeySystemAccess,
                    testBandwidth: !0,
                    progressive: !1,
                    lowLatencyMode: !0,
                    cmcd: void 0,
                  },
                  {
                    cueHandler: g.default,
                    enableCEA708Captions: !0,
                    enableWebVTT: !0,
                    enableIMSC1: !0,
                    captionsTextTrack1Label: 'English',
                    captionsTextTrack1LanguageCode: 'en',
                    captionsTextTrack2Label: 'Spanish',
                    captionsTextTrack2LanguageCode: 'es',
                    captionsTextTrack3Label: 'Unknown CC',
                    captionsTextTrack3LanguageCode: '',
                    captionsTextTrack4Label: 'Unknown CC',
                    captionsTextTrack4LanguageCode: '',
                    renderTextTracksNatively: !0,
                  }
                ),
                {},
                {
                  subtitleStreamController: a.SubtitleStreamController,
                  subtitleTrackController: o.default,
                  timelineController: u.TimelineController,
                  audioStreamController: n.default,
                  audioTrackController: s.default,
                  emeController: f.default,
                  cmcdController: h.default,
                }
              );
              function A(t, e) {
                if (
                  (e.liveSyncDurationCount || e.liveMaxLatencyDurationCount) &&
                  (e.liveSyncDuration || e.liveMaxLatencyDuration)
                )
                  throw new Error(
                    "Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration"
                  );
                if (
                  void 0 !== e.liveMaxLatencyDurationCount &&
                  (void 0 === e.liveSyncDurationCount || e.liveMaxLatencyDurationCount <= e.liveSyncDurationCount)
                )
                  throw new Error(
                    'Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"'
                  );
                if (
                  void 0 !== e.liveMaxLatencyDuration &&
                  (void 0 === e.liveSyncDuration || e.liveMaxLatencyDuration <= e.liveSyncDuration)
                )
                  throw new Error(
                    'Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"'
                  );
                return E({}, t, e);
              }
              function D(t) {
                const e = t.loader;
                e !== v.default && e !== p.default
                  ? (y.logger.log('[config]: Custom loader detected, cannot enable progressive streaming'),
                    (t.progressive = !1))
                  : Object(v.fetchSupported)() &&
                    ((t.loader = v.default),
                    (t.progressive = !0),
                    (t.enableSoftwareAES = !0),
                    y.logger.log('[config]: Progressive streaming enabled, using FetchLoader'));
              }
            },
          './src/controller/abr-controller.ts':
            /*!******************************************!*\
  !*** ./src/controller/abr-controller.ts ***!
  \******************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              const i = r(/*! ./src/polyfills/number */ './src/polyfills/number.ts'),
                n = r(/*! ../utils/ewma-bandwidth-estimator */ './src/utils/ewma-bandwidth-estimator.ts'),
                s = r(/*! ../events */ './src/events.ts'),
                a = r(/*! ../utils/buffer-helper */ './src/utils/buffer-helper.ts'),
                o = r(/*! ../errors */ './src/errors.ts'),
                l = r(/*! ../types/loader */ './src/types/loader.ts'),
                u = r(/*! ../utils/logger */ './src/utils/logger.ts');
              function c(t, e) {
                for (let r = 0; r < e.length; r++) {
                  const i = e[r];
                  (i.enumerable = i.enumerable || !1),
                    (i.configurable = !0),
                    'value' in i && (i.writable = !0),
                    Object.defineProperty(t, i.key, i);
                }
              }
              const d = (function () {
                function t(t) {
                  (this.hls = void 0),
                    (this.lastLoadedFragLevel = 0),
                    (this._nextAutoLevel = -1),
                    (this.timer = void 0),
                    (this.onCheck = this._abandonRulesCheck.bind(this)),
                    (this.fragCurrent = null),
                    (this.partCurrent = null),
                    (this.bitrateTestDelay = 0),
                    (this.bwEstimator = void 0),
                    (this.hls = t);
                  const e = t.config;
                  (this.bwEstimator = new n.default(e.abrEwmaSlowVoD, e.abrEwmaFastVoD, e.abrEwmaDefaultEstimate)),
                    this.registerListeners();
                }
                const e = t.prototype;
                return (
                  (e.registerListeners = function () {
                    const t = this.hls;
                    t.on(s.Events.FRAG_LOADING, this.onFragLoading, this),
                      t.on(s.Events.FRAG_LOADED, this.onFragLoaded, this),
                      t.on(s.Events.FRAG_BUFFERED, this.onFragBuffered, this),
                      t.on(s.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                      t.on(s.Events.ERROR, this.onError, this);
                  }),
                  (e.unregisterListeners = function () {
                    const t = this.hls;
                    t.off(s.Events.FRAG_LOADING, this.onFragLoading, this),
                      t.off(s.Events.FRAG_LOADED, this.onFragLoaded, this),
                      t.off(s.Events.FRAG_BUFFERED, this.onFragBuffered, this),
                      t.off(s.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                      t.off(s.Events.ERROR, this.onError, this);
                  }),
                  (e.destroy = function () {
                    this.unregisterListeners(),
                      this.clearTimer(),
                      (this.hls = this.onCheck = null),
                      (this.fragCurrent = this.partCurrent = null);
                  }),
                  (e.onFragLoading = function (t, e) {
                    let r,
                      i = e.frag;
                    i.type === l.PlaylistLevelType.MAIN &&
                      (this.timer ||
                        ((this.fragCurrent = i),
                        (this.partCurrent = null != (r = e.part) ? r : null),
                        (this.timer = self.setInterval(this.onCheck, 100))));
                  }),
                  (e.onLevelLoaded = function (t, e) {
                    const r = this.hls.config;
                    e.details.live
                      ? this.bwEstimator.update(r.abrEwmaSlowLive, r.abrEwmaFastLive)
                      : this.bwEstimator.update(r.abrEwmaSlowVoD, r.abrEwmaFastVoD);
                  }),
                  (e._abandonRulesCheck = function () {
                    const t = this.fragCurrent,
                      e = this.partCurrent,
                      r = this.hls,
                      n = r.autoLevelEnabled,
                      o = r.config,
                      l = r.media;
                    if (t && l) {
                      const c = e ? e.stats : t.stats,
                        d = e ? e.duration : t.duration;
                      if (c.aborted)
                        return (
                          u.logger.warn('frag loader destroy or aborted, disarm abandonRules'),
                          this.clearTimer(),
                          void (this._nextAutoLevel = -1)
                        );
                      if (n && !l.paused && l.playbackRate && l.readyState) {
                        const f = performance.now() - c.loading.start,
                          h = Math.abs(l.playbackRate);
                        if (!(f <= (500 * d) / h)) {
                          const p = r.levels,
                            v = r.minAutoLevel,
                            g = p[t.level],
                            m = c.total || Math.max(c.loaded, Math.round((d * g.maxBitrate) / 8)),
                            y = Math.max(1, c.bwEstimate ? c.bwEstimate / 8 : (1e3 * c.loaded) / f),
                            E = (m - c.loaded) / y,
                            T = l.currentTime,
                            b = (a.BufferHelper.bufferInfo(l, T, o.maxBufferHole).end - T) / h;
                          if (!(b >= (2 * d) / h || E <= b)) {
                            let S,
                              L = Number.POSITIVE_INFINITY;
                            for (S = t.level - 1; S > v; S--) {
                              if ((L = (d * p[S].maxBitrate) / (6.4 * y)) < b) break;
                            }
                            if (!(L >= E)) {
                              const A = this.bwEstimator.getEstimate();
                              u.logger.warn(
                                'Fragment ' +
                                  t.sn +
                                  (e ? ' part ' + e.index : '') +
                                  ' of level ' +
                                  t.level +
                                  ' is loading too slowly and will cause an underbuffer; aborting and switching to level ' +
                                  S +
                                  '\n      Current BW estimate: ' +
                                  (Object(i.isFiniteNumber)(A) ? (A / 1024).toFixed(3) : 'Unknown') +
                                  ' Kb/s\n      Estimated load time for current fragment: ' +
                                  E.toFixed(3) +
                                  ' s\n      Estimated load time for the next fragment: ' +
                                  L.toFixed(3) +
                                  ' s\n      Time to underbuffer: ' +
                                  b.toFixed(3) +
                                  ' s'
                              ),
                                (r.nextLoadLevel = S),
                                this.bwEstimator.sample(f, c.loaded),
                                this.clearTimer(),
                                t.loader && ((this.fragCurrent = this.partCurrent = null), t.loader.abort()),
                                r.trigger(s.Events.FRAG_LOAD_EMERGENCY_ABORTED, { frag: t, part: e, stats: c });
                            }
                          }
                        }
                      }
                    }
                  }),
                  (e.onFragLoaded = function (t, e) {
                    const r = e.frag,
                      n = e.part;
                    if (r.type === l.PlaylistLevelType.MAIN && Object(i.isFiniteNumber)(r.sn)) {
                      const a = n ? n.stats : r.stats,
                        o = n ? n.duration : r.duration;
                      if (
                        (this.clearTimer(),
                        (this.lastLoadedFragLevel = r.level),
                        (this._nextAutoLevel = -1),
                        this.hls.config.abrMaxWithRealBitrate)
                      ) {
                        const u = this.hls.levels[r.level],
                          c = (u.loaded ? u.loaded.bytes : 0) + a.loaded,
                          d = (u.loaded ? u.loaded.duration : 0) + o;
                        (u.loaded = { bytes: c, duration: d }), (u.realBitrate = Math.round((8 * c) / d));
                      }
                      if (r.bitrateTest) {
                        const f = { stats: a, frag: r, part: n, id: r.type };
                        this.onFragBuffered(s.Events.FRAG_BUFFERED, f), (r.bitrateTest = !1);
                      }
                    }
                  }),
                  (e.onFragBuffered = function (t, e) {
                    const r = e.frag,
                      i = e.part,
                      n = i ? i.stats : r.stats;
                    if (!n.aborted && r.type === l.PlaylistLevelType.MAIN && 'initSegment' !== r.sn) {
                      const s = n.parsing.end - n.loading.start;
                      this.bwEstimator.sample(s, n.loaded),
                        (n.bwEstimate = this.bwEstimator.getEstimate()),
                        r.bitrateTest ? (this.bitrateTestDelay = s / 1e3) : (this.bitrateTestDelay = 0);
                    }
                  }),
                  (e.onError = function (t, e) {
                    switch (e.details) {
                      case o.ErrorDetails.FRAG_LOAD_ERROR:
                      case o.ErrorDetails.FRAG_LOAD_TIMEOUT:
                        this.clearTimer();
                    }
                  }),
                  (e.clearTimer = function () {
                    self.clearInterval(this.timer), (this.timer = void 0);
                  }),
                  (e.getNextABRAutoLevel = function () {
                    let t = this.fragCurrent,
                      e = this.partCurrent,
                      r = this.hls,
                      i = r.maxAutoLevel,
                      n = r.config,
                      s = r.minAutoLevel,
                      o = r.media,
                      l = e ? e.duration : t ? t.duration : 0,
                      c = o ? o.currentTime : 0,
                      d = o && 0 !== o.playbackRate ? Math.abs(o.playbackRate) : 1,
                      f = this.bwEstimator ? this.bwEstimator.getEstimate() : n.abrEwmaDefaultEstimate,
                      h = (a.BufferHelper.bufferInfo(o, c, n.maxBufferHole).end - c) / d,
                      p = this.findBestLevel(f, s, i, h, n.abrBandWidthFactor, n.abrBandWidthUpFactor);
                    if (p >= 0) return p;
                    u.logger.trace(
                      (h ? 'rebuffering expected' : 'buffer is empty') + ', finding optimal quality level'
                    );
                    let v = l ? Math.min(l, n.maxStarvationDelay) : n.maxStarvationDelay,
                      g = n.abrBandWidthFactor,
                      m = n.abrBandWidthUpFactor;
                    if (!h) {
                      const y = this.bitrateTestDelay;
                      if (y)
                        (v = (l ? Math.min(l, n.maxLoadingDelay) : n.maxLoadingDelay) - y),
                          u.logger.trace(
                            'bitrate test took ' +
                              Math.round(1e3 * y) +
                              'ms, set first fragment max fetchDuration to ' +
                              Math.round(1e3 * v) +
                              ' ms'
                          ),
                          (g = m = 1);
                    }
                    return (p = this.findBestLevel(f, s, i, h + v, g, m)), Math.max(p, 0);
                  }),
                  (e.findBestLevel = function (t, e, r, i, n, s) {
                    for (
                      var a,
                        o = this.fragCurrent,
                        l = this.partCurrent,
                        c = this.lastLoadedFragLevel,
                        d = this.hls.levels,
                        f = d[c],
                        h = !(null === f || void 0 === f || null === (a = f.details) || void 0 === a || !a.live),
                        p = null === f || void 0 === f ? void 0 : f.codecSet,
                        v = l ? l.duration : o ? o.duration : 0,
                        g = r;
                      g >= e;
                      g--
                    ) {
                      const m = d[g];
                      if (m && (!p || m.codecSet === p)) {
                        let y = m.details,
                          E =
                            (l
                              ? null === y || void 0 === y
                                ? void 0
                                : y.partTarget
                              : null === y || void 0 === y
                                ? void 0
                                : y.averagetargetduration) || v,
                          T = void 0;
                        T = g <= c ? n * t : s * t;
                        const b = d[g].maxBitrate,
                          S = (b * E) / T;
                        if (
                          (u.logger.trace(
                            'level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: ' +
                              g +
                              '/' +
                              Math.round(T) +
                              '/' +
                              b +
                              '/' +
                              E +
                              '/' +
                              i +
                              '/' +
                              S
                          ),
                          T > b && (!S || (h && !this.bitrateTestDelay) || S < i))
                        )
                          return g;
                      }
                    }
                    return -1;
                  }),
                  (function (t, e, r) {
                    e && c(t.prototype, e), r && c(t, r);
                  })(t, [
                    {
                      key: 'nextAutoLevel',
                      get: function () {
                        const t = this._nextAutoLevel,
                          e = this.bwEstimator;
                        if (!(-1 === t || (e && e.canEstimate()))) return t;
                        let r = this.getNextABRAutoLevel();
                        return -1 !== t && (r = Math.min(t, r)), r;
                      },
                      set: function (t) {
                        this._nextAutoLevel = t;
                      },
                    },
                  ]),
                  t
                );
              })();
              e.default = d;
            },
          './src/controller/audio-stream-controller.ts':
            /*!***************************************************!*\
  !*** ./src/controller/audio-stream-controller.ts ***!
  \***************************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              const i = r(/*! ./src/polyfills/number */ './src/polyfills/number.ts'),
                n = r(/*! ./base-stream-controller */ './src/controller/base-stream-controller.ts'),
                s = r(/*! ../events */ './src/events.ts'),
                a = r(/*! ../utils/buffer-helper */ './src/utils/buffer-helper.ts'),
                o = r(/*! ./fragment-tracker */ './src/controller/fragment-tracker.ts'),
                l = r(/*! ../types/level */ './src/types/level.ts'),
                u = r(/*! ../types/loader */ './src/types/loader.ts'),
                c = r(/*! ../loader/fragment */ './src/loader/fragment.ts'),
                d = r(/*! ../demux/chunk-cache */ './src/demux/chunk-cache.ts'),
                f = r(/*! ../demux/transmuxer-interface */ './src/demux/transmuxer-interface.ts'),
                h = r(/*! ../types/transmuxer */ './src/types/transmuxer.ts'),
                p = r(/*! ./fragment-finders */ './src/controller/fragment-finders.ts'),
                v = r(/*! ../utils/discontinuities */ './src/utils/discontinuities.ts'),
                g = r(/*! ../errors */ './src/errors.ts'),
                m = r(/*! ../utils/logger */ './src/utils/logger.ts');
              function y() {
                return (y =
                  Object.assign ||
                  function (t) {
                    for (let e = 1; e < arguments.length; e++) {
                      const r = arguments[e];
                      for (const i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
                    }
                    return t;
                  }).apply(this, arguments);
              }
              function E(t, e) {
                return (E =
                  Object.setPrototypeOf ||
                  function (t, e) {
                    return (t.__proto__ = e), t;
                  })(t, e);
              }
              const T = (function (t) {
                function e(e, r) {
                  let i;
                  return (
                    ((i = t.call(this, e, r, '[audio-stream-controller]') || this).videoBuffer = null),
                    (i.videoTrackCC = -1),
                    (i.waitingVideoCC = -1),
                    (i.audioSwitch = !1),
                    (i.trackId = -1),
                    (i.waitingData = null),
                    (i.mainDetails = null),
                    (i.bufferFlushed = !1),
                    i._registerListeners(),
                    i
                  );
                }
                !(function (t, e) {
                  (t.prototype = Object.create(e.prototype)), (t.prototype.constructor = t), E(t, e);
                })(e, t);
                const r = e.prototype;
                return (
                  (r.onHandlerDestroying = function () {
                    this._unregisterListeners(), (this.mainDetails = null);
                  }),
                  (r._registerListeners = function () {
                    const t = this.hls;
                    t.on(s.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                      t.on(s.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                      t.on(s.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                      t.on(s.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                      t.on(s.Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this),
                      t.on(s.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this),
                      t.on(s.Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this),
                      t.on(s.Events.ERROR, this.onError, this),
                      t.on(s.Events.BUFFER_RESET, this.onBufferReset, this),
                      t.on(s.Events.BUFFER_CREATED, this.onBufferCreated, this),
                      t.on(s.Events.BUFFER_FLUSHED, this.onBufferFlushed, this),
                      t.on(s.Events.INIT_PTS_FOUND, this.onInitPtsFound, this),
                      t.on(s.Events.FRAG_BUFFERED, this.onFragBuffered, this);
                  }),
                  (r._unregisterListeners = function () {
                    const t = this.hls;
                    t.off(s.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                      t.off(s.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                      t.off(s.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                      t.off(s.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                      t.off(s.Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this),
                      t.off(s.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this),
                      t.off(s.Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this),
                      t.off(s.Events.ERROR, this.onError, this),
                      t.off(s.Events.BUFFER_RESET, this.onBufferReset, this),
                      t.off(s.Events.BUFFER_CREATED, this.onBufferCreated, this),
                      t.off(s.Events.BUFFER_FLUSHED, this.onBufferFlushed, this),
                      t.off(s.Events.INIT_PTS_FOUND, this.onInitPtsFound, this),
                      t.off(s.Events.FRAG_BUFFERED, this.onFragBuffered, this);
                  }),
                  (r.onInitPtsFound = function (t, e) {
                    const r = e.frag,
                      i = e.id,
                      s = e.initPTS;
                    if ('main' === i) {
                      const a = r.cc;
                      (this.initPTS[r.cc] = s),
                        this.log('InitPTS for cc: ' + a + ' found from main: ' + s),
                        (this.videoTrackCC = a),
                        this.state === n.State.WAITING_INIT_PTS && this.tick();
                    }
                  }),
                  (r.startLoad = function (t) {
                    if (!this.levels) return (this.startPosition = t), void (this.state = n.State.STOPPED);
                    const e = this.lastCurrentTime;
                    this.stopLoad(),
                      this.setInterval(100),
                      (this.fragLoadError = 0),
                      e > 0 && -1 === t
                        ? (this.log('Override startPosition with lastCurrentTime @' + e.toFixed(3)),
                          (this.state = n.State.IDLE))
                        : ((this.loadedmetadata = !1), (this.state = n.State.WAITING_TRACK)),
                      (this.nextLoadPosition = this.startPosition = this.lastCurrentTime = t),
                      this.tick();
                  }),
                  (r.doTick = function () {
                    switch (this.state) {
                      case n.State.IDLE:
                        this.doTickIdle();
                        break;
                      case n.State.WAITING_TRACK:
                        var e,
                          r = this.levels,
                          i = this.trackId,
                          s =
                            null === r || void 0 === r
                              ? void 0
                              : null === (e = r[i]) || void 0 === e
                                ? void 0
                                : e.details;
                        if (s) {
                          if (this.waitForCdnTuneIn(s)) break;
                          this.state = n.State.WAITING_INIT_PTS;
                        }
                        break;
                      case n.State.FRAG_LOADING_WAITING_RETRY:
                        var o,
                          l = performance.now(),
                          u = this.retryDate;
                        (!u || l >= u || (null !== (o = this.media) && void 0 !== o && o.seeking)) &&
                          (this.log('RetryDate reached, switch back to IDLE state'), (this.state = n.State.IDLE));
                        break;
                      case n.State.WAITING_INIT_PTS:
                        var c = this.waitingData;
                        if (c) {
                          const d = c.frag,
                            f = c.part,
                            h = c.cache,
                            v = c.complete;
                          if (void 0 !== this.initPTS[d.cc]) {
                            (this.waitingData = null), (this.waitingVideoCC = -1), (this.state = n.State.FRAG_LOADING);
                            const g = { frag: d, part: f, payload: h.flush(), networkDetails: null };
                            this._handleFragmentLoadProgress(g),
                              v && t.prototype._handleFragmentLoadComplete.call(this, g);
                          } else if (this.videoTrackCC !== this.waitingVideoCC)
                            m.logger.log(
                              'Waiting fragment cc (' + d.cc + ') cancelled because video is at cc ' + this.videoTrackCC
                            ),
                              this.clearWaitingFragment();
                          else {
                            const y = this.getLoadPosition(),
                              E = a.BufferHelper.bufferInfo(this.mediaBuffer, y, this.config.maxBufferHole);
                            Object(p.fragmentWithinToleranceTest)(E.end, this.config.maxFragLookUpTolerance, d) < 0 &&
                              (m.logger.log(
                                'Waiting fragment cc (' +
                                  d.cc +
                                  ') @ ' +
                                  d.start +
                                  ' cancelled because another fragment at ' +
                                  E.end +
                                  ' is needed'
                              ),
                              this.clearWaitingFragment());
                          }
                        } else this.state = n.State.IDLE;
                    }
                    this.onTickEnd();
                  }),
                  (r.clearWaitingFragment = function () {
                    const t = this.waitingData;
                    t &&
                      (this.fragmentTracker.removeFragment(t.frag),
                      (this.waitingData = null),
                      (this.waitingVideoCC = -1),
                      (this.state = n.State.IDLE));
                  }),
                  (r.onTickEnd = function () {
                    const t = this.media;
                    if (t && t.readyState) {
                      const e = (this.mediaBuffer ? this.mediaBuffer : t).buffered;
                      !this.loadedmetadata && e.length && (this.loadedmetadata = !0),
                        (this.lastCurrentTime = t.currentTime);
                    }
                  }),
                  (r.doTickIdle = function () {
                    let t,
                      e,
                      r = this.hls,
                      i = this.levels,
                      a = this.media,
                      o = this.trackId,
                      l = r.config;
                    if (i && i[o] && (a || (!this.startFragRequested && l.startFragPrefetch))) {
                      const d = i[o].details;
                      if (!d || (d.live && this.levelLastLoaded !== o) || this.waitForCdnTuneIn(d))
                        this.state = n.State.WAITING_TRACK;
                      else {
                        this.bufferFlushed &&
                          ((this.bufferFlushed = !1),
                          this.afterBufferFlushed(
                            this.mediaBuffer ? this.mediaBuffer : this.media,
                            c.ElementaryStreamTypes.AUDIO,
                            u.PlaylistLevelType.AUDIO
                          ));
                        const f = this.getFwdBufferInfo(
                          this.mediaBuffer ? this.mediaBuffer : this.media,
                          u.PlaylistLevelType.AUDIO
                        );
                        if (null !== f) {
                          const h = f.len,
                            p = this.getMaxBufferLength(),
                            v = this.audioSwitch;
                          if (!(h >= p) || v) {
                            if (!v && this._streamEnded(f, d))
                              return (
                                r.trigger(s.Events.BUFFER_EOS, { type: 'audio' }), void (this.state = n.State.ENDED)
                              );
                            let g = d.fragments[0].start,
                              m = f.end;
                            if (v) {
                              const y = this.getLoadPosition();
                              (m = y),
                                d.PTSKnown &&
                                  y < g &&
                                  (f.end > g || f.nextStart) &&
                                  (this.log('Alt audio track ahead of main track, seek to start of alt audio track'),
                                  (a.currentTime = g + 0.05));
                            }
                            const E = this.getNextFragment(m, d);
                            E
                              ? 'identity' !== (null === (t = E.decryptdata) || void 0 === t ? void 0 : t.keyFormat) ||
                                (null !== (e = E.decryptdata) && void 0 !== e && e.key)
                                ? this.loadFragment(E, d, m)
                                : this.loadKey(E, d)
                              : (this.bufferFlushed = !0);
                          }
                        }
                      }
                    }
                  }),
                  (r.getMaxBufferLength = function () {
                    const e = t.prototype.getMaxBufferLength.call(this),
                      r = this.getFwdBufferInfo(
                        this.videoBuffer ? this.videoBuffer : this.media,
                        u.PlaylistLevelType.MAIN
                      );
                    return null === r ? e : Math.max(e, r.len);
                  }),
                  (r.onMediaDetaching = function () {
                    (this.videoBuffer = null), t.prototype.onMediaDetaching.call(this);
                  }),
                  (r.onAudioTracksUpdated = function (t, e) {
                    const r = e.audioTracks;
                    this.resetTransmuxer(),
                      (this.levels = r.map(function (t) {
                        return new l.Level(t);
                      }));
                  }),
                  (r.onAudioTrackSwitching = function (t, e) {
                    const r = !!e.url;
                    this.trackId = e.id;
                    const i = this.fragCurrent;
                    null !== i && void 0 !== i && i.loader && i.loader.abort(),
                      (this.fragCurrent = null),
                      this.clearWaitingFragment(),
                      r ? this.setInterval(100) : this.resetTransmuxer(),
                      r ? ((this.audioSwitch = !0), (this.state = n.State.IDLE)) : (this.state = n.State.STOPPED),
                      this.tick();
                  }),
                  (r.onManifestLoading = function () {
                    (this.mainDetails = null),
                      this.fragmentTracker.removeAllFragments(),
                      (this.startPosition = this.lastCurrentTime = 0),
                      (this.bufferFlushed = !1);
                  }),
                  (r.onLevelLoaded = function (t, e) {
                    this.mainDetails = e.details;
                  }),
                  (r.onAudioTrackLoaded = function (t, e) {
                    let r,
                      i = this.levels,
                      s = e.details,
                      a = e.id;
                    if (i) {
                      this.log(
                        'Track ' + a + ' loaded [' + s.startSN + ',' + s.endSN + '],duration:' + s.totalduration
                      );
                      let o = i[a],
                        l = 0;
                      if (s.live || (null !== (r = o.details) && void 0 !== r && r.live)) {
                        const u = this.mainDetails;
                        if ((s.fragments[0] || (s.deltaUpdateFailed = !0), s.deltaUpdateFailed || !u)) return;
                        !o.details && s.hasProgramDateTime && u.hasProgramDateTime
                          ? (Object(v.alignMediaPlaylistByPDT)(s, u), (l = s.fragments[0].start))
                          : (l = this.alignPlaylists(s, o.details));
                      }
                      (o.details = s),
                        (this.levelLastLoaded = a),
                        this.startFragRequested || (!this.mainDetails && s.live) || this.setStartPosition(o.details, l),
                        this.state !== n.State.WAITING_TRACK || this.waitForCdnTuneIn(s) || (this.state = n.State.IDLE),
                        this.tick();
                    } else this.warn('Audio tracks were reset while loading level ' + a);
                  }),
                  (r._handleFragmentLoadProgress = function (t) {
                    let e,
                      r = t.frag,
                      i = t.part,
                      s = t.payload,
                      a = this.config,
                      o = this.trackId,
                      l = this.levels;
                    if (l) {
                      const c = l[o];
                      console.assert(c, 'Audio track is defined on fragment load progress');
                      const p = c.details;
                      console.assert(p, 'Audio track details are defined on fragment load progress');
                      let v = a.defaultAudioCodec || c.audioCodec || 'mp4a.40.2',
                        g = this.transmuxer;
                      g ||
                        (g = this.transmuxer =
                          new f.default(
                            this.hls,
                            u.PlaylistLevelType.AUDIO,
                            this._handleTransmuxComplete.bind(this),
                            this._handleTransmuxerFlush.bind(this)
                          ));
                      const y = this.initPTS[r.cc],
                        E = null === (e = r.initSegment) || void 0 === e ? void 0 : e.data;
                      if (void 0 !== y) {
                        const T = i ? i.index : -1,
                          b = -1 !== T,
                          S = new h.ChunkMetadata(r.level, r.sn, r.stats.chunkCount, s.byteLength, T, b);
                        g.push(s, E, v, '', r, i, p.totalduration, !1, S, y);
                      } else {
                        m.logger.log(
                          'Unknown video PTS for cc ' +
                            r.cc +
                            ', waiting for video PTS before demuxing audio frag ' +
                            r.sn +
                            ' of [' +
                            p.startSN +
                            ' ,' +
                            p.endSN +
                            '],track ' +
                            o
                        ),
                          (this.waitingData = this.waitingData || {
                            frag: r,
                            part: i,
                            cache: new d.default(),
                            complete: !1,
                          }).cache.push(new Uint8Array(s)),
                          (this.waitingVideoCC = this.videoTrackCC),
                          (this.state = n.State.WAITING_INIT_PTS);
                      }
                    } else
                      this.warn(
                        'Audio tracks were reset while fragment load was in progress. Fragment ' +
                          r.sn +
                          ' of level ' +
                          r.level +
                          ' will not be buffered'
                      );
                  }),
                  (r._handleFragmentLoadComplete = function (e) {
                    this.waitingData
                      ? (this.waitingData.complete = !0)
                      : t.prototype._handleFragmentLoadComplete.call(this, e);
                  }),
                  (r.onBufferReset = function () {
                    (this.mediaBuffer = this.videoBuffer = null), (this.loadedmetadata = !1);
                  }),
                  (r.onBufferCreated = function (t, e) {
                    const r = e.tracks.audio;
                    r && (this.mediaBuffer = r.buffer), e.tracks.video && (this.videoBuffer = e.tracks.video.buffer);
                  }),
                  (r.onFragBuffered = function (t, e) {
                    const r = e.frag,
                      i = e.part;
                    r.type === u.PlaylistLevelType.AUDIO &&
                      (this.fragContextChanged(r)
                        ? this.warn(
                            'Fragment ' +
                              r.sn +
                              (i ? ' p: ' + i.index : '') +
                              ' of level ' +
                              r.level +
                              ' finished buffering, but was aborted. state: ' +
                              this.state +
                              ', audioSwitch: ' +
                              this.audioSwitch
                          )
                        : ('initSegment' !== r.sn &&
                            ((this.fragPrevious = r),
                            this.audioSwitch &&
                              ((this.audioSwitch = !1),
                              this.hls.trigger(s.Events.AUDIO_TRACK_SWITCHED, { id: this.trackId }))),
                          this.fragBufferedComplete(r, i)));
                  }),
                  (r.onError = function (e, r) {
                    switch (r.details) {
                      case g.ErrorDetails.FRAG_LOAD_ERROR:
                      case g.ErrorDetails.FRAG_LOAD_TIMEOUT:
                      case g.ErrorDetails.KEY_LOAD_ERROR:
                      case g.ErrorDetails.KEY_LOAD_TIMEOUT:
                        this.onFragmentOrKeyLoadError(u.PlaylistLevelType.AUDIO, r);
                        break;
                      case g.ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
                      case g.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
                        this.state !== n.State.ERROR &&
                          this.state !== n.State.STOPPED &&
                          ((this.state = r.fatal ? n.State.ERROR : n.State.IDLE),
                          this.warn(r.details + ' while loading frag, switching to ' + this.state + ' state'));
                        break;
                      case g.ErrorDetails.BUFFER_FULL_ERROR:
                        if ('audio' === r.parent && (this.state === n.State.PARSING || this.state === n.State.PARSED)) {
                          let i = !0,
                            s = this.getFwdBufferInfo(this.mediaBuffer, u.PlaylistLevelType.AUDIO);
                          s && s.len > 0.5 && (i = !this.reduceMaxBufferLength(s.len)),
                            i &&
                              (this.warn(
                                'Buffer full error also media.currentTime is not buffered, flush audio buffer'
                              ),
                              (this.fragCurrent = null),
                              t.prototype.flushMainBuffer.call(this, 0, Number.POSITIVE_INFINITY, 'audio')),
                            this.resetLoadingState();
                        }
                    }
                  }),
                  (r.onBufferFlushed = function (t, e) {
                    e.type === c.ElementaryStreamTypes.AUDIO && (this.bufferFlushed = !0);
                  }),
                  (r._handleTransmuxComplete = function (t) {
                    let e,
                      r = 'audio',
                      i = this.hls,
                      a = t.remuxResult,
                      o = t.chunkMeta,
                      l = this.getCurrentContext(o);
                    if (!l)
                      return (
                        this.warn(
                          'The loading context changed while buffering fragment ' +
                            o.sn +
                            ' of level ' +
                            o.level +
                            '. This chunk will not be buffered.'
                        ),
                        void this.resetLiveStartWhenNotLoaded(o.level)
                      );
                    const u = l.frag,
                      d = l.part,
                      f = a.audio,
                      h = a.text,
                      p = a.id3,
                      v = a.initSegment;
                    if (!this.fragContextChanged(u)) {
                      if (
                        ((this.state = n.State.PARSING),
                        this.audioSwitch && f && this.completeAudioSwitch(),
                        null !== v &&
                          void 0 !== v &&
                          v.tracks &&
                          (this._bufferInitSegment(v.tracks, u, o),
                          i.trigger(s.Events.FRAG_PARSING_INIT_SEGMENT, { frag: u, id: r, tracks: v.tracks })),
                        f)
                      ) {
                        const g = f.startPTS,
                          m = f.endPTS,
                          E = f.startDTS,
                          T = f.endDTS;
                        d &&
                          (d.elementaryStreams[c.ElementaryStreamTypes.AUDIO] = {
                            startPTS: g,
                            endPTS: m,
                            startDTS: E,
                            endDTS: T,
                          }),
                          u.setElementaryStreamInfo(c.ElementaryStreamTypes.AUDIO, g, m, E, T),
                          this.bufferFragmentData(f, u, d, o);
                      }
                      if (null !== p && void 0 !== p && null !== (e = p.samples) && void 0 !== e && e.length) {
                        const b = y({ frag: u, id: r }, p);
                        i.trigger(s.Events.FRAG_PARSING_METADATA, b);
                      }
                      if (h) {
                        const S = y({ frag: u, id: r }, h);
                        i.trigger(s.Events.FRAG_PARSING_USERDATA, S);
                      }
                    }
                  }),
                  (r._bufferInitSegment = function (t, e, r) {
                    if (this.state === n.State.PARSING) {
                      t.video && delete t.video;
                      const i = t.audio;
                      if (i) {
                        (i.levelCodec = i.codec),
                          (i.id = 'audio'),
                          this.log(
                            'Init audio buffer, container:' + i.container + ', codecs[parsed]=[' + i.codec + ']'
                          ),
                          this.hls.trigger(s.Events.BUFFER_CODECS, t);
                        const a = i.initSegment;
                        if (null !== a && void 0 !== a && a.byteLength) {
                          const o = { type: 'audio', frag: e, part: null, chunkMeta: r, parent: e.type, data: a };
                          this.hls.trigger(s.Events.BUFFER_APPENDING, o);
                        }
                        this.tick();
                      }
                    }
                  }),
                  (r.loadFragment = function (e, r, s) {
                    const a = this.fragmentTracker.getState(e);
                    (this.fragCurrent = e),
                      (this.audioSwitch || a === o.FragmentState.NOT_LOADED || a === o.FragmentState.PARTIAL) &&
                        ('initSegment' === e.sn
                          ? this._loadInitSegment(e)
                          : r.live && !Object(i.isFiniteNumber)(this.initPTS[e.cc])
                            ? (this.log(
                                'Waiting for video PTS in continuity counter ' +
                                  e.cc +
                                  ' of live stream before loading audio fragment ' +
                                  e.sn +
                                  ' of level ' +
                                  this.trackId
                              ),
                              (this.state = n.State.WAITING_INIT_PTS))
                            : ((this.startFragRequested = !0), t.prototype.loadFragment.call(this, e, r, s)));
                  }),
                  (r.completeAudioSwitch = function () {
                    const e = this.hls,
                      r = this.media,
                      i = this.trackId;
                    r &&
                      (this.log('Switching audio track : flushing all audio'),
                      t.prototype.flushMainBuffer.call(this, 0, Number.POSITIVE_INFINITY, 'audio')),
                      (this.audioSwitch = !1),
                      e.trigger(s.Events.AUDIO_TRACK_SWITCHED, { id: i });
                  }),
                  e
                );
              })(n.default);
              e.default = T;
            },
          './src/controller/audio-track-controller.ts':
            /*!**************************************************!*\
  !*** ./src/controller/audio-track-controller.ts ***!
  \**************************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              const i = r(/*! ../events */ './src/events.ts'),
                n = r(/*! ../errors */ './src/errors.ts'),
                s = r(/*! ./base-playlist-controller */ './src/controller/base-playlist-controller.ts'),
                a = r(/*! ../types/loader */ './src/types/loader.ts');
              function o(t, e) {
                for (let r = 0; r < e.length; r++) {
                  const i = e[r];
                  (i.enumerable = i.enumerable || !1),
                    (i.configurable = !0),
                    'value' in i && (i.writable = !0),
                    Object.defineProperty(t, i.key, i);
                }
              }
              function l(t, e) {
                return (l =
                  Object.setPrototypeOf ||
                  function (t, e) {
                    return (t.__proto__ = e), t;
                  })(t, e);
              }
              const u = (function (t) {
                function e(e) {
                  let r;
                  return (
                    ((r = t.call(this, e, '[audio-track-controller]') || this).tracks = []),
                    (r.groupId = null),
                    (r.tracksInGroup = []),
                    (r.trackId = -1),
                    (r.trackName = ''),
                    (r.selectDefaultTrack = !0),
                    r.registerListeners(),
                    r
                  );
                }
                !(function (t, e) {
                  (t.prototype = Object.create(e.prototype)), (t.prototype.constructor = t), l(t, e);
                })(e, t);
                const r = e.prototype;
                return (
                  (r.registerListeners = function () {
                    const t = this.hls;
                    t.on(i.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                      t.on(i.Events.MANIFEST_PARSED, this.onManifestParsed, this),
                      t.on(i.Events.LEVEL_LOADING, this.onLevelLoading, this),
                      t.on(i.Events.LEVEL_SWITCHING, this.onLevelSwitching, this),
                      t.on(i.Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this),
                      t.on(i.Events.ERROR, this.onError, this);
                  }),
                  (r.unregisterListeners = function () {
                    const t = this.hls;
                    t.off(i.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                      t.off(i.Events.MANIFEST_PARSED, this.onManifestParsed, this),
                      t.off(i.Events.LEVEL_LOADING, this.onLevelLoading, this),
                      t.off(i.Events.LEVEL_SWITCHING, this.onLevelSwitching, this),
                      t.off(i.Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this),
                      t.off(i.Events.ERROR, this.onError, this);
                  }),
                  (r.destroy = function () {
                    this.unregisterListeners(),
                      (this.tracks.length = 0),
                      (this.tracksInGroup.length = 0),
                      t.prototype.destroy.call(this);
                  }),
                  (r.onManifestLoading = function () {
                    (this.tracks = []),
                      (this.groupId = null),
                      (this.tracksInGroup = []),
                      (this.trackId = -1),
                      (this.trackName = ''),
                      (this.selectDefaultTrack = !0);
                  }),
                  (r.onManifestParsed = function (t, e) {
                    this.tracks = e.audioTracks || [];
                  }),
                  (r.onAudioTrackLoaded = function (t, e) {
                    const r = e.id,
                      i = e.details,
                      n = this.tracksInGroup[r];
                    if (n) {
                      const s = n.details;
                      (n.details = e.details),
                        this.log('audioTrack ' + r + ' loaded [' + i.startSN + '-' + i.endSN + ']'),
                        r === this.trackId && ((this.retryCount = 0), this.playlistLoaded(r, e, s));
                    } else this.warn('Invalid audio track id ' + r);
                  }),
                  (r.onLevelLoading = function (t, e) {
                    this.switchLevel(e.level);
                  }),
                  (r.onLevelSwitching = function (t, e) {
                    this.switchLevel(e.level);
                  }),
                  (r.switchLevel = function (t) {
                    const e = this.hls.levels[t];
                    if (null !== e && void 0 !== e && e.audioGroupIds) {
                      const r = e.audioGroupIds[e.urlId];
                      if (this.groupId !== r) {
                        this.groupId = r;
                        const n = this.tracks.filter(function (t) {
                          return !r || t.groupId === r;
                        });
                        this.selectDefaultTrack &&
                          !n.some(function (t) {
                            return t.default;
                          }) &&
                          (this.selectDefaultTrack = !1),
                          (this.tracksInGroup = n);
                        const s = { audioTracks: n };
                        this.log('Updating audio tracks, ' + n.length + ' track(s) found in "' + r + '" group-id'),
                          this.hls.trigger(i.Events.AUDIO_TRACKS_UPDATED, s),
                          this.selectInitialTrack();
                      }
                    }
                  }),
                  (r.onError = function (e, r) {
                    t.prototype.onError.call(this, e, r),
                      !r.fatal &&
                        r.context &&
                        r.context.type === a.PlaylistContextType.AUDIO_TRACK &&
                        r.context.id === this.trackId &&
                        r.context.groupId === this.groupId &&
                        this.retryLoadingOrFail(r);
                  }),
                  (r.setAudioTrack = function (t) {
                    const e = this.tracksInGroup;
                    if (t < 0 || t >= e.length) this.warn('Invalid id passed to audio-track controller');
                    else {
                      this.clearTimer();
                      const r = e[this.trackId];
                      this.log('Now switching to audio-track index ' + t);
                      const n = e[t],
                        s = n.id,
                        a = n.groupId,
                        o = void 0 === a ? '' : a,
                        l = n.name,
                        u = n.type,
                        c = n.url;
                      if (
                        ((this.trackId = t),
                        (this.trackName = l),
                        (this.selectDefaultTrack = !1),
                        this.hls.trigger(i.Events.AUDIO_TRACK_SWITCHING, {
                          id: s,
                          groupId: o,
                          name: l,
                          type: u,
                          url: c,
                        }),
                        !n.details || n.details.live)
                      ) {
                        const d = this.switchParams(n.url, null === r || void 0 === r ? void 0 : r.details);
                        this.loadPlaylist(d);
                      }
                    }
                  }),
                  (r.selectInitialTrack = function () {
                    const t = this.tracksInGroup;
                    console.assert(t.length, 'Initial audio track should be selected when tracks are known');
                    const e = this.trackName,
                      r = this.findTrackId(e) || this.findTrackId();
                    -1 !== r
                      ? this.setAudioTrack(r)
                      : (this.warn('No track found for running audio group-ID: ' + this.groupId),
                        this.hls.trigger(i.Events.ERROR, {
                          type: n.ErrorTypes.MEDIA_ERROR,
                          details: n.ErrorDetails.AUDIO_TRACK_LOAD_ERROR,
                          fatal: !0,
                        }));
                  }),
                  (r.findTrackId = function (t) {
                    for (let e = this.tracksInGroup, r = 0; r < e.length; r++) {
                      const i = e[r];
                      if ((!this.selectDefaultTrack || i.default) && (!t || t === i.name)) return i.id;
                    }
                    return -1;
                  }),
                  (r.loadPlaylist = function (t) {
                    const e = this.tracksInGroup[this.trackId];
                    if (this.shouldLoadTrack(e)) {
                      let r = e.id,
                        n = e.groupId,
                        s = e.url;
                      if (t)
                        try {
                          s = t.addDirectives(s);
                        } catch (t) {
                          this.warn('Could not construct new URL with HLS Delivery Directives: ' + t);
                        }
                      this.log('loading audio-track playlist for id: ' + r),
                        this.clearTimer(),
                        this.hls.trigger(i.Events.AUDIO_TRACK_LOADING, {
                          url: s,
                          id: r,
                          groupId: n,
                          deliveryDirectives: t || null,
                        });
                    }
                  }),
                  (function (t, e, r) {
                    e && o(t.prototype, e), r && o(t, r);
                  })(e, [
                    {
                      key: 'audioTracks',
                      get: function () {
                        return this.tracksInGroup;
                      },
                    },
                    {
                      key: 'audioTrack',
                      get: function () {
                        return this.trackId;
                      },
                      set: function (t) {
                        (this.selectDefaultTrack = !1), this.setAudioTrack(t);
                      },
                    },
                  ]),
                  e
                );
              })(s.default);
              e.default = u;
            },
          './src/controller/base-playlist-controller.ts':
            /*!****************************************************!*\
  !*** ./src/controller/base-playlist-controller.ts ***!
  \****************************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return l;
                });
              var i = r(/*! ./src/polyfills/number */ './src/polyfills/number.ts'),
                n = r(/*! ../types/level */ './src/types/level.ts'),
                s = r(/*! ./level-helper */ './src/controller/level-helper.ts'),
                a = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                o = r(/*! ../errors */ './src/errors.ts'),
                l = (function () {
                  function t(t, e) {
                    (this.hls = void 0),
                      (this.timer = -1),
                      (this.canLoad = !1),
                      (this.retryCount = 0),
                      (this.log = void 0),
                      (this.warn = void 0),
                      (this.log = a.logger.log.bind(a.logger, e + ':')),
                      (this.warn = a.logger.warn.bind(a.logger, e + ':')),
                      (this.hls = t);
                  }
                  const e = t.prototype;
                  return (
                    (e.destroy = function () {
                      this.clearTimer(), (this.hls = this.log = this.warn = null);
                    }),
                    (e.onError = function (t, e) {
                      e.fatal && e.type === o.ErrorTypes.NETWORK_ERROR && this.clearTimer();
                    }),
                    (e.clearTimer = function () {
                      clearTimeout(this.timer), (this.timer = -1);
                    }),
                    (e.startLoad = function () {
                      (this.canLoad = !0), (this.retryCount = 0), this.loadPlaylist();
                    }),
                    (e.stopLoad = function () {
                      (this.canLoad = !1), this.clearTimer();
                    }),
                    (e.switchParams = function (t, e) {
                      const r = null === e || void 0 === e ? void 0 : e.renditionReports;
                      if (r)
                        for (let s = 0; s < r.length; s++) {
                          const a = r[s],
                            o = '' + a.URI;
                          if (o === t.substr(-o.length)) {
                            let l = parseInt(a['LAST-MSN']),
                              u = parseInt(a['LAST-PART']);
                            if (e && this.hls.config.lowLatencyMode) {
                              const c = Math.min(e.age - e.partTarget, e.targetduration);
                              void 0 !== u && c > e.partTarget && (u += 1);
                            }
                            if (Object(i.isFiniteNumber)(l))
                              return new n.HlsUrlParameters(l, Object(i.isFiniteNumber)(u) ? u : void 0, n.HlsSkip.No);
                          }
                        }
                    }),
                    (e.loadPlaylist = function (t) {}),
                    (e.shouldLoadTrack = function (t) {
                      return this.canLoad && t && !!t.url && (!t.details || t.details.live);
                    }),
                    (e.playlistLoaded = function (t, e, r) {
                      const i = this,
                        n = e.details,
                        a = e.stats,
                        o = a.loading.end ? Math.max(0, self.performance.now() - a.loading.end) : 0;
                      if (((n.advancedDateTime = Date.now() - o), n.live || (null !== r && void 0 !== r && r.live))) {
                        if (
                          (n.reloaded(r),
                          r &&
                            this.log(
                              'live playlist ' +
                                t +
                                ' ' +
                                (n.advanced ? 'REFRESHED ' + n.lastPartSn + '-' + n.lastPartIndex : 'MISSED')
                            ),
                          r && n.fragments.length > 0 && Object(s.mergeDetails)(r, n),
                          !this.canLoad || !n.live)
                        )
                          return;
                        let l,
                          u = void 0,
                          c = void 0;
                        if (n.canBlockReload && n.endSN && n.advanced) {
                          const d = this.hls.config.lowLatencyMode,
                            f = n.lastPartSn,
                            h = n.endSN,
                            p = n.lastPartIndex,
                            v = f === h;
                          -1 !== p ? ((u = v ? h + 1 : f), (c = v ? (d ? 0 : p) : p + 1)) : (u = h + 1);
                          let g = n.age,
                            m = g + n.ageHeader,
                            y = Math.min(m - n.partTarget, 1.5 * n.targetduration);
                          if (y > 0) {
                            if (r && y > r.tuneInGoal)
                              this.warn(
                                'CDN Tune-in goal increased from: ' +
                                  r.tuneInGoal +
                                  ' to: ' +
                                  y +
                                  ' with playlist age: ' +
                                  n.age
                              ),
                                (y = 0);
                            else {
                              const E = Math.floor(y / n.targetduration);
                              if (((u += E), void 0 !== c)) c += Math.round((y % n.targetduration) / n.partTarget);
                              this.log(
                                'CDN Tune-in age: ' +
                                  n.ageHeader +
                                  's last advanced ' +
                                  g.toFixed(2) +
                                  's goal: ' +
                                  y +
                                  ' skip sn ' +
                                  E +
                                  ' to part ' +
                                  c
                              );
                            }
                            n.tuneInGoal = y;
                          }
                          if (((l = this.getDeliveryDirectives(n, e.deliveryDirectives, u, c)), d || !v))
                            return void this.loadPlaylist(l);
                        } else l = this.getDeliveryDirectives(n, e.deliveryDirectives, u, c);
                        let T = Object(s.computeReloadInterval)(n, a);
                        void 0 !== u && n.canBlockReload && (T -= n.partTarget || 1),
                          this.log('reload live playlist ' + t + ' in ' + Math.round(T) + ' ms'),
                          (this.timer = self.setTimeout(function () {
                            return i.loadPlaylist(l);
                          }, T));
                      } else this.clearTimer();
                    }),
                    (e.getDeliveryDirectives = function (t, e, r, i) {
                      let s = Object(n.getSkipValue)(t, r);
                      return (
                        null !== e &&
                          void 0 !== e &&
                          e.skip &&
                          t.deltaUpdateFailed &&
                          ((r = e.msn), (i = e.part), (s = n.HlsSkip.No)),
                        new n.HlsUrlParameters(r, i, s)
                      );
                    }),
                    (e.retryLoadingOrFail = function (t) {
                      let e,
                        r = this,
                        i = this.hls.config,
                        n = this.retryCount < i.levelLoadingMaxRetry;
                      if (n)
                        if (
                          (this.retryCount++,
                          t.details.indexOf('LoadTimeOut') > -1 &&
                            null !== (e = t.context) &&
                            void 0 !== e &&
                            e.deliveryDirectives)
                        )
                          this.warn('retry playlist loading #' + this.retryCount + ' after "' + t.details + '"'),
                            this.loadPlaylist();
                        else {
                          const s = Math.min(
                            Math.pow(2, this.retryCount) * i.levelLoadingRetryDelay,
                            i.levelLoadingMaxRetryTimeout
                          );
                          (this.timer = self.setTimeout(function () {
                            return r.loadPlaylist();
                          }, s)),
                            this.warn(
                              'retry playlist loading #' +
                                this.retryCount +
                                ' in ' +
                                s +
                                ' ms after "' +
                                t.details +
                                '"'
                            );
                        }
                      else
                        this.warn('cannot recover from error "' + t.details + '"'), this.clearTimer(), (t.fatal = !0);
                      return n;
                    }),
                    t
                  );
                })();
            },
          './src/controller/base-stream-controller.ts':
            /*!**************************************************!*\
  !*** ./src/controller/base-stream-controller.ts ***!
  \**************************************************/
            /*! exports provided: State, default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'State', function () {
                  return b;
                }),
                r.d(e, 'default', function () {
                  return S;
                });
              const i = r(/*! ./src/polyfills/number */ './src/polyfills/number.ts'),
                n = r(/*! ../task-loop */ './src/task-loop.ts'),
                s = r(/*! ./fragment-tracker */ './src/controller/fragment-tracker.ts'),
                a = r(/*! ../utils/buffer-helper */ './src/utils/buffer-helper.ts'),
                o = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                l = r(/*! ../events */ './src/events.ts'),
                u = r(/*! ../errors */ './src/errors.ts'),
                c = r(/*! ../types/transmuxer */ './src/types/transmuxer.ts'),
                d = r(/*! ../utils/mp4-tools */ './src/utils/mp4-tools.ts'),
                f = r(/*! ../utils/discontinuities */ './src/utils/discontinuities.ts'),
                h = r(/*! ./fragment-finders */ './src/controller/fragment-finders.ts'),
                p = r(/*! ./level-helper */ './src/controller/level-helper.ts'),
                v = r(/*! ../loader/fragment-loader */ './src/loader/fragment-loader.ts'),
                g = r(/*! ../crypt/decrypter */ './src/crypt/decrypter.ts'),
                m = r(/*! ../utils/time-ranges */ './src/utils/time-ranges.ts'),
                y = r(/*! ../types/loader */ './src/types/loader.ts');
              function E(t, e) {
                for (let r = 0; r < e.length; r++) {
                  const i = e[r];
                  (i.enumerable = i.enumerable || !1),
                    (i.configurable = !0),
                    'value' in i && (i.writable = !0),
                    Object.defineProperty(t, i.key, i);
                }
              }
              function T(t, e) {
                return (T =
                  Object.setPrototypeOf ||
                  function (t, e) {
                    return (t.__proto__ = e), t;
                  })(t, e);
              }
              var b = {
                  STOPPED: 'STOPPED',
                  IDLE: 'IDLE',
                  KEY_LOADING: 'KEY_LOADING',
                  FRAG_LOADING: 'FRAG_LOADING',
                  FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
                  WAITING_TRACK: 'WAITING_TRACK',
                  PARSING: 'PARSING',
                  PARSED: 'PARSED',
                  BACKTRACKING: 'BACKTRACKING',
                  ENDED: 'ENDED',
                  ERROR: 'ERROR',
                  WAITING_INIT_PTS: 'WAITING_INIT_PTS',
                  WAITING_LEVEL: 'WAITING_LEVEL',
                },
                S = (function (t) {
                  function e(e, r, i) {
                    let n;
                    return (
                      ((n = t.call(this) || this).hls = void 0),
                      (n.fragPrevious = null),
                      (n.fragCurrent = null),
                      (n.fragmentTracker = void 0),
                      (n.transmuxer = null),
                      (n._state = b.STOPPED),
                      (n.media = void 0),
                      (n.mediaBuffer = void 0),
                      (n.config = void 0),
                      (n.bitrateTest = !1),
                      (n.lastCurrentTime = 0),
                      (n.nextLoadPosition = 0),
                      (n.startPosition = 0),
                      (n.loadedmetadata = !1),
                      (n.fragLoadError = 0),
                      (n.retryDate = 0),
                      (n.levels = null),
                      (n.fragmentLoader = void 0),
                      (n.levelLastLoaded = null),
                      (n.startFragRequested = !1),
                      (n.decrypter = void 0),
                      (n.initPTS = []),
                      (n.onvseeking = null),
                      (n.onvended = null),
                      (n.logPrefix = ''),
                      (n.log = void 0),
                      (n.warn = void 0),
                      (n.logPrefix = i),
                      (n.log = o.logger.log.bind(o.logger, i + ':')),
                      (n.warn = o.logger.warn.bind(o.logger, i + ':')),
                      (n.hls = e),
                      (n.fragmentLoader = new v.default(e.config)),
                      (n.fragmentTracker = r),
                      (n.config = e.config),
                      (n.decrypter = new g.default(e, e.config)),
                      e.on(
                        l.Events.KEY_LOADED,
                        n.onKeyLoaded,
                        (function (t) {
                          if (void 0 === t)
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                          return t;
                        })(n)
                      ),
                      n
                    );
                  }
                  !(function (t, e) {
                    (t.prototype = Object.create(e.prototype)), (t.prototype.constructor = t), T(t, e);
                  })(e, t);
                  const r = e.prototype;
                  return (
                    (r.doTick = function () {
                      this.onTickEnd();
                    }),
                    (r.onTickEnd = function () {}),
                    (r.startLoad = function (t) {}),
                    (r.stopLoad = function () {
                      this.fragmentLoader.abort();
                      const t = this.fragCurrent;
                      t && this.fragmentTracker.removeFragment(t),
                        this.resetTransmuxer(),
                        (this.fragCurrent = null),
                        (this.fragPrevious = null),
                        this.clearInterval(),
                        this.clearNextTick(),
                        (this.state = b.STOPPED);
                    }),
                    (r._streamEnded = function (t, e) {
                      const r = this.fragCurrent,
                        i = this.fragmentTracker;
                      if (!e.live && r && r.sn >= e.endSN && !t.nextStart) {
                        const n = e.partList;
                        if (null !== n && void 0 !== n && n.length) {
                          const o = n[n.length - 1];
                          return a.BufferHelper.isBuffered(this.media, o.start + o.duration / 2);
                        }
                        const l = i.getState(r);
                        return l === s.FragmentState.PARTIAL || l === s.FragmentState.OK;
                      }
                      return !1;
                    }),
                    (r.onMediaAttached = function (t, e) {
                      const r = (this.media = this.mediaBuffer = e.media);
                      (this.onvseeking = this.onMediaSeeking.bind(this)),
                        (this.onvended = this.onMediaEnded.bind(this)),
                        r.addEventListener('seeking', this.onvseeking),
                        r.addEventListener('ended', this.onvended);
                      const i = this.config;
                      this.levels && i.autoStartLoad && this.state === b.STOPPED && this.startLoad(i.startPosition);
                    }),
                    (r.onMediaDetaching = function () {
                      const t = this.media;
                      null !== t &&
                        void 0 !== t &&
                        t.ended &&
                        (this.log('MSE detaching and video ended, reset startPosition'),
                        (this.startPosition = this.lastCurrentTime = 0)),
                        t &&
                          (t.removeEventListener('seeking', this.onvseeking),
                          t.removeEventListener('ended', this.onvended),
                          (this.onvseeking = this.onvended = null)),
                        (this.media = this.mediaBuffer = null),
                        (this.loadedmetadata = !1),
                        this.fragmentTracker.removeAllFragments(),
                        this.stopLoad();
                    }),
                    (r.onMediaSeeking = function () {
                      const t = this.config,
                        e = this.fragCurrent,
                        r = this.media,
                        n = this.mediaBuffer,
                        s = this.state,
                        o = r ? r.currentTime : 0,
                        l = a.BufferHelper.bufferInfo(n || r, o, t.maxBufferHole);
                      if (
                        (this.log(
                          'media seeking to ' + (Object(i.isFiniteNumber)(o) ? o.toFixed(3) : o) + ', state: ' + s
                        ),
                        s === b.ENDED)
                      )
                        this.resetLoadingState();
                      else if (e && !l.len) {
                        const u = t.maxFragLookUpTolerance,
                          c = e.start - u,
                          d = o > e.start + e.duration + u;
                        (o < c || d) &&
                          (d &&
                            e.loader &&
                            (this.log(
                              'seeking outside of buffer while fragment load in progress, cancel fragment load'
                            ),
                            e.loader.abort()),
                          this.resetLoadingState());
                      }
                      r && (this.lastCurrentTime = o),
                        this.loadedmetadata || l.len || (this.nextLoadPosition = this.startPosition = o),
                        this.tickImmediate();
                    }),
                    (r.onMediaEnded = function () {
                      this.startPosition = this.lastCurrentTime = 0;
                    }),
                    (r.onKeyLoaded = function (t, e) {
                      if (this.state === b.KEY_LOADING && e.frag === this.fragCurrent && this.levels) {
                        this.state = b.IDLE;
                        const r = this.levels[e.frag.level].details;
                        r && this.loadFragment(e.frag, r, e.frag.start);
                      }
                    }),
                    (r.onHandlerDestroying = function () {
                      this.stopLoad(), t.prototype.onHandlerDestroying.call(this);
                    }),
                    (r.onHandlerDestroyed = function () {
                      (this.state = b.STOPPED),
                        this.hls.off(l.Events.KEY_LOADED, this.onKeyLoaded, this),
                        this.fragmentLoader && this.fragmentLoader.destroy(),
                        this.decrypter && this.decrypter.destroy(),
                        (this.hls =
                          this.log =
                          this.warn =
                          this.decrypter =
                          this.fragmentLoader =
                          this.fragmentTracker =
                            null),
                        t.prototype.onHandlerDestroyed.call(this);
                    }),
                    (r.loadKey = function (t, e) {
                      this.log(
                        'Loading key for ' +
                          t.sn +
                          ' of [' +
                          e.startSN +
                          '-' +
                          e.endSN +
                          '], ' +
                          ('[stream-controller]' === this.logPrefix ? 'level' : 'track') +
                          ' ' +
                          t.level
                      ),
                        (this.state = b.KEY_LOADING),
                        (this.fragCurrent = t),
                        this.hls.trigger(l.Events.KEY_LOADING, { frag: t });
                    }),
                    (r.loadFragment = function (t, e, r) {
                      this._loadFragForPlayback(t, e, r);
                    }),
                    (r._loadFragForPlayback = function (t, e, r) {
                      const i = this;
                      this._doFragLoad(t, e, r, function (e) {
                        if (i.fragContextChanged(t))
                          return (
                            i.warn(
                              'Fragment ' +
                                t.sn +
                                (e.part ? ' p: ' + e.part.index : '') +
                                ' of level ' +
                                t.level +
                                ' was dropped during download.'
                            ),
                            void i.fragmentTracker.removeFragment(t)
                          );
                        t.stats.chunkCount++, i._handleFragmentLoadProgress(e);
                      })
                        .then(function (e) {
                          if (e) {
                            i.fragLoadError = 0;
                            const r = i.state;
                            if (!i.fragContextChanged(t))
                              return 'payload' in e &&
                                (i.log('Loaded fragment ' + t.sn + ' of level ' + t.level),
                                i.hls.trigger(l.Events.FRAG_LOADED, e),
                                i.state === b.BACKTRACKING)
                                ? (i.fragmentTracker.backtrack(t, e), void i.resetFragmentLoading(t))
                                : void i._handleFragmentLoadComplete(e);
                            (r === b.FRAG_LOADING || r === b.BACKTRACKING || (!i.fragCurrent && r === b.PARSING)) &&
                              (i.fragmentTracker.removeFragment(t), (i.state = b.IDLE));
                          }
                        })
                        .catch(function (e) {
                          i.warn(e), i.resetFragmentLoading(t);
                        });
                    }),
                    (r.flushMainBuffer = function (t, e, r) {
                      if ((void 0 === r && (r = null), t - e)) {
                        const i = { startOffset: t, endOffset: e, type: r };
                        (this.fragLoadError = 0), this.hls.trigger(l.Events.BUFFER_FLUSHING, i);
                      }
                    }),
                    (r._loadInitSegment = function (t) {
                      const e = this;
                      this._doFragLoad(t)
                        .then(function (r) {
                          if (!r || e.fragContextChanged(t) || !e.levels) throw new Error('init load aborted');
                          return r;
                        })
                        .then(function (r) {
                          const i = e.hls,
                            n = r.payload,
                            s = t.decryptdata;
                          if (n && n.byteLength > 0 && s && s.key && s.iv && 'AES-128' === s.method) {
                            const a = self.performance.now();
                            return e.decrypter
                              .webCryptoDecrypt(new Uint8Array(n), s.key.buffer, s.iv.buffer)
                              .then(function (e) {
                                const n = self.performance.now();
                                return (
                                  i.trigger(l.Events.FRAG_DECRYPTED, {
                                    frag: t,
                                    payload: e,
                                    stats: { tstart: a, tdecrypt: n },
                                  }),
                                  (r.payload = e),
                                  r
                                );
                              });
                          }
                          return r;
                        })
                        .then(function (r) {
                          const i = e.fragCurrent,
                            n = e.hls,
                            s = e.levels;
                          if (!s) throw new Error('init load aborted, missing levels');
                          const a = s[t.level].details;
                          console.assert(a, 'Level details are defined when init segment is loaded');
                          const o = t.stats;
                          (e.state = b.IDLE),
                            (e.fragLoadError = 0),
                            (t.data = new Uint8Array(r.payload)),
                            (o.parsing.start = o.buffering.start = self.performance.now()),
                            (o.parsing.end = o.buffering.end = self.performance.now()),
                            r.frag === i &&
                              n.trigger(l.Events.FRAG_BUFFERED, { stats: o, frag: i, part: null, id: t.type }),
                            e.tick();
                        })
                        .catch(function (r) {
                          e.warn(r), e.resetFragmentLoading(t);
                        });
                    }),
                    (r.fragContextChanged = function (t) {
                      const e = this.fragCurrent;
                      return !t || !e || t.level !== e.level || t.sn !== e.sn || t.urlId !== e.urlId;
                    }),
                    (r.fragBufferedComplete = function (t, e) {
                      const r = this.mediaBuffer ? this.mediaBuffer : this.media;
                      this.log(
                        'Buffered ' +
                          t.type +
                          ' sn: ' +
                          t.sn +
                          (e ? ' part: ' + e.index : '') +
                          ' of ' +
                          ('[stream-controller]' === this.logPrefix ? 'level' : 'track') +
                          ' ' +
                          t.level +
                          ' ' +
                          m.default.toString(a.BufferHelper.getBuffered(r))
                      ),
                        (this.state = b.IDLE),
                        this.tick();
                    }),
                    (r._handleFragmentLoadComplete = function (t) {
                      const e = this.transmuxer;
                      if (e) {
                        const r = t.frag,
                          i = t.part,
                          n = t.partsLoaded,
                          s =
                            !n ||
                            0 === n.length ||
                            n.some(function (t) {
                              return !t;
                            }),
                          a = new c.ChunkMetadata(r.level, r.sn, r.stats.chunkCount + 1, 0, i ? i.index : -1, !s);
                        e.flush(a);
                      }
                    }),
                    (r._handleFragmentLoadProgress = function (t) {}),
                    (r._doFragLoad = function (t, e, r, n) {
                      const s = this;
                      if ((void 0 === r && (r = null), !this.levels))
                        throw new Error('frag load aborted, missing levels');
                      if (((r = Math.max(t.start, r || 0)), this.config.lowLatencyMode && e)) {
                        const a = e.partList;
                        if (a && n) {
                          r > t.end && e.fragmentHint && (t = e.fragmentHint);
                          const o = this.getNextPart(a, t, r);
                          if (o > -1) {
                            const u = a[o];
                            return (
                              this.log(
                                'Loading part sn: ' +
                                  t.sn +
                                  ' p: ' +
                                  u.index +
                                  ' cc: ' +
                                  t.cc +
                                  ' of playlist [' +
                                  e.startSN +
                                  '-' +
                                  e.endSN +
                                  '] parts [0-' +
                                  o +
                                  '-' +
                                  (a.length - 1) +
                                  '] ' +
                                  ('[stream-controller]' === this.logPrefix ? 'level' : 'track') +
                                  ': ' +
                                  t.level +
                                  ', target: ' +
                                  parseFloat(r.toFixed(3))
                              ),
                              (this.nextLoadPosition = u.start + u.duration),
                              (this.state = b.FRAG_LOADING),
                              this.hls.trigger(l.Events.FRAG_LOADING, { frag: t, part: a[o], targetBufferTime: r }),
                              this.doFragPartsLoad(t, a, o, n).catch(function (t) {
                                return s.handleFragLoadError(t);
                              })
                            );
                          }
                          if (!t.url || this.loadedEndOfParts(a, r)) return Promise.resolve(null);
                        }
                      }
                      return (
                        this.log(
                          'Loading fragment ' +
                            t.sn +
                            ' cc: ' +
                            t.cc +
                            ' ' +
                            (e ? 'of [' + e.startSN + '-' + e.endSN + '] ' : '') +
                            ('[stream-controller]' === this.logPrefix ? 'level' : 'track') +
                            ': ' +
                            t.level +
                            ', target: ' +
                            parseFloat(r.toFixed(3))
                        ),
                        Object(i.isFiniteNumber)(t.sn) &&
                          !this.bitrateTest &&
                          (this.nextLoadPosition = t.start + t.duration),
                        (this.state = b.FRAG_LOADING),
                        this.hls.trigger(l.Events.FRAG_LOADING, { frag: t, targetBufferTime: r }),
                        this.fragmentLoader.load(t, n).catch(function (t) {
                          return s.handleFragLoadError(t);
                        })
                      );
                    }),
                    (r.doFragPartsLoad = function (t, e, r, i) {
                      const n = this;
                      return new Promise(function (s, a) {
                        const o = [];
                        !(function r(u) {
                          const c = e[u];
                          n.fragmentLoader
                            .loadPart(t, c, i)
                            .then(function (i) {
                              o[c.index] = i;
                              const a = i.part;
                              n.hls.trigger(l.Events.FRAG_LOADED, i);
                              const d = e[u + 1];
                              if (!d || d.fragment !== t) return s({ frag: t, part: a, partsLoaded: o });
                              r(u + 1);
                            })
                            .catch(a);
                        })(r);
                      });
                    }),
                    (r.handleFragLoadError = function (t) {
                      const e = t.data;
                      return (
                        e && e.details === u.ErrorDetails.INTERNAL_ABORTED
                          ? this.handleFragLoadAborted(e.frag, e.part)
                          : this.hls.trigger(l.Events.ERROR, e),
                        null
                      );
                    }),
                    (r._handleTransmuxerFlush = function (t) {
                      const e = this.getCurrentContext(t);
                      if (e && this.state === b.PARSING) {
                        const r = e.frag,
                          i = e.part,
                          n = e.level,
                          s = self.performance.now();
                        (r.stats.parsing.end = s),
                          i && (i.stats.parsing.end = s),
                          this.updateLevelTiming(r, i, n, t.partial);
                      } else this.fragCurrent || (this.state = b.IDLE);
                    }),
                    (r.getCurrentContext = function (t) {
                      const e = this.levels,
                        r = t.level,
                        i = t.sn,
                        n = t.part;
                      if (!e || !e[r])
                        return (
                          this.warn(
                            'Levels object was unset while buffering fragment ' +
                              i +
                              ' of level ' +
                              r +
                              '. The current chunk will not be buffered.'
                          ),
                          null
                        );
                      const s = e[r],
                        a = n > -1 ? Object(p.getPartWith)(s, i, n) : null,
                        o = a ? a.fragment : Object(p.getFragmentWithSN)(s, i, this.fragCurrent);
                      return o ? { frag: o, part: a, level: s } : null;
                    }),
                    (r.bufferFragmentData = function (t, e, r, i) {
                      if (t && this.state === b.PARSING) {
                        let n = t.data1,
                          s = t.data2,
                          a = n;
                        if ((n && s && (a = Object(d.appendUint8Array)(n, s)), a && a.length)) {
                          const o = { type: t.type, frag: e, part: r, chunkMeta: i, parent: e.type, data: a };
                          this.hls.trigger(l.Events.BUFFER_APPENDING, o),
                            t.dropped && t.independent && !r && this.flushBufferGap(e);
                        }
                      }
                    }),
                    (r.flushBufferGap = function (t) {
                      const e = this.media;
                      if (e)
                        if (a.BufferHelper.isBuffered(e, e.currentTime)) {
                          const r = e.currentTime,
                            i = a.BufferHelper.bufferInfo(e, r, 0),
                            n = t.duration,
                            s = Math.min(2 * this.config.maxFragLookUpTolerance, 0.25 * n),
                            o = Math.max(Math.min(t.start - s, i.end - s), r + s);
                          t.start - o > s && this.flushMainBuffer(o, t.start);
                        } else this.flushMainBuffer(0, t.start);
                    }),
                    (r.getFwdBufferInfo = function (t, e) {
                      const r = this.config,
                        n = this.getLoadPosition();
                      if (!Object(i.isFiniteNumber)(n)) return null;
                      const s = a.BufferHelper.bufferInfo(t, n, r.maxBufferHole);
                      if (0 === s.len && void 0 !== s.nextStart) {
                        const o = this.fragmentTracker.getBufferedFrag(n, e);
                        if (o && s.nextStart < o.end)
                          return a.BufferHelper.bufferInfo(t, n, Math.max(s.nextStart, r.maxBufferHole));
                      }
                      return s;
                    }),
                    (r.getMaxBufferLength = function (t) {
                      let e,
                        r = this.config;
                      return (
                        (e = t ? Math.max((8 * r.maxBufferSize) / t, r.maxBufferLength) : r.maxBufferLength),
                        Math.min(e, r.maxMaxBufferLength)
                      );
                    }),
                    (r.reduceMaxBufferLength = function (t) {
                      const e = this.config,
                        r = t || e.maxBufferLength;
                      return (
                        e.maxMaxBufferLength >= r &&
                        ((e.maxMaxBufferLength /= 2),
                        this.warn('Reduce max buffer length to ' + e.maxMaxBufferLength + 's'),
                        !0)
                      );
                    }),
                    (r.getNextFragment = function (t, e) {
                      let r,
                        i,
                        n = e.fragments,
                        s = n.length;
                      if (!s) return null;
                      let a,
                        o = this.config,
                        l = n[0].start;
                      if (e.live) {
                        const u = o.initialLiveManifestSize;
                        if (s < u)
                          return (
                            this.warn('Not enough fragments to start playback (have: ' + s + ', need: ' + u + ')'), null
                          );
                        e.PTSKnown ||
                          this.startFragRequested ||
                          -1 !== this.startPosition ||
                          ((a = this.getInitialLiveFragment(e, n)),
                          (this.startPosition = a ? this.hls.liveSyncPosition || a.start : t));
                      } else t <= l && (a = n[0]);
                      if (!a) {
                        const c = o.lowLatencyMode ? e.partEnd : e.fragmentEnd;
                        a = this.getFragmentAtPosition(t, c, e);
                      }
                      return (
                        null === (r = a) ||
                          void 0 === r ||
                          !r.initSegment ||
                          (null !== (i = a) && void 0 !== i && i.initSegment.data) ||
                          this.bitrateTest ||
                          (a = a.initSegment),
                        a
                      );
                    }),
                    (r.getNextPart = function (t, e, r) {
                      for (var i = -1, n = !1, s = !0, a = 0, o = t.length; a < o; a++) {
                        const l = t[a];
                        if (((s = s && !l.independent), i > -1 && r < l.start)) break;
                        const u = l.loaded;
                        !u && (n || l.independent || s) && l.fragment === e && (i = a), (n = u);
                      }
                      return i;
                    }),
                    (r.loadedEndOfParts = function (t, e) {
                      const r = t[t.length - 1];
                      return r && e > r.start && r.loaded;
                    }),
                    (r.getInitialLiveFragment = function (t, e) {
                      let r = this.fragPrevious,
                        i = null;
                      if (r) {
                        if (
                          (t.hasProgramDateTime &&
                            (this.log(
                              'Live playlist, switching playlist, load frag with same PDT: ' + r.programDateTime
                            ),
                            (i = Object(h.findFragmentByPDT)(
                              e,
                              r.endProgramDateTime,
                              this.config.maxFragLookUpTolerance
                            ))),
                          !i)
                        ) {
                          const n = r.sn + 1;
                          if (n >= t.startSN && n <= t.endSN) {
                            const s = e[n - t.startSN];
                            r.cc === s.cc &&
                              ((i = s), this.log('Live playlist, switching playlist, load frag with next SN: ' + i.sn));
                          }
                          i ||
                            ((i = Object(h.findFragWithCC)(e, r.cc)) &&
                              this.log('Live playlist, switching playlist, load frag with same CC: ' + i.sn));
                        }
                      } else {
                        const a = this.hls.liveSyncPosition;
                        null !== a && (i = this.getFragmentAtPosition(a, this.bitrateTest ? t.fragmentEnd : t.edge, t));
                      }
                      return i;
                    }),
                    (r.getFragmentAtPosition = function (t, e, r) {
                      let i,
                        n = this.config,
                        a = this.fragPrevious,
                        o = r.fragments,
                        l = r.endSN,
                        u = r.fragmentHint,
                        c = n.maxFragLookUpTolerance,
                        d = !!(n.lowLatencyMode && r.partList && u);
                      if ((d && u && !this.bitrateTest && ((o = o.concat(u)), (l = u.sn)), t < e)) {
                        const f = t > e - c ? 0 : c;
                        i = Object(h.findFragmentByPTS)(a, o, t, f);
                      } else i = o[o.length - 1];
                      if (i) {
                        const p = i.sn - r.startSN,
                          v = a && i.level === a.level,
                          g = o[p + 1];
                        if (this.fragmentTracker.getState(i) === s.FragmentState.BACKTRACKED) {
                          i = null;
                          for (let m = p; o[m] && this.fragmentTracker.getState(o[m]) === s.FragmentState.BACKTRACKED; )
                            i = a ? o[m--] : o[--m];
                          i || (i = g);
                        } else
                          a &&
                            i.sn === a.sn &&
                            !d &&
                            v &&
                            (i.sn < l && this.fragmentTracker.getState(g) !== s.FragmentState.OK
                              ? (this.log('SN ' + i.sn + ' just loaded, load next one: ' + g.sn), (i = g))
                              : (i = null));
                      }
                      return i;
                    }),
                    (r.synchronizeToLiveEdge = function (t) {
                      const e = this.config,
                        r = this.media;
                      if (r) {
                        const i = this.hls.liveSyncPosition,
                          n = r.currentTime,
                          s = t.fragments[0].start,
                          a = t.edge,
                          o = n >= s - e.maxFragLookUpTolerance && n <= a;
                        if (null !== i && r.duration > i && (n < i || !o)) {
                          const l =
                            void 0 !== e.liveMaxLatencyDuration
                              ? e.liveMaxLatencyDuration
                              : e.liveMaxLatencyDurationCount * t.targetduration;
                          ((!o && r.readyState < 4) || n < a - l) &&
                            (this.loadedmetadata || (this.nextLoadPosition = i),
                            r.readyState &&
                              (this.warn(
                                'Playback: ' +
                                  n.toFixed(3) +
                                  ' is located too far from the end of live sliding playlist: ' +
                                  a +
                                  ', reset currentTime to : ' +
                                  i.toFixed(3)
                              ),
                              (r.currentTime = i)));
                        }
                      }
                    }),
                    (r.alignPlaylists = function (t, e) {
                      const r = this.levels,
                        n = this.levelLastLoaded,
                        s = this.fragPrevious,
                        a = null !== n ? r[n] : null,
                        o = t.fragments.length;
                      if (!o) return this.warn('No fragments in live playlist'), 0;
                      const l = t.fragments[0].start,
                        u = !e,
                        c = t.alignedSliding && Object(i.isFiniteNumber)(l);
                      if (u || (!c && !l)) {
                        Object(f.alignStream)(s, a, t);
                        const d = t.fragments[0].start;
                        return (
                          this.log(
                            'Live playlist sliding: ' +
                              d.toFixed(2) +
                              ' start-sn: ' +
                              (e ? e.startSN : 'na') +
                              '->' +
                              t.startSN +
                              ' prev-sn: ' +
                              (s ? s.sn : 'na') +
                              ' fragments: ' +
                              o
                          ),
                          d
                        );
                      }
                      return l;
                    }),
                    (r.waitForCdnTuneIn = function (t) {
                      return t.live && t.canBlockReload && t.tuneInGoal > Math.max(t.partHoldBack, 3 * t.partTarget);
                    }),
                    (r.setStartPosition = function (t, e) {
                      let r = this.startPosition;
                      if ((r < e && (r = -1), -1 === r || -1 === this.lastCurrentTime)) {
                        const n = t.startTimeOffset;
                        Object(i.isFiniteNumber)(n)
                          ? ((r = e + n),
                            n < 0 && (r += t.totalduration),
                            (r = Math.min(Math.max(e, r), e + t.totalduration)),
                            this.log('Start time offset ' + n + ' found in playlist, adjust startPosition to ' + r),
                            (this.startPosition = r))
                          : t.live
                            ? (r = this.hls.liveSyncPosition || e)
                            : (this.startPosition = r = 0),
                          (this.lastCurrentTime = r);
                      }
                      this.nextLoadPosition = r;
                    }),
                    (r.getLoadPosition = function () {
                      let t = this.media,
                        e = 0;
                      return (
                        this.loadedmetadata && t
                          ? (e = t.currentTime)
                          : this.nextLoadPosition && (e = this.nextLoadPosition),
                        e
                      );
                    }),
                    (r.handleFragLoadAborted = function (t, e) {
                      this.transmuxer &&
                        'initSegment' !== t.sn &&
                        t.stats.aborted &&
                        (this.warn(
                          'Fragment ' + t.sn + (e ? ' part' + e.index : '') + ' of level ' + t.level + ' was aborted'
                        ),
                        this.resetFragmentLoading(t));
                    }),
                    (r.resetFragmentLoading = function (t) {
                      (this.fragCurrent && this.fragContextChanged(t)) || (this.state = b.IDLE);
                    }),
                    (r.onFragmentOrKeyLoadError = function (t, e) {
                      if (!e.fatal) {
                        const r = e.frag;
                        if (r && r.type === t) {
                          const i = this.fragCurrent;
                          console.assert(
                            i && r.sn === i.sn && r.level === i.level && r.urlId === i.urlId,
                            'Frag load error must match current frag to retry'
                          );
                          const n = this.config;
                          if (this.fragLoadError + 1 <= n.fragLoadingMaxRetry) {
                            if (this.resetLiveStartWhenNotLoaded(r.level)) return;
                            const s = Math.min(
                              Math.pow(2, this.fragLoadError) * n.fragLoadingRetryDelay,
                              n.fragLoadingMaxRetryTimeout
                            );
                            this.warn(
                              'Fragment ' +
                                r.sn +
                                ' of ' +
                                t +
                                ' ' +
                                r.level +
                                ' failed to load, retrying in ' +
                                s +
                                'ms'
                            ),
                              (this.retryDate = self.performance.now() + s),
                              this.fragLoadError++,
                              (this.state = b.FRAG_LOADING_WAITING_RETRY);
                          } else
                            e.levelRetry
                              ? (t === y.PlaylistLevelType.AUDIO && (this.fragCurrent = null),
                                (this.fragLoadError = 0),
                                (this.state = b.IDLE))
                              : (o.logger.error(e.details + ' reaches max retry, redispatch as fatal ...'),
                                (e.fatal = !0),
                                this.hls.stopLoad(),
                                (this.state = b.ERROR));
                        }
                      }
                    }),
                    (r.afterBufferFlushed = function (t, e, r) {
                      if (t) {
                        const i = a.BufferHelper.getBuffered(t);
                        this.fragmentTracker.detectEvictedFragments(e, i, r),
                          this.state === b.ENDED && this.resetLoadingState();
                      }
                    }),
                    (r.resetLoadingState = function () {
                      (this.fragCurrent = null), (this.fragPrevious = null), (this.state = b.IDLE);
                    }),
                    (r.resetLiveStartWhenNotLoaded = function (t) {
                      if (!this.loadedmetadata) {
                        this.startFragRequested = !1;
                        const e = this.levels ? this.levels[t].details : null;
                        if (null !== e && void 0 !== e && e.live)
                          return (this.startPosition = -1), this.setStartPosition(e, 0), this.resetLoadingState(), !0;
                        this.nextLoadPosition = this.startPosition;
                      }
                      return !1;
                    }),
                    (r.updateLevelTiming = function (t, e, r, i) {
                      const n = this,
                        s = r.details;
                      console.assert(!!s, 'level.details must be defined'),
                        Object.keys(t.elementaryStreams).reduce(function (e, a) {
                          const o = t.elementaryStreams[a];
                          if (o) {
                            const u = o.endPTS - o.startPTS;
                            if (u <= 0)
                              return (
                                n.warn(
                                  'Could not parse fragment ' +
                                    t.sn +
                                    ' ' +
                                    a +
                                    ' duration reliably (' +
                                    u +
                                    ') resetting transmuxer to fallback to playlist timing'
                                ),
                                n.resetTransmuxer(),
                                e || !1
                              );
                            const c = i
                              ? 0
                              : Object(p.updateFragPTSDTS)(s, t, o.startPTS, o.endPTS, o.startDTS, o.endDTS);
                            return (
                              n.hls.trigger(l.Events.LEVEL_PTS_UPDATED, {
                                details: s,
                                level: r,
                                drift: c,
                                type: a,
                                frag: t,
                                start: o.startPTS,
                                end: o.endPTS,
                              }),
                              !0
                            );
                          }
                          return e;
                        }, !1)
                          ? ((this.state = b.PARSED), this.hls.trigger(l.Events.FRAG_PARSED, { frag: t, part: e }))
                          : this.resetLoadingState();
                    }),
                    (r.resetTransmuxer = function () {
                      this.transmuxer && (this.transmuxer.destroy(), (this.transmuxer = null));
                    }),
                    (function (t, e, r) {
                      e && E(t.prototype, e), r && E(t, r);
                    })(e, [
                      {
                        key: 'state',
                        get: function () {
                          return this._state;
                        },
                        set: function (t) {
                          const e = this._state;
                          e !== t && ((this._state = t), this.log(e + '->' + t));
                        },
                      },
                    ]),
                    e
                  );
                })(n.default);
            },
          './src/controller/buffer-controller.ts':
            /*!*********************************************!*\
  !*** ./src/controller/buffer-controller.ts ***!
  \*********************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return h;
                });
              var i = r(/*! ./src/polyfills/number */ './src/polyfills/number.ts'),
                n = r(/*! ../events */ './src/events.ts'),
                s = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                a = r(/*! ../errors */ './src/errors.ts'),
                o = r(/*! ../utils/buffer-helper */ './src/utils/buffer-helper.ts'),
                l = r(/*! ../utils/mediasource-helper */ './src/utils/mediasource-helper.ts'),
                u = r(/*! ../loader/fragment */ './src/loader/fragment.ts'),
                c = r(/*! ./buffer-operation-queue */ './src/controller/buffer-operation-queue.ts'),
                d = Object(l.getMediaSource)(),
                f = /([ha]vc.)(?:\.[^.,]+)+/,
                h = (function () {
                  function t(t) {
                    const e = this;
                    (this.details = null),
                      (this._objectUrl = null),
                      (this.operationQueue = void 0),
                      (this.listeners = void 0),
                      (this.hls = void 0),
                      (this.bufferCodecEventsExpected = 0),
                      (this._bufferCodecEventsTotal = 0),
                      (this.media = null),
                      (this.mediaSource = null),
                      (this.appendError = 0),
                      (this.tracks = {}),
                      (this.pendingTracks = {}),
                      (this.sourceBuffer = void 0),
                      (this._onMediaSourceOpen = function () {
                        const t = e.hls,
                          r = e.media,
                          i = e.mediaSource;
                        s.logger.log('[buffer-controller]: Media source opened'),
                          r && (e.updateMediaElementDuration(), t.trigger(n.Events.MEDIA_ATTACHED, { media: r })),
                          i && i.removeEventListener('sourceopen', e._onMediaSourceOpen),
                          e.checkPendingTracks();
                      }),
                      (this._onMediaSourceClose = function () {
                        s.logger.log('[buffer-controller]: Media source closed');
                      }),
                      (this._onMediaSourceEnded = function () {
                        s.logger.log('[buffer-controller]: Media source ended');
                      }),
                      (this.hls = t),
                      this._initSourceBuffer(),
                      this.registerListeners();
                  }
                  const e = t.prototype;
                  return (
                    (e.hasSourceTypes = function () {
                      return this.getSourceBufferTypes().length > 0 || Object.keys(this.pendingTracks).length > 0;
                    }),
                    (e.destroy = function () {
                      this.unregisterListeners(), (this.details = null);
                    }),
                    (e.registerListeners = function () {
                      const t = this.hls;
                      t.on(n.Events.MEDIA_ATTACHING, this.onMediaAttaching, this),
                        t.on(n.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                        t.on(n.Events.MANIFEST_PARSED, this.onManifestParsed, this),
                        t.on(n.Events.BUFFER_RESET, this.onBufferReset, this),
                        t.on(n.Events.BUFFER_APPENDING, this.onBufferAppending, this),
                        t.on(n.Events.BUFFER_CODECS, this.onBufferCodecs, this),
                        t.on(n.Events.BUFFER_EOS, this.onBufferEos, this),
                        t.on(n.Events.BUFFER_FLUSHING, this.onBufferFlushing, this),
                        t.on(n.Events.LEVEL_UPDATED, this.onLevelUpdated, this),
                        t.on(n.Events.FRAG_PARSED, this.onFragParsed, this),
                        t.on(n.Events.FRAG_CHANGED, this.onFragChanged, this);
                    }),
                    (e.unregisterListeners = function () {
                      const t = this.hls;
                      t.off(n.Events.MEDIA_ATTACHING, this.onMediaAttaching, this),
                        t.off(n.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                        t.off(n.Events.MANIFEST_PARSED, this.onManifestParsed, this),
                        t.off(n.Events.BUFFER_RESET, this.onBufferReset, this),
                        t.off(n.Events.BUFFER_APPENDING, this.onBufferAppending, this),
                        t.off(n.Events.BUFFER_CODECS, this.onBufferCodecs, this),
                        t.off(n.Events.BUFFER_EOS, this.onBufferEos, this),
                        t.off(n.Events.BUFFER_FLUSHING, this.onBufferFlushing, this),
                        t.off(n.Events.LEVEL_UPDATED, this.onLevelUpdated, this),
                        t.off(n.Events.FRAG_PARSED, this.onFragParsed, this),
                        t.off(n.Events.FRAG_CHANGED, this.onFragChanged, this);
                    }),
                    (e._initSourceBuffer = function () {
                      (this.sourceBuffer = {}),
                        (this.operationQueue = new c.default(this.sourceBuffer)),
                        (this.listeners = { audio: [], video: [], audiovideo: [] });
                    }),
                    (e.onManifestParsed = function (t, e) {
                      let r = 2;
                      ((e.audio && !e.video) || !e.altAudio) && (r = 1),
                        (this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = r),
                        (this.details = null),
                        s.logger.log(this.bufferCodecEventsExpected + ' bufferCodec event(s) expected');
                    }),
                    (e.onMediaAttaching = function (t, e) {
                      const r = (this.media = e.media);
                      if (r && d) {
                        const i = (this.mediaSource = new d());
                        i.addEventListener('sourceopen', this._onMediaSourceOpen),
                          i.addEventListener('sourceended', this._onMediaSourceEnded),
                          i.addEventListener('sourceclose', this._onMediaSourceClose),
                          (r.src = self.URL.createObjectURL(i)),
                          (this._objectUrl = r.src);
                      }
                    }),
                    (e.onMediaDetaching = function () {
                      const t = this.media,
                        e = this.mediaSource,
                        r = this._objectUrl;
                      if (e) {
                        if ((s.logger.log('[buffer-controller]: media source detaching'), 'open' === e.readyState))
                          try {
                            e.endOfStream();
                          } catch (t) {
                            s.logger.warn(
                              '[buffer-controller]: onMediaDetaching: ' + t.message + ' while calling endOfStream'
                            );
                          }
                        this.onBufferReset(),
                          e.removeEventListener('sourceopen', this._onMediaSourceOpen),
                          e.removeEventListener('sourceended', this._onMediaSourceEnded),
                          e.removeEventListener('sourceclose', this._onMediaSourceClose),
                          t &&
                            (r && self.URL.revokeObjectURL(r),
                            t.src === r
                              ? (t.removeAttribute('src'), t.load())
                              : s.logger.warn(
                                  '[buffer-controller]: media.src was changed by a third party - skip cleanup'
                                )),
                          (this.mediaSource = null),
                          (this.media = null),
                          (this._objectUrl = null),
                          (this.bufferCodecEventsExpected = this._bufferCodecEventsTotal),
                          (this.pendingTracks = {}),
                          (this.tracks = {});
                      }
                      this.hls.trigger(n.Events.MEDIA_DETACHED, void 0);
                    }),
                    (e.onBufferReset = function () {
                      const t = this;
                      this.getSourceBufferTypes().forEach(function (e) {
                        const r = t.sourceBuffer[e];
                        try {
                          r &&
                            (t.removeBufferListeners(e),
                            t.mediaSource && t.mediaSource.removeSourceBuffer(r),
                            (t.sourceBuffer[e] = void 0));
                        } catch (t) {
                          s.logger.warn('[buffer-controller]: Failed to reset the ' + e + ' buffer', t);
                        }
                      }),
                        this._initSourceBuffer();
                    }),
                    (e.onBufferCodecs = function (t, e) {
                      const r = this,
                        i = this.getSourceBufferTypes().length;
                      Object.keys(e).forEach(function (t) {
                        if (i) {
                          const n = r.tracks[t];
                          if (n && 'function' == typeof n.buffer.changeType) {
                            const s = e[t],
                              a = s.codec,
                              o = s.levelCodec,
                              l = s.container;
                            if ((n.levelCodec || n.codec).replace(f, '$1') !== (o || a).replace(f, '$1')) {
                              const u = l + ';codecs=' + (o || a);
                              r.appendChangeType(t, u);
                            }
                          }
                        } else r.pendingTracks[t] = e[t];
                      }),
                        i ||
                          ((this.bufferCodecEventsExpected = Math.max(this.bufferCodecEventsExpected - 1, 0)),
                          this.mediaSource && 'open' === this.mediaSource.readyState && this.checkPendingTracks());
                    }),
                    (e.appendChangeType = function (t, e) {
                      const r = this,
                        i = this.operationQueue,
                        n = {
                          execute: function () {
                            const n = r.sourceBuffer[t];
                            n &&
                              (s.logger.log('[buffer-controller]: changing ' + t + ' sourceBuffer type to ' + e),
                              n.changeType(e)),
                              i.shiftAndExecuteNext(t);
                          },
                          onStart: function () {},
                          onComplete: function () {},
                          onError: function (e) {
                            s.logger.warn('[buffer-controller]: Failed to change ' + t + ' SourceBuffer type', e);
                          },
                        };
                      i.append(n, t);
                    }),
                    (e.onBufferAppending = function (t, e) {
                      const r = this,
                        i = this.hls,
                        l = this.operationQueue,
                        u = this.tracks,
                        c = e.data,
                        d = e.type,
                        f = e.frag,
                        h = e.part,
                        p = e.chunkMeta,
                        v = p.buffering[d],
                        g = self.performance.now();
                      v.start = g;
                      const m = f.stats.buffering,
                        y = h ? h.stats.buffering : null;
                      0 === m.start && (m.start = g), y && 0 === y.start && (y.start = g);
                      const E = u.audio,
                        T =
                          'audio' === d &&
                          1 === p.id &&
                          'audio/mpeg' === (null === E || void 0 === E ? void 0 : E.container),
                        b = {
                          execute: function () {
                            if (((v.executeStart = self.performance.now()), T)) {
                              const t = r.sourceBuffer[d];
                              if (t) {
                                const e = f.start - t.timestampOffset;
                                Math.abs(e) >= 0.1 &&
                                  (s.logger.log(
                                    '[buffer-controller]: Updating audio SourceBuffer timestampOffset to ' +
                                      f.start +
                                      ' (delta: ' +
                                      e +
                                      ') sn: ' +
                                      f.sn +
                                      ')'
                                  ),
                                  (t.timestampOffset = f.start));
                              }
                            }
                            r.appendExecutor(c, d);
                          },
                          onStart: function () {},
                          onComplete: function () {
                            const t = self.performance.now();
                            (v.executeEnd = v.end = t),
                              0 === m.first && (m.first = t),
                              y && 0 === y.first && (y.first = t);
                            const e = r.sourceBuffer,
                              i = {};
                            for (const s in e) i[s] = o.BufferHelper.getBuffered(e[s]);
                            (r.appendError = 0),
                              r.hls.trigger(n.Events.BUFFER_APPENDED, {
                                type: d,
                                frag: f,
                                part: h,
                                chunkMeta: p,
                                parent: f.type,
                                timeRanges: i,
                              });
                          },
                          onError: function (t) {
                            s.logger.error(
                              '[buffer-controller]: Error encountered while trying to append to the ' +
                                d +
                                ' SourceBuffer',
                              t
                            );
                            const e = {
                              type: a.ErrorTypes.MEDIA_ERROR,
                              parent: f.type,
                              details: a.ErrorDetails.BUFFER_APPEND_ERROR,
                              err: t,
                              fatal: !1,
                            };
                            t.code === DOMException.QUOTA_EXCEEDED_ERR
                              ? (e.details = a.ErrorDetails.BUFFER_FULL_ERROR)
                              : (r.appendError++,
                                (e.details = a.ErrorDetails.BUFFER_APPEND_ERROR),
                                r.appendError > i.config.appendErrorMaxRetry &&
                                  (s.logger.error(
                                    '[buffer-controller]: Failed ' +
                                      i.config.appendErrorMaxRetry +
                                      ' times to append segment in sourceBuffer'
                                  ),
                                  (e.fatal = !0))),
                              i.trigger(n.Events.ERROR, e);
                          },
                        };
                      l.append(b, d);
                    }),
                    (e.onBufferFlushing = function (t, e) {
                      const r = this,
                        i = this.operationQueue,
                        a = function (t) {
                          return {
                            execute: r.removeExecutor.bind(r, t, e.startOffset, e.endOffset),
                            onStart: function () {},
                            onComplete: function () {
                              r.hls.trigger(n.Events.BUFFER_FLUSHED, { type: t });
                            },
                            onError: function (e) {
                              s.logger.warn('[buffer-controller]: Failed to remove from ' + t + ' SourceBuffer', e);
                            },
                          };
                        };
                      e.type
                        ? i.append(a(e.type), e.type)
                        : this.getSourceBufferTypes().forEach(function (t) {
                            i.append(a(t), t);
                          });
                    }),
                    (e.onFragParsed = function (t, e) {
                      const r = this,
                        i = e.frag,
                        a = e.part,
                        o = [],
                        l = a ? a.elementaryStreams : i.elementaryStreams;
                      l[u.ElementaryStreamTypes.AUDIOVIDEO]
                        ? o.push('audiovideo')
                        : (l[u.ElementaryStreamTypes.AUDIO] && o.push('audio'),
                          l[u.ElementaryStreamTypes.VIDEO] && o.push('video'));
                      0 === o.length &&
                        s.logger.warn(
                          'Fragments must have at least one ElementaryStreamType set. type: ' +
                            i.type +
                            ' level: ' +
                            i.level +
                            ' sn: ' +
                            i.sn
                        ),
                        this.blockBuffers(function () {
                          const t = self.performance.now();
                          (i.stats.buffering.end = t), a && (a.stats.buffering.end = t);
                          const e = a ? a.stats : i.stats;
                          r.hls.trigger(n.Events.FRAG_BUFFERED, { frag: i, part: a, stats: e, id: i.type });
                        }, o);
                    }),
                    (e.onFragChanged = function (t, e) {
                      this.flushBackBuffer();
                    }),
                    (e.onBufferEos = function (t, e) {
                      const r = this;
                      this.getSourceBufferTypes().reduce(function (t, i) {
                        const n = r.sourceBuffer[i];
                        return (
                          (e.type && e.type !== i) ||
                            (n &&
                              !n.ended &&
                              ((n.ended = !0), s.logger.log('[buffer-controller]: ' + i + ' sourceBuffer now EOS'))),
                          t && !(n && !n.ended)
                        );
                      }, !0) &&
                        this.blockBuffers(function () {
                          const t = r.mediaSource;
                          t && 'open' === t.readyState && t.endOfStream();
                        });
                    }),
                    (e.onLevelUpdated = function (t, e) {
                      const r = e.details;
                      r.fragments.length &&
                        ((this.details = r),
                        this.getSourceBufferTypes().length
                          ? this.blockBuffers(this.updateMediaElementDuration.bind(this))
                          : this.updateMediaElementDuration());
                    }),
                    (e.flushBackBuffer = function () {
                      const t = this.hls,
                        e = this.details,
                        r = this.media,
                        s = this.sourceBuffer;
                      if (r && null !== e) {
                        const a = this.getSourceBufferTypes();
                        if (a.length) {
                          const l =
                            e.live && null !== t.config.liveBackBufferLength
                              ? t.config.liveBackBufferLength
                              : t.config.backBufferLength;
                          if (Object(i.isFiniteNumber)(l) && !(l < 0)) {
                            const u = r.currentTime,
                              c = e.levelTargetDuration,
                              d = Math.max(l, c),
                              f = Math.floor(u / c) * c - d;
                            a.forEach(function (r) {
                              const i = s[r];
                              if (i) {
                                const a = o.BufferHelper.getBuffered(i);
                                a.length > 0 &&
                                  f > a.start(0) &&
                                  (t.trigger(n.Events.BACK_BUFFER_REACHED, { bufferEnd: f }),
                                  e.live && t.trigger(n.Events.LIVE_BACK_BUFFER_REACHED, { bufferEnd: f }),
                                  t.trigger(n.Events.BUFFER_FLUSHING, { startOffset: 0, endOffset: f, type: r }));
                              }
                            });
                          }
                        }
                      }
                    }),
                    (e.updateMediaElementDuration = function () {
                      if (this.details && this.media && this.mediaSource && 'open' === this.mediaSource.readyState) {
                        const t = this.details,
                          e = this.hls,
                          r = this.media,
                          n = this.mediaSource,
                          a = t.fragments[0].start + t.totalduration,
                          o = r.duration,
                          l = Object(i.isFiniteNumber)(n.duration) ? n.duration : 0;
                        t.live && e.config.liveDurationInfinity
                          ? (s.logger.log('[buffer-controller]: Media Source duration is set to Infinity'),
                            (n.duration = 1 / 0),
                            this.updateSeekableRange(t))
                          : ((a > l && a > o) || !Object(i.isFiniteNumber)(o)) &&
                            (s.logger.log('[buffer-controller]: Updating Media Source duration to ' + a.toFixed(3)),
                            (n.duration = a));
                      }
                    }),
                    (e.updateSeekableRange = function (t) {
                      const e = this.mediaSource,
                        r = t.fragments;
                      if (r.length && t.live && null !== e && void 0 !== e && e.setLiveSeekableRange) {
                        const i = Math.max(0, r[0].start),
                          n = Math.max(i, i + t.totalduration);
                        e.setLiveSeekableRange(i, n);
                      }
                    }),
                    (e.checkPendingTracks = function () {
                      const t = this.bufferCodecEventsExpected,
                        e = this.operationQueue,
                        r = this.pendingTracks,
                        i = Object.keys(r).length;
                      if ((i && !t) || 2 === i) {
                        this.createSourceBuffers(r), (this.pendingTracks = {});
                        const s = this.getSourceBufferTypes();
                        if (0 === s.length)
                          return void this.hls.trigger(n.Events.ERROR, {
                            type: a.ErrorTypes.MEDIA_ERROR,
                            details: a.ErrorDetails.BUFFER_INCOMPATIBLE_CODECS_ERROR,
                            fatal: !0,
                            reason: 'could not create source buffer for media codec(s)',
                          });
                        s.forEach(function (t) {
                          e.executeNext(t);
                        });
                      }
                    }),
                    (e.createSourceBuffers = function (t) {
                      const e = this.sourceBuffer,
                        r = this.mediaSource;
                      if (!r) throw Error('createSourceBuffers called when mediaSource was null');
                      let i = 0;
                      for (const o in t)
                        if (!e[o]) {
                          const l = t[o];
                          if (!l) throw Error('source buffer exists for track ' + o + ', however track does not');
                          const u = l.levelCodec || l.codec,
                            c = l.container + ';codecs=' + u;
                          s.logger.log('[buffer-controller]: creating sourceBuffer(' + c + ')');
                          try {
                            const d = (e[o] = r.addSourceBuffer(c)),
                              f = o;
                            this.addBufferListener(f, 'updatestart', this._onSBUpdateStart),
                              this.addBufferListener(f, 'updateend', this._onSBUpdateEnd),
                              this.addBufferListener(f, 'error', this._onSBUpdateError),
                              (this.tracks[o] = {
                                buffer: d,
                                codec: u,
                                container: l.container,
                                levelCodec: l.levelCodec,
                                id: l.id,
                              }),
                              i++;
                          } catch (t) {
                            s.logger.error('[buffer-controller]: error while trying to add sourceBuffer: ' + t.message),
                              this.hls.trigger(n.Events.ERROR, {
                                type: a.ErrorTypes.MEDIA_ERROR,
                                details: a.ErrorDetails.BUFFER_ADD_CODEC_ERROR,
                                fatal: !1,
                                error: t,
                                mimeType: c,
                              });
                          }
                        }
                      i && this.hls.trigger(n.Events.BUFFER_CREATED, { tracks: this.tracks });
                    }),
                    (e._onSBUpdateStart = function (t) {
                      this.operationQueue.current(t).onStart();
                    }),
                    (e._onSBUpdateEnd = function (t) {
                      const e = this.operationQueue;
                      e.current(t).onComplete(), e.shiftAndExecuteNext(t);
                    }),
                    (e._onSBUpdateError = function (t, e) {
                      s.logger.error('[buffer-controller]: ' + t + ' SourceBuffer error', e),
                        this.hls.trigger(n.Events.ERROR, {
                          type: a.ErrorTypes.MEDIA_ERROR,
                          details: a.ErrorDetails.BUFFER_APPENDING_ERROR,
                          fatal: !1,
                        });
                      const r = this.operationQueue.current(t);
                      r && r.onError(e);
                    }),
                    (e.removeExecutor = function (t, e, r) {
                      const n = this.media,
                        a = this.mediaSource,
                        o = this.operationQueue,
                        l = this.sourceBuffer[t];
                      if (!n || !a || !l)
                        return (
                          s.logger.warn(
                            '[buffer-controller]: Attempting to remove from the ' +
                              t +
                              ' SourceBuffer, but it does not exist'
                          ),
                          void o.shiftAndExecuteNext(t)
                        );
                      const u = Object(i.isFiniteNumber)(n.duration) ? n.duration : 1 / 0,
                        c = Object(i.isFiniteNumber)(a.duration) ? a.duration : 1 / 0,
                        d = Math.max(0, e),
                        f = Math.min(r, u, c);
                      f > d
                        ? (s.logger.log(
                            '[buffer-controller]: Removing [' + d + ',' + f + '] from the ' + t + ' SourceBuffer'
                          ),
                          console.assert(!l.updating, t + ' sourceBuffer must not be updating'),
                          l.remove(d, f))
                        : o.shiftAndExecuteNext(t);
                    }),
                    (e.appendExecutor = function (t, e) {
                      const r = this.operationQueue,
                        i = this.sourceBuffer[e];
                      if (!i)
                        return (
                          s.logger.warn(
                            '[buffer-controller]: Attempting to append to the ' +
                              e +
                              ' SourceBuffer, but it does not exist'
                          ),
                          void r.shiftAndExecuteNext(e)
                        );
                      (i.ended = !1),
                        console.assert(!i.updating, e + ' sourceBuffer must not be updating'),
                        i.appendBuffer(t);
                    }),
                    (e.blockBuffers = function (t, e) {
                      const r = this;
                      if ((void 0 === e && (e = this.getSourceBufferTypes()), !e.length))
                        return (
                          s.logger.log('[buffer-controller]: Blocking operation requested, but no SourceBuffers exist'),
                          void Promise.resolve(t)
                        );
                      const i = this.operationQueue,
                        n = e.map(function (t) {
                          return i.appendBlocker(t);
                        });
                      Promise.all(n).then(function () {
                        t(),
                          e.forEach(function (t) {
                            const e = r.sourceBuffer[t];
                            (e && e.updating) || i.shiftAndExecuteNext(t);
                          });
                      });
                    }),
                    (e.getSourceBufferTypes = function () {
                      return Object.keys(this.sourceBuffer);
                    }),
                    (e.addBufferListener = function (t, e, r) {
                      const i = this.sourceBuffer[t];
                      if (i) {
                        const n = r.bind(this, t);
                        this.listeners[t].push({ event: e, listener: n }), i.addEventListener(e, n);
                      }
                    }),
                    (e.removeBufferListeners = function (t) {
                      const e = this.sourceBuffer[t];
                      e &&
                        this.listeners[t].forEach(function (t) {
                          e.removeEventListener(t.event, t.listener);
                        });
                    }),
                    t
                  );
                })();
            },
          './src/controller/buffer-operation-queue.ts':
            /*!**************************************************!*\
  !*** ./src/controller/buffer-operation-queue.ts ***!
  \**************************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return n;
                });
              var i = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                n = (function () {
                  function t(t) {
                    (this.buffers = void 0),
                      (this.queues = { video: [], audio: [], audiovideo: [] }),
                      (this.buffers = t);
                  }
                  const e = t.prototype;
                  return (
                    (e.append = function (t, e) {
                      const r = this.queues[e];
                      r.push(t), 1 === r.length && this.buffers[e] && this.executeNext(e);
                    }),
                    (e.insertAbort = function (t, e) {
                      this.queues[e].unshift(t), this.executeNext(e);
                    }),
                    (e.appendBlocker = function (t) {
                      let e,
                        r = new Promise(function (t) {
                          e = t;
                        }),
                        i = {
                          execute: e,
                          onStart: function () {},
                          onComplete: function () {},
                          onError: function () {},
                        };
                      return this.append(i, t), r;
                    }),
                    (e.executeNext = function (t) {
                      const e = this.buffers,
                        r = this.queues,
                        n = e[t],
                        s = r[t];
                      if (s.length) {
                        const a = s[0];
                        try {
                          a.execute();
                        } catch (e) {
                          i.logger.warn(
                            '[buffer-operation-queue]: Unhandled exception executing the current operation'
                          ),
                            a.onError(e),
                            (n && n.updating) || (s.shift(), this.executeNext(t));
                        }
                      }
                    }),
                    (e.shiftAndExecuteNext = function (t) {
                      this.queues[t].shift(), this.executeNext(t);
                    }),
                    (e.current = function (t) {
                      return this.queues[t][0];
                    }),
                    t
                  );
                })();
            },
          './src/controller/cap-level-controller.ts':
            /*!************************************************!*\
  !*** ./src/controller/cap-level-controller.ts ***!
  \************************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              const i = r(/*! ../events */ './src/events.ts');
              function n(t, e) {
                for (let r = 0; r < e.length; r++) {
                  const i = e[r];
                  (i.enumerable = i.enumerable || !1),
                    (i.configurable = !0),
                    'value' in i && (i.writable = !0),
                    Object.defineProperty(t, i.key, i);
                }
              }
              const s = (function () {
                function t(t) {
                  (this.autoLevelCapping = void 0),
                    (this.firstLevel = void 0),
                    (this.media = void 0),
                    (this.restrictedLevels = void 0),
                    (this.timer = void 0),
                    (this.hls = void 0),
                    (this.streamController = void 0),
                    (this.clientRect = void 0),
                    (this.hls = t),
                    (this.autoLevelCapping = Number.POSITIVE_INFINITY),
                    (this.firstLevel = -1),
                    (this.media = null),
                    (this.restrictedLevels = []),
                    (this.timer = void 0),
                    (this.clientRect = null),
                    this.registerListeners();
                }
                const e = t.prototype;
                return (
                  (e.setStreamController = function (t) {
                    this.streamController = t;
                  }),
                  (e.destroy = function () {
                    this.unregisterListener(),
                      this.hls.config.capLevelToPlayerSize && this.stopCapping(),
                      (this.media = null),
                      (this.clientRect = null),
                      (this.hls = this.streamController = null);
                  }),
                  (e.registerListeners = function () {
                    const t = this.hls;
                    t.on(i.Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this),
                      t.on(i.Events.MEDIA_ATTACHING, this.onMediaAttaching, this),
                      t.on(i.Events.MANIFEST_PARSED, this.onManifestParsed, this),
                      t.on(i.Events.BUFFER_CODECS, this.onBufferCodecs, this),
                      t.on(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this);
                  }),
                  (e.unregisterListener = function () {
                    const t = this.hls;
                    t.off(i.Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this),
                      t.off(i.Events.MEDIA_ATTACHING, this.onMediaAttaching, this),
                      t.off(i.Events.MANIFEST_PARSED, this.onManifestParsed, this),
                      t.off(i.Events.BUFFER_CODECS, this.onBufferCodecs, this),
                      t.off(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this);
                  }),
                  (e.onFpsDropLevelCapping = function (e, r) {
                    t.isLevelAllowed(r.droppedLevel, this.restrictedLevels) &&
                      this.restrictedLevels.push(r.droppedLevel);
                  }),
                  (e.onMediaAttaching = function (t, e) {
                    this.media = e.media instanceof HTMLVideoElement ? e.media : null;
                  }),
                  (e.onManifestParsed = function (t, e) {
                    const r = this.hls;
                    (this.restrictedLevels = []),
                      (this.firstLevel = e.firstLevel),
                      r.config.capLevelToPlayerSize && e.video && this.startCapping();
                  }),
                  (e.onBufferCodecs = function (t, e) {
                    this.hls.config.capLevelToPlayerSize && e.video && this.startCapping();
                  }),
                  (e.onMediaDetaching = function () {
                    this.stopCapping();
                  }),
                  (e.detectPlayerSize = function () {
                    if (this.media && this.mediaHeight > 0 && this.mediaWidth > 0) {
                      const t = this.hls.levels;
                      if (t.length) {
                        const e = this.hls;
                        (e.autoLevelCapping = this.getMaxLevel(t.length - 1)),
                          e.autoLevelCapping > this.autoLevelCapping &&
                            this.streamController &&
                            this.streamController.nextLevelSwitch(),
                          (this.autoLevelCapping = e.autoLevelCapping);
                      }
                    }
                  }),
                  (e.getMaxLevel = function (e) {
                    const r = this,
                      i = this.hls.levels;
                    if (!i.length) return -1;
                    const n = i.filter(function (i, n) {
                      return t.isLevelAllowed(n, r.restrictedLevels) && n <= e;
                    });
                    return (this.clientRect = null), t.getMaxLevelByMediaSize(n, this.mediaWidth, this.mediaHeight);
                  }),
                  (e.startCapping = function () {
                    this.timer ||
                      ((this.autoLevelCapping = Number.POSITIVE_INFINITY),
                      (this.hls.firstLevel = this.getMaxLevel(this.firstLevel)),
                      self.clearInterval(this.timer),
                      (this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1e3)),
                      this.detectPlayerSize());
                  }),
                  (e.stopCapping = function () {
                    (this.restrictedLevels = []),
                      (this.firstLevel = -1),
                      (this.autoLevelCapping = Number.POSITIVE_INFINITY),
                      this.timer && (self.clearInterval(this.timer), (this.timer = void 0));
                  }),
                  (e.getDimensions = function () {
                    if (this.clientRect) return this.clientRect;
                    const t = this.media,
                      e = { width: 0, height: 0 };
                    if (t) {
                      const r = t.getBoundingClientRect();
                      (e.width = r.width),
                        (e.height = r.height),
                        e.width ||
                          e.height ||
                          ((e.width = r.right - r.left || t.width || 0),
                          (e.height = r.bottom - r.top || t.height || 0));
                    }
                    return (this.clientRect = e), e;
                  }),
                  (t.isLevelAllowed = function (t, e) {
                    return void 0 === e && (e = []), -1 === e.indexOf(t);
                  }),
                  (t.getMaxLevelByMediaSize = function (t, e, r) {
                    if (!t || !t.length) return -1;
                    for (
                      var i = function (t, e) {
                          return !e || t.width !== e.width || t.height !== e.height;
                        },
                        n = t.length - 1,
                        s = 0;
                      s < t.length;
                      s += 1
                    ) {
                      const a = t[s];
                      if ((a.width >= e || a.height >= r) && i(a, t[s + 1])) {
                        n = s;
                        break;
                      }
                    }
                    return n;
                  }),
                  (function (t, e, r) {
                    e && n(t.prototype, e), r && n(t, r);
                  })(
                    t,
                    [
                      {
                        key: 'mediaWidth',
                        get: function () {
                          return this.getDimensions().width * t.contentScaleFactor;
                        },
                      },
                      {
                        key: 'mediaHeight',
                        get: function () {
                          return this.getDimensions().height * t.contentScaleFactor;
                        },
                      },
                    ],
                    [
                      {
                        key: 'contentScaleFactor',
                        get: function () {
                          let t = 1;
                          try {
                            t = self.devicePixelRatio;
                          } catch (t) {}
                          return t;
                        },
                      },
                    ]
                  ),
                  t
                );
              })();
              e.default = s;
            },
          './src/controller/cmcd-controller.ts':
            /*!*******************************************!*\
  !*** ./src/controller/cmcd-controller.ts ***!
  \*******************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return f;
                });
              const i = r(/*! ../events */ './src/events.ts'),
                n = r(/*! ../types/cmcd */ './src/types/cmcd.ts'),
                s = r(/*! ../utils/buffer-helper */ './src/utils/buffer-helper.ts'),
                a = r(/*! ../utils/logger */ './src/utils/logger.ts');
              function o(t, e) {
                for (let r = 0; r < e.length; r++) {
                  const i = e[r];
                  (i.enumerable = i.enumerable || !1),
                    (i.configurable = !0),
                    'value' in i && (i.writable = !0),
                    Object.defineProperty(t, i.key, i);
                }
              }
              function l(t, e, r) {
                return e && o(t.prototype, e), r && o(t, r), t;
              }
              function u(t, e) {
                let r = ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
                if (r) return (r = r.call(t)).next.bind(r);
                if (
                  Array.isArray(t) ||
                  (r = (function (t, e) {
                    if (!t) return;
                    if ('string' == typeof t) return c(t, e);
                    let r = Object.prototype.toString.call(t).slice(8, -1);
                    'Object' === r && t.constructor && (r = t.constructor.name);
                    if ('Map' === r || 'Set' === r) return Array.from(t);
                    if ('Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return c(t, e);
                  })(t)) ||
                  (e && t && 'number' == typeof t.length)
                ) {
                  r && (t = r);
                  let i = 0;
                  return function () {
                    return i >= t.length ? { done: !0 } : { done: !1, value: t[i++] };
                  };
                }
                throw new TypeError(
                  'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
                );
              }
              function c(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for (var r = 0, i = new Array(e); r < e; r++) i[r] = t[r];
                return i;
              }
              function d() {
                return (d =
                  Object.assign ||
                  function (t) {
                    for (let e = 1; e < arguments.length; e++) {
                      const r = arguments[e];
                      for (const i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
                    }
                    return t;
                  }).apply(this, arguments);
              }
              var f = (function () {
                function t(e) {
                  const r = this;
                  (this.hls = void 0),
                    (this.config = void 0),
                    (this.media = void 0),
                    (this.sid = void 0),
                    (this.cid = void 0),
                    (this.useHeaders = !1),
                    (this.initialized = !1),
                    (this.starved = !1),
                    (this.buffering = !0),
                    (this.audioBuffer = void 0),
                    (this.videoBuffer = void 0),
                    (this.onWaiting = function () {
                      r.initialized && (r.starved = !0), (r.buffering = !0);
                    }),
                    (this.onPlaying = function () {
                      r.initialized || (r.initialized = !0), (r.buffering = !1);
                    }),
                    (this.applyPlaylistData = function (t) {
                      try {
                        r.apply(t, { ot: n.CMCDObjectType.MANIFEST, su: !r.initialized });
                      } catch (t) {
                        a.logger.warn('Could not generate manifest CMCD data.', t);
                      }
                    }),
                    (this.applyFragmentData = function (t) {
                      try {
                        const e = t.frag,
                          i = r.hls.levels[e.level],
                          s = r.getObjectType(e),
                          o = { d: 1e3 * e.duration, ot: s };
                        (s !== n.CMCDObjectType.VIDEO && s !== n.CMCDObjectType.AUDIO && s != n.CMCDObjectType.MUXED) ||
                          ((o.br = i.bitrate / 1e3),
                          (o.tb = r.getTopBandwidth(s) / 1e3),
                          (o.bl = r.getBufferLength(s))),
                          r.apply(t, o);
                      } catch (t) {
                        a.logger.warn('Could not generate segment CMCD data.', t);
                      }
                    }),
                    (this.hls = e);
                  const i = (this.config = e.config),
                    s = i.cmcd;
                  null != s &&
                    ((i.pLoader = this.createPlaylistLoader()),
                    (i.fLoader = this.createFragmentLoader()),
                    (this.sid = s.sessionId || t.uuid()),
                    (this.cid = s.contentId),
                    (this.useHeaders = !0 === s.useHeaders),
                    this.registerListeners());
                }
                const e = t.prototype;
                return (
                  (e.registerListeners = function () {
                    const t = this.hls;
                    t.on(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                      t.on(i.Events.MEDIA_DETACHED, this.onMediaDetached, this),
                      t.on(i.Events.BUFFER_CREATED, this.onBufferCreated, this);
                  }),
                  (e.unregisterListeners = function () {
                    const t = this.hls;
                    t.off(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                      t.off(i.Events.MEDIA_DETACHED, this.onMediaDetached, this),
                      t.off(i.Events.BUFFER_CREATED, this.onBufferCreated, this),
                      this.onMediaDetached();
                  }),
                  (e.destroy = function () {
                    this.unregisterListeners(), (this.hls = this.config = this.audioBuffer = this.videoBuffer = null);
                  }),
                  (e.onMediaAttached = function (t, e) {
                    (this.media = e.media),
                      this.media.addEventListener('waiting', this.onWaiting),
                      this.media.addEventListener('playing', this.onPlaying);
                  }),
                  (e.onMediaDetached = function () {
                    this.media &&
                      (this.media.removeEventListener('waiting', this.onWaiting),
                      this.media.removeEventListener('playing', this.onPlaying),
                      (this.media = null));
                  }),
                  (e.onBufferCreated = function (t, e) {
                    let r, i;
                    (this.audioBuffer = null === (r = e.tracks.audio) || void 0 === r ? void 0 : r.buffer),
                      (this.videoBuffer = null === (i = e.tracks.video) || void 0 === i ? void 0 : i.buffer);
                  }),
                  (e.createData = function () {
                    let t;
                    return {
                      v: n.CMCDVersion,
                      sf: n.CMCDStreamingFormat.HLS,
                      sid: this.sid,
                      cid: this.cid,
                      pr: null === (t = this.media) || void 0 === t ? void 0 : t.playbackRate,
                      mtp: this.hls.bandwidthEstimate / 1e3,
                    };
                  }),
                  (e.apply = function (e, r) {
                    void 0 === r && (r = {}), d(r, this.createData());
                    const i =
                      r.ot === n.CMCDObjectType.INIT ||
                      r.ot === n.CMCDObjectType.VIDEO ||
                      r.ot === n.CMCDObjectType.MUXED;
                    if (
                      (this.starved && i && ((r.bs = !0), (r.su = !0), (this.starved = !1)),
                      null == r.su && (r.su = this.buffering),
                      this.useHeaders)
                    ) {
                      const s = t.toHeaders(r);
                      if (!Object.keys(s).length) return;
                      e.headers || (e.headers = {}), d(e.headers, s);
                    } else {
                      const a = t.toQuery(r);
                      if (!a) return;
                      e.url = t.appendQueryToUri(e.url, a);
                    }
                  }),
                  (e.getObjectType = function (t) {
                    const e = t.type;
                    return 'subtitle' === e
                      ? n.CMCDObjectType.TIMED_TEXT
                      : 'initSegment' === t.sn
                        ? n.CMCDObjectType.INIT
                        : 'audio' === e
                          ? n.CMCDObjectType.AUDIO
                          : 'main' === e
                            ? this.hls.audioTracks.length
                              ? n.CMCDObjectType.VIDEO
                              : n.CMCDObjectType.MUXED
                            : void 0;
                  }),
                  (e.getTopBandwidth = function (t) {
                    let e,
                      r = 0,
                      i = this.hls;
                    if (t === n.CMCDObjectType.AUDIO) e = i.audioTracks;
                    else {
                      const s = i.maxAutoLevel,
                        a = s > -1 ? s + 1 : i.levels.length;
                      e = i.levels.slice(0, a);
                    }
                    for (var o, l = u(e); !(o = l()).done; ) {
                      const c = o.value;
                      c.bitrate > r && (r = c.bitrate);
                    }
                    return r > 0 ? r : NaN;
                  }),
                  (e.getBufferLength = function (t) {
                    const e = this.hls.media,
                      r = t === n.CMCDObjectType.AUDIO ? this.audioBuffer : this.videoBuffer;
                    return r && e
                      ? 1e3 * s.BufferHelper.bufferInfo(r, e.currentTime, this.config.maxBufferHole).len
                      : NaN;
                  }),
                  (e.createPlaylistLoader = function () {
                    const t = this.config.pLoader,
                      e = this.applyPlaylistData,
                      r = t || this.config.loader;
                    return (function () {
                      function t(t) {
                        (this.loader = void 0), (this.loader = new r(t));
                      }
                      const i = t.prototype;
                      return (
                        (i.destroy = function () {
                          this.loader.destroy();
                        }),
                        (i.abort = function () {
                          this.loader.abort();
                        }),
                        (i.load = function (t, r, i) {
                          e(t), this.loader.load(t, r, i);
                        }),
                        l(t, [
                          {
                            key: 'stats',
                            get: function () {
                              return this.loader.stats;
                            },
                          },
                          {
                            key: 'context',
                            get: function () {
                              return this.loader.context;
                            },
                          },
                        ]),
                        t
                      );
                    })();
                  }),
                  (e.createFragmentLoader = function () {
                    const t = this.config.fLoader,
                      e = this.applyFragmentData,
                      r = t || this.config.loader;
                    return (function () {
                      function t(t) {
                        (this.loader = void 0), (this.loader = new r(t));
                      }
                      const i = t.prototype;
                      return (
                        (i.destroy = function () {
                          this.loader.destroy();
                        }),
                        (i.abort = function () {
                          this.loader.abort();
                        }),
                        (i.load = function (t, r, i) {
                          e(t), this.loader.load(t, r, i);
                        }),
                        l(t, [
                          {
                            key: 'stats',
                            get: function () {
                              return this.loader.stats;
                            },
                          },
                          {
                            key: 'context',
                            get: function () {
                              return this.loader.context;
                            },
                          },
                        ]),
                        t
                      );
                    })();
                  }),
                  (t.uuid = function () {
                    const t = URL.createObjectURL(new Blob()),
                      e = t.toString();
                    return URL.revokeObjectURL(t), e.substr(e.lastIndexOf('/') + 1);
                  }),
                  (t.serialize = function (t) {
                    for (
                      var e,
                        r = [],
                        i = function (t) {
                          return !Number.isNaN(t) && null != t && '' !== t && !1 !== t;
                        },
                        n = function (t) {
                          return Math.round(t);
                        },
                        s = function (t) {
                          return 100 * n(t / 100);
                        },
                        a = {
                          br: n,
                          d: n,
                          bl: s,
                          dl: s,
                          mtp: s,
                          nor: function (t) {
                            return encodeURIComponent(t);
                          },
                          rtp: s,
                          tb: n,
                        },
                        o = u(Object.keys(t || {}).sort());
                      !(e = o()).done;

                    ) {
                      let l = e.value,
                        c = t[l];
                      if (i(c) && !(('v' === l && 1 === c) || ('pr' == l && 1 === c))) {
                        const d = a[l];
                        d && (c = d(c));
                        let f = typeof c,
                          h = void 0;
                        (h =
                          'ot' === l || 'sf' === l || 'st' === l
                            ? l + '=' + c
                            : 'boolean' === f
                              ? l
                              : 'number' === f
                                ? l + '=' + c
                                : l + '=' + JSON.stringify(c)),
                          r.push(h);
                      }
                    }
                    return r.join(',');
                  }),
                  (t.toHeaders = function (e) {
                    for (
                      var r = {},
                        i = ['Object', 'Request', 'Session', 'Status'],
                        n = [{}, {}, {}, {}],
                        s = {
                          br: 0,
                          d: 0,
                          ot: 0,
                          tb: 0,
                          bl: 1,
                          dl: 1,
                          mtp: 1,
                          nor: 1,
                          nrr: 1,
                          su: 1,
                          cid: 2,
                          pr: 2,
                          sf: 2,
                          sid: 2,
                          st: 2,
                          v: 2,
                          bs: 3,
                          rtp: 3,
                        },
                        a = 0,
                        o = Object.keys(e);
                      a < o.length;
                      a++
                    ) {
                      const l = o[a];
                      n[null != s[l] ? s[l] : 1][l] = e[l];
                    }
                    for (let u = 0; u < n.length; u++) {
                      const c = t.serialize(n[u]);
                      c && (r['CMCD-' + i[u]] = c);
                    }
                    return r;
                  }),
                  (t.toQuery = function (e) {
                    return 'CMCD=' + encodeURIComponent(t.serialize(e));
                  }),
                  (t.appendQueryToUri = function (t, e) {
                    return e ? '' + t + (t.includes('?') ? '&' : '?') + e : t;
                  }),
                  t
                );
              })();
            },
          './src/controller/eme-controller.ts':
            /*!******************************************!*\
  !*** ./src/controller/eme-controller.ts ***!
  \******************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              const i = r(/*! ../events */ './src/events.ts'),
                n = r(/*! ../errors */ './src/errors.ts'),
                s = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                a = r(/*! ../utils/mediakeys-helper */ './src/utils/mediakeys-helper.ts');
              function o(t, e) {
                for (let r = 0; r < e.length; r++) {
                  const i = e[r];
                  (i.enumerable = i.enumerable || !1),
                    (i.configurable = !0),
                    'value' in i && (i.writable = !0),
                    Object.defineProperty(t, i.key, i);
                }
              }
              const l = (function () {
                function t(t) {
                  (this.hls = void 0),
                    (this._widevineLicenseUrl = void 0),
                    (this._licenseXhrSetup = void 0),
                    (this._licenseResponseCallback = void 0),
                    (this._emeEnabled = void 0),
                    (this._requestMediaKeySystemAccess = void 0),
                    (this._drmSystemOptions = void 0),
                    (this._config = void 0),
                    (this._mediaKeysList = []),
                    (this._media = null),
                    (this._hasSetMediaKeys = !1),
                    (this._requestLicenseFailureCount = 0),
                    (this.mediaKeysPromise = null),
                    (this._onMediaEncrypted = this.onMediaEncrypted.bind(this)),
                    (this.hls = t),
                    (this._config = t.config),
                    (this._widevineLicenseUrl = this._config.widevineLicenseUrl),
                    (this._licenseXhrSetup = this._config.licenseXhrSetup),
                    (this._licenseResponseCallback = this._config.licenseResponseCallback),
                    (this._emeEnabled = this._config.emeEnabled),
                    (this._requestMediaKeySystemAccess = this._config.requestMediaKeySystemAccessFunc),
                    (this._drmSystemOptions = this._config.drmSystemOptions),
                    this._registerListeners();
                }
                const e = t.prototype;
                return (
                  (e.destroy = function () {
                    this._unregisterListeners(),
                      (this.hls = this._onMediaEncrypted = null),
                      (this._requestMediaKeySystemAccess = null);
                  }),
                  (e._registerListeners = function () {
                    this.hls.on(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                      this.hls.on(i.Events.MEDIA_DETACHED, this.onMediaDetached, this),
                      this.hls.on(i.Events.MANIFEST_PARSED, this.onManifestParsed, this);
                  }),
                  (e._unregisterListeners = function () {
                    this.hls.off(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                      this.hls.off(i.Events.MEDIA_DETACHED, this.onMediaDetached, this),
                      this.hls.off(i.Events.MANIFEST_PARSED, this.onManifestParsed, this);
                  }),
                  (e.getLicenseServerUrl = function (t) {
                    switch (t) {
                      case a.KeySystems.WIDEVINE:
                        if (!this._widevineLicenseUrl) break;
                        return this._widevineLicenseUrl;
                    }
                    throw new Error('no license server URL configured for key-system "' + t + '"');
                  }),
                  (e._attemptKeySystemAccess = function (t, e, r) {
                    const i = this,
                      n = (function (t, e, r, i) {
                        switch (t) {
                          case a.KeySystems.WIDEVINE:
                            return (function (t, e, r) {
                              const i = { audioCapabilities: [], videoCapabilities: [] };
                              return (
                                t.forEach(function (t) {
                                  i.audioCapabilities.push({
                                    contentType: 'audio/mp4; codecs="' + t + '"',
                                    robustness: r.audioRobustness || '',
                                  });
                                }),
                                e.forEach(function (t) {
                                  i.videoCapabilities.push({
                                    contentType: 'video/mp4; codecs="' + t + '"',
                                    robustness: r.videoRobustness || '',
                                  });
                                }),
                                [i]
                              );
                            })(e, r, i);
                          default:
                            throw new Error('Unknown key-system: ' + t);
                        }
                      })(t, e, r, this._drmSystemOptions);
                    s.logger.log('Requesting encrypted media key-system access');
                    const o = this.requestMediaKeySystemAccess(t, n);
                    (this.mediaKeysPromise = o.then(function (e) {
                      return i._onMediaKeySystemAccessObtained(t, e);
                    })),
                      o.catch(function (e) {
                        s.logger.error('Failed to obtain key-system "' + t + '" access:', e);
                      });
                  }),
                  (e._onMediaKeySystemAccessObtained = function (t, e) {
                    const r = this;
                    s.logger.log('Access for key-system "' + t + '" obtained');
                    const i = { mediaKeysSessionInitialized: !1, mediaKeySystemAccess: e, mediaKeySystemDomain: t };
                    this._mediaKeysList.push(i);
                    const n = Promise.resolve()
                      .then(function () {
                        return e.createMediaKeys();
                      })
                      .then(function (e) {
                        return (
                          (i.mediaKeys = e),
                          s.logger.log('Media-keys created for key-system "' + t + '"'),
                          r._onMediaKeysCreated(),
                          e
                        );
                      });
                    return (
                      n.catch(function (t) {
                        s.logger.error('Failed to create media-keys:', t);
                      }),
                      n
                    );
                  }),
                  (e._onMediaKeysCreated = function () {
                    const t = this;
                    this._mediaKeysList.forEach(function (e) {
                      e.mediaKeysSession ||
                        ((e.mediaKeysSession = e.mediaKeys.createSession()),
                        t._onNewMediaKeySession(e.mediaKeysSession));
                    });
                  }),
                  (e._onNewMediaKeySession = function (t) {
                    const e = this;
                    s.logger.log('New key-system session ' + t.sessionId),
                      t.addEventListener(
                        'message',
                        function (r) {
                          e._onKeySessionMessage(t, r.message);
                        },
                        !1
                      );
                  }),
                  (e._onKeySessionMessage = function (t, e) {
                    s.logger.log('Got EME message event, creating license request'),
                      this._requestLicense(e, function (e) {
                        s.logger.log(
                          'Received license data (length: ' + (e ? e.byteLength : e) + '), updating key-session'
                        ),
                          t.update(e);
                      });
                  }),
                  (e.onMediaEncrypted = function (t) {
                    const e = this;
                    if (
                      (s.logger.log('Media is encrypted using "' + t.initDataType + '" init data type'),
                      !this.mediaKeysPromise)
                    )
                      return (
                        s.logger.error('Fatal: Media is encrypted but no CDM access or no keys have been requested'),
                        void this.hls.trigger(i.Events.ERROR, {
                          type: n.ErrorTypes.KEY_SYSTEM_ERROR,
                          details: n.ErrorDetails.KEY_SYSTEM_NO_KEYS,
                          fatal: !0,
                        })
                      );
                    const r = function (r) {
                      e._media &&
                        (e._attemptSetMediaKeys(r),
                        e._generateRequestWithPreferredKeySession(t.initDataType, t.initData));
                    };
                    this.mediaKeysPromise.then(r).catch(r);
                  }),
                  (e._attemptSetMediaKeys = function (t) {
                    if (!this._media)
                      throw new Error('Attempted to set mediaKeys without first attaching a media element');
                    if (!this._hasSetMediaKeys) {
                      const e = this._mediaKeysList[0];
                      if (!e || !e.mediaKeys)
                        return (
                          s.logger.error(
                            'Fatal: Media is encrypted but no CDM access or no keys have been obtained yet'
                          ),
                          void this.hls.trigger(i.Events.ERROR, {
                            type: n.ErrorTypes.KEY_SYSTEM_ERROR,
                            details: n.ErrorDetails.KEY_SYSTEM_NO_KEYS,
                            fatal: !0,
                          })
                        );
                      s.logger.log('Setting keys for encrypted media'),
                        this._media.setMediaKeys(e.mediaKeys),
                        (this._hasSetMediaKeys = !0);
                    }
                  }),
                  (e._generateRequestWithPreferredKeySession = function (t, e) {
                    const r = this,
                      a = this._mediaKeysList[0];
                    if (!a)
                      return (
                        s.logger.error('Fatal: Media is encrypted but not any key-system access has been obtained yet'),
                        void this.hls.trigger(i.Events.ERROR, {
                          type: n.ErrorTypes.KEY_SYSTEM_ERROR,
                          details: n.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                          fatal: !0,
                        })
                      );
                    if (a.mediaKeysSessionInitialized)
                      s.logger.warn('Key-Session already initialized but requested again');
                    else {
                      const o = a.mediaKeysSession;
                      if (!o)
                        return (
                          s.logger.error('Fatal: Media is encrypted but no key-session existing'),
                          void this.hls.trigger(i.Events.ERROR, {
                            type: n.ErrorTypes.KEY_SYSTEM_ERROR,
                            details: n.ErrorDetails.KEY_SYSTEM_NO_SESSION,
                            fatal: !0,
                          })
                        );
                      if (!e)
                        return (
                          s.logger.warn('Fatal: initData required for generating a key session is null'),
                          void this.hls.trigger(i.Events.ERROR, {
                            type: n.ErrorTypes.KEY_SYSTEM_ERROR,
                            details: n.ErrorDetails.KEY_SYSTEM_NO_INIT_DATA,
                            fatal: !0,
                          })
                        );
                      s.logger.log('Generating key-session request for "' + t + '" init data type'),
                        (a.mediaKeysSessionInitialized = !0),
                        o
                          .generateRequest(t, e)
                          .then(function () {
                            s.logger.debug('Key-session generation succeeded');
                          })
                          .catch(function (t) {
                            s.logger.error('Error generating key-session request:', t),
                              r.hls.trigger(i.Events.ERROR, {
                                type: n.ErrorTypes.KEY_SYSTEM_ERROR,
                                details: n.ErrorDetails.KEY_SYSTEM_NO_SESSION,
                                fatal: !1,
                              });
                          });
                    }
                  }),
                  (e._createLicenseXhr = function (t, e, r) {
                    const i = new XMLHttpRequest();
                    (i.responseType = 'arraybuffer'),
                      (i.onreadystatechange = this._onLicenseRequestReadyStageChange.bind(this, i, t, e, r));
                    let n = this._licenseXhrSetup;
                    if (n)
                      try {
                        n.call(this.hls, i, t), (n = void 0);
                      } catch (t) {
                        s.logger.error(t);
                      }
                    try {
                      i.readyState || i.open('POST', t, !0), n && n.call(this.hls, i, t);
                    } catch (t) {
                      throw new Error('issue setting up KeySystem license XHR ' + t);
                    }
                    return i;
                  }),
                  (e._onLicenseRequestReadyStageChange = function (t, e, r, a) {
                    switch (t.readyState) {
                      case 4:
                        if (200 === t.status) {
                          (this._requestLicenseFailureCount = 0), s.logger.log('License request succeeded');
                          let o = t.response,
                            l = this._licenseResponseCallback;
                          if (l)
                            try {
                              o = l.call(this.hls, t, e);
                            } catch (t) {
                              s.logger.error(t);
                            }
                          a(o);
                        } else {
                          if (
                            (s.logger.error(
                              'License Request XHR failed (' + e + '). Status: ' + t.status + ' (' + t.statusText + ')'
                            ),
                            this._requestLicenseFailureCount++,
                            this._requestLicenseFailureCount > 3)
                          )
                            return void this.hls.trigger(i.Events.ERROR, {
                              type: n.ErrorTypes.KEY_SYSTEM_ERROR,
                              details: n.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                              fatal: !0,
                            });
                          const u = 3 - this._requestLicenseFailureCount + 1;
                          s.logger.warn('Retrying license request, ' + u + ' attempts left'),
                            this._requestLicense(r, a);
                        }
                    }
                  }),
                  (e._generateLicenseRequestChallenge = function (t, e) {
                    switch (t.mediaKeySystemDomain) {
                      case a.KeySystems.WIDEVINE:
                        return e;
                    }
                    throw new Error('unsupported key-system: ' + t.mediaKeySystemDomain);
                  }),
                  (e._requestLicense = function (t, e) {
                    s.logger.log('Requesting content license for key-system');
                    const r = this._mediaKeysList[0];
                    if (!r)
                      return (
                        s.logger.error(
                          'Fatal error: Media is encrypted but no key-system access has been obtained yet'
                        ),
                        void this.hls.trigger(i.Events.ERROR, {
                          type: n.ErrorTypes.KEY_SYSTEM_ERROR,
                          details: n.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                          fatal: !0,
                        })
                      );
                    try {
                      const a = this.getLicenseServerUrl(r.mediaKeySystemDomain),
                        o = this._createLicenseXhr(a, t, e);
                      s.logger.log('Sending license request to URL: ' + a);
                      const l = this._generateLicenseRequestChallenge(r, t);
                      o.send(l);
                    } catch (t) {
                      s.logger.error('Failure requesting DRM license: ' + t),
                        this.hls.trigger(i.Events.ERROR, {
                          type: n.ErrorTypes.KEY_SYSTEM_ERROR,
                          details: n.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                          fatal: !0,
                        });
                    }
                  }),
                  (e.onMediaAttached = function (t, e) {
                    if (this._emeEnabled) {
                      const r = e.media;
                      (this._media = r), r.addEventListener('encrypted', this._onMediaEncrypted);
                    }
                  }),
                  (e.onMediaDetached = function () {
                    const t = this._media,
                      e = this._mediaKeysList;
                    t &&
                      (t.removeEventListener('encrypted', this._onMediaEncrypted),
                      (this._media = null),
                      (this._mediaKeysList = []),
                      Promise.all(
                        e.map(function (t) {
                          if (t.mediaKeysSession) return t.mediaKeysSession.close().catch(function () {});
                        })
                      )
                        .then(function () {
                          return t.setMediaKeys(null);
                        })
                        .catch(function () {}));
                  }),
                  (e.onManifestParsed = function (t, e) {
                    if (this._emeEnabled) {
                      const r = e.levels
                          .map(function (t) {
                            return t.audioCodec;
                          })
                          .filter(function (t) {
                            return !!t;
                          }),
                        i = e.levels
                          .map(function (t) {
                            return t.videoCodec;
                          })
                          .filter(function (t) {
                            return !!t;
                          });
                      this._attemptKeySystemAccess(a.KeySystems.WIDEVINE, r, i);
                    }
                  }),
                  (function (t, e, r) {
                    e && o(t.prototype, e), r && o(t, r);
                  })(t, [
                    {
                      key: 'requestMediaKeySystemAccess',
                      get: function () {
                        if (!this._requestMediaKeySystemAccess)
                          throw new Error('No requestMediaKeySystemAccess function configured');
                        return this._requestMediaKeySystemAccess;
                      },
                    },
                  ]),
                  t
                );
              })();
              e.default = l;
            },
          './src/controller/fps-controller.ts':
            /*!******************************************!*\
  !*** ./src/controller/fps-controller.ts ***!
  \******************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              const i = r(/*! ../events */ './src/events.ts'),
                n = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                s = (function () {
                  function t(t) {
                    (this.hls = void 0),
                      (this.isVideoPlaybackQualityAvailable = !1),
                      (this.timer = void 0),
                      (this.media = null),
                      (this.lastTime = void 0),
                      (this.lastDroppedFrames = 0),
                      (this.lastDecodedFrames = 0),
                      (this.streamController = void 0),
                      (this.hls = t),
                      this.registerListeners();
                  }
                  const e = t.prototype;
                  return (
                    (e.setStreamController = function (t) {
                      this.streamController = t;
                    }),
                    (e.registerListeners = function () {
                      this.hls.on(i.Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
                    }),
                    (e.unregisterListeners = function () {
                      this.hls.off(i.Events.MEDIA_ATTACHING, this.onMediaAttaching);
                    }),
                    (e.destroy = function () {
                      this.timer && clearInterval(this.timer),
                        this.unregisterListeners(),
                        (this.isVideoPlaybackQualityAvailable = !1),
                        (this.media = null);
                    }),
                    (e.onMediaAttaching = function (t, e) {
                      const r = this.hls.config;
                      if (r.capLevelOnFPSDrop) {
                        const i = e.media instanceof self.HTMLVideoElement ? e.media : null;
                        (this.media = i),
                          i &&
                            'function' == typeof i.getVideoPlaybackQuality &&
                            (this.isVideoPlaybackQualityAvailable = !0),
                          self.clearInterval(this.timer),
                          (this.timer = self.setInterval(
                            this.checkFPSInterval.bind(this),
                            r.fpsDroppedMonitoringPeriod
                          ));
                      }
                    }),
                    (e.checkFPS = function (t, e, r) {
                      const s = performance.now();
                      if (e) {
                        if (this.lastTime) {
                          const a = s - this.lastTime,
                            o = r - this.lastDroppedFrames,
                            l = e - this.lastDecodedFrames,
                            u = (1e3 * o) / a,
                            c = this.hls;
                          if (
                            (c.trigger(i.Events.FPS_DROP, {
                              currentDropped: o,
                              currentDecoded: l,
                              totalDroppedFrames: r,
                            }),
                            u > 0 && o > c.config.fpsDroppedMonitoringThreshold * l)
                          ) {
                            let d = c.currentLevel;
                            n.logger.warn('drop FPS ratio greater than max allowed value for currentLevel: ' + d),
                              d > 0 &&
                                (-1 === c.autoLevelCapping || c.autoLevelCapping >= d) &&
                                ((d -= 1),
                                c.trigger(i.Events.FPS_DROP_LEVEL_CAPPING, { level: d, droppedLevel: c.currentLevel }),
                                (c.autoLevelCapping = d),
                                this.streamController.nextLevelSwitch());
                          }
                        }
                        (this.lastTime = s), (this.lastDroppedFrames = r), (this.lastDecodedFrames = e);
                      }
                    }),
                    (e.checkFPSInterval = function () {
                      const t = this.media;
                      if (t)
                        if (this.isVideoPlaybackQualityAvailable) {
                          const e = t.getVideoPlaybackQuality();
                          this.checkFPS(t, e.totalVideoFrames, e.droppedVideoFrames);
                        } else this.checkFPS(t, t.webkitDecodedFrameCount, t.webkitDroppedFrameCount);
                    }),
                    t
                  );
                })();
              e.default = s;
            },
          './src/controller/fragment-finders.ts':
            /*!********************************************!*\
  !*** ./src/controller/fragment-finders.ts ***!
  \********************************************/
            /*! exports provided: findFragmentByPDT, findFragmentByPTS, fragmentWithinToleranceTest, pdtWithinToleranceTest, findFragWithCC */ function (
              t,
              e,
              r
            ) {
              'use strict';
              r.r(e),
                r.d(e, 'findFragmentByPDT', function () {
                  return s;
                }),
                r.d(e, 'findFragmentByPTS', function () {
                  return a;
                }),
                r.d(e, 'fragmentWithinToleranceTest', function () {
                  return o;
                }),
                r.d(e, 'pdtWithinToleranceTest', function () {
                  return l;
                }),
                r.d(e, 'findFragWithCC', function () {
                  return u;
                });
              const i = r(/*! ./src/polyfills/number */ './src/polyfills/number.ts'),
                n = r(/*! ../utils/binary-search */ './src/utils/binary-search.ts');
              function s(t, e, r) {
                if (null === e || !Array.isArray(t) || !t.length || !Object(i.isFiniteNumber)(e)) return null;
                if (e < (t[0].programDateTime || 0)) return null;
                if (e >= (t[t.length - 1].endProgramDateTime || 0)) return null;
                r = r || 0;
                for (let n = 0; n < t.length; ++n) {
                  const s = t[n];
                  if (l(e, r, s)) return s;
                }
                return null;
              }
              function a(t, e, r, i) {
                void 0 === r && (r = 0), void 0 === i && (i = 0);
                let s = null;
                if (
                  (t ? (s = e[t.sn - e[0].sn + 1] || null) : 0 === r && 0 === e[0].start && (s = e[0]),
                  s && 0 === o(r, i, s))
                )
                  return s;
                const a = n.default.search(e, o.bind(null, r, i));
                return a || s;
              }
              function o(t, e, r) {
                void 0 === t && (t = 0), void 0 === e && (e = 0);
                const i = Math.min(e, r.duration + (r.deltaPTS ? r.deltaPTS : 0));
                return r.start + r.duration - i <= t ? 1 : r.start - i > t && r.start ? -1 : 0;
              }
              function l(t, e, r) {
                const i = 1e3 * Math.min(e, r.duration + (r.deltaPTS ? r.deltaPTS : 0));
                return (r.endProgramDateTime || 0) - i > t;
              }
              function u(t, e) {
                return n.default.search(t, function (t) {
                  return t.cc < e ? 1 : t.cc > e ? -1 : 0;
                });
              }
            },
          './src/controller/fragment-tracker.ts':
            /*!********************************************!*\
  !*** ./src/controller/fragment-tracker.ts ***!
  \********************************************/
            /*! exports provided: FragmentState, FragmentTracker */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'FragmentState', function () {
                  return i;
                }),
                r.d(e, 'FragmentTracker', function () {
                  return a;
                });
              let i,
                n = r(/*! ../events */ './src/events.ts'),
                s = r(/*! ../types/loader */ './src/types/loader.ts');
              !(function (t) {
                (t.NOT_LOADED = 'NOT_LOADED'),
                  (t.BACKTRACKED = 'BACKTRACKED'),
                  (t.APPENDING = 'APPENDING'),
                  (t.PARTIAL = 'PARTIAL'),
                  (t.OK = 'OK');
              })(i || (i = {}));
              var a = (function () {
                function t(t) {
                  (this.activeFragment = null),
                    (this.activeParts = null),
                    (this.fragments = Object.create(null)),
                    (this.timeRanges = Object.create(null)),
                    (this.bufferPadding = 0.2),
                    (this.hls = void 0),
                    (this.hls = t),
                    this._registerListeners();
                }
                const e = t.prototype;
                return (
                  (e._registerListeners = function () {
                    const t = this.hls;
                    t.on(n.Events.BUFFER_APPENDED, this.onBufferAppended, this),
                      t.on(n.Events.FRAG_BUFFERED, this.onFragBuffered, this),
                      t.on(n.Events.FRAG_LOADED, this.onFragLoaded, this);
                  }),
                  (e._unregisterListeners = function () {
                    const t = this.hls;
                    t.off(n.Events.BUFFER_APPENDED, this.onBufferAppended, this),
                      t.off(n.Events.FRAG_BUFFERED, this.onFragBuffered, this),
                      t.off(n.Events.FRAG_LOADED, this.onFragLoaded, this);
                  }),
                  (e.destroy = function () {
                    this._unregisterListeners(), (this.fragments = this.timeRanges = null);
                  }),
                  (e.getAppendedFrag = function (t, e) {
                    if (e === s.PlaylistLevelType.MAIN) {
                      const r = this.activeFragment,
                        i = this.activeParts;
                      if (!r) return null;
                      if (i)
                        for (let n = i.length; n--; ) {
                          const a = i[n],
                            o = a ? a.end : r.appendedPTS;
                          if (a.start <= t && void 0 !== o && t <= o)
                            return n > 9 && (this.activeParts = i.slice(n - 9)), a;
                        }
                      else if (r.start <= t && void 0 !== r.appendedPTS && t <= r.appendedPTS) return r;
                    }
                    return this.getBufferedFrag(t, e);
                  }),
                  (e.getBufferedFrag = function (t, e) {
                    for (let r = this.fragments, i = Object.keys(r), n = i.length; n--; ) {
                      const s = r[i[n]];
                      if ((null === s || void 0 === s ? void 0 : s.body.type) === e && s.buffered) {
                        const a = s.body;
                        if (a.start <= t && t <= a.end) return a;
                      }
                    }
                    return null;
                  }),
                  (e.detectEvictedFragments = function (t, e, r) {
                    const i = this;
                    Object.keys(this.fragments).forEach(function (n) {
                      const s = i.fragments[n];
                      if (s)
                        if (s.buffered) {
                          const a = s.range[t];
                          a &&
                            a.time.some(function (t) {
                              const r = !i.isTimeBuffered(t.startPTS, t.endPTS, e);
                              return r && i.removeFragment(s.body), r;
                            });
                        } else s.body.type === r && i.removeFragment(s.body);
                    });
                  }),
                  (e.detectPartialFragments = function (t) {
                    const e = this,
                      r = this.timeRanges,
                      i = t.frag,
                      n = t.part;
                    if (r && 'initSegment' !== i.sn) {
                      const s = l(i),
                        a = this.fragments[s];
                      a &&
                        (Object.keys(r).forEach(function (t) {
                          const s = i.elementaryStreams[t];
                          if (s) {
                            const o = r[t],
                              l = null !== n || !0 === s.partial;
                            a.range[t] = e.getBufferedTimes(i, n, l, o);
                          }
                        }),
                        (a.backtrack = a.loaded = null),
                        Object.keys(a.range).length ? (a.buffered = !0) : this.removeFragment(a.body));
                    }
                  }),
                  (e.fragBuffered = function (t) {
                    const e = l(t),
                      r = this.fragments[e];
                    r && ((r.backtrack = r.loaded = null), (r.buffered = !0));
                  }),
                  (e.getBufferedTimes = function (t, e, r, i) {
                    for (
                      var n = { time: [], partial: r },
                        s = e ? e.start : t.start,
                        a = e ? e.end : t.end,
                        o = t.minEndPTS || a,
                        l = t.maxStartPTS || s,
                        u = 0;
                      u < i.length;
                      u++
                    ) {
                      const c = i.start(u) - this.bufferPadding,
                        d = i.end(u) + this.bufferPadding;
                      if (l >= c && o <= d) {
                        n.time.push({ startPTS: Math.max(s, i.start(u)), endPTS: Math.min(a, i.end(u)) });
                        break;
                      }
                      if (s < d && a > c)
                        (n.partial = !0),
                          n.time.push({ startPTS: Math.max(s, i.start(u)), endPTS: Math.min(a, i.end(u)) });
                      else if (a <= c) break;
                    }
                    return n;
                  }),
                  (e.getPartialFragment = function (t) {
                    let e,
                      r,
                      i,
                      n = null,
                      s = 0,
                      a = this.bufferPadding,
                      l = this.fragments;
                    return (
                      Object.keys(l).forEach(function (u) {
                        const c = l[u];
                        c &&
                          o(c) &&
                          ((r = c.body.start - a),
                          (i = c.body.end + a),
                          t >= r && t <= i && ((e = Math.min(t - r, i - t)), s <= e && ((n = c.body), (s = e))));
                      }),
                      n
                    );
                  }),
                  (e.getState = function (t) {
                    const e = l(t),
                      r = this.fragments[e];
                    return r
                      ? r.buffered
                        ? o(r)
                          ? i.PARTIAL
                          : i.OK
                        : r.backtrack
                          ? i.BACKTRACKED
                          : i.APPENDING
                      : i.NOT_LOADED;
                  }),
                  (e.backtrack = function (t, e) {
                    const r = l(t),
                      i = this.fragments[r];
                    if (!i || i.backtrack) return null;
                    const n = (i.backtrack = e || i.loaded);
                    return (i.loaded = null), n;
                  }),
                  (e.getBacktrackData = function (t) {
                    const e = l(t),
                      r = this.fragments[e];
                    if (r) {
                      let i,
                        n = r.backtrack;
                      if (null !== n && void 0 !== n && null !== (i = n.payload) && void 0 !== i && i.byteLength)
                        return n;
                      this.removeFragment(t);
                    }
                    return null;
                  }),
                  (e.isTimeBuffered = function (t, e, r) {
                    for (var i, n, s = 0; s < r.length; s++) {
                      if (
                        ((i = r.start(s) - this.bufferPadding), (n = r.end(s) + this.bufferPadding), t >= i && e <= n)
                      )
                        return !0;
                      if (e <= i) return !1;
                    }
                    return !1;
                  }),
                  (e.onFragLoaded = function (t, e) {
                    const r = e.frag,
                      i = e.part;
                    if ('initSegment' !== r.sn && !r.bitrateTest && !i) {
                      const n = l(r);
                      this.fragments[n] = {
                        body: r,
                        loaded: e,
                        backtrack: null,
                        buffered: !1,
                        range: Object.create(null),
                      };
                    }
                  }),
                  (e.onBufferAppended = function (t, e) {
                    const r = this,
                      i = e.frag,
                      n = e.part,
                      a = e.timeRanges;
                    if (i.type === s.PlaylistLevelType.MAIN)
                      if (((this.activeFragment = i), n)) {
                        let o = this.activeParts;
                        o || (this.activeParts = o = []), o.push(n);
                      } else this.activeParts = null;
                    (this.timeRanges = a),
                      Object.keys(a).forEach(function (t) {
                        const e = a[t];
                        if ((r.detectEvictedFragments(t, e), !n))
                          for (let s = 0; s < e.length; s++) i.appendedPTS = Math.max(e.end(s), i.appendedPTS || 0);
                      });
                  }),
                  (e.onFragBuffered = function (t, e) {
                    this.detectPartialFragments(e);
                  }),
                  (e.hasFragment = function (t) {
                    const e = l(t);
                    return !!this.fragments[e];
                  }),
                  (e.removeFragmentsInRange = function (t, e, r) {
                    const i = this;
                    Object.keys(this.fragments).forEach(function (n) {
                      const s = i.fragments[n];
                      if (s && s.buffered) {
                        const a = s.body;
                        a.type === r && a.start < e && a.end > t && i.removeFragment(a);
                      }
                    });
                  }),
                  (e.removeFragment = function (t) {
                    const e = l(t);
                    (t.stats.loaded = 0), t.clearElementaryStreamInfo(), delete this.fragments[e];
                  }),
                  (e.removeAllFragments = function () {
                    (this.fragments = Object.create(null)), (this.activeFragment = null), (this.activeParts = null);
                  }),
                  t
                );
              })();
              function o(t) {
                let e, r;
                return (
                  t.buffered &&
                  ((null === (e = t.range.video) || void 0 === e ? void 0 : e.partial) ||
                    (null === (r = t.range.audio) || void 0 === r ? void 0 : r.partial))
                );
              }
              function l(t) {
                return t.type + '_' + t.level + '_' + t.urlId + '_' + t.sn;
              }
            },
          './src/controller/gap-controller.ts':
            /*!******************************************!*\
  !*** ./src/controller/gap-controller.ts ***!
  \******************************************/
            /*! exports provided: STALL_MINIMUM_DURATION_MS, MAX_START_GAP_JUMP, SKIP_BUFFER_HOLE_STEP_SECONDS, SKIP_BUFFER_RANGE_START, default */ function (
              t,
              e,
              r
            ) {
              'use strict';
              r.r(e),
                r.d(e, 'STALL_MINIMUM_DURATION_MS', function () {
                  return o;
                }),
                r.d(e, 'MAX_START_GAP_JUMP', function () {
                  return l;
                }),
                r.d(e, 'SKIP_BUFFER_HOLE_STEP_SECONDS', function () {
                  return u;
                }),
                r.d(e, 'SKIP_BUFFER_RANGE_START', function () {
                  return c;
                }),
                r.d(e, 'default', function () {
                  return d;
                });
              var i = r(/*! ../utils/buffer-helper */ './src/utils/buffer-helper.ts'),
                n = r(/*! ../errors */ './src/errors.ts'),
                s = r(/*! ../events */ './src/events.ts'),
                a = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                o = 250,
                l = 2,
                u = 0.1,
                c = 0.05,
                d = (function () {
                  function t(t, e, r, i) {
                    (this.config = void 0),
                      (this.media = void 0),
                      (this.fragmentTracker = void 0),
                      (this.hls = void 0),
                      (this.nudgeRetry = 0),
                      (this.stallReported = !1),
                      (this.stalled = null),
                      (this.moved = !1),
                      (this.seeking = !1),
                      (this.config = t),
                      (this.media = e),
                      (this.fragmentTracker = r),
                      (this.hls = i);
                  }
                  const e = t.prototype;
                  return (
                    (e.destroy = function () {
                      this.hls = this.fragmentTracker = this.media = null;
                    }),
                    (e.poll = function (t) {
                      const e = this.config,
                        r = this.media,
                        n = this.stalled,
                        s = r.currentTime,
                        u = r.seeking,
                        c = this.seeking && !u,
                        d = !this.seeking && u;
                      if (((this.seeking = u), s === t)) {
                        if (
                          ((d || c) && (this.stalled = null),
                          !r.paused && !r.ended && 0 !== r.playbackRate && i.BufferHelper.getBuffered(r).length)
                        ) {
                          const f = i.BufferHelper.bufferInfo(r, s, 0),
                            h = f.len > 0,
                            p = f.nextStart || 0;
                          if (h || p) {
                            if (u) {
                              const v = f.len > l,
                                g = !p || (p - s > l && !this.fragmentTracker.getPartialFragment(s));
                              if (v || g) return;
                              this.moved = !1;
                            }
                            if (!this.moved && null !== this.stalled) {
                              let m,
                                y = Math.max(p, f.start || 0) - s,
                                E = this.hls.levels ? this.hls.levels[this.hls.currentLevel] : null,
                                T = (
                                  null === E || void 0 === E
                                    ? void 0
                                    : null === (m = E.details) || void 0 === m
                                      ? void 0
                                      : m.live
                                )
                                  ? 2 * E.details.targetduration
                                  : l;
                              if (y > 0 && y <= T) return void this._trySkipBufferHole(null);
                            }
                            const b = self.performance.now();
                            if (null !== n) {
                              const S = b - n;
                              !u && S >= o && this._reportStall(f.len);
                              const L = i.BufferHelper.bufferInfo(r, s, e.maxBufferHole);
                              this._tryFixBufferStall(L, S);
                            } else this.stalled = b;
                          }
                        }
                      } else if (((this.moved = !0), null !== n)) {
                        if (this.stallReported) {
                          const A = self.performance.now() - n;
                          a.logger.warn('playback not stuck anymore @' + s + ', after ' + Math.round(A) + 'ms'),
                            (this.stallReported = !1);
                        }
                        (this.stalled = null), (this.nudgeRetry = 0);
                      }
                    }),
                    (e._tryFixBufferStall = function (t, e) {
                      const r = this.config,
                        i = this.fragmentTracker,
                        n = this.media.currentTime,
                        s = i.getPartialFragment(n);
                      if (s && this._trySkipBufferHole(s)) return;
                      t.len > r.maxBufferHole &&
                        e > 1e3 * r.highBufferWatchdogPeriod &&
                        (a.logger.warn('Trying to nudge playhead over buffer-hole'),
                        (this.stalled = null),
                        this._tryNudgeBuffer());
                    }),
                    (e._reportStall = function (t) {
                      const e = this.hls,
                        r = this.media;
                      this.stallReported ||
                        ((this.stallReported = !0),
                        a.logger.warn(
                          'Playback stalling at @' + r.currentTime + ' due to low buffer (buffer=' + t + ')'
                        ),
                        e.trigger(s.Events.ERROR, {
                          type: n.ErrorTypes.MEDIA_ERROR,
                          details: n.ErrorDetails.BUFFER_STALLED_ERROR,
                          fatal: !1,
                          buffer: t,
                        }));
                    }),
                    (e._trySkipBufferHole = function (t) {
                      for (
                        let e = this.config,
                          r = this.hls,
                          o = this.media,
                          l = o.currentTime,
                          d = 0,
                          f = i.BufferHelper.getBuffered(o),
                          h = 0;
                        h < f.length;
                        h++
                      ) {
                        const p = f.start(h);
                        if (l + e.maxBufferHole >= d && l < p) {
                          const v = Math.max(p + c, o.currentTime + u);
                          return (
                            a.logger.warn('skipping hole, adjusting currentTime from ' + l + ' to ' + v),
                            (this.moved = !0),
                            (this.stalled = null),
                            (o.currentTime = v),
                            t &&
                              r.trigger(s.Events.ERROR, {
                                type: n.ErrorTypes.MEDIA_ERROR,
                                details: n.ErrorDetails.BUFFER_SEEK_OVER_HOLE,
                                fatal: !1,
                                reason: 'fragment loaded with buffer holes, seeking from ' + l + ' to ' + v,
                                frag: t,
                              }),
                            v
                          );
                        }
                        d = f.end(h);
                      }
                      return 0;
                    }),
                    (e._tryNudgeBuffer = function () {
                      const t = this.config,
                        e = this.hls,
                        r = this.media,
                        i = r.currentTime,
                        o = (this.nudgeRetry || 0) + 1;
                      if (((this.nudgeRetry = o), o < t.nudgeMaxRetry)) {
                        const l = i + o * t.nudgeOffset;
                        a.logger.warn("Nudging 'currentTime' from " + i + ' to ' + l),
                          (r.currentTime = l),
                          e.trigger(s.Events.ERROR, {
                            type: n.ErrorTypes.MEDIA_ERROR,
                            details: n.ErrorDetails.BUFFER_NUDGE_ON_STALL,
                            fatal: !1,
                          });
                      } else
                        a.logger.error(
                          'Playhead still not moving while enough data buffered @' +
                            i +
                            ' after ' +
                            t.nudgeMaxRetry +
                            ' nudges'
                        ),
                          e.trigger(s.Events.ERROR, {
                            type: n.ErrorTypes.MEDIA_ERROR,
                            details: n.ErrorDetails.BUFFER_STALLED_ERROR,
                            fatal: !0,
                          });
                    }),
                    t
                  );
                })();
            },
          './src/controller/id3-track-controller.ts':
            /*!************************************************!*\
  !*** ./src/controller/id3-track-controller.ts ***!
  \************************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              const i = r(/*! ../events */ './src/events.ts'),
                n = r(/*! ../utils/texttrack-utils */ './src/utils/texttrack-utils.ts'),
                s = r(/*! ../demux/id3 */ './src/demux/id3.ts'),
                a = (function () {
                  function t(t) {
                    (this.hls = void 0),
                      (this.id3Track = null),
                      (this.media = null),
                      (this.hls = t),
                      this._registerListeners();
                  }
                  const e = t.prototype;
                  return (
                    (e.destroy = function () {
                      this._unregisterListeners();
                    }),
                    (e._registerListeners = function () {
                      const t = this.hls;
                      t.on(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                        t.on(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                        t.on(i.Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this),
                        t.on(i.Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
                    }),
                    (e._unregisterListeners = function () {
                      const t = this.hls;
                      t.off(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                        t.off(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                        t.off(i.Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this),
                        t.off(i.Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
                    }),
                    (e.onMediaAttached = function (t, e) {
                      this.media = e.media;
                    }),
                    (e.onMediaDetaching = function () {
                      this.id3Track &&
                        (Object(n.clearCurrentCues)(this.id3Track), (this.id3Track = null), (this.media = null));
                    }),
                    (e.getID3Track = function (t) {
                      if (this.media) {
                        for (let e = 0; e < t.length; e++) {
                          const r = t[e];
                          if ('metadata' === r.kind && 'id3' === r.label)
                            return Object(n.sendAddTrackEvent)(r, this.media), r;
                        }
                        return this.media.addTextTrack('metadata', 'id3');
                      }
                    }),
                    (e.onFragParsingMetadata = function (t, e) {
                      if (this.media) {
                        const r = e.frag,
                          i = e.samples;
                        this.id3Track ||
                          ((this.id3Track = this.getID3Track(this.media.textTracks)), (this.id3Track.mode = 'hidden'));
                        for (let n = self.WebKitDataCue || self.VTTCue || self.TextTrackCue, a = 0; a < i.length; a++) {
                          const o = s.getID3Frames(i[a].data);
                          if (o) {
                            let l = i[a].pts,
                              u = a < i.length - 1 ? i[a + 1].pts : r.end;
                            u - l <= 0 && (u = l + 0.25);
                            for (let c = 0; c < o.length; c++) {
                              const d = o[c];
                              if (!s.isTimeStampFrame(d)) {
                                const f = new n(l, u, '');
                                (f.value = d), this.id3Track.addCue(f);
                              }
                            }
                          }
                        }
                      }
                    }),
                    (e.onBufferFlushing = function (t, e) {
                      const r = e.startOffset,
                        i = e.endOffset,
                        s = e.type;
                      if (!s || 'audio' === s) {
                        const a = this.id3Track;
                        a && Object(n.removeCuesInRange)(a, r, i);
                      }
                    }),
                    t
                  );
                })();
              e.default = a;
            },
          './src/controller/latency-controller.ts':
            /*!**********************************************!*\
  !*** ./src/controller/latency-controller.ts ***!
  \**********************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return o;
                });
              const i = r(/*! ../errors */ './src/errors.ts'),
                n = r(/*! ../events */ './src/events.ts'),
                s = r(/*! ../utils/logger */ './src/utils/logger.ts');
              function a(t, e) {
                for (let r = 0; r < e.length; r++) {
                  const i = e[r];
                  (i.enumerable = i.enumerable || !1),
                    (i.configurable = !0),
                    'value' in i && (i.writable = !0),
                    Object.defineProperty(t, i.key, i);
                }
              }
              var o = (function () {
                function t(t) {
                  const e = this;
                  (this.hls = void 0),
                    (this.config = void 0),
                    (this.media = null),
                    (this.levelDetails = null),
                    (this.currentTime = 0),
                    (this.stallCount = 0),
                    (this._latency = null),
                    (this.timeupdateHandler = function () {
                      return e.timeupdate();
                    }),
                    (this.hls = t),
                    (this.config = t.config),
                    this.registerListeners();
                }
                const e = t.prototype;
                return (
                  (e.destroy = function () {
                    this.unregisterListeners(),
                      this.onMediaDetaching(),
                      (this.levelDetails = null),
                      (this.hls = this.timeupdateHandler = null);
                  }),
                  (e.registerListeners = function () {
                    this.hls.on(n.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                      this.hls.on(n.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                      this.hls.on(n.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                      this.hls.on(n.Events.LEVEL_UPDATED, this.onLevelUpdated, this),
                      this.hls.on(n.Events.ERROR, this.onError, this);
                  }),
                  (e.unregisterListeners = function () {
                    this.hls.off(n.Events.MEDIA_ATTACHED, this.onMediaAttached),
                      this.hls.off(n.Events.MEDIA_DETACHING, this.onMediaDetaching),
                      this.hls.off(n.Events.MANIFEST_LOADING, this.onManifestLoading),
                      this.hls.off(n.Events.LEVEL_UPDATED, this.onLevelUpdated),
                      this.hls.off(n.Events.ERROR, this.onError);
                  }),
                  (e.onMediaAttached = function (t, e) {
                    (this.media = e.media), this.media.addEventListener('timeupdate', this.timeupdateHandler);
                  }),
                  (e.onMediaDetaching = function () {
                    this.media &&
                      (this.media.removeEventListener('timeupdate', this.timeupdateHandler), (this.media = null));
                  }),
                  (e.onManifestLoading = function () {
                    (this.levelDetails = null), (this._latency = null), (this.stallCount = 0);
                  }),
                  (e.onLevelUpdated = function (t, e) {
                    const r = e.details;
                    (this.levelDetails = r),
                      r.advanced && this.timeupdate(),
                      !r.live && this.media && this.media.removeEventListener('timeupdate', this.timeupdateHandler);
                  }),
                  (e.onError = function (t, e) {
                    e.details === i.ErrorDetails.BUFFER_STALLED_ERROR &&
                      (this.stallCount++,
                      s.logger.warn('[playback-rate-controller]: Stall detected, adjusting target latency'));
                  }),
                  (e.timeupdate = function () {
                    const t = this.media,
                      e = this.levelDetails;
                    if (t && e) {
                      this.currentTime = t.currentTime;
                      const r = this.computeLatency();
                      if (null !== r) {
                        this._latency = r;
                        const i = this.config,
                          n = i.lowLatencyMode,
                          s = i.maxLiveSyncPlaybackRate;
                        if (n && 1 !== s) {
                          const a = this.targetLatency;
                          if (null !== a) {
                            const o = r - a,
                              l = o < Math.min(this.maxLatency, a + e.targetduration);
                            if (e.live && l && o > 0.05 && this.forwardBufferLength > 1) {
                              const u = Math.min(2, Math.max(1, s)),
                                c = Math.round((2 / (1 + Math.exp(-0.75 * o - this.edgeStalled))) * 20) / 20;
                              t.playbackRate = Math.min(u, Math.max(1, c));
                            } else 1 !== t.playbackRate && 0 !== t.playbackRate && (t.playbackRate = 1);
                          }
                        }
                      }
                    }
                  }),
                  (e.estimateLiveEdge = function () {
                    const t = this.levelDetails;
                    return null === t ? null : t.edge + t.age;
                  }),
                  (e.computeLatency = function () {
                    const t = this.estimateLiveEdge();
                    return null === t ? null : t - this.currentTime;
                  }),
                  (function (t, e, r) {
                    e && a(t.prototype, e), r && a(t, r);
                  })(t, [
                    {
                      key: 'latency',
                      get: function () {
                        return this._latency || 0;
                      },
                    },
                    {
                      key: 'maxLatency',
                      get: function () {
                        const t = this.config,
                          e = this.levelDetails;
                        return void 0 !== t.liveMaxLatencyDuration
                          ? t.liveMaxLatencyDuration
                          : e
                            ? t.liveMaxLatencyDurationCount * e.targetduration
                            : 0;
                      },
                    },
                    {
                      key: 'targetLatency',
                      get: function () {
                        const t = this.levelDetails;
                        if (null === t) return null;
                        let e = t.holdBack,
                          r = t.partHoldBack,
                          i = t.targetduration,
                          n = this.config,
                          s = n.liveSyncDuration,
                          a = n.liveSyncDurationCount,
                          o = n.lowLatencyMode,
                          l = this.hls.userConfig,
                          u = (o && r) || e;
                        (l.liveSyncDuration || l.liveSyncDurationCount || 0 === u) && (u = void 0 !== s ? s : a * i);
                        const c = i;
                        return u + Math.min(1 * this.stallCount, c);
                      },
                    },
                    {
                      key: 'liveSyncPosition',
                      get: function () {
                        const t = this.estimateLiveEdge(),
                          e = this.targetLatency,
                          r = this.levelDetails;
                        if (null === t || null === e || null === r) return null;
                        const i = r.edge,
                          n = t - e - this.edgeStalled,
                          s = i - r.totalduration,
                          a = i - ((this.config.lowLatencyMode && r.partTarget) || r.targetduration);
                        return Math.min(Math.max(s, n), a);
                      },
                    },
                    {
                      key: 'drift',
                      get: function () {
                        const t = this.levelDetails;
                        return null === t ? 1 : t.drift;
                      },
                    },
                    {
                      key: 'edgeStalled',
                      get: function () {
                        const t = this.levelDetails;
                        if (null === t) return 0;
                        const e = 3 * ((this.config.lowLatencyMode && t.partTarget) || t.targetduration);
                        return Math.max(t.age - e, 0);
                      },
                    },
                    {
                      key: 'forwardBufferLength',
                      get: function () {
                        const t = this.media,
                          e = this.levelDetails;
                        if (!t || !e) return 0;
                        const r = t.buffered.length;
                        return r ? t.buffered.end(r - 1) : e.edge - this.currentTime;
                      },
                    },
                  ]),
                  t
                );
              })();
            },
          './src/controller/level-controller.ts':
            /*!********************************************!*\
  !*** ./src/controller/level-controller.ts ***!
  \********************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return p;
                });
              const i = r(/*! ../types/level */ './src/types/level.ts'),
                n = r(/*! ../events */ './src/events.ts'),
                s = r(/*! ../errors */ './src/errors.ts'),
                a = r(/*! ../utils/codecs */ './src/utils/codecs.ts'),
                o = r(/*! ./level-helper */ './src/controller/level-helper.ts'),
                l = r(/*! ./base-playlist-controller */ './src/controller/base-playlist-controller.ts'),
                u = r(/*! ../types/loader */ './src/types/loader.ts');
              function c() {
                return (c =
                  Object.assign ||
                  function (t) {
                    for (let e = 1; e < arguments.length; e++) {
                      const r = arguments[e];
                      for (const i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
                    }
                    return t;
                  }).apply(this, arguments);
              }
              function d(t, e) {
                for (let r = 0; r < e.length; r++) {
                  const i = e[r];
                  (i.enumerable = i.enumerable || !1),
                    (i.configurable = !0),
                    'value' in i && (i.writable = !0),
                    Object.defineProperty(t, i.key, i);
                }
              }
              function f(t, e) {
                return (f =
                  Object.setPrototypeOf ||
                  function (t, e) {
                    return (t.__proto__ = e), t;
                  })(t, e);
              }
              var h = /chrome|firefox/.test(navigator.userAgent.toLowerCase()),
                p = (function (t) {
                  function e(e) {
                    let r;
                    return (
                      ((r = t.call(this, e, '[level-controller]') || this)._levels = []),
                      (r._firstLevel = -1),
                      (r._startLevel = void 0),
                      (r.currentLevelIndex = -1),
                      (r.manualLevelIndex = -1),
                      (r.onParsedComplete = void 0),
                      r._registerListeners(),
                      r
                    );
                  }
                  !(function (t, e) {
                    (t.prototype = Object.create(e.prototype)), (t.prototype.constructor = t), f(t, e);
                  })(e, t);
                  const r = e.prototype;
                  return (
                    (r._registerListeners = function () {
                      const t = this.hls;
                      t.on(n.Events.MANIFEST_LOADED, this.onManifestLoaded, this),
                        t.on(n.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                        t.on(n.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this),
                        t.on(n.Events.FRAG_LOADED, this.onFragLoaded, this),
                        t.on(n.Events.ERROR, this.onError, this);
                    }),
                    (r._unregisterListeners = function () {
                      const t = this.hls;
                      t.off(n.Events.MANIFEST_LOADED, this.onManifestLoaded, this),
                        t.off(n.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                        t.off(n.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this),
                        t.off(n.Events.FRAG_LOADED, this.onFragLoaded, this),
                        t.off(n.Events.ERROR, this.onError, this);
                    }),
                    (r.destroy = function () {
                      this._unregisterListeners(),
                        (this.manualLevelIndex = -1),
                        (this._levels.length = 0),
                        t.prototype.destroy.call(this);
                    }),
                    (r.startLoad = function () {
                      this._levels.forEach(function (t) {
                        t.loadError = 0;
                      }),
                        t.prototype.startLoad.call(this);
                    }),
                    (r.onManifestLoaded = function (t, e) {
                      let r,
                        l,
                        u = [],
                        c = [],
                        d = [],
                        f = {},
                        p = !1,
                        v = !1,
                        g = !1;
                      if (
                        (e.levels.forEach(function (t) {
                          const e = t.attrs;
                          (p = p || !(!t.width || !t.height)),
                            (v = v || !!t.videoCodec),
                            (g = g || !!t.audioCodec),
                            h && t.audioCodec && -1 !== t.audioCodec.indexOf('mp4a.40.34') && (t.audioCodec = void 0);
                          const r = t.bitrate + '-' + t.attrs.RESOLUTION + '-' + t.attrs.CODECS;
                          (l = f[r]) ? l.url.push(t.url) : ((l = new i.Level(t)), (f[r] = l), u.push(l)),
                            e &&
                              (e.AUDIO && Object(o.addGroupId)(l, 'audio', e.AUDIO),
                              e.SUBTITLES && Object(o.addGroupId)(l, 'text', e.SUBTITLES));
                        }),
                        (p || v) &&
                          g &&
                          (u = u.filter(function (t) {
                            const e = t.videoCodec,
                              r = t.width,
                              i = t.height;
                            return !!e || !(!r || !i);
                          })),
                        (u = u.filter(function (t) {
                          const e = t.audioCodec,
                            r = t.videoCodec;
                          return (
                            (!e || Object(a.isCodecSupportedInMp4)(e, 'audio')) &&
                            (!r || Object(a.isCodecSupportedInMp4)(r, 'video'))
                          );
                        })),
                        e.audioTracks &&
                          ((c = e.audioTracks.filter(function (t) {
                            return !t.audioCodec || Object(a.isCodecSupportedInMp4)(t.audioCodec, 'audio');
                          })),
                          Object(o.assignTrackIdsByGroup)(c)),
                        e.subtitles && ((d = e.subtitles), Object(o.assignTrackIdsByGroup)(d)),
                        u.length > 0)
                      ) {
                        (r = u[0].bitrate),
                          u.sort(function (t, e) {
                            return t.bitrate - e.bitrate;
                          }),
                          (this._levels = u);
                        for (let m = 0; m < u.length; m++)
                          if (u[m].bitrate === r) {
                            (this._firstLevel = m),
                              this.log('manifest loaded, ' + u.length + ' level(s) found, first bitrate: ' + r);
                            break;
                          }
                        const y = g && !v,
                          E = {
                            levels: u,
                            audioTracks: c,
                            subtitleTracks: d,
                            firstLevel: this._firstLevel,
                            stats: e.stats,
                            audio: g,
                            video: v,
                            altAudio:
                              !y &&
                              c.some(function (t) {
                                return !!t.url;
                              }),
                          };
                        this.hls.trigger(n.Events.MANIFEST_PARSED, E),
                          (this.hls.config.autoStartLoad || this.hls.forceStartLoad) &&
                            this.hls.startLoad(this.hls.config.startPosition);
                      } else
                        this.hls.trigger(n.Events.ERROR, {
                          type: s.ErrorTypes.MEDIA_ERROR,
                          details: s.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
                          fatal: !0,
                          url: e.url,
                          reason: 'no level with compatible codecs found in manifest',
                        });
                    }),
                    (r.onError = function (e, r) {
                      if ((t.prototype.onError.call(this, e, r), !r.fatal)) {
                        const i = r.context,
                          n = this._levels[this.currentLevelIndex];
                        if (
                          i &&
                          ((i.type === u.PlaylistContextType.AUDIO_TRACK &&
                            n.audioGroupIds &&
                            i.groupId === n.audioGroupIds[n.urlId]) ||
                            (i.type === u.PlaylistContextType.SUBTITLE_TRACK &&
                              n.textGroupIds &&
                              i.groupId === n.textGroupIds[n.urlId]))
                        )
                          this.redundantFailover(this.currentLevelIndex);
                        else {
                          let a,
                            o = !1,
                            l = !0;
                          switch (r.details) {
                            case s.ErrorDetails.FRAG_LOAD_ERROR:
                            case s.ErrorDetails.FRAG_LOAD_TIMEOUT:
                            case s.ErrorDetails.KEY_LOAD_ERROR:
                            case s.ErrorDetails.KEY_LOAD_TIMEOUT:
                              if (r.frag) {
                                const c = this._levels[r.frag.level];
                                c
                                  ? (c.fragmentError++,
                                    c.fragmentError > this.hls.config.fragLoadingMaxRetry && (a = r.frag.level))
                                  : (a = r.frag.level);
                              }
                              break;
                            case s.ErrorDetails.LEVEL_LOAD_ERROR:
                            case s.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                              i && (i.deliveryDirectives && (l = !1), (a = i.level)), (o = !0);
                              break;
                            case s.ErrorDetails.REMUX_ALLOC_ERROR:
                              (a = r.level), (o = !0);
                          }
                          void 0 !== a && this.recoverLevel(r, a, o, l);
                        }
                      }
                    }),
                    (r.recoverLevel = function (t, e, r, i) {
                      const n = t.details,
                        s = this._levels[e];
                      if ((s.loadError++, r)) {
                        if (!this.retryLoadingOrFail(t)) return void (this.currentLevelIndex = -1);
                        t.levelRetry = !0;
                      }
                      if (i) {
                        const a = s.url.length;
                        if (a > 1 && s.loadError < a) (t.levelRetry = !0), this.redundantFailover(e);
                        else if (-1 === this.manualLevelIndex) {
                          const o = 0 === e ? this._levels.length - 1 : e - 1;
                          this.currentLevelIndex !== o &&
                            0 === this._levels[o].loadError &&
                            (this.warn(n + ': switch to ' + o), (t.levelRetry = !0), (this.hls.nextAutoLevel = o));
                        }
                      }
                    }),
                    (r.redundantFailover = function (t) {
                      const e = this._levels[t],
                        r = e.url.length;
                      if (r > 1) {
                        const i = (e.urlId + 1) % r;
                        this.warn('Switching to redundant URL-id ' + i),
                          this._levels.forEach(function (t) {
                            t.urlId = i;
                          }),
                          (this.level = t);
                      }
                    }),
                    (r.onFragLoaded = function (t, e) {
                      const r = e.frag;
                      if (void 0 !== r && r.type === u.PlaylistLevelType.MAIN) {
                        const i = this._levels[r.level];
                        void 0 !== i && ((i.fragmentError = 0), (i.loadError = 0));
                      }
                    }),
                    (r.onLevelLoaded = function (t, e) {
                      let r,
                        i,
                        n = e.level,
                        s = e.details,
                        a = this._levels[n];
                      if (!a)
                        return (
                          this.warn('Invalid level index ' + n),
                          void (
                            null !== (i = e.deliveryDirectives) &&
                            void 0 !== i &&
                            i.skip &&
                            (s.deltaUpdateFailed = !0)
                          )
                        );
                      n === this.currentLevelIndex
                        ? (0 === a.fragmentError && ((a.loadError = 0), (this.retryCount = 0)),
                          this.playlistLoaded(n, e, a.details))
                        : null !== (r = e.deliveryDirectives) && void 0 !== r && r.skip && (s.deltaUpdateFailed = !0);
                    }),
                    (r.onAudioTrackSwitched = function (t, e) {
                      const r = this.hls.levels[this.currentLevelIndex];
                      if (r && r.audioGroupIds) {
                        for (var i = -1, n = this.hls.audioTracks[e.id].groupId, s = 0; s < r.audioGroupIds.length; s++)
                          if (r.audioGroupIds[s] === n) {
                            i = s;
                            break;
                          }
                        i !== r.urlId && ((r.urlId = i), this.startLoad());
                      }
                    }),
                    (r.loadPlaylist = function (t) {
                      const e = this.currentLevelIndex,
                        r = this._levels[e];
                      if (this.canLoad && r && r.url.length > 0) {
                        let i = r.urlId,
                          s = r.url[i];
                        if (t)
                          try {
                            s = t.addDirectives(s);
                          } catch (t) {
                            this.warn('Could not construct new URL with HLS Delivery Directives: ' + t);
                          }
                        this.log(
                          'Attempt loading level index ' +
                            e +
                            (t ? ' at sn ' + t.msn + ' part ' + t.part : '') +
                            ' with URL-id ' +
                            i +
                            ' ' +
                            s
                        ),
                          this.clearTimer(),
                          this.hls.trigger(n.Events.LEVEL_LOADING, {
                            url: s,
                            level: e,
                            id: i,
                            deliveryDirectives: t || null,
                          });
                      }
                    }),
                    (r.removeLevel = function (t, e) {
                      const r = function (t, r) {
                          return r !== e;
                        },
                        i = this._levels
                          .filter(function (i, n) {
                            return (
                              n !== t ||
                              (i.url.length > 1 &&
                                void 0 !== e &&
                                ((i.url = i.url.filter(r)),
                                i.audioGroupIds && (i.audioGroupIds = i.audioGroupIds.filter(r)),
                                i.textGroupIds && (i.textGroupIds = i.textGroupIds.filter(r)),
                                (i.urlId = 0),
                                !0))
                            );
                          })
                          .map(function (t, e) {
                            const r = t.details;
                            return (
                              null !== r &&
                                void 0 !== r &&
                                r.fragments &&
                                r.fragments.forEach(function (t) {
                                  t.level = e;
                                }),
                              t
                            );
                          });
                      (this._levels = i), this.hls.trigger(n.Events.LEVELS_UPDATED, { levels: i });
                    }),
                    (function (t, e, r) {
                      e && d(t.prototype, e), r && d(t, r);
                    })(e, [
                      {
                        key: 'levels',
                        get: function () {
                          return 0 === this._levels.length ? null : this._levels;
                        },
                      },
                      {
                        key: 'level',
                        get: function () {
                          return this.currentLevelIndex;
                        },
                        set: function (t) {
                          let e,
                            r = this._levels;
                          if (
                            0 !== r.length &&
                            (this.currentLevelIndex !== t || null === (e = r[t]) || void 0 === e || !e.details)
                          ) {
                            if (t < 0 || t >= r.length) {
                              const i = t < 0;
                              if (
                                (this.hls.trigger(n.Events.ERROR, {
                                  type: s.ErrorTypes.OTHER_ERROR,
                                  details: s.ErrorDetails.LEVEL_SWITCH_ERROR,
                                  level: t,
                                  fatal: i,
                                  reason: 'invalid level idx',
                                }),
                                i)
                              )
                                return;
                              t = Math.min(t, r.length - 1);
                            }
                            this.clearTimer();
                            const a = this.currentLevelIndex,
                              o = r[a],
                              l = r[t];
                            this.log('switching to level ' + t + ' from ' + a), (this.currentLevelIndex = t);
                            const u = c({}, l, { level: t, maxBitrate: l.maxBitrate, uri: l.uri, urlId: l.urlId });
                            delete u._urlId, this.hls.trigger(n.Events.LEVEL_SWITCHING, u);
                            const d = l.details;
                            if (!d || d.live) {
                              const f = this.switchParams(l.uri, null === o || void 0 === o ? void 0 : o.details);
                              this.loadPlaylist(f);
                            }
                          }
                        },
                      },
                      {
                        key: 'manualLevel',
                        get: function () {
                          return this.manualLevelIndex;
                        },
                        set: function (t) {
                          (this.manualLevelIndex = t),
                            void 0 === this._startLevel && (this._startLevel = t),
                            -1 !== t && (this.level = t);
                        },
                      },
                      {
                        key: 'firstLevel',
                        get: function () {
                          return this._firstLevel;
                        },
                        set: function (t) {
                          this._firstLevel = t;
                        },
                      },
                      {
                        key: 'startLevel',
                        get: function () {
                          if (void 0 === this._startLevel) {
                            const t = this.hls.config.startLevel;
                            return void 0 !== t ? t : this._firstLevel;
                          }
                          return this._startLevel;
                        },
                        set: function (t) {
                          this._startLevel = t;
                        },
                      },
                      {
                        key: 'nextLoadLevel',
                        get: function () {
                          return -1 !== this.manualLevelIndex ? this.manualLevelIndex : this.hls.nextAutoLevel;
                        },
                        set: function (t) {
                          (this.level = t), -1 === this.manualLevelIndex && (this.hls.nextAutoLevel = t);
                        },
                      },
                    ]),
                    e
                  );
                })(l.default);
            },
          './src/controller/level-helper.ts':
            /*!****************************************!*\
  !*** ./src/controller/level-helper.ts ***!
  \****************************************/
            /*! exports provided: addGroupId, assignTrackIdsByGroup, updatePTS, updateFragPTSDTS, mergeDetails, mapPartIntersection, mapFragmentIntersection, adjustSliding, addSliding, computeReloadInterval, getFragmentWithSN, getPartWith */ function (
              t,
              e,
              r
            ) {
              'use strict';
              r.r(e),
                r.d(e, 'addGroupId', function () {
                  return s;
                }),
                r.d(e, 'assignTrackIdsByGroup', function () {
                  return a;
                }),
                r.d(e, 'updatePTS', function () {
                  return o;
                }),
                r.d(e, 'updateFragPTSDTS', function () {
                  return u;
                }),
                r.d(e, 'mergeDetails', function () {
                  return c;
                }),
                r.d(e, 'mapPartIntersection', function () {
                  return d;
                }),
                r.d(e, 'mapFragmentIntersection', function () {
                  return f;
                }),
                r.d(e, 'adjustSliding', function () {
                  return h;
                }),
                r.d(e, 'addSliding', function () {
                  return p;
                }),
                r.d(e, 'computeReloadInterval', function () {
                  return v;
                }),
                r.d(e, 'getFragmentWithSN', function () {
                  return g;
                }),
                r.d(e, 'getPartWith', function () {
                  return m;
                });
              const i = r(/*! ./src/polyfills/number */ './src/polyfills/number.ts'),
                n = r(/*! ../utils/logger */ './src/utils/logger.ts');
              function s(t, e, r) {
                switch (e) {
                  case 'audio':
                    t.audioGroupIds || (t.audioGroupIds = []), t.audioGroupIds.push(r);
                    break;
                  case 'text':
                    t.textGroupIds || (t.textGroupIds = []), t.textGroupIds.push(r);
                }
              }
              function a(t) {
                const e = {};
                t.forEach(function (t) {
                  const r = t.groupId || '';
                  (t.id = e[r] = e[r] || 0), e[r]++;
                });
              }
              function o(t, e, r) {
                l(t[e], t[r]);
              }
              function l(t, e) {
                const r = e.startPTS;
                if (Object(i.isFiniteNumber)(r)) {
                  let n,
                    s = 0;
                  e.sn > t.sn ? ((s = r - t.start), (n = t)) : ((s = t.start - r), (n = e)),
                    n.duration !== s && (n.duration = s);
                } else if (e.sn > t.sn) {
                  t.cc === e.cc && t.minEndPTS
                    ? (e.start = t.start + (t.minEndPTS - t.start))
                    : (e.start = t.start + t.duration);
                } else e.start = Math.max(t.start - e.duration, 0);
              }
              function u(t, e, r, s, a, o) {
                s - r <= 0 &&
                  (n.logger.warn('Fragment should have a positive duration', e),
                  (s = r + e.duration),
                  (o = a + e.duration));
                let u = r,
                  c = s,
                  d = e.startPTS,
                  f = e.endPTS;
                if (Object(i.isFiniteNumber)(d)) {
                  const h = Math.abs(d - r);
                  Object(i.isFiniteNumber)(e.deltaPTS) ? (e.deltaPTS = Math.max(h, e.deltaPTS)) : (e.deltaPTS = h),
                    (u = Math.max(r, d)),
                    (r = Math.min(r, d)),
                    (a = Math.min(a, e.startDTS)),
                    (c = Math.min(s, f)),
                    (s = Math.max(s, f)),
                    (o = Math.max(o, e.endDTS));
                }
                e.duration = s - r;
                const p = r - e.start;
                (e.appendedPTS = s),
                  (e.start = e.startPTS = r),
                  (e.maxStartPTS = u),
                  (e.startDTS = a),
                  (e.endPTS = s),
                  (e.minEndPTS = c),
                  (e.endDTS = o);
                let v,
                  g = e.sn;
                if (!t || g < t.startSN || g > t.endSN) return 0;
                const m = g - t.startSN,
                  y = t.fragments;
                for (y[m] = e, v = m; v > 0; v--) l(y[v], y[v - 1]);
                for (v = m; v < y.length - 1; v++) l(y[v], y[v + 1]);
                return t.fragmentHint && l(y[y.length - 1], t.fragmentHint), (t.PTSKnown = t.alignedSliding = !0), p;
              }
              function c(t, e) {
                for (var r = null, s = t.fragments, a = s.length - 1; a >= 0; a--) {
                  const o = s[a].initSegment;
                  if (o) {
                    r = o;
                    break;
                  }
                }
                t.fragmentHint && delete t.fragmentHint.endPTS;
                let l,
                  c = 0;
                (f(t, e, function (t, n) {
                  t.relurl && (c = t.cc - n.cc),
                    Object(i.isFiniteNumber)(t.startPTS) &&
                      Object(i.isFiniteNumber)(t.endPTS) &&
                      ((n.start = n.startPTS = t.startPTS),
                      (n.startDTS = t.startDTS),
                      (n.appendedPTS = t.appendedPTS),
                      (n.maxStartPTS = t.maxStartPTS),
                      (n.endPTS = t.endPTS),
                      (n.endDTS = t.endDTS),
                      (n.minEndPTS = t.minEndPTS),
                      (n.duration = t.endPTS - t.startPTS),
                      n.duration && (l = n),
                      (e.PTSKnown = e.alignedSliding = !0)),
                    (n.elementaryStreams = t.elementaryStreams),
                    (n.loader = t.loader),
                    (n.stats = t.stats),
                    (n.urlId = t.urlId),
                    t.initSegment && ((n.initSegment = t.initSegment), (r = t.initSegment));
                }),
                r) &&
                  (e.fragmentHint ? e.fragments.concat(e.fragmentHint) : e.fragments).forEach(function (t) {
                    let e;
                    (t.initSegment &&
                      t.initSegment.relurl !== (null === (e = r) || void 0 === e ? void 0 : e.relurl)) ||
                      (t.initSegment = r);
                  });
                if (
                  e.skippedSegments &&
                  ((e.deltaUpdateFailed = e.fragments.some(function (t) {
                    return !t;
                  })),
                  e.deltaUpdateFailed)
                ) {
                  n.logger.warn('[level-helper] Previous playlist missing segments skipped in delta playlist');
                  for (let p = e.skippedSegments; p--; ) e.fragments.shift();
                  (e.startSN = e.fragments[0].sn), (e.startCC = e.fragments[0].cc);
                }
                const v = e.fragments;
                if (c) {
                  n.logger.warn('discontinuity sliding from playlist, take drift into account');
                  for (let g = 0; g < v.length; g++) v[g].cc += c;
                }
                e.skippedSegments && (e.startCC = e.fragments[0].cc),
                  d(t.partList, e.partList, function (t, e) {
                    (e.elementaryStreams = t.elementaryStreams), (e.stats = t.stats);
                  }),
                  l ? u(e, l, l.startPTS, l.endPTS, l.startDTS, l.endDTS) : h(t, e),
                  v.length && (e.totalduration = e.edge - v[0].start),
                  (e.driftStartTime = t.driftStartTime),
                  (e.driftStart = t.driftStart);
                const m = e.advancedDateTime;
                if (e.advanced && m) {
                  const y = e.edge;
                  e.driftStart || ((e.driftStartTime = m), (e.driftStart = y)), (e.driftEndTime = m), (e.driftEnd = y);
                } else
                  (e.driftEndTime = t.driftEndTime),
                    (e.driftEnd = t.driftEnd),
                    (e.advancedDateTime = t.advancedDateTime);
              }
              function d(t, e, r) {
                if (t && e)
                  for (let i = 0, n = 0, s = t.length; n <= s; n++) {
                    const a = t[n],
                      o = e[n + i];
                    a && o && a.index === o.index && a.fragment.sn === o.fragment.sn ? r(a, o) : i--;
                  }
              }
              function f(t, e, r) {
                for (
                  let i = e.skippedSegments,
                    n = Math.max(t.startSN, e.startSN) - e.startSN,
                    s = (t.fragmentHint ? 1 : 0) + (i ? e.endSN : Math.min(t.endSN, e.endSN)) - e.startSN,
                    a = e.startSN - t.startSN,
                    o = e.fragmentHint ? e.fragments.concat(e.fragmentHint) : e.fragments,
                    l = t.fragmentHint ? t.fragments.concat(t.fragmentHint) : t.fragments,
                    u = n;
                  u <= s;
                  u++
                ) {
                  let c = l[a + u],
                    d = o[u];
                  i && !d && u < i && (d = e.fragments[u] = c), c && d && r(c, d);
                }
              }
              function h(t, e) {
                const r = e.startSN + e.skippedSegments - t.startSN,
                  i = t.fragments;
                r < 0 || r >= i.length || p(e, i[r].start);
              }
              function p(t, e) {
                if (e) {
                  for (let r = t.fragments, i = t.skippedSegments; i < r.length; i++) r[i].start += e;
                  t.fragmentHint && (t.fragmentHint.start += e);
                }
              }
              function v(t, e) {
                let r,
                  i = 1e3 * t.levelTargetDuration,
                  n = i / 2,
                  s = t.age,
                  a = s > 0 && s < 3 * i,
                  o = e.loading.end - e.loading.start,
                  l = t.availabilityDelay;
                if (!1 === t.updated)
                  if (a) {
                    const u = 333 * t.misses;
                    (r = Math.max(Math.min(n, 2 * o), u)), (t.availabilityDelay = (t.availabilityDelay || 0) + r);
                  } else r = n;
                else a ? ((l = Math.min(l || i / 2, s)), (t.availabilityDelay = l), (r = l + i - s)) : (r = i - o);
                return Math.round(r);
              }
              function g(t, e, r) {
                if (!t || !t.details) return null;
                let i = t.details,
                  n = i.fragments[e - i.startSN];
                return n || ((n = i.fragmentHint) && n.sn === e ? n : e < i.startSN && r && r.sn === e ? r : null);
              }
              function m(t, e, r) {
                if (!t || !t.details) return null;
                const i = t.details.partList;
                if (i)
                  for (let n = i.length; n--; ) {
                    const s = i[n];
                    if (s.index === r && s.fragment.sn === e) return s;
                  }
                return null;
              }
            },
          './src/controller/stream-controller.ts':
            /*!*********************************************!*\
  !*** ./src/controller/stream-controller.ts ***!
  \*********************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return y;
                });
              const i = r(/*! ./src/polyfills/number */ './src/polyfills/number.ts'),
                n = r(/*! ./base-stream-controller */ './src/controller/base-stream-controller.ts'),
                s = r(/*! ../is-supported */ './src/is-supported.ts'),
                a = r(/*! ../events */ './src/events.ts'),
                o = r(/*! ../utils/buffer-helper */ './src/utils/buffer-helper.ts'),
                l = r(/*! ./fragment-tracker */ './src/controller/fragment-tracker.ts'),
                u = r(/*! ../types/loader */ './src/types/loader.ts'),
                c = r(/*! ../loader/fragment */ './src/loader/fragment.ts'),
                d = r(/*! ../demux/transmuxer-interface */ './src/demux/transmuxer-interface.ts'),
                f = r(/*! ../types/transmuxer */ './src/types/transmuxer.ts'),
                h = r(/*! ./gap-controller */ './src/controller/gap-controller.ts'),
                p = r(/*! ../errors */ './src/errors.ts'),
                v = r(/*! ../utils/logger */ './src/utils/logger.ts');
              function g(t, e) {
                for (let r = 0; r < e.length; r++) {
                  const i = e[r];
                  (i.enumerable = i.enumerable || !1),
                    (i.configurable = !0),
                    'value' in i && (i.writable = !0),
                    Object.defineProperty(t, i.key, i);
                }
              }
              function m(t, e) {
                return (m =
                  Object.setPrototypeOf ||
                  function (t, e) {
                    return (t.__proto__ = e), t;
                  })(t, e);
              }
              var y = (function (t) {
                function e(e, r) {
                  let i;
                  return (
                    ((i = t.call(this, e, r, '[stream-controller]') || this).audioCodecSwap = !1),
                    (i.gapController = null),
                    (i.level = -1),
                    (i._forceStartLoad = !1),
                    (i.altAudio = !1),
                    (i.audioOnly = !1),
                    (i.fragPlaying = null),
                    (i.onvplaying = null),
                    (i.onvseeked = null),
                    (i.fragLastKbps = 0),
                    (i.stalled = !1),
                    (i.couldBacktrack = !1),
                    (i.audioCodecSwitch = !1),
                    (i.videoBuffer = null),
                    i._registerListeners(),
                    i
                  );
                }
                !(function (t, e) {
                  (t.prototype = Object.create(e.prototype)), (t.prototype.constructor = t), m(t, e);
                })(e, t);
                const r = e.prototype;
                return (
                  (r._registerListeners = function () {
                    const t = this.hls;
                    t.on(a.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                      t.on(a.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                      t.on(a.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                      t.on(a.Events.MANIFEST_PARSED, this.onManifestParsed, this),
                      t.on(a.Events.LEVEL_LOADING, this.onLevelLoading, this),
                      t.on(a.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                      t.on(a.Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this),
                      t.on(a.Events.ERROR, this.onError, this),
                      t.on(a.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this),
                      t.on(a.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this),
                      t.on(a.Events.BUFFER_CREATED, this.onBufferCreated, this),
                      t.on(a.Events.BUFFER_FLUSHED, this.onBufferFlushed, this),
                      t.on(a.Events.LEVELS_UPDATED, this.onLevelsUpdated, this),
                      t.on(a.Events.FRAG_BUFFERED, this.onFragBuffered, this);
                  }),
                  (r._unregisterListeners = function () {
                    const t = this.hls;
                    t.off(a.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                      t.off(a.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                      t.off(a.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                      t.off(a.Events.MANIFEST_PARSED, this.onManifestParsed, this),
                      t.off(a.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                      t.off(a.Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this),
                      t.off(a.Events.ERROR, this.onError, this),
                      t.off(a.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this),
                      t.off(a.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this),
                      t.off(a.Events.BUFFER_CREATED, this.onBufferCreated, this),
                      t.off(a.Events.BUFFER_FLUSHED, this.onBufferFlushed, this),
                      t.off(a.Events.LEVELS_UPDATED, this.onLevelsUpdated, this),
                      t.off(a.Events.FRAG_BUFFERED, this.onFragBuffered, this);
                  }),
                  (r.onHandlerDestroying = function () {
                    this._unregisterListeners(), this.onMediaDetaching();
                  }),
                  (r.startLoad = function (t) {
                    if (this.levels) {
                      const e = this.lastCurrentTime,
                        r = this.hls;
                      if (
                        (this.stopLoad(),
                        this.setInterval(100),
                        (this.level = -1),
                        (this.fragLoadError = 0),
                        !this.startFragRequested)
                      ) {
                        let i = r.startLevel;
                        -1 === i &&
                          (r.config.testBandwidth ? ((i = 0), (this.bitrateTest = !0)) : (i = r.nextAutoLevel)),
                          (this.level = r.nextLoadLevel = i),
                          (this.loadedmetadata = !1);
                      }
                      e > 0 &&
                        -1 === t &&
                        (this.log('Override startPosition with lastCurrentTime @' + e.toFixed(3)), (t = e)),
                        (this.state = n.State.IDLE),
                        (this.nextLoadPosition = this.startPosition = this.lastCurrentTime = t),
                        this.tick();
                    } else (this._forceStartLoad = !0), (this.state = n.State.STOPPED);
                  }),
                  (r.stopLoad = function () {
                    (this._forceStartLoad = !1), t.prototype.stopLoad.call(this);
                  }),
                  (r.doTick = function () {
                    switch (this.state) {
                      case n.State.IDLE:
                        this.doTickIdle();
                        break;
                      case n.State.WAITING_LEVEL:
                        var t,
                          e = this.levels,
                          r = this.level,
                          i =
                            null === e || void 0 === e
                              ? void 0
                              : null === (t = e[r]) || void 0 === t
                                ? void 0
                                : t.details;
                        if (i && (!i.live || this.levelLastLoaded === this.level)) {
                          if (this.waitForCdnTuneIn(i)) break;
                          this.state = n.State.IDLE;
                          break;
                        }
                        break;
                      case n.State.FRAG_LOADING_WAITING_RETRY:
                        var s,
                          a = self.performance.now(),
                          o = this.retryDate;
                        (!o || a >= o || (null !== (s = this.media) && void 0 !== s && s.seeking)) &&
                          (this.log('retryDate reached, switch back to IDLE state'), (this.state = n.State.IDLE));
                    }
                    this.onTickEnd();
                  }),
                  (r.onTickEnd = function () {
                    t.prototype.onTickEnd.call(this), this.checkBuffer(), this.checkFragmentChanged();
                  }),
                  (r.doTickIdle = function () {
                    let t,
                      e,
                      r = this.hls,
                      i = this.levelLastLoaded,
                      s = this.levels,
                      o = this.media,
                      d = r.config,
                      f = r.nextLoadLevel;
                    if (
                      null !== i &&
                      (o || (!this.startFragRequested && d.startFragPrefetch)) &&
                      (!this.altAudio || !this.audioOnly) &&
                      s &&
                      s[f]
                    ) {
                      const h = s[f];
                      this.level = r.nextLoadLevel = f;
                      const p = h.details;
                      if (!p || this.state === n.State.WAITING_LEVEL || (p.live && this.levelLastLoaded !== f))
                        this.state = n.State.WAITING_LEVEL;
                      else {
                        const v = this.getFwdBufferInfo(
                          this.mediaBuffer ? this.mediaBuffer : o,
                          u.PlaylistLevelType.MAIN
                        );
                        if (null !== v)
                          if (!(v.len >= this.getMaxBufferLength(h.maxBitrate))) {
                            if (this._streamEnded(v, p)) {
                              const g = {};
                              return (
                                this.altAudio && (g.type = 'video'),
                                this.hls.trigger(a.Events.BUFFER_EOS, g),
                                void (this.state = n.State.ENDED)
                              );
                            }
                            let m = v.end,
                              y = this.getNextFragment(m, p);
                            if (this.couldBacktrack && !this.fragPrevious && y && 'initSegment' !== y.sn) {
                              const E = y.sn - p.startSN;
                              E > 1 && ((y = p.fragments[E - 1]), this.fragmentTracker.removeFragment(y));
                            }
                            if (
                              y &&
                              this.fragmentTracker.getState(y) === l.FragmentState.OK &&
                              this.nextLoadPosition > m
                            ) {
                              const T =
                                this.audioOnly && !this.altAudio
                                  ? c.ElementaryStreamTypes.AUDIO
                                  : c.ElementaryStreamTypes.VIDEO;
                              this.afterBufferFlushed(o, T, u.PlaylistLevelType.MAIN),
                                (y = this.getNextFragment(this.nextLoadPosition, p));
                            }
                            y &&
                              (!y.initSegment || y.initSegment.data || this.bitrateTest || (y = y.initSegment),
                              'identity' !== (null === (t = y.decryptdata) || void 0 === t ? void 0 : t.keyFormat) ||
                              (null !== (e = y.decryptdata) && void 0 !== e && e.key)
                                ? this.loadFragment(y, p, m)
                                : this.loadKey(y, p));
                          }
                      }
                    }
                  }),
                  (r.loadFragment = function (e, r, i) {
                    let n,
                      s = this.fragmentTracker.getState(e);
                    if (((this.fragCurrent = e), s === l.FragmentState.BACKTRACKED)) {
                      const a = this.fragmentTracker.getBacktrackData(e);
                      if (a) return this._handleFragmentLoadProgress(a), void this._handleFragmentLoadComplete(a);
                      s = l.FragmentState.NOT_LOADED;
                    }
                    s === l.FragmentState.NOT_LOADED || s === l.FragmentState.PARTIAL
                      ? 'initSegment' === e.sn
                        ? this._loadInitSegment(e)
                        : this.bitrateTest
                          ? ((e.bitrateTest = !0),
                            this.log(
                              'Fragment ' +
                                e.sn +
                                ' of level ' +
                                e.level +
                                ' is being downloaded to test bitrate and will not be buffered'
                            ),
                            this._loadBitrateTestFrag(e))
                          : ((this.startFragRequested = !0), t.prototype.loadFragment.call(this, e, r, i))
                      : s === l.FragmentState.APPENDING
                        ? this.reduceMaxBufferLength(e.duration) && this.fragmentTracker.removeFragment(e)
                        : 0 === (null === (n = this.media) || void 0 === n ? void 0 : n.buffered.length) &&
                          this.fragmentTracker.removeAllFragments();
                  }),
                  (r.getAppendedFrag = function (t) {
                    const e = this.fragmentTracker.getAppendedFrag(t, u.PlaylistLevelType.MAIN);
                    return e && 'fragment' in e ? e.fragment : e;
                  }),
                  (r.getBufferedFrag = function (t) {
                    return this.fragmentTracker.getBufferedFrag(t, u.PlaylistLevelType.MAIN);
                  }),
                  (r.followingBufferedFrag = function (t) {
                    return t ? this.getBufferedFrag(t.end + 0.5) : null;
                  }),
                  (r.immediateLevelSwitch = function () {
                    this.abortCurrentFrag(), this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
                  }),
                  (r.nextLevelSwitch = function () {
                    const t = this.levels,
                      e = this.media;
                    if (null !== e && void 0 !== e && e.readyState) {
                      let r,
                        i = this.getAppendedFrag(e.currentTime);
                      if ((i && i.start > 1 && this.flushMainBuffer(0, i.start - 1), !e.paused && t)) {
                        const n = t[this.hls.nextLoadLevel],
                          s = this.fragLastKbps;
                        r = s && this.fragCurrent ? (this.fragCurrent.duration * n.maxBitrate) / (1e3 * s) + 1 : 0;
                      } else r = 0;
                      const a = this.getBufferedFrag(e.currentTime + r);
                      if (a) {
                        const o = this.followingBufferedFrag(a);
                        if (o) {
                          this.abortCurrentFrag();
                          const l = o.maxStartPTS ? o.maxStartPTS : o.start,
                            u = o.duration,
                            c = Math.max(
                              a.end,
                              l + Math.min(Math.max(u - this.config.maxFragLookUpTolerance, 0.5 * u), 0.75 * u)
                            );
                          this.flushMainBuffer(c, Number.POSITIVE_INFINITY);
                        }
                      }
                    }
                  }),
                  (r.abortCurrentFrag = function () {
                    const t = this.fragCurrent;
                    (this.fragCurrent = null),
                      null !== t && void 0 !== t && t.loader && t.loader.abort(),
                      this.state === n.State.KEY_LOADING && (this.state = n.State.IDLE),
                      (this.nextLoadPosition = this.getLoadPosition());
                  }),
                  (r.flushMainBuffer = function (e, r) {
                    t.prototype.flushMainBuffer.call(this, e, r, this.altAudio ? 'video' : null);
                  }),
                  (r.onMediaAttached = function (e, r) {
                    t.prototype.onMediaAttached.call(this, e, r);
                    const i = r.media;
                    (this.onvplaying = this.onMediaPlaying.bind(this)),
                      (this.onvseeked = this.onMediaSeeked.bind(this)),
                      i.addEventListener('playing', this.onvplaying),
                      i.addEventListener('seeked', this.onvseeked),
                      (this.gapController = new h.default(this.config, i, this.fragmentTracker, this.hls));
                  }),
                  (r.onMediaDetaching = function () {
                    const e = this.media;
                    e &&
                      (e.removeEventListener('playing', this.onvplaying),
                      e.removeEventListener('seeked', this.onvseeked),
                      (this.onvplaying = this.onvseeked = null),
                      (this.videoBuffer = null)),
                      (this.fragPlaying = null),
                      this.gapController && (this.gapController.destroy(), (this.gapController = null)),
                      t.prototype.onMediaDetaching.call(this);
                  }),
                  (r.onMediaPlaying = function () {
                    this.tick();
                  }),
                  (r.onMediaSeeked = function () {
                    const t = this.media,
                      e = t ? t.currentTime : null;
                    Object(i.isFiniteNumber)(e) && this.log('Media seeked to ' + e.toFixed(3)), this.tick();
                  }),
                  (r.onManifestLoading = function () {
                    this.log('Trigger BUFFER_RESET'),
                      this.hls.trigger(a.Events.BUFFER_RESET, void 0),
                      this.fragmentTracker.removeAllFragments(),
                      (this.couldBacktrack = this.stalled = !1),
                      (this.startPosition = this.lastCurrentTime = 0),
                      (this.fragPlaying = null);
                  }),
                  (r.onManifestParsed = function (t, e) {
                    let r,
                      i = !1,
                      n = !1;
                    e.levels.forEach(function (t) {
                      (r = t.audioCodec) &&
                        (-1 !== r.indexOf('mp4a.40.2') && (i = !0), -1 !== r.indexOf('mp4a.40.5') && (n = !0));
                    }),
                      (this.audioCodecSwitch = i && n && !Object(s.changeTypeSupported)()),
                      this.audioCodecSwitch &&
                        this.log('Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC'),
                      (this.levels = e.levels),
                      (this.startFragRequested = !1);
                  }),
                  (r.onLevelLoading = function (t, e) {
                    const r = this.levels;
                    if (r && this.state === n.State.IDLE) {
                      const i = r[e.level];
                      (!i.details ||
                        (i.details.live && this.levelLastLoaded !== e.level) ||
                        this.waitForCdnTuneIn(i.details)) &&
                        (this.state = n.State.WAITING_LEVEL);
                    }
                  }),
                  (r.onLevelLoaded = function (t, e) {
                    let r,
                      i = this.levels,
                      s = e.level,
                      o = e.details,
                      l = o.totalduration;
                    if (i) {
                      this.log(
                        'Level ' +
                          s +
                          ' loaded [' +
                          o.startSN +
                          ',' +
                          o.endSN +
                          '], cc [' +
                          o.startCC +
                          ', ' +
                          o.endCC +
                          '] duration:' +
                          l
                      );
                      const u = this.fragCurrent;
                      !u ||
                        (this.state !== n.State.FRAG_LOADING && this.state !== n.State.FRAG_LOADING_WAITING_RETRY) ||
                        (u.level !== e.level && u.loader && ((this.state = n.State.IDLE), u.loader.abort()));
                      let c = i[s],
                        d = 0;
                      if (o.live || (null !== (r = c.details) && void 0 !== r && r.live)) {
                        if ((o.fragments[0] || (o.deltaUpdateFailed = !0), o.deltaUpdateFailed)) return;
                        d = this.alignPlaylists(o, c.details);
                      }
                      if (
                        ((c.details = o),
                        (this.levelLastLoaded = s),
                        this.hls.trigger(a.Events.LEVEL_UPDATED, { details: o, level: s }),
                        this.state === n.State.WAITING_LEVEL)
                      ) {
                        if (this.waitForCdnTuneIn(o)) return;
                        this.state = n.State.IDLE;
                      }
                      this.startFragRequested ? o.live && this.synchronizeToLiveEdge(o) : this.setStartPosition(o, d),
                        this.tick();
                    } else this.warn('Levels were reset while loading level ' + s);
                  }),
                  (r._handleFragmentLoadProgress = function (t) {
                    let e,
                      r = t.frag,
                      i = t.part,
                      n = t.payload,
                      s = this.levels;
                    if (s) {
                      const a = s[r.level],
                        o = a.details;
                      if (o) {
                        const l = a.videoCodec,
                          c = o.PTSKnown || !o.live,
                          h = null === (e = r.initSegment) || void 0 === e ? void 0 : e.data,
                          p = this._getAudioCodec(a),
                          v = (this.transmuxer =
                            this.transmuxer ||
                            new d.default(
                              this.hls,
                              u.PlaylistLevelType.MAIN,
                              this._handleTransmuxComplete.bind(this),
                              this._handleTransmuxerFlush.bind(this)
                            )),
                          g = i ? i.index : -1,
                          m = -1 !== g,
                          y = new f.ChunkMetadata(r.level, r.sn, r.stats.chunkCount, n.byteLength, g, m),
                          E = this.initPTS[r.cc];
                        v.push(n, h, p, l, r, i, o.totalduration, c, y, E);
                      } else
                        this.warn(
                          'Dropping fragment ' + r.sn + ' of level ' + r.level + ' after level details were reset'
                        );
                    } else
                      this.warn(
                        'Levels were reset while fragment load was in progress. Fragment ' +
                          r.sn +
                          ' of level ' +
                          r.level +
                          ' will not be buffered'
                      );
                  }),
                  (r.onAudioTrackSwitching = function (t, e) {
                    const r = this.altAudio,
                      i = !!e.url,
                      n = e.id;
                    if (!i) {
                      if (this.mediaBuffer !== this.media) {
                        this.log('Switching on main audio, use media.buffered to schedule main fragment loading'),
                          (this.mediaBuffer = this.media);
                        const s = this.fragCurrent;
                        null !== s &&
                          void 0 !== s &&
                          s.loader &&
                          (this.log('Switching to main audio track, cancel main fragment load'), s.loader.abort()),
                          this.resetTransmuxer(),
                          this.resetLoadingState();
                      } else this.audioOnly && this.resetTransmuxer();
                      const o = this.hls;
                      r &&
                        o.trigger(a.Events.BUFFER_FLUSHING, {
                          startOffset: 0,
                          endOffset: Number.POSITIVE_INFINITY,
                          type: 'audio',
                        }),
                        o.trigger(a.Events.AUDIO_TRACK_SWITCHED, { id: n });
                    }
                  }),
                  (r.onAudioTrackSwitched = function (t, e) {
                    const r = e.id,
                      i = !!this.hls.audioTracks[r].url;
                    if (i) {
                      const n = this.videoBuffer;
                      n &&
                        this.mediaBuffer !== n &&
                        (this.log('Switching on alternate audio, use video.buffered to schedule main fragment loading'),
                        (this.mediaBuffer = n));
                    }
                    (this.altAudio = i), this.tick();
                  }),
                  (r.onBufferCreated = function (t, e) {
                    let r,
                      i,
                      n = e.tracks,
                      s = !1;
                    for (const a in n) {
                      const o = n[a];
                      if ('main' === o.id) {
                        if (((i = a), (r = o), 'video' === a)) {
                          const l = n[a];
                          l && (this.videoBuffer = l.buffer);
                        }
                      } else s = !0;
                    }
                    s && r
                      ? (this.log('Alternate track found, use ' + i + '.buffered to schedule main fragment loading'),
                        (this.mediaBuffer = r.buffer))
                      : (this.mediaBuffer = this.media);
                  }),
                  (r.onFragBuffered = function (t, e) {
                    const r = e.frag,
                      i = e.part;
                    if (!r || r.type === u.PlaylistLevelType.MAIN) {
                      if (this.fragContextChanged(r))
                        return (
                          this.warn(
                            'Fragment ' +
                              r.sn +
                              (i ? ' p: ' + i.index : '') +
                              ' of level ' +
                              r.level +
                              ' finished buffering, but was aborted. state: ' +
                              this.state
                          ),
                          void (this.state === n.State.PARSED && (this.state = n.State.IDLE))
                        );
                      const s = i ? i.stats : r.stats;
                      (this.fragLastKbps = Math.round((8 * s.total) / (s.buffering.end - s.loading.first))),
                        'initSegment' !== r.sn && (this.fragPrevious = r),
                        this.fragBufferedComplete(r, i);
                    }
                  }),
                  (r.onError = function (t, e) {
                    switch (e.details) {
                      case p.ErrorDetails.FRAG_LOAD_ERROR:
                      case p.ErrorDetails.FRAG_LOAD_TIMEOUT:
                      case p.ErrorDetails.KEY_LOAD_ERROR:
                      case p.ErrorDetails.KEY_LOAD_TIMEOUT:
                        this.onFragmentOrKeyLoadError(u.PlaylistLevelType.MAIN, e);
                        break;
                      case p.ErrorDetails.LEVEL_LOAD_ERROR:
                      case p.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                        this.state !== n.State.ERROR &&
                          (e.fatal
                            ? (this.warn('' + e.details), (this.state = n.State.ERROR))
                            : e.levelRetry || this.state !== n.State.WAITING_LEVEL || (this.state = n.State.IDLE));
                        break;
                      case p.ErrorDetails.BUFFER_FULL_ERROR:
                        if ('main' === e.parent && (this.state === n.State.PARSING || this.state === n.State.PARSED)) {
                          let r = !0,
                            i = this.getFwdBufferInfo(this.media, u.PlaylistLevelType.MAIN);
                          i && i.len > 0.5 && (r = !this.reduceMaxBufferLength(i.len)),
                            r &&
                              (this.warn('buffer full error also media.currentTime is not buffered, flush main'),
                              this.immediateLevelSwitch()),
                            this.resetLoadingState();
                        }
                    }
                  }),
                  (r.checkBuffer = function () {
                    const t = this.media,
                      e = this.gapController;
                    if (t && e && t.readyState) {
                      const r = o.BufferHelper.getBuffered(t);
                      !this.loadedmetadata && r.length
                        ? ((this.loadedmetadata = !0), this.seekToStartPos())
                        : e.poll(this.lastCurrentTime),
                        (this.lastCurrentTime = t.currentTime);
                    }
                  }),
                  (r.onFragLoadEmergencyAborted = function () {
                    (this.state = n.State.IDLE),
                      this.loadedmetadata ||
                        ((this.startFragRequested = !1), (this.nextLoadPosition = this.startPosition)),
                      this.tickImmediate();
                  }),
                  (r.onBufferFlushed = function (t, e) {
                    const r = e.type;
                    if (r !== c.ElementaryStreamTypes.AUDIO || (this.audioOnly && !this.altAudio)) {
                      const i =
                        (r === c.ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
                      this.afterBufferFlushed(i, r, u.PlaylistLevelType.MAIN);
                    }
                  }),
                  (r.onLevelsUpdated = function (t, e) {
                    this.levels = e.levels;
                  }),
                  (r.swapAudioCodec = function () {
                    this.audioCodecSwap = !this.audioCodecSwap;
                  }),
                  (r.seekToStartPos = function () {
                    let t = this.media,
                      e = t.currentTime,
                      r = this.startPosition;
                    if (r >= 0 && e < r) {
                      if (t.seeking) return void v.logger.log('could not seek to ' + r + ', already seeking at ' + e);
                      const i = o.BufferHelper.getBuffered(t),
                        n = (i.length ? i.start(0) : 0) - r;
                      n > 0 &&
                        (n < this.config.maxBufferHole || n < this.config.maxFragLookUpTolerance) &&
                        (v.logger.log('adjusting start position by ' + n + ' to match buffer start'),
                        (r += n),
                        (this.startPosition = r)),
                        this.log('seek to target start position ' + r + ' from current time ' + e),
                        (t.currentTime = r);
                    }
                  }),
                  (r._getAudioCodec = function (t) {
                    let e = this.config.defaultAudioCodec || t.audioCodec;
                    return (
                      this.audioCodecSwap &&
                        e &&
                        (this.log('Swapping audio codec'),
                        (e = -1 !== e.indexOf('mp4a.40.5') ? 'mp4a.40.2' : 'mp4a.40.5')),
                      e
                    );
                  }),
                  (r._loadBitrateTestFrag = function (t) {
                    const e = this;
                    this._doFragLoad(t).then(function (r) {
                      const i = e.hls;
                      if (r && !i.nextLoadLevel && !e.fragContextChanged(t)) {
                        (e.fragLoadError = 0),
                          (e.state = n.State.IDLE),
                          (e.startFragRequested = !1),
                          (e.bitrateTest = !1);
                        const s = t.stats;
                        (s.parsing.start =
                          s.parsing.end =
                          s.buffering.start =
                          s.buffering.end =
                            self.performance.now()),
                          i.trigger(a.Events.FRAG_LOADED, r);
                      }
                    });
                  }),
                  (r._handleTransmuxComplete = function (t) {
                    let e,
                      r = 'main',
                      s = this.hls,
                      o = t.remuxResult,
                      l = t.chunkMeta,
                      u = this.getCurrentContext(l);
                    if (!u)
                      return (
                        this.warn(
                          'The loading context changed while buffering fragment ' +
                            l.sn +
                            ' of level ' +
                            l.level +
                            '. This chunk will not be buffered.'
                        ),
                        void this.resetLiveStartWhenNotLoaded(l.level)
                      );
                    const d = u.frag,
                      f = u.part,
                      h = u.level,
                      p = o.video,
                      v = o.text,
                      g = o.id3,
                      m = o.initSegment,
                      y = this.altAudio ? void 0 : o.audio;
                    if (!this.fragContextChanged(d)) {
                      if (((this.state = n.State.PARSING), m)) {
                        m.tracks &&
                          (this._bufferInitSegment(h, m.tracks, d, l),
                          s.trigger(a.Events.FRAG_PARSING_INIT_SEGMENT, { frag: d, id: r, tracks: m.tracks }));
                        const E = m.initPTS,
                          T = m.timescale;
                        Object(i.isFiniteNumber)(E) &&
                          ((this.initPTS[d.cc] = E),
                          s.trigger(a.Events.INIT_PTS_FOUND, { frag: d, id: r, initPTS: E, timescale: T }));
                      }
                      if (p && !1 !== o.independent) {
                        if (h.details) {
                          const b = p.startPTS,
                            S = p.endPTS,
                            L = p.startDTS,
                            A = p.endDTS;
                          if (f) f.elementaryStreams[p.type] = { startPTS: b, endPTS: S, startDTS: L, endDTS: A };
                          else if (
                            (p.firstKeyFrame && p.independent && (this.couldBacktrack = !0), p.dropped && p.independent)
                          ) {
                            if (this.getLoadPosition() + this.config.maxBufferHole < b) return void this.backtrack(d);
                            d.setElementaryStreamInfo(p.type, d.start, S, d.start, A, !0);
                          }
                          d.setElementaryStreamInfo(p.type, b, S, L, A), this.bufferFragmentData(p, d, f, l);
                        }
                      } else if (!1 === o.independent) return void this.backtrack(d);
                      if (y) {
                        const D = y.startPTS,
                          k = y.endPTS,
                          C = y.startDTS,
                          x = y.endDTS;
                        f &&
                          (f.elementaryStreams[c.ElementaryStreamTypes.AUDIO] = {
                            startPTS: D,
                            endPTS: k,
                            startDTS: C,
                            endDTS: x,
                          }),
                          d.setElementaryStreamInfo(c.ElementaryStreamTypes.AUDIO, D, k, C, x),
                          this.bufferFragmentData(y, d, f, l);
                      }
                      if (null !== g && void 0 !== g && null !== (e = g.samples) && void 0 !== e && e.length) {
                        const R = { frag: d, id: r, samples: g.samples };
                        s.trigger(a.Events.FRAG_PARSING_METADATA, R);
                      }
                      if (v) {
                        const w = { frag: d, id: r, samples: v.samples };
                        s.trigger(a.Events.FRAG_PARSING_USERDATA, w);
                      }
                    }
                  }),
                  (r._bufferInitSegment = function (t, e, r, i) {
                    const s = this;
                    if (this.state === n.State.PARSING) {
                      (this.audioOnly = !!e.audio && !e.video), this.altAudio && !this.audioOnly && delete e.audio;
                      const o = e.audio,
                        l = e.video,
                        u = e.audiovideo;
                      if (o) {
                        let c = t.audioCodec,
                          d = navigator.userAgent.toLowerCase();
                        this.audioCodecSwitch &&
                          (c && (c = -1 !== c.indexOf('mp4a.40.5') ? 'mp4a.40.2' : 'mp4a.40.5'),
                          1 !== o.metadata.channelCount && -1 === d.indexOf('firefox') && (c = 'mp4a.40.5')),
                          -1 !== d.indexOf('android') &&
                            'audio/mpeg' !== o.container &&
                            ((c = 'mp4a.40.2'), this.log('Android: force audio codec to ' + c)),
                          t.audioCodec &&
                            t.audioCodec !== c &&
                            this.log('Swapping manifest audio codec "' + t.audioCodec + '" for "' + c + '"'),
                          (o.levelCodec = c),
                          (o.id = 'main'),
                          this.log(
                            'Init audio buffer, container:' +
                              o.container +
                              ', codecs[selected/level/parsed]=[' +
                              (c || '') +
                              '/' +
                              (t.audioCodec || '') +
                              '/' +
                              o.codec +
                              ']'
                          );
                      }
                      l &&
                        ((l.levelCodec = t.videoCodec),
                        (l.id = 'main'),
                        this.log(
                          'Init video buffer, container:' +
                            l.container +
                            ', codecs[level/parsed]=[' +
                            (t.videoCodec || '') +
                            '/' +
                            l.codec +
                            ']'
                        )),
                        u &&
                          this.log(
                            'Init audiovideo buffer, container:' +
                              u.container +
                              ', codecs[level/parsed]=[' +
                              (t.attrs.CODECS || '') +
                              '/' +
                              u.codec +
                              ']'
                          ),
                        this.hls.trigger(a.Events.BUFFER_CODECS, e),
                        Object.keys(e).forEach(function (t) {
                          const n = e[t].initSegment;
                          null !== n &&
                            void 0 !== n &&
                            n.byteLength &&
                            s.hls.trigger(a.Events.BUFFER_APPENDING, {
                              type: t,
                              data: n,
                              frag: r,
                              part: null,
                              chunkMeta: i,
                              parent: r.type,
                            });
                        }),
                        this.tick();
                    }
                  }),
                  (r.backtrack = function (t) {
                    (this.couldBacktrack = !0), this.resetTransmuxer(), this.flushBufferGap(t);
                    const e = this.fragmentTracker.backtrack(t);
                    (this.fragPrevious = null),
                      (this.nextLoadPosition = t.start),
                      e ? this.resetFragmentLoading(t) : (this.state = n.State.BACKTRACKING);
                  }),
                  (r.checkFragmentChanged = function () {
                    let t = this.media,
                      e = null;
                    if (t && t.readyState > 1 && !1 === t.seeking) {
                      const r = t.currentTime;
                      if (
                        (o.BufferHelper.isBuffered(t, r)
                          ? (e = this.getAppendedFrag(r))
                          : o.BufferHelper.isBuffered(t, r + 0.1) && (e = this.getAppendedFrag(r + 0.1)),
                        e)
                      ) {
                        const i = this.fragPlaying,
                          n = e.level;
                        (i && e.sn === i.sn && i.level === n && e.urlId === i.urlId) ||
                          (this.hls.trigger(a.Events.FRAG_CHANGED, { frag: e }),
                          (i && i.level === n) || this.hls.trigger(a.Events.LEVEL_SWITCHED, { level: n }),
                          (this.fragPlaying = e));
                      }
                    }
                  }),
                  (function (t, e, r) {
                    e && g(t.prototype, e), r && g(t, r);
                  })(e, [
                    {
                      key: 'nextLevel',
                      get: function () {
                        const t = this.nextBufferedFrag;
                        return t ? t.level : -1;
                      },
                    },
                    {
                      key: 'currentLevel',
                      get: function () {
                        const t = this.media;
                        if (t) {
                          const e = this.getAppendedFrag(t.currentTime);
                          if (e) return e.level;
                        }
                        return -1;
                      },
                    },
                    {
                      key: 'nextBufferedFrag',
                      get: function () {
                        const t = this.media;
                        if (t) {
                          const e = this.getAppendedFrag(t.currentTime);
                          return this.followingBufferedFrag(e);
                        }
                        return null;
                      },
                    },
                    {
                      key: 'forceStartLoad',
                      get: function () {
                        return this._forceStartLoad;
                      },
                    },
                  ]),
                  e
                );
              })(n.default);
            },
          './src/controller/subtitle-stream-controller.ts':
            /*!******************************************************!*\
  !*** ./src/controller/subtitle-stream-controller.ts ***!
  \******************************************************/
            /*! exports provided: SubtitleStreamController */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'SubtitleStreamController', function () {
                  return p;
                });
              const i = r(/*! ../events */ './src/events.ts'),
                n = r(/*! ../utils/buffer-helper */ './src/utils/buffer-helper.ts'),
                s = r(/*! ./fragment-finders */ './src/controller/fragment-finders.ts'),
                a = r(/*! ../utils/discontinuities */ './src/utils/discontinuities.ts'),
                o = r(/*! ./level-helper */ './src/controller/level-helper.ts'),
                l = r(/*! ./fragment-tracker */ './src/controller/fragment-tracker.ts'),
                u = r(/*! ./base-stream-controller */ './src/controller/base-stream-controller.ts'),
                c = r(/*! ../types/loader */ './src/types/loader.ts'),
                d = r(/*! ../types/level */ './src/types/level.ts');
              function f(t, e) {
                for (let r = 0; r < e.length; r++) {
                  const i = e[r];
                  (i.enumerable = i.enumerable || !1),
                    (i.configurable = !0),
                    'value' in i && (i.writable = !0),
                    Object.defineProperty(t, i.key, i);
                }
              }
              function h(t, e) {
                return (h =
                  Object.setPrototypeOf ||
                  function (t, e) {
                    return (t.__proto__ = e), t;
                  })(t, e);
              }
              var p = (function (t) {
                function e(e, r) {
                  let i;
                  return (
                    ((i = t.call(this, e, r, '[subtitle-stream-controller]') || this).levels = []),
                    (i.currentTrackId = -1),
                    (i.tracksBuffered = []),
                    (i.mainDetails = null),
                    i._registerListeners(),
                    i
                  );
                }
                !(function (t, e) {
                  (t.prototype = Object.create(e.prototype)), (t.prototype.constructor = t), h(t, e);
                })(e, t);
                const r = e.prototype;
                return (
                  (r.onHandlerDestroying = function () {
                    this._unregisterListeners(), (this.mainDetails = null);
                  }),
                  (r._registerListeners = function () {
                    const t = this.hls;
                    t.on(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                      t.on(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                      t.on(i.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                      t.on(i.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                      t.on(i.Events.ERROR, this.onError, this),
                      t.on(i.Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this),
                      t.on(i.Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this),
                      t.on(i.Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this),
                      t.on(i.Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this),
                      t.on(i.Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
                  }),
                  (r._unregisterListeners = function () {
                    const t = this.hls;
                    t.off(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                      t.off(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                      t.off(i.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                      t.off(i.Events.LEVEL_LOADED, this.onLevelLoaded, this),
                      t.off(i.Events.ERROR, this.onError, this),
                      t.off(i.Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this),
                      t.off(i.Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this),
                      t.off(i.Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this),
                      t.off(i.Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this),
                      t.off(i.Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
                  }),
                  (r.startLoad = function () {
                    this.stopLoad(), (this.state = u.State.IDLE), this.setInterval(500), this.tick();
                  }),
                  (r.onManifestLoading = function () {
                    (this.mainDetails = null), this.fragmentTracker.removeAllFragments();
                  }),
                  (r.onLevelLoaded = function (t, e) {
                    this.mainDetails = e.details;
                  }),
                  (r.onSubtitleFragProcessed = function (t, e) {
                    const r = e.frag,
                      i = e.success;
                    if (((this.fragPrevious = r), (this.state = u.State.IDLE), i)) {
                      const n = this.tracksBuffered[this.currentTrackId];
                      if (n) {
                        for (var s, a = r.start, o = 0; o < n.length; o++)
                          if (a >= n[o].start && a <= n[o].end) {
                            s = n[o];
                            break;
                          }
                        const l = r.start + r.duration;
                        s ? (s.end = l) : ((s = { start: a, end: l }), n.push(s)), this.fragmentTracker.fragBuffered(r);
                      }
                    }
                  }),
                  (r.onBufferFlushing = function (t, e) {
                    const r = e.startOffset,
                      i = e.endOffset;
                    if (0 === r && i !== Number.POSITIVE_INFINITY) {
                      const n = this.currentTrackId,
                        s = this.levels;
                      if (!s.length || !s[n] || !s[n].details) return;
                      const a = i - s[n].details.targetduration;
                      if (a <= 0) return;
                      (e.endOffsetSubtitles = Math.max(0, a)),
                        this.tracksBuffered.forEach(function (t) {
                          for (let e = 0; e < t.length; )
                            if (t[e].end <= a) t.shift();
                            else {
                              if (!(t[e].start < a)) break;
                              (t[e].start = a), e++;
                            }
                        }),
                        this.fragmentTracker.removeFragmentsInRange(r, a, c.PlaylistLevelType.SUBTITLE);
                    }
                  }),
                  (r.onError = function (t, e) {
                    let r,
                      i = e.frag;
                    i &&
                      i.type === c.PlaylistLevelType.SUBTITLE &&
                      (null !== (r = this.fragCurrent) && void 0 !== r && r.loader && this.fragCurrent.loader.abort(),
                      (this.state = u.State.IDLE));
                  }),
                  (r.onSubtitleTracksUpdated = function (t, e) {
                    const r = this,
                      i = e.subtitleTracks;
                    (this.tracksBuffered = []),
                      (this.levels = i.map(function (t) {
                        return new d.Level(t);
                      })),
                      this.fragmentTracker.removeAllFragments(),
                      (this.fragPrevious = null),
                      this.levels.forEach(function (t) {
                        r.tracksBuffered[t.id] = [];
                      }),
                      (this.mediaBuffer = null);
                  }),
                  (r.onSubtitleTrackSwitch = function (t, e) {
                    if (((this.currentTrackId = e.id), this.levels.length && -1 !== this.currentTrackId)) {
                      const r = this.levels[this.currentTrackId];
                      null !== r && void 0 !== r && r.details
                        ? (this.mediaBuffer = this.mediaBufferTimeRanges)
                        : (this.mediaBuffer = null),
                        r && this.setInterval(500);
                    } else this.clearInterval();
                  }),
                  (r.onSubtitleTrackLoaded = function (t, e) {
                    let r,
                      i = e.details,
                      n = e.id,
                      l = this.currentTrackId,
                      c = this.levels;
                    if (c.length) {
                      const d = c[l];
                      if (!(n >= c.length || n !== l) && d) {
                        if (
                          ((this.mediaBuffer = this.mediaBufferTimeRanges),
                          i.live || (null !== (r = d.details) && void 0 !== r && r.live))
                        ) {
                          const f = this.mainDetails;
                          if (i.deltaUpdateFailed || !f) return;
                          const h = f.fragments[0];
                          if (d.details)
                            0 === this.alignPlaylists(i, d.details) && h && Object(o.addSliding)(i, h.start);
                          else
                            i.hasProgramDateTime && f.hasProgramDateTime
                              ? Object(a.alignMediaPlaylistByPDT)(i, f)
                              : h && Object(o.addSliding)(i, h.start);
                        }
                        if (
                          ((d.details = i),
                          (this.levelLastLoaded = n),
                          this.tick(),
                          i.live && !this.fragCurrent && this.media && this.state === u.State.IDLE)
                        )
                          Object(s.findFragmentByPTS)(null, i.fragments, this.media.currentTime, 0) ||
                            (this.warn('Subtitle playlist not aligned with playback'), (d.details = void 0));
                      }
                    }
                  }),
                  (r._handleFragmentLoadComplete = function (t) {
                    const e = t.frag,
                      r = t.payload,
                      n = e.decryptdata,
                      s = this.hls;
                    if (
                      !this.fragContextChanged(e) &&
                      r &&
                      r.byteLength > 0 &&
                      n &&
                      n.key &&
                      n.iv &&
                      'AES-128' === n.method
                    ) {
                      const a = performance.now();
                      this.decrypter.webCryptoDecrypt(new Uint8Array(r), n.key.buffer, n.iv.buffer).then(function (t) {
                        const r = performance.now();
                        s.trigger(i.Events.FRAG_DECRYPTED, { frag: e, payload: t, stats: { tstart: a, tdecrypt: r } });
                      });
                    }
                  }),
                  (r.doTick = function () {
                    if (this.media) {
                      if (this.state === u.State.IDLE) {
                        let t,
                          e = this.currentTrackId,
                          r = this.levels;
                        if (!r.length || !r[e] || !r[e].details) return;
                        const i = r[e].details,
                          a = i.targetduration,
                          o = this.config,
                          c = this.media,
                          d = n.BufferHelper.bufferedInfo(
                            this.mediaBufferTimeRanges,
                            c.currentTime - a,
                            o.maxBufferHole
                          ),
                          f = d.end;
                        if (d.len > this.getMaxBufferLength() + a) return;
                        console.assert(i, 'Subtitle track details are defined on idle subtitle stream controller tick');
                        let h,
                          p = i.fragments,
                          v = p.length,
                          g = i.edge,
                          m = this.fragPrevious;
                        if (f < g) {
                          const y = o.maxFragLookUpTolerance;
                          !(h = Object(s.findFragmentByPTS)(m, p, f, y)) && m && m.start < p[0].start && (h = p[0]);
                        } else h = p[v - 1];
                        null !== (t = h) && void 0 !== t && t.encrypted
                          ? this.loadKey(h, i)
                          : h &&
                            this.fragmentTracker.getState(h) === l.FragmentState.NOT_LOADED &&
                            this.loadFragment(h, i, f);
                      }
                    } else this.state = u.State.IDLE;
                  }),
                  (r.loadFragment = function (e, r, i) {
                    (this.fragCurrent = e), t.prototype.loadFragment.call(this, e, r, i);
                  }),
                  (function (t, e, r) {
                    e && f(t.prototype, e), r && f(t, r);
                  })(e, [
                    {
                      key: 'mediaBufferTimeRanges',
                      get: function () {
                        return this.tracksBuffered[this.currentTrackId] || [];
                      },
                    },
                  ]),
                  e
                );
              })(u.default);
            },
          './src/controller/subtitle-track-controller.ts':
            /*!*****************************************************!*\
  !*** ./src/controller/subtitle-track-controller.ts ***!
  \*****************************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              const i = r(/*! ../events */ './src/events.ts'),
                n = r(/*! ../utils/texttrack-utils */ './src/utils/texttrack-utils.ts'),
                s = r(/*! ./base-playlist-controller */ './src/controller/base-playlist-controller.ts'),
                a = r(/*! ../types/loader */ './src/types/loader.ts');
              function o(t, e) {
                for (let r = 0; r < e.length; r++) {
                  const i = e[r];
                  (i.enumerable = i.enumerable || !1),
                    (i.configurable = !0),
                    'value' in i && (i.writable = !0),
                    Object.defineProperty(t, i.key, i);
                }
              }
              function l(t, e) {
                return (l =
                  Object.setPrototypeOf ||
                  function (t, e) {
                    return (t.__proto__ = e), t;
                  })(t, e);
              }
              const u = (function (t) {
                function e(e) {
                  let r;
                  return (
                    ((r = t.call(this, e, '[subtitle-track-controller]') || this).media = null),
                    (r.tracks = []),
                    (r.groupId = null),
                    (r.tracksInGroup = []),
                    (r.trackId = -1),
                    (r.selectDefaultTrack = !0),
                    (r.queuedDefaultTrack = -1),
                    (r.trackChangeListener = function () {
                      return r.onTextTracksChanged();
                    }),
                    (r.asyncPollTrackChange = function () {
                      return r.pollTrackChange(0);
                    }),
                    (r.useTextTrackPolling = !1),
                    (r.subtitlePollingInterval = -1),
                    (r.subtitleDisplay = !0),
                    r.registerListeners(),
                    r
                  );
                }
                !(function (t, e) {
                  (t.prototype = Object.create(e.prototype)), (t.prototype.constructor = t), l(t, e);
                })(e, t);
                const r = e.prototype;
                return (
                  (r.destroy = function () {
                    this.unregisterListeners(),
                      (this.tracks.length = 0),
                      (this.tracksInGroup.length = 0),
                      (this.trackChangeListener = this.asyncPollTrackChange = null),
                      t.prototype.destroy.call(this);
                  }),
                  (r.registerListeners = function () {
                    const t = this.hls;
                    t.on(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                      t.on(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                      t.on(i.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                      t.on(i.Events.MANIFEST_PARSED, this.onManifestParsed, this),
                      t.on(i.Events.LEVEL_LOADING, this.onLevelLoading, this),
                      t.on(i.Events.LEVEL_SWITCHING, this.onLevelSwitching, this),
                      t.on(i.Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this),
                      t.on(i.Events.ERROR, this.onError, this);
                  }),
                  (r.unregisterListeners = function () {
                    const t = this.hls;
                    t.off(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this),
                      t.off(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                      t.off(i.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                      t.off(i.Events.MANIFEST_PARSED, this.onManifestParsed, this),
                      t.off(i.Events.LEVEL_LOADING, this.onLevelLoading, this),
                      t.off(i.Events.LEVEL_SWITCHING, this.onLevelSwitching, this),
                      t.off(i.Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this),
                      t.off(i.Events.ERROR, this.onError, this);
                  }),
                  (r.onMediaAttached = function (t, e) {
                    (this.media = e.media),
                      this.media &&
                        (this.queuedDefaultTrack > -1 &&
                          ((this.subtitleTrack = this.queuedDefaultTrack), (this.queuedDefaultTrack = -1)),
                        (this.useTextTrackPolling = !(this.media.textTracks && 'onchange' in this.media.textTracks)),
                        this.useTextTrackPolling
                          ? this.pollTrackChange(500)
                          : this.media.textTracks.addEventListener('change', this.asyncPollTrackChange));
                  }),
                  (r.pollTrackChange = function (t) {
                    self.clearInterval(this.subtitlePollingInterval),
                      (this.subtitlePollingInterval = self.setInterval(this.trackChangeListener, t));
                  }),
                  (r.onMediaDetaching = function () {
                    this.media &&
                      (self.clearInterval(this.subtitlePollingInterval),
                      this.useTextTrackPolling ||
                        this.media.textTracks.removeEventListener('change', this.asyncPollTrackChange),
                      this.trackId > -1 && (this.queuedDefaultTrack = this.trackId),
                      c(this.media.textTracks).forEach(function (t) {
                        Object(n.clearCurrentCues)(t);
                      }),
                      (this.subtitleTrack = -1),
                      (this.media = null));
                  }),
                  (r.onManifestLoading = function () {
                    (this.tracks = []),
                      (this.groupId = null),
                      (this.tracksInGroup = []),
                      (this.trackId = -1),
                      (this.selectDefaultTrack = !0);
                  }),
                  (r.onManifestParsed = function (t, e) {
                    this.tracks = e.subtitleTracks;
                  }),
                  (r.onSubtitleTrackLoaded = function (t, e) {
                    const r = e.id,
                      i = e.details,
                      n = this.trackId,
                      s = this.tracksInGroup[n];
                    if (s) {
                      const a = s.details;
                      (s.details = e.details),
                        this.log('subtitle track ' + r + ' loaded [' + i.startSN + '-' + i.endSN + ']'),
                        r === this.trackId && ((this.retryCount = 0), this.playlistLoaded(r, e, a));
                    } else this.warn('Invalid subtitle track id ' + r);
                  }),
                  (r.onLevelLoading = function (t, e) {
                    this.switchLevel(e.level);
                  }),
                  (r.onLevelSwitching = function (t, e) {
                    this.switchLevel(e.level);
                  }),
                  (r.switchLevel = function (t) {
                    const e = this.hls.levels[t];
                    if (null !== e && void 0 !== e && e.textGroupIds) {
                      const r = e.textGroupIds[e.urlId];
                      if (this.groupId !== r) {
                        const n = this.tracksInGroup ? this.tracksInGroup[this.trackId] : void 0,
                          s = this.tracks.filter(function (t) {
                            return !r || t.groupId === r;
                          });
                        this.tracksInGroup = s;
                        const a = this.findTrackId(null === n || void 0 === n ? void 0 : n.name) || this.findTrackId();
                        this.groupId = r;
                        const o = { subtitleTracks: s };
                        this.log('Updating subtitle tracks, ' + s.length + ' track(s) found in "' + r + '" group-id'),
                          this.hls.trigger(i.Events.SUBTITLE_TRACKS_UPDATED, o),
                          -1 !== a && this.setSubtitleTrack(a, n);
                      }
                    }
                  }),
                  (r.findTrackId = function (t) {
                    for (let e = this.tracksInGroup, r = 0; r < e.length; r++) {
                      const i = e[r];
                      if ((!this.selectDefaultTrack || i.default) && (!t || t === i.name)) return i.id;
                    }
                    return -1;
                  }),
                  (r.onError = function (e, r) {
                    t.prototype.onError.call(this, e, r),
                      !r.fatal &&
                        r.context &&
                        r.context.type === a.PlaylistContextType.SUBTITLE_TRACK &&
                        r.context.id === this.trackId &&
                        r.context.groupId === this.groupId &&
                        this.retryLoadingOrFail(r);
                  }),
                  (r.loadPlaylist = function (t) {
                    const e = this.tracksInGroup[this.trackId];
                    if (this.shouldLoadTrack(e)) {
                      let r = e.id,
                        n = e.groupId,
                        s = e.url;
                      if (t)
                        try {
                          s = t.addDirectives(s);
                        } catch (t) {
                          this.warn('Could not construct new URL with HLS Delivery Directives: ' + t);
                        }
                      this.log('Loading subtitle playlist for id ' + r),
                        this.hls.trigger(i.Events.SUBTITLE_TRACK_LOADING, {
                          url: s,
                          id: r,
                          groupId: n,
                          deliveryDirectives: t || null,
                        });
                    }
                  }),
                  (r.toggleTrackModes = function (t) {
                    const e = this,
                      r = this.media,
                      i = this.subtitleDisplay,
                      n = this.trackId;
                    if (r) {
                      const s = c(r.textTracks),
                        a = s.filter(function (t) {
                          return t.groupId === e.groupId;
                        });
                      if (-1 === t)
                        [].slice.call(s).forEach(function (t) {
                          t.mode = 'disabled';
                        });
                      else {
                        const o = a[n];
                        o && (o.mode = 'disabled');
                      }
                      const l = a[t];
                      l && (l.mode = i ? 'showing' : 'hidden');
                    }
                  }),
                  (r.setSubtitleTrack = function (t, e) {
                    let r,
                      n = this.tracksInGroup;
                    if (this.media) {
                      if (
                        (this.trackId !== t && this.toggleTrackModes(t),
                        !(
                          (this.trackId === t && (-1 === t || (null !== (r = n[t]) && void 0 !== r && r.details))) ||
                          t < -1 ||
                          t >= n.length
                        ))
                      ) {
                        this.clearTimer();
                        const s = n[t];
                        if ((this.log('Switching to subtitle track ' + t), (this.trackId = t), s)) {
                          const a = s.id,
                            o = s.groupId,
                            l = void 0 === o ? '' : o,
                            u = s.name,
                            c = s.type,
                            d = s.url;
                          this.hls.trigger(i.Events.SUBTITLE_TRACK_SWITCH, {
                            id: a,
                            groupId: l,
                            name: u,
                            type: c,
                            url: d,
                          });
                          const f = this.switchParams(s.url, null === e || void 0 === e ? void 0 : e.details);
                          this.loadPlaylist(f);
                        } else this.hls.trigger(i.Events.SUBTITLE_TRACK_SWITCH, { id: t });
                      }
                    } else this.queuedDefaultTrack = t;
                  }),
                  (r.onTextTracksChanged = function () {
                    if (
                      (this.useTextTrackPolling || self.clearInterval(this.subtitlePollingInterval),
                      this.media && this.hls.config.renderTextTracksNatively)
                    ) {
                      for (var t = -1, e = c(this.media.textTracks), r = 0; r < e.length; r++)
                        if ('hidden' === e[r].mode) t = r;
                        else if ('showing' === e[r].mode) {
                          t = r;
                          break;
                        }
                      this.subtitleTrack !== t && (this.subtitleTrack = t);
                    }
                  }),
                  (function (t, e, r) {
                    e && o(t.prototype, e), r && o(t, r);
                  })(e, [
                    {
                      key: 'subtitleTracks',
                      get: function () {
                        return this.tracksInGroup;
                      },
                    },
                    {
                      key: 'subtitleTrack',
                      get: function () {
                        return this.trackId;
                      },
                      set: function (t) {
                        this.selectDefaultTrack = !1;
                        const e = this.tracksInGroup ? this.tracksInGroup[this.trackId] : void 0;
                        this.setSubtitleTrack(t, e);
                      },
                    },
                  ]),
                  e
                );
              })(s.default);
              function c(t) {
                for (var e = [], r = 0; r < t.length; r++) {
                  const i = t[r];
                  'subtitles' === i.kind && i.label && e.push(t[r]);
                }
                return e;
              }
              e.default = u;
            },
          './src/controller/timeline-controller.ts':
            /*!***********************************************!*\
  !*** ./src/controller/timeline-controller.ts ***!
  \***********************************************/
            /*! exports provided: TimelineController */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'TimelineController', function () {
                  return f;
                });
              var i = r(/*! ./src/polyfills/number */ './src/polyfills/number.ts'),
                n = r(/*! ../events */ './src/events.ts'),
                s = r(/*! ../utils/cea-608-parser */ './src/utils/cea-608-parser.ts'),
                a = r(/*! ../utils/output-filter */ './src/utils/output-filter.ts'),
                o = r(/*! ../utils/webvtt-parser */ './src/utils/webvtt-parser.ts'),
                l = r(/*! ../utils/texttrack-utils */ './src/utils/texttrack-utils.ts'),
                u = r(/*! ../utils/imsc1-ttml-parser */ './src/utils/imsc1-ttml-parser.ts'),
                c = r(/*! ../types/loader */ './src/types/loader.ts'),
                d = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                f = (function () {
                  function t(t) {
                    if (
                      ((this.hls = void 0),
                      (this.media = null),
                      (this.config = void 0),
                      (this.enabled = !0),
                      (this.Cues = void 0),
                      (this.textTracks = []),
                      (this.tracks = []),
                      (this.initPTS = []),
                      (this.timescale = []),
                      (this.unparsedVttFrags = []),
                      (this.captionsTracks = {}),
                      (this.nonNativeCaptionsTracks = {}),
                      (this.cea608Parser1 = void 0),
                      (this.cea608Parser2 = void 0),
                      (this.lastSn = -1),
                      (this.lastPartIndex = -1),
                      (this.prevCC = -1),
                      (this.vttCCs = { ccOffset: 0, presentationOffset: 0, 0: { start: 0, prevCC: -1, new: !1 } }),
                      (this.captionsProperties = void 0),
                      (this.hls = t),
                      (this.config = t.config),
                      (this.Cues = t.config.cueHandler),
                      (this.captionsProperties = {
                        textTrack1: {
                          label: this.config.captionsTextTrack1Label,
                          languageCode: this.config.captionsTextTrack1LanguageCode,
                        },
                        textTrack2: {
                          label: this.config.captionsTextTrack2Label,
                          languageCode: this.config.captionsTextTrack2LanguageCode,
                        },
                        textTrack3: {
                          label: this.config.captionsTextTrack3Label,
                          languageCode: this.config.captionsTextTrack3LanguageCode,
                        },
                        textTrack4: {
                          label: this.config.captionsTextTrack4Label,
                          languageCode: this.config.captionsTextTrack4LanguageCode,
                        },
                      }),
                      this.config.enableCEA708Captions)
                    ) {
                      const e = new a.default(this, 'textTrack1'),
                        r = new a.default(this, 'textTrack2'),
                        i = new a.default(this, 'textTrack3'),
                        o = new a.default(this, 'textTrack4');
                      (this.cea608Parser1 = new s.default(1, e, r)), (this.cea608Parser2 = new s.default(3, i, o));
                    }
                    t.on(n.Events.MEDIA_ATTACHING, this.onMediaAttaching, this),
                      t.on(n.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                      t.on(n.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                      t.on(n.Events.MANIFEST_LOADED, this.onManifestLoaded, this),
                      t.on(n.Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this),
                      t.on(n.Events.FRAG_LOADING, this.onFragLoading, this),
                      t.on(n.Events.FRAG_LOADED, this.onFragLoaded, this),
                      t.on(n.Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this),
                      t.on(n.Events.FRAG_DECRYPTED, this.onFragDecrypted, this),
                      t.on(n.Events.INIT_PTS_FOUND, this.onInitPtsFound, this),
                      t.on(n.Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this),
                      t.on(n.Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
                  }
                  const e = t.prototype;
                  return (
                    (e.destroy = function () {
                      const t = this.hls;
                      t.off(n.Events.MEDIA_ATTACHING, this.onMediaAttaching, this),
                        t.off(n.Events.MEDIA_DETACHING, this.onMediaDetaching, this),
                        t.off(n.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                        t.off(n.Events.MANIFEST_LOADED, this.onManifestLoaded, this),
                        t.off(n.Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this),
                        t.off(n.Events.FRAG_LOADING, this.onFragLoading, this),
                        t.off(n.Events.FRAG_LOADED, this.onFragLoaded, this),
                        t.off(n.Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this),
                        t.off(n.Events.FRAG_DECRYPTED, this.onFragDecrypted, this),
                        t.off(n.Events.INIT_PTS_FOUND, this.onInitPtsFound, this),
                        t.off(n.Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this),
                        t.off(n.Events.BUFFER_FLUSHING, this.onBufferFlushing, this),
                        (this.hls = this.config = this.cea608Parser1 = this.cea608Parser2 = null);
                    }),
                    (e.addCues = function (t, e, r, i, s) {
                      for (var a = !1, o = s.length; o--; ) {
                        const l = s[o],
                          u = p(l[0], l[1], e, r);
                        if (
                          u >= 0 &&
                          ((l[0] = Math.min(l[0], e)), (l[1] = Math.max(l[1], r)), (a = !0), u / (r - e) > 0.5)
                        )
                          return;
                      }
                      if ((a || s.push([e, r]), this.config.renderTextTracksNatively)) {
                        const c = this.captionsTracks[t];
                        this.Cues.newCue(c, e, r, i);
                      } else {
                        const d = this.Cues.newCue(null, e, r, i);
                        this.hls.trigger(n.Events.CUES_PARSED, { type: 'captions', cues: d, track: t });
                      }
                    }),
                    (e.onInitPtsFound = function (t, e) {
                      const r = this,
                        i = e.frag,
                        s = e.id,
                        a = e.initPTS,
                        o = e.timescale,
                        l = this.unparsedVttFrags;
                      'main' === s && ((this.initPTS[i.cc] = a), (this.timescale[i.cc] = o)),
                        l.length &&
                          ((this.unparsedVttFrags = []),
                          l.forEach(function (t) {
                            r.onFragLoaded(n.Events.FRAG_LOADED, t);
                          }));
                    }),
                    (e.getExistingTrack = function (t) {
                      const e = this.media;
                      if (e)
                        for (let r = 0; r < e.textTracks.length; r++) {
                          const i = e.textTracks[r];
                          if (i[t]) return i;
                        }
                      return null;
                    }),
                    (e.createCaptionsTrack = function (t) {
                      this.config.renderTextTracksNatively ? this.createNativeTrack(t) : this.createNonNativeTrack(t);
                    }),
                    (e.createNativeTrack = function (t) {
                      if (!this.captionsTracks[t]) {
                        const e = this.captionsProperties,
                          r = this.captionsTracks,
                          i = this.media,
                          n = e[t],
                          s = n.label,
                          a = n.languageCode,
                          o = this.getExistingTrack(t);
                        if (o) (r[t] = o), Object(l.clearCurrentCues)(r[t]), Object(l.sendAddTrackEvent)(r[t], i);
                        else {
                          const u = this.createTextTrack('captions', s, a);
                          u && ((u[t] = !0), (r[t] = u));
                        }
                      }
                    }),
                    (e.createNonNativeTrack = function (t) {
                      if (!this.nonNativeCaptionsTracks[t]) {
                        const e = this.captionsProperties[t];
                        if (e) {
                          const r = {
                            _id: t,
                            label: e.label,
                            kind: 'captions',
                            default: !!e.media && !!e.media.default,
                            closedCaptions: e.media,
                          };
                          (this.nonNativeCaptionsTracks[t] = r),
                            this.hls.trigger(n.Events.NON_NATIVE_TEXT_TRACKS_FOUND, { tracks: [r] });
                        }
                      }
                    }),
                    (e.createTextTrack = function (t, e, r) {
                      const i = this.media;
                      if (i) return i.addTextTrack(t, e, r);
                    }),
                    (e.onMediaAttaching = function (t, e) {
                      (this.media = e.media), this._cleanTracks();
                    }),
                    (e.onMediaDetaching = function () {
                      const t = this.captionsTracks;
                      Object.keys(t).forEach(function (e) {
                        Object(l.clearCurrentCues)(t[e]), delete t[e];
                      }),
                        (this.nonNativeCaptionsTracks = {});
                    }),
                    (e.onManifestLoading = function () {
                      (this.lastSn = -1),
                        (this.lastPartIndex = -1),
                        (this.prevCC = -1),
                        (this.vttCCs = { ccOffset: 0, presentationOffset: 0, 0: { start: 0, prevCC: -1, new: !1 } }),
                        this._cleanTracks(),
                        (this.tracks = []),
                        (this.captionsTracks = {}),
                        (this.nonNativeCaptionsTracks = {}),
                        (this.textTracks = []),
                        (this.unparsedVttFrags = this.unparsedVttFrags || []),
                        (this.initPTS = []),
                        (this.timescale = []),
                        this.cea608Parser1 &&
                          this.cea608Parser2 &&
                          (this.cea608Parser1.reset(), this.cea608Parser2.reset());
                    }),
                    (e._cleanTracks = function () {
                      const t = this.media;
                      if (t) {
                        const e = t.textTracks;
                        if (e) for (let r = 0; r < e.length; r++) Object(l.clearCurrentCues)(e[r]);
                      }
                    }),
                    (e.onSubtitleTracksUpdated = function (t, e) {
                      const r = this;
                      this.textTracks = [];
                      const i = e.subtitleTracks || [],
                        s = i.some(function (t) {
                          return t.textCodec === u.IMSC1_CODEC;
                        });
                      if (this.config.enableWebVTT || (s && this.config.enableIMSC1)) {
                        const a = this.tracks && i && this.tracks.length === i.length;
                        if (((this.tracks = i || []), this.config.renderTextTracksNatively)) {
                          const o = this.media ? this.media.textTracks : [];
                          this.tracks.forEach(function (t, e) {
                            let i;
                            if (e < o.length) {
                              for (var n = null, s = 0; s < o.length; s++)
                                if (h(o[s], t)) {
                                  n = o[s];
                                  break;
                                }
                              n && (i = n);
                            }
                            i
                              ? Object(l.clearCurrentCues)(i)
                              : (i = r.createTextTrack('subtitles', t.name, t.lang)) && (i.mode = 'disabled'),
                              i && ((i.groupId = t.groupId), r.textTracks.push(i));
                          });
                        } else if (!a && this.tracks && this.tracks.length) {
                          const c = this.tracks.map(function (t) {
                            return { label: t.name, kind: t.type.toLowerCase(), default: t.default, subtitleTrack: t };
                          });
                          this.hls.trigger(n.Events.NON_NATIVE_TEXT_TRACKS_FOUND, { tracks: c });
                        }
                      }
                    }),
                    (e.onManifestLoaded = function (t, e) {
                      const r = this;
                      this.config.enableCEA708Captions &&
                        e.captions &&
                        e.captions.forEach(function (t) {
                          const e = /(?:CC|SERVICE)([1-4])/.exec(t.instreamId);
                          if (e) {
                            const i = 'textTrack' + e[1],
                              n = r.captionsProperties[i];
                            n && ((n.label = t.name), t.lang && (n.languageCode = t.lang), (n.media = t));
                          }
                        });
                    }),
                    (e.onFragLoading = function (t, e) {
                      const r = this.cea608Parser1,
                        i = this.cea608Parser2,
                        n = this.lastSn,
                        s = this.lastPartIndex;
                      if (this.enabled && r && i && e.frag.type === c.PlaylistLevelType.MAIN) {
                        let a,
                          o,
                          l = e.frag.sn,
                          u =
                            null !=
                            (a =
                              null === e || void 0 === e
                                ? void 0
                                : null === (o = e.part) || void 0 === o
                                  ? void 0
                                  : o.index)
                              ? a
                              : -1;
                        l === n + 1 || (l === n && u === s + 1) || (r.reset(), i.reset()),
                          (this.lastSn = l),
                          (this.lastPartIndex = u);
                      }
                    }),
                    (e.onFragLoaded = function (t, e) {
                      const r = e.frag,
                        s = e.payload,
                        a = this.initPTS,
                        o = this.unparsedVttFrags;
                      if (r.type === c.PlaylistLevelType.SUBTITLE)
                        if (s.byteLength) {
                          if (!Object(i.isFiniteNumber)(a[r.cc]))
                            return (
                              o.push(e),
                              void (
                                a.length &&
                                this.hls.trigger(n.Events.SUBTITLE_FRAG_PROCESSED, {
                                  success: !1,
                                  frag: r,
                                  error: new Error('Missing initial subtitle PTS'),
                                })
                              )
                            );
                          const l = r.decryptdata,
                            d = 'stats' in e;
                          if (null == l || null == l.key || 'AES-128' !== l.method || d) {
                            const f = this.tracks[r.level],
                              h = this.vttCCs;
                            h[r.cc] ||
                              ((h[r.cc] = { start: r.start, prevCC: this.prevCC, new: !0 }), (this.prevCC = r.cc)),
                              f && f.textCodec === u.IMSC1_CODEC ? this._parseIMSC1(r, s) : this._parseVTTs(r, s, h);
                          }
                        } else
                          this.hls.trigger(n.Events.SUBTITLE_FRAG_PROCESSED, {
                            success: !1,
                            frag: r,
                            error: new Error('Empty subtitle payload'),
                          });
                    }),
                    (e._parseIMSC1 = function (t, e) {
                      const r = this,
                        i = this.hls;
                      Object(u.parseIMSC1)(
                        e,
                        this.initPTS[t.cc],
                        this.timescale[t.cc],
                        function (e) {
                          r._appendCues(e, t.level),
                            i.trigger(n.Events.SUBTITLE_FRAG_PROCESSED, { success: !0, frag: t });
                        },
                        function (e) {
                          d.logger.log('Failed to parse IMSC1: ' + e),
                            i.trigger(n.Events.SUBTITLE_FRAG_PROCESSED, { success: !1, frag: t, error: e });
                        }
                      );
                    }),
                    (e._parseVTTs = function (t, e, r) {
                      const i = this,
                        s = this.hls;
                      Object(o.parseWebVTT)(
                        e,
                        this.initPTS[t.cc],
                        this.timescale[t.cc],
                        r,
                        t.cc,
                        t.start,
                        function (e) {
                          i._appendCues(e, t.level),
                            s.trigger(n.Events.SUBTITLE_FRAG_PROCESSED, { success: !0, frag: t });
                        },
                        function (r) {
                          i._fallbackToIMSC1(t, e),
                            d.logger.log('Failed to parse VTT cue: ' + r),
                            s.trigger(n.Events.SUBTITLE_FRAG_PROCESSED, { success: !1, frag: t, error: r });
                        }
                      );
                    }),
                    (e._fallbackToIMSC1 = function (t, e) {
                      const r = this,
                        i = this.tracks[t.level];
                      i.textCodec ||
                        Object(u.parseIMSC1)(
                          e,
                          this.initPTS[t.cc],
                          this.timescale[t.cc],
                          function () {
                            (i.textCodec = u.IMSC1_CODEC), r._parseIMSC1(t, e);
                          },
                          function () {
                            i.textCodec = 'wvtt';
                          }
                        );
                    }),
                    (e._appendCues = function (t, e) {
                      const r = this.hls;
                      if (this.config.renderTextTracksNatively) {
                        const i = this.textTracks[e];
                        if ('disabled' === i.mode) return;
                        t.forEach(function (t) {
                          return Object(l.addCueToTrack)(i, t);
                        });
                      } else {
                        const s = this.tracks[e].default ? 'default' : 'subtitles' + e;
                        r.trigger(n.Events.CUES_PARSED, { type: 'subtitles', cues: t, track: s });
                      }
                    }),
                    (e.onFragDecrypted = function (t, e) {
                      const r = e.frag;
                      if (r.type === c.PlaylistLevelType.SUBTITLE) {
                        if (!Object(i.isFiniteNumber)(this.initPTS[r.cc])) return void this.unparsedVttFrags.push(e);
                        this.onFragLoaded(n.Events.FRAG_LOADED, e);
                      }
                    }),
                    (e.onSubtitleTracksCleared = function () {
                      (this.tracks = []), (this.captionsTracks = {});
                    }),
                    (e.onFragParsingUserdata = function (t, e) {
                      const r = this.cea608Parser1,
                        i = this.cea608Parser2;
                      if (this.enabled && r && i)
                        for (let n = 0; n < e.samples.length; n++) {
                          const s = e.samples[n].bytes;
                          if (s) {
                            const a = this.extractCea608Data(s);
                            r.addData(e.samples[n].pts, a[0]), i.addData(e.samples[n].pts, a[1]);
                          }
                        }
                    }),
                    (e.onBufferFlushing = function (t, e) {
                      const r = e.startOffset,
                        i = e.endOffset,
                        n = e.endOffsetSubtitles,
                        s = e.type,
                        a = this.media;
                      if (a && !(a.currentTime < i)) {
                        if (!s || 'video' === s) {
                          const o = this.captionsTracks;
                          Object.keys(o).forEach(function (t) {
                            return Object(l.removeCuesInRange)(o[t], r, i);
                          });
                        }
                        if (this.config.renderTextTracksNatively && 0 === r && void 0 !== n) {
                          const u = this.textTracks;
                          Object.keys(u).forEach(function (t) {
                            return Object(l.removeCuesInRange)(u[t], r, n);
                          });
                        }
                      }
                    }),
                    (e.extractCea608Data = function (t) {
                      for (var e = 31 & t[0], r = 2, i = [[], []], n = 0; n < e; n++) {
                        const s = t[r++],
                          a = 127 & t[r++],
                          o = 127 & t[r++],
                          l = 3 & s;
                        (0 === a && 0 === o) ||
                          (0 != (4 & s) && ((0 !== l && 1 !== l) || (i[l].push(a), i[l].push(o))));
                      }
                      return i;
                    }),
                    t
                  );
                })();
              function h(t, e) {
                return t && t.label === e.name && !(t.textTrack1 || t.textTrack2);
              }
              function p(t, e, r, i) {
                return Math.min(e, i) - Math.max(t, r);
              }
            },
          './src/crypt/aes-crypto.ts':
            /*!*********************************!*\
  !*** ./src/crypt/aes-crypto.ts ***!
  \*********************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return i;
                });
              var i = (function () {
                function t(t, e) {
                  (this.subtle = void 0), (this.aesIV = void 0), (this.subtle = t), (this.aesIV = e);
                }
                return (
                  (t.prototype.decrypt = function (t, e) {
                    return this.subtle.decrypt({ name: 'AES-CBC', iv: this.aesIV }, e, t);
                  }),
                  t
                );
              })();
            },
          './src/crypt/aes-decryptor.ts':
            /*!************************************!*\
  !*** ./src/crypt/aes-decryptor.ts ***!
  \************************************/
            /*! exports provided: removePadding, default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'removePadding', function () {
                  return n;
                }),
                r.d(e, 'default', function () {
                  return s;
                });
              const i = r(/*! ../utils/typed-array */ './src/utils/typed-array.ts');
              function n(t) {
                const e = t.byteLength,
                  r = e && new DataView(t.buffer).getUint8(e - 1);
                return r ? Object(i.sliceUint8)(t, 0, e - r) : t;
              }
              var s = (function () {
                function t() {
                  (this.rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54]),
                    (this.subMix = [
                      new Uint32Array(256),
                      new Uint32Array(256),
                      new Uint32Array(256),
                      new Uint32Array(256),
                    ]),
                    (this.invSubMix = [
                      new Uint32Array(256),
                      new Uint32Array(256),
                      new Uint32Array(256),
                      new Uint32Array(256),
                    ]),
                    (this.sBox = new Uint32Array(256)),
                    (this.invSBox = new Uint32Array(256)),
                    (this.key = new Uint32Array(0)),
                    (this.ksRows = 0),
                    (this.keySize = 0),
                    (this.keySchedule = void 0),
                    (this.invKeySchedule = void 0),
                    this.initTable();
                }
                const e = t.prototype;
                return (
                  (e.uint8ArrayToUint32Array_ = function (t) {
                    for (var e = new DataView(t), r = new Uint32Array(4), i = 0; i < 4; i++) r[i] = e.getUint32(4 * i);
                    return r;
                  }),
                  (e.initTable = function () {
                    let t = this.sBox,
                      e = this.invSBox,
                      r = this.subMix,
                      i = r[0],
                      n = r[1],
                      s = r[2],
                      a = r[3],
                      o = this.invSubMix,
                      l = o[0],
                      u = o[1],
                      c = o[2],
                      d = o[3],
                      f = new Uint32Array(256),
                      h = 0,
                      p = 0,
                      v = 0;
                    for (v = 0; v < 256; v++) f[v] = v < 128 ? v << 1 : (v << 1) ^ 283;
                    for (v = 0; v < 256; v++) {
                      let g = p ^ (p << 1) ^ (p << 2) ^ (p << 3) ^ (p << 4);
                      (g = (g >>> 8) ^ (255 & g) ^ 99), (t[h] = g), (e[g] = h);
                      let m = f[h],
                        y = f[m],
                        E = f[y],
                        T = (257 * f[g]) ^ (16843008 * g);
                      (i[h] = (T << 24) | (T >>> 8)),
                        (n[h] = (T << 16) | (T >>> 16)),
                        (s[h] = (T << 8) | (T >>> 24)),
                        (a[h] = T),
                        (T = (16843009 * E) ^ (65537 * y) ^ (257 * m) ^ (16843008 * h)),
                        (l[g] = (T << 24) | (T >>> 8)),
                        (u[g] = (T << 16) | (T >>> 16)),
                        (c[g] = (T << 8) | (T >>> 24)),
                        (d[g] = T),
                        h ? ((h = m ^ f[f[f[E ^ m]]]), (p ^= f[f[p]])) : (h = p = 1);
                    }
                  }),
                  (e.expandKey = function (t) {
                    for (var e = this.uint8ArrayToUint32Array_(t), r = !0, i = 0; i < e.length && r; )
                      (r = e[i] === this.key[i]), i++;
                    if (!r) {
                      this.key = e;
                      const n = (this.keySize = e.length);
                      if (4 !== n && 6 !== n && 8 !== n) throw new Error('Invalid aes key size=' + n);
                      let s,
                        a,
                        o,
                        l,
                        u = (this.ksRows = 4 * (n + 6 + 1)),
                        c = (this.keySchedule = new Uint32Array(u)),
                        d = (this.invKeySchedule = new Uint32Array(u)),
                        f = this.sBox,
                        h = this.rcon,
                        p = this.invSubMix,
                        v = p[0],
                        g = p[1],
                        m = p[2],
                        y = p[3];
                      for (s = 0; s < u; s++)
                        s < n
                          ? (o = c[s] = e[s])
                          : ((l = o),
                            s % n == 0
                              ? ((l =
                                  (f[(l = (l << 8) | (l >>> 24)) >>> 24] << 24) |
                                  (f[(l >>> 16) & 255] << 16) |
                                  (f[(l >>> 8) & 255] << 8) |
                                  f[255 & l]),
                                (l ^= h[(s / n) | 0] << 24))
                              : n > 6 &&
                                s % n == 4 &&
                                (l =
                                  (f[l >>> 24] << 24) |
                                  (f[(l >>> 16) & 255] << 16) |
                                  (f[(l >>> 8) & 255] << 8) |
                                  f[255 & l]),
                            (c[s] = o = (c[s - n] ^ l) >>> 0));
                      for (a = 0; a < u; a++)
                        (s = u - a),
                          (l = 3 & a ? c[s] : c[s - 4]),
                          (d[a] =
                            a < 4 || s <= 4
                              ? l
                              : v[f[l >>> 24]] ^ g[f[(l >>> 16) & 255]] ^ m[f[(l >>> 8) & 255]] ^ y[f[255 & l]]),
                          (d[a] = d[a] >>> 0);
                    }
                  }),
                  (e.networkToHostOrderSwap = function (t) {
                    return (t << 24) | ((65280 & t) << 8) | ((16711680 & t) >> 8) | (t >>> 24);
                  }),
                  (e.decrypt = function (t, e, r) {
                    for (
                      var i,
                        n,
                        s,
                        a,
                        o,
                        l,
                        u,
                        c,
                        d,
                        f,
                        h,
                        p,
                        v,
                        g,
                        m = this.keySize + 6,
                        y = this.invKeySchedule,
                        E = this.invSBox,
                        T = this.invSubMix,
                        b = T[0],
                        S = T[1],
                        L = T[2],
                        A = T[3],
                        D = this.uint8ArrayToUint32Array_(r),
                        k = D[0],
                        C = D[1],
                        x = D[2],
                        R = D[3],
                        w = new Int32Array(t),
                        _ = new Int32Array(w.length),
                        I = this.networkToHostOrderSwap;
                      e < w.length;

                    ) {
                      for (
                        d = I(w[e]),
                          f = I(w[e + 1]),
                          h = I(w[e + 2]),
                          p = I(w[e + 3]),
                          o = d ^ y[0],
                          l = p ^ y[1],
                          u = h ^ y[2],
                          c = f ^ y[3],
                          v = 4,
                          g = 1;
                        g < m;
                        g++
                      )
                        (i = b[o >>> 24] ^ S[(l >> 16) & 255] ^ L[(u >> 8) & 255] ^ A[255 & c] ^ y[v]),
                          (n = b[l >>> 24] ^ S[(u >> 16) & 255] ^ L[(c >> 8) & 255] ^ A[255 & o] ^ y[v + 1]),
                          (s = b[u >>> 24] ^ S[(c >> 16) & 255] ^ L[(o >> 8) & 255] ^ A[255 & l] ^ y[v + 2]),
                          (a = b[c >>> 24] ^ S[(o >> 16) & 255] ^ L[(l >> 8) & 255] ^ A[255 & u] ^ y[v + 3]),
                          (o = i),
                          (l = n),
                          (u = s),
                          (c = a),
                          (v += 4);
                      (i =
                        (E[o >>> 24] << 24) ^
                        (E[(l >> 16) & 255] << 16) ^
                        (E[(u >> 8) & 255] << 8) ^
                        E[255 & c] ^
                        y[v]),
                        (n =
                          (E[l >>> 24] << 24) ^
                          (E[(u >> 16) & 255] << 16) ^
                          (E[(c >> 8) & 255] << 8) ^
                          E[255 & o] ^
                          y[v + 1]),
                        (s =
                          (E[u >>> 24] << 24) ^
                          (E[(c >> 16) & 255] << 16) ^
                          (E[(o >> 8) & 255] << 8) ^
                          E[255 & l] ^
                          y[v + 2]),
                        (a =
                          (E[c >>> 24] << 24) ^
                          (E[(o >> 16) & 255] << 16) ^
                          (E[(l >> 8) & 255] << 8) ^
                          E[255 & u] ^
                          y[v + 3]),
                        (_[e] = I(i ^ k)),
                        (_[e + 1] = I(a ^ C)),
                        (_[e + 2] = I(s ^ x)),
                        (_[e + 3] = I(n ^ R)),
                        (k = d),
                        (C = f),
                        (x = h),
                        (R = p),
                        (e += 4);
                    }
                    return _.buffer;
                  }),
                  t
                );
              })();
            },
          './src/crypt/decrypter.ts':
            /*!********************************!*\
  !*** ./src/crypt/decrypter.ts ***!
  \********************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return u;
                });
              var i = r(/*! ./aes-crypto */ './src/crypt/aes-crypto.ts'),
                n = r(/*! ./fast-aes-key */ './src/crypt/fast-aes-key.ts'),
                s = r(/*! ./aes-decryptor */ './src/crypt/aes-decryptor.ts'),
                a = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                o = r(/*! ../utils/mp4-tools */ './src/utils/mp4-tools.ts'),
                l = r(/*! ../utils/typed-array */ './src/utils/typed-array.ts'),
                u = (function () {
                  function t(t, e, r) {
                    const i = (void 0 === r ? {} : r).removePKCS7Padding,
                      n = void 0 === i || i;
                    if (
                      ((this.logEnabled = !0),
                      (this.observer = void 0),
                      (this.config = void 0),
                      (this.removePKCS7Padding = void 0),
                      (this.subtle = null),
                      (this.softwareDecrypter = null),
                      (this.key = null),
                      (this.fastAesKey = null),
                      (this.remainderData = null),
                      (this.currentIV = null),
                      (this.currentResult = null),
                      (this.observer = t),
                      (this.config = e),
                      (this.removePKCS7Padding = n),
                      n)
                    )
                      try {
                        const s = self.crypto;
                        s && (this.subtle = s.subtle || s.webkitSubtle);
                      } catch (t) {}
                    null === this.subtle && (this.config.enableSoftwareAES = !0);
                  }
                  const e = t.prototype;
                  return (
                    (e.destroy = function () {
                      this.observer = null;
                    }),
                    (e.isSync = function () {
                      return this.config.enableSoftwareAES;
                    }),
                    (e.flush = function () {
                      const t = this.currentResult;
                      if (t) {
                        const e = new Uint8Array(t);
                        return this.reset(), this.removePKCS7Padding ? Object(s.removePadding)(e) : e;
                      }
                      this.reset();
                    }),
                    (e.reset = function () {
                      (this.currentResult = null),
                        (this.currentIV = null),
                        (this.remainderData = null),
                        this.softwareDecrypter && (this.softwareDecrypter = null);
                    }),
                    (e.decrypt = function (t, e, r, i) {
                      if (this.config.enableSoftwareAES) {
                        this.softwareDecrypt(new Uint8Array(t), e, r);
                        const n = this.flush();
                        n && i(n.buffer);
                      } else this.webCryptoDecrypt(new Uint8Array(t), e, r).then(i);
                    }),
                    (e.softwareDecrypt = function (t, e, r) {
                      const i = this.currentIV,
                        n = this.currentResult,
                        a = this.remainderData;
                      this.logOnce('JS AES decrypt'),
                        a && ((t = Object(o.appendUint8Array)(a, t)), (this.remainderData = null));
                      const u = this.getValidChunk(t);
                      if (!u.length) return null;
                      i && (r = i);
                      let c = this.softwareDecrypter;
                      c || (c = this.softwareDecrypter = new s.default()), c.expandKey(e);
                      const d = n;
                      return (
                        (this.currentResult = c.decrypt(u.buffer, 0, r)),
                        (this.currentIV = Object(l.sliceUint8)(u, -16).buffer),
                        d || null
                      );
                    }),
                    (e.webCryptoDecrypt = function (t, e, r) {
                      const s = this,
                        a = this.subtle;
                      return (
                        (this.key === e && this.fastAesKey) ||
                          ((this.key = e), (this.fastAesKey = new n.default(a, e))),
                        this.fastAesKey
                          .expandKey()
                          .then(function (e) {
                            return a
                              ? new i.default(a, r).decrypt(t.buffer, e)
                              : Promise.reject(new Error('web crypto not initialized'));
                          })
                          .catch(function (i) {
                            return s.onWebCryptoError(i, t, e, r);
                          })
                      );
                    }),
                    (e.onWebCryptoError = function (t, e, r, i) {
                      return (
                        a.logger.warn('[decrypter.ts]: WebCrypto Error, disable WebCrypto API:', t),
                        (this.config.enableSoftwareAES = !0),
                        (this.logEnabled = !0),
                        this.softwareDecrypt(e, r, i)
                      );
                    }),
                    (e.getValidChunk = function (t) {
                      let e = t,
                        r = t.length - (t.length % 16);
                      return (
                        r !== t.length &&
                          ((e = Object(l.sliceUint8)(t, 0, r)), (this.remainderData = Object(l.sliceUint8)(t, r))),
                        e
                      );
                    }),
                    (e.logOnce = function (t) {
                      this.logEnabled && (a.logger.log('[decrypter.ts]: ' + t), (this.logEnabled = !1));
                    }),
                    t
                  );
                })();
            },
          './src/crypt/fast-aes-key.ts':
            /*!***********************************!*\
  !*** ./src/crypt/fast-aes-key.ts ***!
  \***********************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return i;
                });
              var i = (function () {
                function t(t, e) {
                  (this.subtle = void 0), (this.key = void 0), (this.subtle = t), (this.key = e);
                }
                return (
                  (t.prototype.expandKey = function () {
                    return this.subtle.importKey('raw', this.key, { name: 'AES-CBC' }, !1, ['encrypt', 'decrypt']);
                  }),
                  t
                );
              })();
            },
          './src/demux/aacdemuxer.ts':
            /*!*********************************!*\
  !*** ./src/demux/aacdemuxer.ts ***!
  \*********************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              const i = r(/*! ./base-audio-demuxer */ './src/demux/base-audio-demuxer.ts'),
                n = r(/*! ./adts */ './src/demux/adts.ts'),
                s = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                a = r(/*! ../demux/id3 */ './src/demux/id3.ts');
              function o(t, e) {
                return (o =
                  Object.setPrototypeOf ||
                  function (t, e) {
                    return (t.__proto__ = e), t;
                  })(t, e);
              }
              const l = (function (t) {
                function e(e, r) {
                  let i;
                  return (
                    ((i = t.call(this) || this).observer = void 0),
                    (i.config = void 0),
                    (i.observer = e),
                    (i.config = r),
                    i
                  );
                }
                !(function (t, e) {
                  (t.prototype = Object.create(e.prototype)), (t.prototype.constructor = t), o(t, e);
                })(e, t);
                const r = e.prototype;
                return (
                  (r.resetInitSegment = function (e, r, i) {
                    t.prototype.resetInitSegment.call(this, e, r, i),
                      (this._audioTrack = {
                        container: 'audio/adts',
                        type: 'audio',
                        id: 2,
                        pid: -1,
                        sequenceNumber: 0,
                        isAAC: !0,
                        samples: [],
                        manifestCodec: e,
                        duration: i,
                        inputTimeScale: 9e4,
                        dropped: 0,
                      });
                  }),
                  (e.probe = function (t) {
                    if (!t) return !1;
                    for (let e = (a.getID3Data(t, 0) || []).length, r = t.length; e < r; e++)
                      if (n.probe(t, e)) return s.logger.log('ADTS sync word found !'), !0;
                    return !1;
                  }),
                  (r.canParse = function (t, e) {
                    return n.canParse(t, e);
                  }),
                  (r.appendFrame = function (t, e, r) {
                    n.initTrackConfig(t, this.observer, e, r, t.manifestCodec);
                    const i = n.appendFrame(t, e, r, this.initPTS, this.frameIndex);
                    if (i && 0 === i.missing) return i;
                  }),
                  e
                );
              })(i.default);
              (l.minProbeByteLength = 9), (e.default = l);
            },
          './src/demux/adts.ts':
            /*!***************************!*\
  !*** ./src/demux/adts.ts ***!
  \***************************/
            /*! exports provided: getAudioConfig, isHeaderPattern, getHeaderLength, getFullFrameLength, canGetFrameLength, isHeader, canParse, probe, initTrackConfig, getFrameDuration, parseFrameHeader, appendFrame */ function (
              t,
              e,
              r
            ) {
              'use strict';
              r.r(e),
                r.d(e, 'getAudioConfig', function () {
                  return a;
                }),
                r.d(e, 'isHeaderPattern', function () {
                  return o;
                }),
                r.d(e, 'getHeaderLength', function () {
                  return l;
                }),
                r.d(e, 'getFullFrameLength', function () {
                  return u;
                }),
                r.d(e, 'canGetFrameLength', function () {
                  return c;
                }),
                r.d(e, 'isHeader', function () {
                  return d;
                }),
                r.d(e, 'canParse', function () {
                  return f;
                }),
                r.d(e, 'probe', function () {
                  return h;
                }),
                r.d(e, 'initTrackConfig', function () {
                  return p;
                }),
                r.d(e, 'getFrameDuration', function () {
                  return v;
                }),
                r.d(e, 'parseFrameHeader', function () {
                  return g;
                }),
                r.d(e, 'appendFrame', function () {
                  return m;
                });
              const i = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                n = r(/*! ../errors */ './src/errors.ts'),
                s = r(/*! ../events */ './src/events.ts');
              function a(t, e, r, a) {
                let o,
                  l,
                  u,
                  c,
                  d = navigator.userAgent.toLowerCase(),
                  f = a,
                  h = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
                o = 1 + ((192 & e[r + 2]) >>> 6);
                const p = (60 & e[r + 2]) >>> 2;
                if (!(p > h.length - 1))
                  return (
                    (u = (1 & e[r + 2]) << 2),
                    (u |= (192 & e[r + 3]) >>> 6),
                    i.logger.log('manifest codec:' + a + ', ADTS type:' + o + ', samplingIndex:' + p),
                    /firefox/i.test(d)
                      ? p >= 6
                        ? ((o = 5), (c = new Array(4)), (l = p - 3))
                        : ((o = 2), (c = new Array(2)), (l = p))
                      : -1 !== d.indexOf('android')
                        ? ((o = 2), (c = new Array(2)), (l = p))
                        : ((o = 5),
                          (c = new Array(4)),
                          (a && (-1 !== a.indexOf('mp4a.40.29') || -1 !== a.indexOf('mp4a.40.5'))) || (!a && p >= 6)
                            ? (l = p - 3)
                            : (((a && -1 !== a.indexOf('mp4a.40.2') && ((p >= 6 && 1 === u) || /vivaldi/i.test(d))) ||
                                (!a && 1 === u)) &&
                                ((o = 2), (c = new Array(2))),
                              (l = p))),
                    (c[0] = o << 3),
                    (c[0] |= (14 & p) >> 1),
                    (c[1] |= (1 & p) << 7),
                    (c[1] |= u << 3),
                    5 === o && ((c[1] |= (14 & l) >> 1), (c[2] = (1 & l) << 7), (c[2] |= 8), (c[3] = 0)),
                    { config: c, samplerate: h[p], channelCount: u, codec: 'mp4a.40.' + o, manifestCodec: f }
                  );
                t.trigger(s.Events.ERROR, {
                  type: n.ErrorTypes.MEDIA_ERROR,
                  details: n.ErrorDetails.FRAG_PARSING_ERROR,
                  fatal: !0,
                  reason: 'invalid ADTS sampling index:' + p,
                });
              }
              function o(t, e) {
                return 255 === t[e] && 240 == (246 & t[e + 1]);
              }
              function l(t, e) {
                return 1 & t[e + 1] ? 7 : 9;
              }
              function u(t, e) {
                return ((3 & t[e + 3]) << 11) | (t[e + 4] << 3) | ((224 & t[e + 5]) >>> 5);
              }
              function c(t, e) {
                return e + 5 < t.length;
              }
              function d(t, e) {
                return e + 1 < t.length && o(t, e);
              }
              function f(t, e) {
                return c(t, e) && o(t, e) && u(t, e) <= t.length - e;
              }
              function h(t, e) {
                if (d(t, e)) {
                  const r = l(t, e);
                  if (e + r >= t.length) return !1;
                  const i = u(t, e);
                  if (i <= r) return !1;
                  const n = e + i;
                  return n === t.length || d(t, n);
                }
                return !1;
              }
              function p(t, e, r, n, s) {
                if (!t.samplerate) {
                  const o = a(e, r, n, s);
                  if (!o) return;
                  (t.config = o.config),
                    (t.samplerate = o.samplerate),
                    (t.channelCount = o.channelCount),
                    (t.codec = o.codec),
                    (t.manifestCodec = o.manifestCodec),
                    i.logger.log('parsed codec:' + t.codec + ', rate:' + o.samplerate + ', channels:' + o.channelCount);
                }
              }
              function v(t) {
                return 9216e4 / t;
              }
              function g(t, e, r, i, n) {
                let s = l(t, e),
                  a = u(t, e);
                if ((a -= s) > 0) return { headerLength: s, frameLength: a, stamp: r + i * n };
              }
              function m(t, e, r, i, n) {
                const s = g(e, r, i, n, v(t.samplerate));
                if (s) {
                  let a,
                    o = s.frameLength,
                    l = s.headerLength,
                    u = s.stamp,
                    c = l + o,
                    d = Math.max(0, r + c - e.length);
                  d ? (a = new Uint8Array(c - l)).set(e.subarray(r + l, e.length), 0) : (a = e.subarray(r + l, r + c));
                  const f = { unit: a, pts: u };
                  return d || t.samples.push(f), { sample: f, length: c, missing: d };
                }
              }
            },
          './src/demux/base-audio-demuxer.ts':
            /*!*****************************************!*\
  !*** ./src/demux/base-audio-demuxer.ts ***!
  \*****************************************/
            /*! exports provided: initPTSFn, default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'initPTSFn', function () {
                  return u;
                });
              var i = r(/*! ./src/polyfills/number */ './src/polyfills/number.ts'),
                n = r(/*! ../demux/id3 */ './src/demux/id3.ts'),
                s = r(/*! ./dummy-demuxed-track */ './src/demux/dummy-demuxed-track.ts'),
                a = r(/*! ../utils/mp4-tools */ './src/utils/mp4-tools.ts'),
                o = r(/*! ../utils/typed-array */ './src/utils/typed-array.ts'),
                l = (function () {
                  function t() {
                    (this._audioTrack = void 0),
                      (this._id3Track = void 0),
                      (this.frameIndex = 0),
                      (this.cachedData = null),
                      (this.initPTS = null);
                  }
                  const e = t.prototype;
                  return (
                    (e.resetInitSegment = function (t, e, r) {
                      this._id3Track = {
                        type: 'id3',
                        id: 3,
                        pid: -1,
                        inputTimeScale: 9e4,
                        sequenceNumber: 0,
                        samples: [],
                        dropped: 0,
                      };
                    }),
                    (e.resetTimeStamp = function () {}),
                    (e.resetContiguity = function () {}),
                    (e.canParse = function (t, e) {
                      return !1;
                    }),
                    (e.appendFrame = function (t, e, r) {}),
                    (e.demux = function (t, e) {
                      this.cachedData &&
                        ((t = Object(a.appendUint8Array)(this.cachedData, t)), (this.cachedData = null));
                      let r,
                        i,
                        l = n.getID3Data(t, 0),
                        c = l ? l.length : 0,
                        d = this._audioTrack,
                        f = this._id3Track,
                        h = l ? n.getTimeStamp(l) : void 0,
                        p = t.length;
                      for (
                        (0 !== this.frameIndex && null !== this.initPTS) || (this.initPTS = u(h, e)),
                          l && l.length > 0 && f.samples.push({ pts: this.initPTS, dts: this.initPTS, data: l }),
                          i = this.initPTS;
                        c < p;

                      ) {
                        if (this.canParse(t, c)) {
                          const v = this.appendFrame(d, t, c);
                          v ? (this.frameIndex++, (i = v.sample.pts), (r = c += v.length)) : (c = p);
                        } else
                          n.canParse(t, c)
                            ? ((l = n.getID3Data(t, c)),
                              f.samples.push({ pts: i, dts: i, data: l }),
                              (r = c += l.length))
                            : c++;
                        if (c === p && r !== p) {
                          const g = Object(o.sliceUint8)(t, r);
                          this.cachedData
                            ? (this.cachedData = Object(a.appendUint8Array)(this.cachedData, g))
                            : (this.cachedData = g);
                        }
                      }
                      return {
                        audioTrack: d,
                        avcTrack: Object(s.dummyTrack)(),
                        id3Track: f,
                        textTrack: Object(s.dummyTrack)(),
                      };
                    }),
                    (e.demuxSampleAes = function (t, e, r) {
                      return Promise.reject(
                        new Error('[' + this + '] This demuxer does not support Sample-AES decryption')
                      );
                    }),
                    (e.flush = function (t) {
                      const e = this.cachedData;
                      return (
                        e && ((this.cachedData = null), this.demux(e, 0)),
                        (this.frameIndex = 0),
                        {
                          audioTrack: this._audioTrack,
                          avcTrack: Object(s.dummyTrack)(),
                          id3Track: this._id3Track,
                          textTrack: Object(s.dummyTrack)(),
                        }
                      );
                    }),
                    (e.destroy = function () {}),
                    t
                  );
                })(),
                u = function (t, e) {
                  return Object(i.isFiniteNumber)(t) ? 90 * t : 9e4 * e;
                };
              e.default = l;
            },
          './src/demux/chunk-cache.ts':
            /*!**********************************!*\
  !*** ./src/demux/chunk-cache.ts ***!
  \**********************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return i;
                });
              var i = (function () {
                function t() {
                  (this.chunks = []), (this.dataLength = 0);
                }
                const e = t.prototype;
                return (
                  (e.push = function (t) {
                    this.chunks.push(t), (this.dataLength += t.length);
                  }),
                  (e.flush = function () {
                    let t,
                      e = this.chunks,
                      r = this.dataLength;
                    return e.length
                      ? ((t =
                          1 === e.length
                            ? e[0]
                            : (function (t, e) {
                                for (var r = new Uint8Array(e), i = 0, n = 0; n < t.length; n++) {
                                  const s = t[n];
                                  r.set(s, i), (i += s.length);
                                }
                                return r;
                              })(e, r)),
                        this.reset(),
                        t)
                      : new Uint8Array(0);
                  }),
                  (e.reset = function () {
                    (this.chunks.length = 0), (this.dataLength = 0);
                  }),
                  t
                );
              })();
            },
          './src/demux/dummy-demuxed-track.ts':
            /*!******************************************!*\
  !*** ./src/demux/dummy-demuxed-track.ts ***!
  \******************************************/
            /*! exports provided: dummyTrack */ function (t, e, r) {
              'use strict';
              function i() {
                return { type: '', id: -1, pid: -1, inputTimeScale: 9e4, sequenceNumber: -1, samples: [], dropped: 0 };
              }
              r.r(e),
                r.d(e, 'dummyTrack', function () {
                  return i;
                });
            },
          './src/demux/exp-golomb.ts':
            /*!*********************************!*\
  !*** ./src/demux/exp-golomb.ts ***!
  \*********************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              const i = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                n = (function () {
                  function t(t) {
                    (this.data = void 0),
                      (this.bytesAvailable = void 0),
                      (this.word = void 0),
                      (this.bitsAvailable = void 0),
                      (this.data = t),
                      (this.bytesAvailable = t.byteLength),
                      (this.word = 0),
                      (this.bitsAvailable = 0);
                  }
                  const e = t.prototype;
                  return (
                    (e.loadWord = function () {
                      const t = this.data,
                        e = this.bytesAvailable,
                        r = t.byteLength - e,
                        i = new Uint8Array(4),
                        n = Math.min(4, e);
                      if (0 === n) throw new Error('no bytes available');
                      i.set(t.subarray(r, r + n)),
                        (this.word = new DataView(i.buffer).getUint32(0)),
                        (this.bitsAvailable = 8 * n),
                        (this.bytesAvailable -= n);
                    }),
                    (e.skipBits = function (t) {
                      let e;
                      this.bitsAvailable > t
                        ? ((this.word <<= t), (this.bitsAvailable -= t))
                        : ((t -= this.bitsAvailable),
                          (t -= (e = t >> 3) >> 3),
                          (this.bytesAvailable -= e),
                          this.loadWord(),
                          (this.word <<= t),
                          (this.bitsAvailable -= t));
                    }),
                    (e.readBits = function (t) {
                      let e = Math.min(this.bitsAvailable, t),
                        r = this.word >>> (32 - e);
                      return (
                        t > 32 && i.logger.error('Cannot read more than 32 bits at a time'),
                        (this.bitsAvailable -= e),
                        this.bitsAvailable > 0 ? (this.word <<= e) : this.bytesAvailable > 0 && this.loadWord(),
                        (e = t - e) > 0 && this.bitsAvailable ? (r << e) | this.readBits(e) : r
                      );
                    }),
                    (e.skipLZ = function () {
                      let t;
                      for (t = 0; t < this.bitsAvailable; ++t)
                        if (0 != (this.word & (2147483648 >>> t)))
                          return (this.word <<= t), (this.bitsAvailable -= t), t;
                      return this.loadWord(), t + this.skipLZ();
                    }),
                    (e.skipUEG = function () {
                      this.skipBits(1 + this.skipLZ());
                    }),
                    (e.skipEG = function () {
                      this.skipBits(1 + this.skipLZ());
                    }),
                    (e.readUEG = function () {
                      const t = this.skipLZ();
                      return this.readBits(t + 1) - 1;
                    }),
                    (e.readEG = function () {
                      const t = this.readUEG();
                      return 1 & t ? (1 + t) >>> 1 : -1 * (t >>> 1);
                    }),
                    (e.readBoolean = function () {
                      return 1 === this.readBits(1);
                    }),
                    (e.readUByte = function () {
                      return this.readBits(8);
                    }),
                    (e.readUShort = function () {
                      return this.readBits(16);
                    }),
                    (e.readUInt = function () {
                      return this.readBits(32);
                    }),
                    (e.skipScalingList = function (t) {
                      for (let e = 8, r = 8, i = 0; i < t; i++)
                        0 !== r && (r = (e + this.readEG() + 256) % 256), (e = 0 === r ? e : r);
                    }),
                    (e.readSPS = function () {
                      let t,
                        e,
                        r,
                        i = 0,
                        n = 0,
                        s = 0,
                        a = 0,
                        o = this.readUByte.bind(this),
                        l = this.readBits.bind(this),
                        u = this.readUEG.bind(this),
                        c = this.readBoolean.bind(this),
                        d = this.skipBits.bind(this),
                        f = this.skipEG.bind(this),
                        h = this.skipUEG.bind(this),
                        p = this.skipScalingList.bind(this);
                      o();
                      const v = o();
                      if (
                        (l(5),
                        d(3),
                        o(),
                        h(),
                        100 === v ||
                          110 === v ||
                          122 === v ||
                          244 === v ||
                          44 === v ||
                          83 === v ||
                          86 === v ||
                          118 === v ||
                          128 === v)
                      ) {
                        const g = u();
                        if ((3 === g && d(1), h(), h(), d(1), c()))
                          for (e = 3 !== g ? 8 : 12, r = 0; r < e; r++) c() && p(r < 6 ? 16 : 64);
                      }
                      h();
                      const m = u();
                      if (0 === m) u();
                      else if (1 === m) for (d(1), f(), f(), t = u(), r = 0; r < t; r++) f();
                      h(), d(1);
                      const y = u(),
                        E = u(),
                        T = l(1);
                      0 === T && d(1), d(1), c() && ((i = u()), (n = u()), (s = u()), (a = u()));
                      let b = [1, 1];
                      if (c() && c())
                        switch (o()) {
                          case 1:
                            b = [1, 1];
                            break;
                          case 2:
                            b = [12, 11];
                            break;
                          case 3:
                            b = [10, 11];
                            break;
                          case 4:
                            b = [16, 11];
                            break;
                          case 5:
                            b = [40, 33];
                            break;
                          case 6:
                            b = [24, 11];
                            break;
                          case 7:
                            b = [20, 11];
                            break;
                          case 8:
                            b = [32, 11];
                            break;
                          case 9:
                            b = [80, 33];
                            break;
                          case 10:
                            b = [18, 11];
                            break;
                          case 11:
                            b = [15, 11];
                            break;
                          case 12:
                            b = [64, 33];
                            break;
                          case 13:
                            b = [160, 99];
                            break;
                          case 14:
                            b = [4, 3];
                            break;
                          case 15:
                            b = [3, 2];
                            break;
                          case 16:
                            b = [2, 1];
                            break;
                          case 255:
                            b = [(o() << 8) | o(), (o() << 8) | o()];
                        }
                      return {
                        width: Math.ceil(16 * (y + 1) - 2 * i - 2 * n),
                        height: (2 - T) * (E + 1) * 16 - (T ? 2 : 4) * (s + a),
                        pixelRatio: b,
                      };
                    }),
                    (e.readSliceType = function () {
                      return this.readUByte(), this.readUEG(), this.readUEG();
                    }),
                    t
                  );
                })();
              e.default = n;
            },
          './src/demux/id3.ts':
            /*!**************************!*\
  !*** ./src/demux/id3.ts ***!
  \**************************/
            /*! exports provided: isHeader, isFooter, getID3Data, canParse, getTimeStamp, isTimeStampFrame, getID3Frames, decodeFrame, utf8ArrayToStr, testables */ function (
              t,
              e,
              r
            ) {
              'use strict';
              r.r(e),
                r.d(e, 'isHeader', function () {
                  return n;
                }),
                r.d(e, 'isFooter', function () {
                  return s;
                }),
                r.d(e, 'getID3Data', function () {
                  return a;
                }),
                r.d(e, 'canParse', function () {
                  return l;
                }),
                r.d(e, 'getTimeStamp', function () {
                  return u;
                }),
                r.d(e, 'isTimeStampFrame', function () {
                  return c;
                }),
                r.d(e, 'getID3Frames', function () {
                  return f;
                }),
                r.d(e, 'decodeFrame', function () {
                  return h;
                }),
                r.d(e, 'utf8ArrayToStr', function () {
                  return y;
                }),
                r.d(e, 'testables', function () {
                  return E;
                });
              var i,
                n = function (t, e) {
                  return (
                    e + 10 <= t.length &&
                    73 === t[e] &&
                    68 === t[e + 1] &&
                    51 === t[e + 2] &&
                    t[e + 3] < 255 &&
                    t[e + 4] < 255 &&
                    t[e + 6] < 128 &&
                    t[e + 7] < 128 &&
                    t[e + 8] < 128 &&
                    t[e + 9] < 128
                  );
                },
                s = function (t, e) {
                  return (
                    e + 10 <= t.length &&
                    51 === t[e] &&
                    68 === t[e + 1] &&
                    73 === t[e + 2] &&
                    t[e + 3] < 255 &&
                    t[e + 4] < 255 &&
                    t[e + 6] < 128 &&
                    t[e + 7] < 128 &&
                    t[e + 8] < 128 &&
                    t[e + 9] < 128
                  );
                },
                a = function (t, e) {
                  for (var r = e, i = 0; n(t, e); ) {
                    (i += 10), (i += o(t, e + 6)), s(t, e + 10) && (i += 10), (e += i);
                  }
                  if (i > 0) return t.subarray(r, r + i);
                },
                o = function (t, e) {
                  let r = 0;
                  return (
                    (r = (127 & t[e]) << 21),
                    (r |= (127 & t[e + 1]) << 14),
                    (r |= (127 & t[e + 2]) << 7),
                    (r |= 127 & t[e + 3])
                  );
                },
                l = function (t, e) {
                  return n(t, e) && o(t, e + 6) + 10 <= t.length - e;
                },
                u = function (t) {
                  for (let e = f(t), r = 0; r < e.length; r++) {
                    const i = e[r];
                    if (c(i)) return m(i);
                  }
                },
                c = function (t) {
                  return t && 'PRIV' === t.key && 'com.apple.streaming.transportStreamTimestamp' === t.info;
                },
                d = function (t) {
                  const e = String.fromCharCode(t[0], t[1], t[2], t[3]),
                    r = o(t, 4);
                  return { type: e, size: r, data: t.subarray(10, 10 + r) };
                },
                f = function (t) {
                  for (var e = 0, r = []; n(t, e); ) {
                    for (let i = o(t, e + 6), a = (e += 10) + i; e + 8 < a; ) {
                      const l = d(t.subarray(e)),
                        u = h(l);
                      u && r.push(u), (e += l.size + 10);
                    }
                    s(t, e) && (e += 10);
                  }
                  return r;
                },
                h = function (t) {
                  return 'PRIV' === t.type ? p(t) : 'W' === t.type[0] ? g(t) : v(t);
                },
                p = function (t) {
                  if (!(t.size < 2)) {
                    const e = y(t.data, !0),
                      r = new Uint8Array(t.data.subarray(e.length + 1));
                    return { key: t.type, info: e, data: r.buffer };
                  }
                },
                v = function (t) {
                  if (!(t.size < 2)) {
                    if ('TXXX' === t.type) {
                      let e = 1,
                        r = y(t.data.subarray(e), !0);
                      e += r.length + 1;
                      const i = y(t.data.subarray(e));
                      return { key: t.type, info: r, data: i };
                    }
                    const n = y(t.data.subarray(1));
                    return { key: t.type, data: n };
                  }
                },
                g = function (t) {
                  if ('WXXX' === t.type) {
                    if (t.size < 2) return;
                    let e = 1,
                      r = y(t.data.subarray(e), !0);
                    e += r.length + 1;
                    const i = y(t.data.subarray(e));
                    return { key: t.type, info: r, data: i };
                  }
                  const n = y(t.data);
                  return { key: t.type, data: n };
                },
                m = function (t) {
                  if (8 === t.data.byteLength) {
                    let e = new Uint8Array(t.data),
                      r = 1 & e[3],
                      i = (e[4] << 23) + (e[5] << 15) + (e[6] << 7) + e[7];
                    return (i /= 45), r && (i += 47721858.84), Math.round(i);
                  }
                },
                y = function (t, e) {
                  void 0 === e && (e = !1);
                  const r = T();
                  if (r) {
                    const i = r.decode(t);
                    if (e) {
                      const n = i.indexOf('\0');
                      return -1 !== n ? i.substring(0, n) : i;
                    }
                    return i.replace(/\0/g, '');
                  }
                  for (var s, a, o, l = t.length, u = '', c = 0; c < l; ) {
                    if (0 === (s = t[c++]) && e) return u;
                    if (0 !== s && 3 !== s)
                      switch (s >> 4) {
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                          u += String.fromCharCode(s);
                          break;
                        case 12:
                        case 13:
                          (a = t[c++]), (u += String.fromCharCode(((31 & s) << 6) | (63 & a)));
                          break;
                        case 14:
                          (a = t[c++]),
                            (o = t[c++]),
                            (u += String.fromCharCode(((15 & s) << 12) | ((63 & a) << 6) | ((63 & o) << 0)));
                      }
                  }
                  return u;
                },
                E = { decodeTextFrame: v };
              function T() {
                return i || void 0 === self.TextDecoder || (i = new self.TextDecoder('utf-8')), i;
              }
            },
          './src/demux/mp3demuxer.ts':
            /*!*********************************!*\
  !*** ./src/demux/mp3demuxer.ts ***!
  \*********************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              const i = r(/*! ./base-audio-demuxer */ './src/demux/base-audio-demuxer.ts'),
                n = r(/*! ../demux/id3 */ './src/demux/id3.ts'),
                s = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                a = r(/*! ./mpegaudio */ './src/demux/mpegaudio.ts');
              function o(t, e) {
                return (o =
                  Object.setPrototypeOf ||
                  function (t, e) {
                    return (t.__proto__ = e), t;
                  })(t, e);
              }
              const l = (function (t) {
                function e() {
                  return t.apply(this, arguments) || this;
                }
                !(function (t, e) {
                  (t.prototype = Object.create(e.prototype)), (t.prototype.constructor = t), o(t, e);
                })(e, t);
                const r = e.prototype;
                return (
                  (r.resetInitSegment = function (e, r, i) {
                    t.prototype.resetInitSegment.call(this, e, r, i),
                      (this._audioTrack = {
                        container: 'audio/mpeg',
                        type: 'audio',
                        id: 2,
                        pid: -1,
                        sequenceNumber: 0,
                        isAAC: !1,
                        samples: [],
                        manifestCodec: e,
                        duration: i,
                        inputTimeScale: 9e4,
                        dropped: 0,
                      });
                  }),
                  (e.probe = function (t) {
                    if (!t) return !1;
                    for (let e = (n.getID3Data(t, 0) || []).length, r = t.length; e < r; e++)
                      if (a.probe(t, e)) return s.logger.log('MPEG Audio sync word found !'), !0;
                    return !1;
                  }),
                  (r.canParse = function (t, e) {
                    return a.canParse(t, e);
                  }),
                  (r.appendFrame = function (t, e, r) {
                    if (null !== this.initPTS) return a.appendFrame(t, e, r, this.initPTS, this.frameIndex);
                  }),
                  e
                );
              })(i.default);
              (l.minProbeByteLength = 4), (e.default = l);
            },
          './src/demux/mp4demuxer.ts':
            /*!*********************************!*\
  !*** ./src/demux/mp4demuxer.ts ***!
  \*********************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              const i = r(/*! ../utils/mp4-tools */ './src/utils/mp4-tools.ts'),
                n = r(/*! ./dummy-demuxed-track */ './src/demux/dummy-demuxed-track.ts'),
                s = (function () {
                  function t(t, e) {
                    (this.remainderData = null), (this.config = void 0), (this.config = e);
                  }
                  const e = t.prototype;
                  return (
                    (e.resetTimeStamp = function () {}),
                    (e.resetInitSegment = function () {}),
                    (e.resetContiguity = function () {}),
                    (t.probe = function (t) {
                      return (
                        Object(i.findBox)({ data: t, start: 0, end: Math.min(t.length, 16384) }, ['moof']).length > 0
                      );
                    }),
                    (e.demux = function (t) {
                      let e = t,
                        r = Object(n.dummyTrack)();
                      if (this.config.progressive) {
                        this.remainderData && (e = Object(i.appendUint8Array)(this.remainderData, t));
                        const s = Object(i.segmentValidRange)(e);
                        (this.remainderData = s.remainder), (r.samples = s.valid || new Uint8Array());
                      } else r.samples = e;
                      return {
                        audioTrack: Object(n.dummyTrack)(),
                        avcTrack: r,
                        id3Track: Object(n.dummyTrack)(),
                        textTrack: Object(n.dummyTrack)(),
                      };
                    }),
                    (e.flush = function () {
                      const t = Object(n.dummyTrack)();
                      return (
                        (t.samples = this.remainderData || new Uint8Array()),
                        (this.remainderData = null),
                        {
                          audioTrack: Object(n.dummyTrack)(),
                          avcTrack: t,
                          id3Track: Object(n.dummyTrack)(),
                          textTrack: Object(n.dummyTrack)(),
                        }
                      );
                    }),
                    (e.demuxSampleAes = function (t, e, r) {
                      return Promise.reject(new Error('The MP4 demuxer does not support SAMPLE-AES decryption'));
                    }),
                    (e.destroy = function () {}),
                    t
                  );
                })();
              (s.minProbeByteLength = 1024), (e.default = s);
            },
          './src/demux/mpegaudio.ts':
            /*!********************************!*\
  !*** ./src/demux/mpegaudio.ts ***!
  \********************************/
            /*! exports provided: appendFrame, parseHeader, isHeaderPattern, isHeader, canParse, probe */ function (
              t,
              e,
              r
            ) {
              'use strict';
              r.r(e),
                r.d(e, 'appendFrame', function () {
                  return l;
                }),
                r.d(e, 'parseHeader', function () {
                  return u;
                }),
                r.d(e, 'isHeaderPattern', function () {
                  return c;
                }),
                r.d(e, 'isHeader', function () {
                  return d;
                }),
                r.d(e, 'canParse', function () {
                  return f;
                }),
                r.d(e, 'probe', function () {
                  return h;
                });
              let i = null,
                n = [
                  32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128,
                  160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48,
                  56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112,
                  128, 144, 160,
                ],
                s = [44100, 48e3, 32e3, 22050, 24e3, 16e3, 11025, 12e3, 8e3],
                a = [
                  [0, 72, 144, 12],
                  [0, 0, 0, 0],
                  [0, 72, 144, 12],
                  [0, 144, 144, 12],
                ],
                o = [0, 1, 1, 4];
              function l(t, e, r, i, n) {
                if (!(r + 24 > e.length)) {
                  const s = u(e, r);
                  if (s && r + s.frameLength <= e.length) {
                    const a = i + n * ((9e4 * s.samplesPerFrame) / s.sampleRate),
                      o = { unit: e.subarray(r, r + s.frameLength), pts: a, dts: a };
                    return (
                      (t.config = []),
                      (t.channelCount = s.channelCount),
                      (t.samplerate = s.sampleRate),
                      t.samples.push(o),
                      { sample: o, length: s.frameLength, missing: 0 }
                    );
                  }
                }
              }
              function u(t, e) {
                const r = (t[e + 1] >> 3) & 3,
                  l = (t[e + 1] >> 1) & 3,
                  u = (t[e + 2] >> 4) & 15,
                  c = (t[e + 2] >> 2) & 3;
                if (1 !== r && 0 !== u && 15 !== u && 3 !== c) {
                  const d = (t[e + 2] >> 1) & 1,
                    f = t[e + 3] >> 6,
                    h = 1e3 * n[14 * (3 === r ? 3 - l : 3 === l ? 3 : 4) + u - 1],
                    p = s[3 * (3 === r ? 0 : 2 === r ? 1 : 2) + c],
                    v = 3 === f ? 1 : 2,
                    g = a[r][l],
                    m = o[l],
                    y = 8 * g * m,
                    E = Math.floor((g * h) / p + d) * m;
                  if (null === i) {
                    const T = (navigator.userAgent || '').match(/Chrome\/(\d+)/i);
                    i = T ? parseInt(T[1]) : 0;
                  }
                  return (
                    !!i && i <= 87 && 2 === l && h >= 224e3 && 0 === f && (t[e + 3] = 128 | t[e + 3]),
                    { sampleRate: p, channelCount: v, frameLength: E, samplesPerFrame: y }
                  );
                }
              }
              function c(t, e) {
                return 255 === t[e] && 224 == (224 & t[e + 1]) && 0 != (6 & t[e + 1]);
              }
              function d(t, e) {
                return e + 1 < t.length && c(t, e);
              }
              function f(t, e) {
                return c(t, e) && 4 <= t.length - e;
              }
              function h(t, e) {
                if (e + 1 < t.length && c(t, e)) {
                  let r = u(t, e),
                    i = 4;
                  null !== r && void 0 !== r && r.frameLength && (i = r.frameLength);
                  const n = e + i;
                  return n === t.length || d(t, n);
                }
                return !1;
              }
            },
          './src/demux/sample-aes.ts':
            /*!*********************************!*\
  !*** ./src/demux/sample-aes.ts ***!
  \*********************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              const i = r(/*! ../crypt/decrypter */ './src/crypt/decrypter.ts'),
                n = r(/*! ./tsdemuxer */ './src/demux/tsdemuxer.ts'),
                s = (function () {
                  function t(t, e, r) {
                    (this.keyData = void 0),
                      (this.decrypter = void 0),
                      (this.keyData = r),
                      (this.decrypter = new i.default(t, e, { removePKCS7Padding: !1 }));
                  }
                  const e = t.prototype;
                  return (
                    (e.decryptBuffer = function (t, e) {
                      this.decrypter.decrypt(t, this.keyData.key.buffer, this.keyData.iv.buffer, e);
                    }),
                    (e.decryptAacSample = function (t, e, r, i) {
                      const n = t[e].unit,
                        s = n.subarray(16, n.length - (n.length % 16)),
                        a = s.buffer.slice(s.byteOffset, s.byteOffset + s.length),
                        o = this;
                      this.decryptBuffer(a, function (s) {
                        const a = new Uint8Array(s);
                        n.set(a, 16), i || o.decryptAacSamples(t, e + 1, r);
                      });
                    }),
                    (e.decryptAacSamples = function (t, e, r) {
                      for (; ; e++) {
                        if (e >= t.length) return void r();
                        if (!(t[e].unit.length < 32)) {
                          const i = this.decrypter.isSync();
                          if ((this.decryptAacSample(t, e, r, i), !i)) return;
                        }
                      }
                    }),
                    (e.getAvcEncryptedData = function (t) {
                      for (
                        var e = 16 * Math.floor((t.length - 48) / 160) + 16, r = new Int8Array(e), i = 0, n = 32;
                        n < t.length - 16;
                        n += 160, i += 16
                      )
                        r.set(t.subarray(n, n + 16), i);
                      return r;
                    }),
                    (e.getAvcDecryptedUnit = function (t, e) {
                      for (let r = new Uint8Array(e), i = 0, n = 32; n < t.length - 16; n += 160, i += 16)
                        t.set(r.subarray(i, i + 16), n);
                      return t;
                    }),
                    (e.decryptAvcSample = function (t, e, r, i, s, a) {
                      const o = Object(n.discardEPB)(s.data),
                        l = this.getAvcEncryptedData(o),
                        u = this;
                      this.decryptBuffer(l.buffer, function (n) {
                        (s.data = u.getAvcDecryptedUnit(o, n)), a || u.decryptAvcSamples(t, e, r + 1, i);
                      });
                    }),
                    (e.decryptAvcSamples = function (t, e, r, i) {
                      if (t instanceof Uint8Array) throw new Error('Cannot decrypt samples of type Uint8Array');
                      for (; ; e++, r = 0) {
                        if (e >= t.length) return void i();
                        for (let n = t[e].units; !(r >= n.length); r++) {
                          const s = n[r];
                          if (!(s.data.length <= 48 || (1 !== s.type && 5 !== s.type))) {
                            const a = this.decrypter.isSync();
                            if ((this.decryptAvcSample(t, e, r, i, s, a), !a)) return;
                          }
                        }
                      }
                    }),
                    t
                  );
                })();
              e.default = s;
            },
          './src/demux/transmuxer-interface.ts':
            /*!*******************************************!*\
  !*** ./src/demux/transmuxer-interface.ts ***!
  \*******************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return d;
                });
              var i = r(/*! webworkify-webpack */ './node_modules/webworkify-webpack/index.js'),
                n = r(/*! ../events */ './src/events.ts'),
                s = r(/*! ../demux/transmuxer */ './src/demux/transmuxer.ts'),
                a = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                o = r(/*! ../errors */ './src/errors.ts'),
                l = r(/*! ../utils/mediasource-helper */ './src/utils/mediasource-helper.ts'),
                u = r(/*! eventemitter3 */ './node_modules/eventemitter3/index.js'),
                c = Object(l.getMediaSource)() || {
                  isTypeSupported: function () {
                    return !1;
                  },
                },
                d = (function () {
                  function t(t, e, r, l) {
                    const d = this;
                    (this.hls = void 0),
                      (this.id = void 0),
                      (this.observer = void 0),
                      (this.frag = null),
                      (this.part = null),
                      (this.worker = void 0),
                      (this.onwmsg = void 0),
                      (this.transmuxer = null),
                      (this.onTransmuxComplete = void 0),
                      (this.onFlush = void 0),
                      (this.hls = t),
                      (this.id = e),
                      (this.onTransmuxComplete = r),
                      (this.onFlush = l);
                    const f = t.config,
                      h = function (e, r) {
                        ((r = r || {}).frag = d.frag), (r.id = d.id), t.trigger(e, r);
                      };
                    (this.observer = new u.EventEmitter()),
                      this.observer.on(n.Events.FRAG_DECRYPTED, h),
                      this.observer.on(n.Events.ERROR, h);
                    const p = {
                        mp4: c.isTypeSupported('video/mp4'),
                        mpeg: c.isTypeSupported('audio/mpeg'),
                        mp3: c.isTypeSupported('audio/mp4; codecs="mp3"'),
                      },
                      v = navigator.vendor;
                    if (f.enableWorker && 'undefined' != typeof Worker) {
                      let g;
                      a.logger.log('demuxing in webworker');
                      try {
                        (g = this.worker = i(/*! ../demux/transmuxer-worker.ts */ './src/demux/transmuxer-worker.ts')),
                          (this.onwmsg = this.onWorkerMessage.bind(this)),
                          g.addEventListener('message', this.onwmsg),
                          (g.onerror = function (e) {
                            t.trigger(n.Events.ERROR, {
                              type: o.ErrorTypes.OTHER_ERROR,
                              details: o.ErrorDetails.INTERNAL_EXCEPTION,
                              fatal: !0,
                              event: 'demuxerWorker',
                              error: new Error(e.message + '  (' + e.filename + ':' + e.lineno + ')'),
                            });
                          }),
                          g.postMessage({ cmd: 'init', typeSupported: p, vendor: v, id: e, config: JSON.stringify(f) });
                      } catch (t) {
                        a.logger.warn('Error in worker:', t),
                          a.logger.error('Error while initializing DemuxerWorker, fallback to inline'),
                          g && self.URL.revokeObjectURL(g.objectURL),
                          (this.transmuxer = new s.default(this.observer, p, f, v, e)),
                          (this.worker = null);
                      }
                    } else this.transmuxer = new s.default(this.observer, p, f, v, e);
                  }
                  const e = t.prototype;
                  return (
                    (e.destroy = function () {
                      const t = this.worker;
                      if (t) t.removeEventListener('message', this.onwmsg), t.terminate(), (this.worker = null);
                      else {
                        const e = this.transmuxer;
                        e && (e.destroy(), (this.transmuxer = null));
                      }
                      const r = this.observer;
                      r && r.removeAllListeners(), (this.observer = null);
                    }),
                    (e.push = function (t, e, r, i, n, o, l, u, c, d) {
                      let f,
                        h,
                        p = this;
                      c.transmuxing.start = self.performance.now();
                      const v = this.transmuxer,
                        g = this.worker,
                        m = o ? o.start : n.start,
                        y = n.decryptdata,
                        E = this.frag,
                        T = !(E && n.cc === E.cc),
                        b = !(E && c.level === E.level),
                        S = E ? c.sn - E.sn : -1,
                        L = this.part ? c.part - this.part.index : 1,
                        A = !b && (1 === S || (0 === S && 1 === L)),
                        D = self.performance.now();
                      (b || S || 0 === n.stats.parsing.start) && (n.stats.parsing.start = D),
                        !o || (!L && A) || (o.stats.parsing.start = D);
                      const k = !(
                          E &&
                          (null === (f = n.initSegment) || void 0 === f ? void 0 : f.url) ===
                            (null === (h = E.initSegment) || void 0 === h ? void 0 : h.url)
                        ),
                        C = new s.TransmuxState(T, A, u, b, m, k);
                      if (!A || T || k) {
                        a.logger.log(
                          '[transmuxer-interface, ' +
                            n.type +
                            ']: Starting new transmux session for sn: ' +
                            c.sn +
                            ' p: ' +
                            c.part +
                            ' level: ' +
                            c.level +
                            ' id: ' +
                            c.id +
                            '\n        discontinuity: ' +
                            T +
                            '\n        trackSwitch: ' +
                            b +
                            '\n        contiguous: ' +
                            A +
                            '\n        accurateTimeOffset: ' +
                            u +
                            '\n        timeOffset: ' +
                            m +
                            '\n        initSegmentChange: ' +
                            k
                        );
                        const x = new s.TransmuxConfig(r, i, e, l, d);
                        this.configureTransmuxer(x);
                      }
                      if (((this.frag = n), (this.part = o), g))
                        g.postMessage(
                          { cmd: 'demux', data: t, decryptdata: y, chunkMeta: c, state: C },
                          t instanceof ArrayBuffer ? [t] : []
                        );
                      else if (v) {
                        const R = v.push(t, y, c, C);
                        Object(s.isPromise)(R)
                          ? R.then(function (t) {
                              p.handleTransmuxComplete(t);
                            })
                          : this.handleTransmuxComplete(R);
                      }
                    }),
                    (e.flush = function (t) {
                      const e = this;
                      t.transmuxing.start = self.performance.now();
                      const r = this.transmuxer,
                        i = this.worker;
                      if (i) i.postMessage({ cmd: 'flush', chunkMeta: t });
                      else if (r) {
                        const n = r.flush(t);
                        Object(s.isPromise)(n)
                          ? n.then(function (r) {
                              e.handleFlushResult(r, t);
                            })
                          : this.handleFlushResult(n, t);
                      }
                    }),
                    (e.handleFlushResult = function (t, e) {
                      const r = this;
                      t.forEach(function (t) {
                        r.handleTransmuxComplete(t);
                      }),
                        this.onFlush(e);
                    }),
                    (e.onWorkerMessage = function (t) {
                      const e = t.data,
                        r = this.hls;
                      switch (e.event) {
                        case 'init':
                          self.URL.revokeObjectURL(this.worker.objectURL);
                          break;
                        case 'transmuxComplete':
                          this.handleTransmuxComplete(e.data);
                          break;
                        case 'flush':
                          this.onFlush(e.data);
                          break;
                        default:
                          (e.data = e.data || {}),
                            (e.data.frag = this.frag),
                            (e.data.id = this.id),
                            r.trigger(e.event, e.data);
                      }
                    }),
                    (e.configureTransmuxer = function (t) {
                      const e = this.worker,
                        r = this.transmuxer;
                      e ? e.postMessage({ cmd: 'configure', config: t }) : r && r.configure(t);
                    }),
                    (e.handleTransmuxComplete = function (t) {
                      (t.chunkMeta.transmuxing.end = self.performance.now()), this.onTransmuxComplete(t);
                    }),
                    t
                  );
                })();
            },
          './src/demux/transmuxer-worker.ts':
            /*!****************************************!*\
  !*** ./src/demux/transmuxer-worker.ts ***!
  \****************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return o;
                });
              const i = r(/*! ../demux/transmuxer */ './src/demux/transmuxer.ts'),
                n = r(/*! ../events */ './src/events.ts'),
                s = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                a = r(/*! eventemitter3 */ './node_modules/eventemitter3/index.js');
              function o(t) {
                const e = new a.EventEmitter(),
                  r = function (e, r) {
                    t.postMessage({ event: e, data: r });
                  };
                e.on(n.Events.FRAG_DECRYPTED, r),
                  e.on(n.Events.ERROR, r),
                  t.addEventListener('message', function (n) {
                    const a = n.data;
                    switch (a.cmd) {
                      case 'init':
                        var o = JSON.parse(a.config);
                        (t.transmuxer = new i.default(e, a.typeSupported, o, a.vendor, a.id)),
                          Object(s.enableLogs)(o.debug),
                          r('init', null);
                        break;
                      case 'configure':
                        t.transmuxer.configure(a.config);
                        break;
                      case 'demux':
                        var u = t.transmuxer.push(a.data, a.decryptdata, a.chunkMeta, a.state);
                        Object(i.isPromise)(u)
                          ? u.then(function (e) {
                              l(t, e);
                            })
                          : l(t, u);
                        break;
                      case 'flush':
                        var d = a.chunkMeta,
                          f = t.transmuxer.flush(d);
                        Object(i.isPromise)(f)
                          ? f.then(function (e) {
                              c(t, e, d);
                            })
                          : c(t, f, d);
                    }
                  });
              }
              function l(t, e) {
                if (
                  !(function (t) {
                    return !(t.audio || t.video || t.text || t.id3 || t.initSegment);
                  })(e.remuxResult)
                ) {
                  const r = [],
                    i = e.remuxResult,
                    n = i.audio,
                    s = i.video;
                  n && u(r, n), s && u(r, s), t.postMessage({ event: 'transmuxComplete', data: e }, r);
                }
              }
              function u(t, e) {
                e.data1 && t.push(e.data1.buffer), e.data2 && t.push(e.data2.buffer);
              }
              function c(t, e, r) {
                e.forEach(function (e) {
                  l(t, e);
                }),
                  t.postMessage({ event: 'flush', data: r });
              }
            },
          './src/demux/transmuxer.ts':
            /*!*********************************!*\
  !*** ./src/demux/transmuxer.ts ***!
  \*********************************/
            /*! exports provided: default, isPromise, TransmuxConfig, TransmuxState */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return y;
                }),
                r.d(e, 'isPromise', function () {
                  return T;
                }),
                r.d(e, 'TransmuxConfig', function () {
                  return b;
                }),
                r.d(e, 'TransmuxState', function () {
                  return S;
                });
              let i,
                n = r(/*! ../events */ './src/events.ts'),
                s = r(/*! ../errors */ './src/errors.ts'),
                a = r(/*! ../crypt/decrypter */ './src/crypt/decrypter.ts'),
                o = r(/*! ../demux/aacdemuxer */ './src/demux/aacdemuxer.ts'),
                l = r(/*! ../demux/mp4demuxer */ './src/demux/mp4demuxer.ts'),
                u = r(/*! ../demux/tsdemuxer */ './src/demux/tsdemuxer.ts'),
                c = r(/*! ../demux/mp3demuxer */ './src/demux/mp3demuxer.ts'),
                d = r(/*! ../remux/mp4-remuxer */ './src/remux/mp4-remuxer.ts'),
                f = r(/*! ../remux/passthrough-remuxer */ './src/remux/passthrough-remuxer.ts'),
                h = r(/*! ./chunk-cache */ './src/demux/chunk-cache.ts'),
                p = r(/*! ../utils/mp4-tools */ './src/utils/mp4-tools.ts'),
                v = r(/*! ../utils/logger */ './src/utils/logger.ts');
              try {
                i = self.performance.now.bind(self.performance);
              } catch (t) {
                v.logger.debug('Unable to use Performance API on this environment'), (i = self.Date.now);
              }
              let g = [
                  { demux: u.default, remux: d.default },
                  { demux: l.default, remux: f.default },
                  { demux: o.default, remux: d.default },
                  { demux: c.default, remux: d.default },
                ],
                m = 1024;
              g.forEach(function (t) {
                const e = t.demux;
                m = Math.max(m, e.minProbeByteLength);
              });
              var y = (function () {
                function t(t, e, r, i, n) {
                  (this.observer = void 0),
                    (this.typeSupported = void 0),
                    (this.config = void 0),
                    (this.vendor = void 0),
                    (this.id = void 0),
                    (this.demuxer = void 0),
                    (this.remuxer = void 0),
                    (this.decrypter = void 0),
                    (this.probe = void 0),
                    (this.decryptionPromise = null),
                    (this.transmuxConfig = void 0),
                    (this.currentTransmuxState = void 0),
                    (this.cache = new h.default()),
                    (this.observer = t),
                    (this.typeSupported = e),
                    (this.config = r),
                    (this.vendor = i),
                    (this.id = n);
                }
                const e = t.prototype;
                return (
                  (e.configure = function (t) {
                    (this.transmuxConfig = t), this.decrypter && this.decrypter.reset();
                  }),
                  (e.push = function (t, e, r, n) {
                    const s = this,
                      a = r.transmuxing;
                    a.executeStart = i();
                    let o = new Uint8Array(t),
                      l = this.cache,
                      u = this.config,
                      c = this.currentTransmuxState,
                      d = this.transmuxConfig;
                    n && (this.currentTransmuxState = n);
                    const f = (function (t, e) {
                      let r = null;
                      t.byteLength > 0 && null != e && null != e.key && null !== e.iv && null != e.method && (r = e);
                      return r;
                    })(o, e);
                    if (f && 'AES-128' === f.method) {
                      const h = this.getDecrypter();
                      if (!u.enableSoftwareAES)
                        return (
                          (this.decryptionPromise = h.webCryptoDecrypt(o, f.key.buffer, f.iv.buffer).then(function (t) {
                            const e = s.push(t, null, r);
                            return (s.decryptionPromise = null), e;
                          })),
                          this.decryptionPromise
                        );
                      const v = h.softwareDecrypt(o, f.key.buffer, f.iv.buffer);
                      if (!v) return (a.executeEnd = i()), E(r);
                      o = new Uint8Array(v);
                    }
                    const g = n || c,
                      m = g.contiguous,
                      y = g.discontinuity,
                      T = g.trackSwitch,
                      b = g.accurateTimeOffset,
                      S = g.timeOffset,
                      L = g.initSegmentChange,
                      A = d.audioCodec,
                      D = d.videoCodec,
                      k = d.defaultInitPts,
                      C = d.duration,
                      x = d.initSegmentData;
                    if (
                      ((y || T || L) && this.resetInitSegment(x, A, D, C),
                      (y || L) && this.resetInitialTimestamp(k),
                      m || this.resetContiguity(),
                      this.needsProbing(o, y, T))
                    ) {
                      if (l.dataLength) {
                        const R = l.flush();
                        o = Object(p.appendUint8Array)(R, o);
                      }
                      this.configureTransmuxer(o, d);
                    }
                    const w = this.transmux(o, f, S, b, r),
                      _ = this.currentTransmuxState;
                    return (_.contiguous = !0), (_.discontinuity = !1), (_.trackSwitch = !1), (a.executeEnd = i()), w;
                  }),
                  (e.flush = function (t) {
                    const e = this,
                      r = t.transmuxing;
                    r.executeStart = i();
                    const a = this.decrypter,
                      o = this.cache,
                      l = this.currentTransmuxState,
                      u = this.decryptionPromise;
                    if (u)
                      return u.then(function () {
                        return e.flush(t);
                      });
                    const c = [],
                      d = l.timeOffset;
                    if (a) {
                      const f = a.flush();
                      f && c.push(this.push(f, null, t));
                    }
                    const h = o.dataLength;
                    o.reset();
                    const p = this.demuxer,
                      v = this.remuxer;
                    if (!p || !v)
                      return (
                        h >= m &&
                          this.observer.emit(n.Events.ERROR, n.Events.ERROR, {
                            type: s.ErrorTypes.MEDIA_ERROR,
                            details: s.ErrorDetails.FRAG_PARSING_ERROR,
                            fatal: !0,
                            reason: 'no demux matching with content found',
                          }),
                        (r.executeEnd = i()),
                        [E(t)]
                      );
                    const g = p.flush(d);
                    return T(g)
                      ? g.then(function (r) {
                          return e.flushRemux(c, r, t), c;
                        })
                      : (this.flushRemux(c, g, t), c);
                  }),
                  (e.flushRemux = function (t, e, r) {
                    const n = e.audioTrack,
                      s = e.avcTrack,
                      a = e.id3Track,
                      o = e.textTrack,
                      l = this.currentTransmuxState,
                      u = l.accurateTimeOffset,
                      c = l.timeOffset;
                    v.logger.log(
                      '[transmuxer.ts]: Flushed fragment ' +
                        r.sn +
                        (r.part > -1 ? ' p: ' + r.part : '') +
                        ' of level ' +
                        r.level
                    );
                    const d = this.remuxer.remux(n, s, a, o, c, u, !0, this.id);
                    t.push({ remuxResult: d, chunkMeta: r }), (r.transmuxing.executeEnd = i());
                  }),
                  (e.resetInitialTimestamp = function (t) {
                    const e = this.demuxer,
                      r = this.remuxer;
                    e && r && (e.resetTimeStamp(t), r.resetTimeStamp(t));
                  }),
                  (e.resetContiguity = function () {
                    const t = this.demuxer,
                      e = this.remuxer;
                    t && e && (t.resetContiguity(), e.resetNextTimestamp());
                  }),
                  (e.resetInitSegment = function (t, e, r, i) {
                    const n = this.demuxer,
                      s = this.remuxer;
                    n && s && (n.resetInitSegment(e, r, i), s.resetInitSegment(t, e, r));
                  }),
                  (e.destroy = function () {
                    this.demuxer && (this.demuxer.destroy(), (this.demuxer = void 0)),
                      this.remuxer && (this.remuxer.destroy(), (this.remuxer = void 0));
                  }),
                  (e.transmux = function (t, e, r, i, n) {
                    return e && 'SAMPLE-AES' === e.method
                      ? this.transmuxSampleAes(t, e, r, i, n)
                      : this.transmuxUnencrypted(t, r, i, n);
                  }),
                  (e.transmuxUnencrypted = function (t, e, r, i) {
                    const n = this.demuxer.demux(t, e, !1, !this.config.progressive),
                      s = n.audioTrack,
                      a = n.avcTrack,
                      o = n.id3Track,
                      l = n.textTrack;
                    return { remuxResult: this.remuxer.remux(s, a, o, l, e, r, !1, this.id), chunkMeta: i };
                  }),
                  (e.transmuxSampleAes = function (t, e, r, i, n) {
                    const s = this;
                    return this.demuxer.demuxSampleAes(t, e, r).then(function (t) {
                      return {
                        remuxResult: s.remuxer.remux(t.audioTrack, t.avcTrack, t.id3Track, t.textTrack, r, i, !1, s.id),
                        chunkMeta: n,
                      };
                    });
                  }),
                  (e.configureTransmuxer = function (t, e) {
                    for (
                      var r,
                        i = this.config,
                        n = this.observer,
                        s = this.typeSupported,
                        a = this.vendor,
                        o = e.audioCodec,
                        u = e.defaultInitPts,
                        c = e.duration,
                        d = e.initSegmentData,
                        h = e.videoCodec,
                        p = 0,
                        m = g.length;
                      p < m;
                      p++
                    )
                      if (g[p].demux.probe(t)) {
                        r = g[p];
                        break;
                      }
                    r ||
                      (v.logger.warn('Failed to find demuxer by probing frag, treating as mp4 passthrough'),
                      (r = { demux: l.default, remux: f.default }));
                    const y = this.demuxer,
                      E = this.remuxer,
                      T = r.remux,
                      b = r.demux;
                    (E && E instanceof T) || (this.remuxer = new T(n, i, s, a)),
                      (y && y instanceof b) || ((this.demuxer = new b(n, i, s)), (this.probe = b.probe)),
                      this.resetInitSegment(d, o, h, c),
                      this.resetInitialTimestamp(u);
                  }),
                  (e.needsProbing = function (t, e, r) {
                    return !this.demuxer || !this.remuxer || e || r;
                  }),
                  (e.getDecrypter = function () {
                    let t = this.decrypter;
                    return t || (t = this.decrypter = new a.default(this.observer, this.config)), t;
                  }),
                  t
                );
              })();
              var E = function (t) {
                return { remuxResult: {}, chunkMeta: t };
              };
              function T(t) {
                return 'then' in t && t.then instanceof Function;
              }
              var b = function (t, e, r, i, n) {
                  (this.audioCodec = void 0),
                    (this.videoCodec = void 0),
                    (this.initSegmentData = void 0),
                    (this.duration = void 0),
                    (this.defaultInitPts = void 0),
                    (this.audioCodec = t),
                    (this.videoCodec = e),
                    (this.initSegmentData = r),
                    (this.duration = i),
                    (this.defaultInitPts = n);
                },
                S = function (t, e, r, i, n, s) {
                  (this.discontinuity = void 0),
                    (this.contiguous = void 0),
                    (this.accurateTimeOffset = void 0),
                    (this.trackSwitch = void 0),
                    (this.timeOffset = void 0),
                    (this.initSegmentChange = void 0),
                    (this.discontinuity = t),
                    (this.contiguous = e),
                    (this.accurateTimeOffset = r),
                    (this.trackSwitch = i),
                    (this.timeOffset = n),
                    (this.initSegmentChange = s);
                };
            },
          './src/demux/tsdemuxer.ts':
            /*!********************************!*\
  !*** ./src/demux/tsdemuxer.ts ***!
  \********************************/
            /*! exports provided: discardEPB, default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'discardEPB', function () {
                  return T;
                });
              const i = r(/*! ./adts */ './src/demux/adts.ts'),
                n = r(/*! ./mpegaudio */ './src/demux/mpegaudio.ts'),
                s = r(/*! ./exp-golomb */ './src/demux/exp-golomb.ts'),
                a = r(/*! ./id3 */ './src/demux/id3.ts'),
                o = r(/*! ./sample-aes */ './src/demux/sample-aes.ts'),
                l = r(/*! ../events */ './src/events.ts'),
                u = r(/*! ../utils/mp4-tools */ './src/utils/mp4-tools.ts'),
                c = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                d = r(/*! ../errors */ './src/errors.ts'),
                f = { video: 1, audio: 2, id3: 3, text: 4 },
                h = (function () {
                  function t(t, e, r) {
                    (this.observer = void 0),
                      (this.config = void 0),
                      (this.typeSupported = void 0),
                      (this.sampleAes = null),
                      (this.pmtParsed = !1),
                      (this.audioCodec = void 0),
                      (this.videoCodec = void 0),
                      (this._duration = 0),
                      (this.aacLastPTS = null),
                      (this._initPTS = null),
                      (this._initDTS = null),
                      (this._pmtId = -1),
                      (this._avcTrack = void 0),
                      (this._audioTrack = void 0),
                      (this._id3Track = void 0),
                      (this._txtTrack = void 0),
                      (this.aacOverFlow = null),
                      (this.avcSample = null),
                      (this.remainderData = null),
                      (this.observer = t),
                      (this.config = e),
                      (this.typeSupported = r);
                  }
                  (t.probe = function (e) {
                    const r = t.syncOffset(e);
                    return (
                      !(r < 0) &&
                      (r &&
                        c.logger.warn('MPEG2-TS detected but first sync word found @ offset ' + r + ', junk ahead ?'),
                      !0)
                    );
                  }),
                    (t.syncOffset = function (t) {
                      for (let e = Math.min(1e3, t.length - 564), r = 0; r < e; ) {
                        if (71 === t[r] && 71 === t[r + 188] && 71 === t[r + 376]) return r;
                        r++;
                      }
                      return -1;
                    }),
                    (t.createTrack = function (t, e) {
                      return {
                        container: 'video' === t || 'audio' === t ? 'video/mp2t' : void 0,
                        type: t,
                        id: f[t],
                        pid: -1,
                        inputTimeScale: 9e4,
                        sequenceNumber: 0,
                        samples: [],
                        dropped: 0,
                        duration: 'audio' === t ? e : void 0,
                      };
                    });
                  const e = t.prototype;
                  return (
                    (e.resetInitSegment = function (e, r, i) {
                      (this.pmtParsed = !1),
                        (this._pmtId = -1),
                        (this._avcTrack = t.createTrack('video', i)),
                        (this._audioTrack = t.createTrack('audio', i)),
                        (this._id3Track = t.createTrack('id3', i)),
                        (this._txtTrack = t.createTrack('text', i)),
                        (this._audioTrack.isAAC = !0),
                        (this.aacOverFlow = null),
                        (this.aacLastPTS = null),
                        (this.avcSample = null),
                        (this.audioCodec = e),
                        (this.videoCodec = r),
                        (this._duration = i);
                    }),
                    (e.resetTimeStamp = function () {}),
                    (e.resetContiguity = function () {
                      const t = this._audioTrack,
                        e = this._avcTrack,
                        r = this._id3Track;
                      t && (t.pesData = null),
                        e && (e.pesData = null),
                        r && (r.pesData = null),
                        (this.aacOverFlow = null),
                        (this.aacLastPTS = null);
                    }),
                    (e.demux = function (e, r, i, n) {
                      let s;
                      void 0 === i && (i = !1), void 0 === n && (n = !1), i || (this.sampleAes = null);
                      let a = this._avcTrack,
                        o = this._audioTrack,
                        f = this._id3Track,
                        h = a.pid,
                        p = a.pesData,
                        y = o.pid,
                        E = f.pid,
                        T = o.pesData,
                        b = f.pesData,
                        S = !1,
                        L = this.pmtParsed,
                        A = this._pmtId,
                        D = e.length;
                      if (
                        (this.remainderData &&
                          ((D = (e = Object(u.appendUint8Array)(this.remainderData, e)).length),
                          (this.remainderData = null)),
                        D < 188 && !n)
                      )
                        return (
                          (this.remainderData = e),
                          { audioTrack: o, avcTrack: a, id3Track: f, textTrack: this._txtTrack }
                        );
                      const k = Math.max(0, t.syncOffset(e));
                      (D -= (D + k) % 188) < e.byteLength &&
                        !n &&
                        (this.remainderData = new Uint8Array(e.buffer, D, e.buffer.byteLength - D));
                      for (var C = 0, x = k; x < D; x += 188)
                        if (71 === e[x]) {
                          let R = !!(64 & e[x + 1]),
                            w = ((31 & e[x + 1]) << 8) + e[x + 2],
                            _ = void 0;
                          if ((48 & e[x + 3]) >> 4 > 1) {
                            if ((_ = x + 5 + e[x + 4]) === x + 188) continue;
                          } else _ = x + 4;
                          switch (w) {
                            case h:
                              R && (p && (s = m(p)) && this.parseAVCPES(s, !1), (p = { data: [], size: 0 })),
                                p && (p.data.push(e.subarray(_, x + 188)), (p.size += x + 188 - _));
                              break;
                            case y:
                              R &&
                                (T && (s = m(T)) && (o.isAAC ? this.parseAACPES(s) : this.parseMPEGPES(s)),
                                (T = { data: [], size: 0 })),
                                T && (T.data.push(e.subarray(_, x + 188)), (T.size += x + 188 - _));
                              break;
                            case E:
                              R && (b && (s = m(b)) && this.parseID3PES(s), (b = { data: [], size: 0 })),
                                b && (b.data.push(e.subarray(_, x + 188)), (b.size += x + 188 - _));
                              break;
                            case 0:
                              R && (_ += e[_] + 1), (A = this._pmtId = v(e, _));
                              break;
                            case A:
                              R && (_ += e[_] + 1);
                              var I = g(e, _, !0 === this.typeSupported.mpeg || !0 === this.typeSupported.mp3, i);
                              (h = I.avc) > 0 && (a.pid = h),
                                (y = I.audio) > 0 && ((o.pid = y), (o.isAAC = I.isAAC)),
                                (E = I.id3) > 0 && (f.pid = E),
                                S && !L && (c.logger.log('reparse from beginning'), (S = !1), (x = k - 188)),
                                (L = this.pmtParsed = !0);
                              break;
                            case 17:
                            case 8191:
                              break;
                            default:
                              S = !0;
                          }
                        } else C++;
                      C > 0 &&
                        this.observer.emit(l.Events.ERROR, l.Events.ERROR, {
                          type: d.ErrorTypes.MEDIA_ERROR,
                          details: d.ErrorDetails.FRAG_PARSING_ERROR,
                          fatal: !1,
                          reason: 'Found ' + C + ' TS packet/s that do not start with 0x47',
                        }),
                        (a.pesData = p),
                        (o.pesData = T),
                        (f.pesData = b);
                      const O = { audioTrack: o, avcTrack: a, id3Track: f, textTrack: this._txtTrack };
                      return n && this.extractRemainingSamples(O), O;
                    }),
                    (e.flush = function () {
                      let t,
                        e = this.remainderData;
                      return (
                        (this.remainderData = null),
                        (t = e
                          ? this.demux(e, -1, !1, !0)
                          : {
                              audioTrack: this._audioTrack,
                              avcTrack: this._avcTrack,
                              textTrack: this._txtTrack,
                              id3Track: this._id3Track,
                            }),
                        this.extractRemainingSamples(t),
                        this.sampleAes ? this.decrypt(t, this.sampleAes) : t
                      );
                    }),
                    (e.extractRemainingSamples = function (t) {
                      let e,
                        r = t.audioTrack,
                        i = t.avcTrack,
                        n = t.id3Track,
                        s = i.pesData,
                        a = r.pesData,
                        o = n.pesData;
                      s && (e = m(s)) ? (this.parseAVCPES(e, !0), (i.pesData = null)) : (i.pesData = s),
                        a && (e = m(a))
                          ? (r.isAAC ? this.parseAACPES(e) : this.parseMPEGPES(e), (r.pesData = null))
                          : (null !== a &&
                              void 0 !== a &&
                              a.size &&
                              c.logger.log('last AAC PES packet truncated,might overlap between fragments'),
                            (r.pesData = a)),
                        o && (e = m(o)) ? (this.parseID3PES(e), (n.pesData = null)) : (n.pesData = o);
                    }),
                    (e.demuxSampleAes = function (t, e, r) {
                      const i = this.demux(t, r, !0, !this.config.progressive),
                        n = (this.sampleAes = new o.default(this.observer, this.config, e));
                      return this.decrypt(i, n);
                    }),
                    (e.decrypt = function (t, e) {
                      return new Promise(function (r) {
                        const i = t.audioTrack,
                          n = t.avcTrack;
                        i.samples && i.isAAC
                          ? e.decryptAacSamples(i.samples, 0, function () {
                              n.samples
                                ? e.decryptAvcSamples(n.samples, 0, 0, function () {
                                    r(t);
                                  })
                                : r(t);
                            })
                          : n.samples &&
                            e.decryptAvcSamples(n.samples, 0, 0, function () {
                              r(t);
                            });
                      });
                    }),
                    (e.destroy = function () {
                      (this._initPTS = this._initDTS = null), (this._duration = 0);
                    }),
                    (e.parseAVCPES = function (t, e) {
                      let r,
                        i = this,
                        n = this._avcTrack,
                        o = this.parseAVCNALu(t.data),
                        l = this.avcSample,
                        u = !1;
                      (t.data = null),
                        l && o.length && !n.audFound && (y(l, n), (l = this.avcSample = p(!1, t.pts, t.dts, ''))),
                        o.forEach(function (e) {
                          switch (e.type) {
                            case 1:
                              (r = !0), l || (l = i.avcSample = p(!0, t.pts, t.dts, '')), (l.frame = !0);
                              var o = e.data;
                              if (u && o.length > 4) {
                                const c = new s.default(o).readSliceType();
                                (2 !== c && 4 !== c && 7 !== c && 9 !== c) || (l.key = !0);
                              }
                              break;
                            case 5:
                              (r = !0), l || (l = i.avcSample = p(!0, t.pts, t.dts, '')), (l.key = !0), (l.frame = !0);
                              break;
                            case 6:
                              r = !0;
                              var d = new s.default(T(e.data));
                              d.readUByte();
                              for (let f = 0, h = 0, v = !1, g = 0; !v && d.bytesAvailable > 1; ) {
                                f = 0;
                                do {
                                  f += g = d.readUByte();
                                } while (255 === g);
                                h = 0;
                                do {
                                  h += g = d.readUByte();
                                } while (255 === g);
                                if (4 === f && 0 !== d.bytesAvailable) {
                                  if (((v = !0), 181 === d.readUByte()))
                                    if (49 === d.readUShort())
                                      if (1195456820 === d.readUInt())
                                        if (3 === d.readUByte()) {
                                          for (
                                            var m = d.readUByte(), b = 31 & m, S = [m, d.readUByte()], L = 0;
                                            L < b;
                                            L++
                                          )
                                            S.push(d.readUByte()), S.push(d.readUByte()), S.push(d.readUByte());
                                          E(i._txtTrack.samples, { type: 3, pts: t.pts, bytes: S });
                                        }
                                } else if (5 === f && 0 !== d.bytesAvailable) {
                                  if (((v = !0), h > 16)) {
                                    for (var A = [], D = 0; D < 16; D++)
                                      A.push(d.readUByte().toString(16)),
                                        (3 !== D && 5 !== D && 7 !== D && 9 !== D) || A.push('-');
                                    for (var k = h - 16, C = new Uint8Array(k), x = 0; x < k; x++) C[x] = d.readUByte();
                                    E(i._txtTrack.samples, {
                                      pts: t.pts,
                                      payloadType: f,
                                      uuid: A.join(''),
                                      userData: Object(a.utf8ArrayToStr)(C),
                                      userDataBytes: C,
                                    });
                                  }
                                } else if (h < d.bytesAvailable) for (let R = 0; R < h; R++) d.readUByte();
                              }
                              break;
                            case 7:
                              if (((r = !0), (u = !0), !n.sps)) {
                                const w = new s.default(e.data).readSPS();
                                (n.width = w.width),
                                  (n.height = w.height),
                                  (n.pixelRatio = w.pixelRatio),
                                  (n.sps = [e.data]),
                                  (n.duration = i._duration);
                                for (var _ = e.data.subarray(1, 4), I = 'avc1.', O = 0; O < 3; O++) {
                                  let P = _[O].toString(16);
                                  P.length < 2 && (P = '0' + P), (I += P);
                                }
                                n.codec = I;
                              }
                              break;
                            case 8:
                              (r = !0), n.pps || (n.pps = [e.data]);
                              break;
                            case 9:
                              (r = !1), (n.audFound = !0), l && y(l, n), (l = i.avcSample = p(!1, t.pts, t.dts, ''));
                              break;
                            case 12:
                              r = !1;
                              break;
                            default:
                              (r = !1), l && (l.debug += 'unknown NAL ' + e.type + ' ');
                          }
                          l && r && l.units.push(e);
                        }),
                        e && l && (y(l, n), (this.avcSample = null));
                    }),
                    (e.getLastNalUnit = function () {
                      let t,
                        e,
                        r = this.avcSample;
                      if (!r || 0 === r.units.length) {
                        const i = this._avcTrack.samples;
                        r = i[i.length - 1];
                      }
                      if (null !== (t = r) && void 0 !== t && t.units) {
                        const n = r.units;
                        e = n[n.length - 1];
                      }
                      return e;
                    }),
                    (e.parseAVCNALu = function (t) {
                      let e,
                        r,
                        i = t.byteLength,
                        n = this._avcTrack,
                        s = n.naluState || 0,
                        a = s,
                        o = [],
                        l = 0,
                        u = -1,
                        c = 0;
                      for (-1 === s && ((u = 0), (c = 31 & t[0]), (s = 0), (l = 1)); l < i; )
                        if (((e = t[l++]), s))
                          if (1 !== s)
                            if (e)
                              if (1 === e) {
                                if (u >= 0) {
                                  const d = { data: t.subarray(u, l - s - 1), type: c };
                                  o.push(d);
                                } else {
                                  const f = this.getLastNalUnit();
                                  if (
                                    f &&
                                    (a && l <= 4 - a && f.state && (f.data = f.data.subarray(0, f.data.byteLength - a)),
                                    (r = l - s - 1) > 0)
                                  ) {
                                    const h = new Uint8Array(f.data.byteLength + r);
                                    h.set(f.data, 0),
                                      h.set(t.subarray(0, r), f.data.byteLength),
                                      (f.data = h),
                                      (f.state = 0);
                                  }
                                }
                                l < i ? ((u = l), (c = 31 & t[l]), (s = 0)) : (s = -1);
                              } else s = 0;
                            else s = 3;
                          else s = e ? 0 : 2;
                        else s = e ? 0 : 1;
                      if (u >= 0 && s >= 0) {
                        const p = { data: t.subarray(u, i), type: c, state: s };
                        o.push(p);
                      }
                      if (0 === o.length) {
                        const v = this.getLastNalUnit();
                        if (v) {
                          const g = new Uint8Array(v.data.byteLength + t.byteLength);
                          g.set(v.data, 0), g.set(t, v.data.byteLength), (v.data = g);
                        }
                      }
                      return (n.naluState = s), o;
                    }),
                    (e.parseAACPES = function (t) {
                      let e,
                        r,
                        n,
                        s,
                        a,
                        o = 0,
                        u = this._audioTrack,
                        f = this.aacOverFlow,
                        h = t.data;
                      if (f) {
                        this.aacOverFlow = null;
                        const p = f.sample.unit.byteLength,
                          v = Math.min(f.missing, p),
                          g = p - v;
                        f.sample.unit.set(h.subarray(0, v), g), u.samples.push(f.sample), (o = f.missing);
                      }
                      for (e = o, r = h.length; e < r - 1 && !i.isHeader(h, e); e++);
                      if (
                        e !== o &&
                        (e < r - 1
                          ? ((n = 'AAC PES did not start with ADTS header,offset:' + e), (s = !1))
                          : ((n = 'no ADTS header found in AAC PES'), (s = !0)),
                        c.logger.warn('parsing error:' + n),
                        this.observer.emit(l.Events.ERROR, l.Events.ERROR, {
                          type: d.ErrorTypes.MEDIA_ERROR,
                          details: d.ErrorDetails.FRAG_PARSING_ERROR,
                          fatal: s,
                          reason: n,
                        }),
                        s)
                      )
                        return;
                      if ((i.initTrackConfig(u, this.observer, h, e, this.audioCodec), void 0 !== t.pts)) a = t.pts;
                      else {
                        if (!f) return void c.logger.warn('[tsdemuxer]: AAC PES unknown PTS');
                        const m = i.getFrameDuration(u.samplerate);
                        a = f.sample.pts + m;
                      }
                      for (let y = 0; e < r; ) {
                        if (i.isHeader(h, e)) {
                          if (e + 5 < r) {
                            const E = i.appendFrame(u, h, e, a, y);
                            if (E) {
                              if (!E.missing) {
                                (e += E.length), y++;
                                continue;
                              }
                              this.aacOverFlow = E;
                            }
                          }
                          break;
                        }
                        e++;
                      }
                    }),
                    (e.parseMPEGPES = function (t) {
                      let e = t.data,
                        r = e.length,
                        i = 0,
                        s = 0,
                        a = t.pts;
                      if (void 0 !== a)
                        for (; s < r; )
                          if (n.isHeader(e, s)) {
                            const o = n.appendFrame(this._audioTrack, e, s, a, i);
                            if (!o) break;
                            (s += o.length), i++;
                          } else s++;
                      else c.logger.warn('[tsdemuxer]: MPEG PES unknown PTS');
                    }),
                    (e.parseID3PES = function (t) {
                      void 0 !== t.pts
                        ? this._id3Track.samples.push(t)
                        : c.logger.warn('[tsdemuxer]: ID3 PES unknown PTS');
                    }),
                    t
                  );
                })();
              function p(t, e, r, i) {
                return { key: t, frame: !1, pts: e, dts: r, units: [], debug: i, length: 0 };
              }
              function v(t, e) {
                return ((31 & t[e + 10]) << 8) | t[e + 11];
              }
              function g(t, e, r, i) {
                const n = { audio: -1, avc: -1, id3: -1, isAAC: !0 },
                  s = e + 3 + (((15 & t[e + 1]) << 8) | t[e + 2]) - 4;
                for (e += 12 + (((15 & t[e + 10]) << 8) | t[e + 11]); e < s; ) {
                  const a = ((31 & t[e + 1]) << 8) | t[e + 2];
                  switch (t[e]) {
                    case 207:
                      if (!i) {
                        c.logger.log('ADTS AAC with AES-128-CBC frame encryption found in unencrypted stream');
                        break;
                      }
                    case 15:
                      -1 === n.audio && (n.audio = a);
                      break;
                    case 21:
                      -1 === n.id3 && (n.id3 = a);
                      break;
                    case 219:
                      if (!i) {
                        c.logger.log('H.264 with AES-128-CBC slice encryption found in unencrypted stream');
                        break;
                      }
                    case 27:
                      -1 === n.avc && (n.avc = a);
                      break;
                    case 3:
                    case 4:
                      r
                        ? -1 === n.audio && ((n.audio = a), (n.isAAC = !1))
                        : c.logger.log('MPEG audio found, not supported in this browser');
                      break;
                    case 36:
                      c.logger.warn('Unsupported HEVC stream type found');
                  }
                  e += 5 + (((15 & t[e + 3]) << 8) | t[e + 4]);
                }
                return n;
              }
              function m(t) {
                let e,
                  r,
                  i,
                  n,
                  s,
                  a = 0,
                  o = t.data;
                if (!t || 0 === t.size) return null;
                for (; o[0].length < 19 && o.length > 1; ) {
                  const l = new Uint8Array(o[0].length + o[1].length);
                  l.set(o[0]), l.set(o[1], o[0].length), (o[0] = l), o.splice(1, 1);
                }
                if (1 === ((e = o[0])[0] << 16) + (e[1] << 8) + e[2]) {
                  if ((r = (e[4] << 8) + e[5]) && r > t.size - 6) return null;
                  const u = e[7];
                  192 & u &&
                    ((n =
                      536870912 * (14 & e[9]) +
                      4194304 * (255 & e[10]) +
                      16384 * (254 & e[11]) +
                      128 * (255 & e[12]) +
                      (254 & e[13]) / 2),
                    64 & u
                      ? n -
                          (s =
                            536870912 * (14 & e[14]) +
                            4194304 * (255 & e[15]) +
                            16384 * (254 & e[16]) +
                            128 * (255 & e[17]) +
                            (254 & e[18]) / 2) >
                          54e5 &&
                        (c.logger.warn(Math.round((n - s) / 9e4) + 's delta between PTS and DTS, align them'), (n = s))
                      : (s = n));
                  let d = (i = e[8]) + 9;
                  if (t.size <= d) return null;
                  t.size -= d;
                  for (var f = new Uint8Array(t.size), h = 0, p = o.length; h < p; h++) {
                    let v = (e = o[h]).byteLength;
                    if (d) {
                      if (d > v) {
                        d -= v;
                        continue;
                      }
                      (e = e.subarray(d)), (v -= d), (d = 0);
                    }
                    f.set(e, a), (a += v);
                  }
                  return r && (r -= i + 3), { data: f, pts: n, dts: s, len: r };
                }
                return null;
              }
              function y(t, e) {
                if (t.units.length && t.frame) {
                  if (void 0 === t.pts) {
                    const r = e.samples,
                      i = r.length;
                    if (!i) return void e.dropped++;
                    const n = r[i - 1];
                    (t.pts = n.pts), (t.dts = n.dts);
                  }
                  e.samples.push(t);
                }
                t.debug.length && c.logger.log(t.pts + '/' + t.dts + ':' + t.debug);
              }
              function E(t, e) {
                const r = t.length;
                if (r > 0) {
                  if (e.pts >= t[r - 1].pts) t.push(e);
                  else
                    for (let i = r - 1; i >= 0; i--)
                      if (e.pts < t[i].pts) {
                        t.splice(i, 0, e);
                        break;
                      }
                } else t.push(e);
              }
              function T(t) {
                for (var e = t.byteLength, r = [], i = 1; i < e - 2; )
                  0 === t[i] && 0 === t[i + 1] && 3 === t[i + 2] ? (r.push(i + 2), (i += 2)) : i++;
                if (0 === r.length) return t;
                let n = e - r.length,
                  s = new Uint8Array(n),
                  a = 0;
                for (i = 0; i < n; a++, i++) a === r[0] && (a++, r.shift()), (s[i] = t[a]);
                return s;
              }
              (h.minProbeByteLength = 188), (e.default = h);
            },
          './src/errors.ts':
            /*!***********************!*\
  !*** ./src/errors.ts ***!
  \***********************/
            /*! exports provided: ErrorTypes, ErrorDetails */ function (t, e, r) {
              'use strict';
              let i, n;
              r.r(e),
                r.d(e, 'ErrorTypes', function () {
                  return i;
                }),
                r.d(e, 'ErrorDetails', function () {
                  return n;
                }),
                (function (t) {
                  (t.NETWORK_ERROR = 'networkError'),
                    (t.MEDIA_ERROR = 'mediaError'),
                    (t.KEY_SYSTEM_ERROR = 'keySystemError'),
                    (t.MUX_ERROR = 'muxError'),
                    (t.OTHER_ERROR = 'otherError');
                })(i || (i = {})),
                (function (t) {
                  (t.KEY_SYSTEM_NO_KEYS = 'keySystemNoKeys'),
                    (t.KEY_SYSTEM_NO_ACCESS = 'keySystemNoAccess'),
                    (t.KEY_SYSTEM_NO_SESSION = 'keySystemNoSession'),
                    (t.KEY_SYSTEM_LICENSE_REQUEST_FAILED = 'keySystemLicenseRequestFailed'),
                    (t.KEY_SYSTEM_NO_INIT_DATA = 'keySystemNoInitData'),
                    (t.MANIFEST_LOAD_ERROR = 'manifestLoadError'),
                    (t.MANIFEST_LOAD_TIMEOUT = 'manifestLoadTimeOut'),
                    (t.MANIFEST_PARSING_ERROR = 'manifestParsingError'),
                    (t.MANIFEST_INCOMPATIBLE_CODECS_ERROR = 'manifestIncompatibleCodecsError'),
                    (t.LEVEL_EMPTY_ERROR = 'levelEmptyError'),
                    (t.LEVEL_LOAD_ERROR = 'levelLoadError'),
                    (t.LEVEL_LOAD_TIMEOUT = 'levelLoadTimeOut'),
                    (t.LEVEL_SWITCH_ERROR = 'levelSwitchError'),
                    (t.AUDIO_TRACK_LOAD_ERROR = 'audioTrackLoadError'),
                    (t.AUDIO_TRACK_LOAD_TIMEOUT = 'audioTrackLoadTimeOut'),
                    (t.SUBTITLE_LOAD_ERROR = 'subtitleTrackLoadError'),
                    (t.SUBTITLE_TRACK_LOAD_TIMEOUT = 'subtitleTrackLoadTimeOut'),
                    (t.FRAG_LOAD_ERROR = 'fragLoadError'),
                    (t.FRAG_LOAD_TIMEOUT = 'fragLoadTimeOut'),
                    (t.FRAG_DECRYPT_ERROR = 'fragDecryptError'),
                    (t.FRAG_PARSING_ERROR = 'fragParsingError'),
                    (t.REMUX_ALLOC_ERROR = 'remuxAllocError'),
                    (t.KEY_LOAD_ERROR = 'keyLoadError'),
                    (t.KEY_LOAD_TIMEOUT = 'keyLoadTimeOut'),
                    (t.BUFFER_ADD_CODEC_ERROR = 'bufferAddCodecError'),
                    (t.BUFFER_INCOMPATIBLE_CODECS_ERROR = 'bufferIncompatibleCodecsError'),
                    (t.BUFFER_APPEND_ERROR = 'bufferAppendError'),
                    (t.BUFFER_APPENDING_ERROR = 'bufferAppendingError'),
                    (t.BUFFER_STALLED_ERROR = 'bufferStalledError'),
                    (t.BUFFER_FULL_ERROR = 'bufferFullError'),
                    (t.BUFFER_SEEK_OVER_HOLE = 'bufferSeekOverHole'),
                    (t.BUFFER_NUDGE_ON_STALL = 'bufferNudgeOnStall'),
                    (t.INTERNAL_EXCEPTION = 'internalException'),
                    (t.INTERNAL_ABORTED = 'aborted'),
                    (t.UNKNOWN = 'unknown');
                })(n || (n = {}));
            },
          './src/events.ts':
            /*!***********************!*\
  !*** ./src/events.ts ***!
  \***********************/
            /*! exports provided: Events */ function (t, e, r) {
              'use strict';
              let i;
              r.r(e),
                r.d(e, 'Events', function () {
                  return i;
                }),
                (function (t) {
                  (t.MEDIA_ATTACHING = 'hlsMediaAttaching'),
                    (t.MEDIA_ATTACHED = 'hlsMediaAttached'),
                    (t.MEDIA_DETACHING = 'hlsMediaDetaching'),
                    (t.MEDIA_DETACHED = 'hlsMediaDetached'),
                    (t.BUFFER_RESET = 'hlsBufferReset'),
                    (t.BUFFER_CODECS = 'hlsBufferCodecs'),
                    (t.BUFFER_CREATED = 'hlsBufferCreated'),
                    (t.BUFFER_APPENDING = 'hlsBufferAppending'),
                    (t.BUFFER_APPENDED = 'hlsBufferAppended'),
                    (t.BUFFER_EOS = 'hlsBufferEos'),
                    (t.BUFFER_FLUSHING = 'hlsBufferFlushing'),
                    (t.BUFFER_FLUSHED = 'hlsBufferFlushed'),
                    (t.MANIFEST_LOADING = 'hlsManifestLoading'),
                    (t.MANIFEST_LOADED = 'hlsManifestLoaded'),
                    (t.MANIFEST_PARSED = 'hlsManifestParsed'),
                    (t.LEVEL_SWITCHING = 'hlsLevelSwitching'),
                    (t.LEVEL_SWITCHED = 'hlsLevelSwitched'),
                    (t.LEVEL_LOADING = 'hlsLevelLoading'),
                    (t.LEVEL_LOADED = 'hlsLevelLoaded'),
                    (t.LEVEL_UPDATED = 'hlsLevelUpdated'),
                    (t.LEVEL_PTS_UPDATED = 'hlsLevelPtsUpdated'),
                    (t.LEVELS_UPDATED = 'hlsLevelsUpdated'),
                    (t.AUDIO_TRACKS_UPDATED = 'hlsAudioTracksUpdated'),
                    (t.AUDIO_TRACK_SWITCHING = 'hlsAudioTrackSwitching'),
                    (t.AUDIO_TRACK_SWITCHED = 'hlsAudioTrackSwitched'),
                    (t.AUDIO_TRACK_LOADING = 'hlsAudioTrackLoading'),
                    (t.AUDIO_TRACK_LOADED = 'hlsAudioTrackLoaded'),
                    (t.SUBTITLE_TRACKS_UPDATED = 'hlsSubtitleTracksUpdated'),
                    (t.SUBTITLE_TRACKS_CLEARED = 'hlsSubtitleTracksCleared'),
                    (t.SUBTITLE_TRACK_SWITCH = 'hlsSubtitleTrackSwitch'),
                    (t.SUBTITLE_TRACK_LOADING = 'hlsSubtitleTrackLoading'),
                    (t.SUBTITLE_TRACK_LOADED = 'hlsSubtitleTrackLoaded'),
                    (t.SUBTITLE_FRAG_PROCESSED = 'hlsSubtitleFragProcessed'),
                    (t.CUES_PARSED = 'hlsCuesParsed'),
                    (t.NON_NATIVE_TEXT_TRACKS_FOUND = 'hlsNonNativeTextTracksFound'),
                    (t.INIT_PTS_FOUND = 'hlsInitPtsFound'),
                    (t.FRAG_LOADING = 'hlsFragLoading'),
                    (t.FRAG_LOAD_EMERGENCY_ABORTED = 'hlsFragLoadEmergencyAborted'),
                    (t.FRAG_LOADED = 'hlsFragLoaded'),
                    (t.FRAG_DECRYPTED = 'hlsFragDecrypted'),
                    (t.FRAG_PARSING_INIT_SEGMENT = 'hlsFragParsingInitSegment'),
                    (t.FRAG_PARSING_USERDATA = 'hlsFragParsingUserdata'),
                    (t.FRAG_PARSING_METADATA = 'hlsFragParsingMetadata'),
                    (t.FRAG_PARSED = 'hlsFragParsed'),
                    (t.FRAG_BUFFERED = 'hlsFragBuffered'),
                    (t.FRAG_CHANGED = 'hlsFragChanged'),
                    (t.FPS_DROP = 'hlsFpsDrop'),
                    (t.FPS_DROP_LEVEL_CAPPING = 'hlsFpsDropLevelCapping'),
                    (t.ERROR = 'hlsError'),
                    (t.DESTROYING = 'hlsDestroying'),
                    (t.KEY_LOADING = 'hlsKeyLoading'),
                    (t.KEY_LOADED = 'hlsKeyLoaded'),
                    (t.LIVE_BACK_BUFFER_REACHED = 'hlsLiveBackBufferReached'),
                    (t.BACK_BUFFER_REACHED = 'hlsBackBufferReached');
                })(i || (i = {}));
            },
          './src/hls.ts':
            /*!********************!*\
  !*** ./src/hls.ts ***!
  \********************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return y;
                });
              const i = r(/*! url-toolkit */ './node_modules/url-toolkit/src/url-toolkit.js'),
                n = r(/*! ./loader/playlist-loader */ './src/loader/playlist-loader.ts'),
                s = r(/*! ./loader/key-loader */ './src/loader/key-loader.ts'),
                a = r(/*! ./controller/id3-track-controller */ './src/controller/id3-track-controller.ts'),
                o = r(/*! ./controller/latency-controller */ './src/controller/latency-controller.ts'),
                l = r(/*! ./controller/level-controller */ './src/controller/level-controller.ts'),
                u = r(/*! ./controller/fragment-tracker */ './src/controller/fragment-tracker.ts'),
                c = r(/*! ./controller/stream-controller */ './src/controller/stream-controller.ts'),
                d = r(/*! ./is-supported */ './src/is-supported.ts'),
                f = r(/*! ./utils/logger */ './src/utils/logger.ts'),
                h = r(/*! ./config */ './src/config.ts'),
                p = r(/*! eventemitter3 */ './node_modules/eventemitter3/index.js'),
                v = r(/*! ./events */ './src/events.ts'),
                g = r(/*! ./errors */ './src/errors.ts');
              function m(t, e) {
                for (let r = 0; r < e.length; r++) {
                  const i = e[r];
                  (i.enumerable = i.enumerable || !1),
                    (i.configurable = !0),
                    'value' in i && (i.writable = !0),
                    Object.defineProperty(t, i.key, i);
                }
              }
              var y = (function () {
                function t(e) {
                  void 0 === e && (e = {}),
                    (this.config = void 0),
                    (this.userConfig = void 0),
                    (this.coreComponents = void 0),
                    (this.networkControllers = void 0),
                    (this._emitter = new p.EventEmitter()),
                    (this._autoLevelCapping = void 0),
                    (this.abrController = void 0),
                    (this.bufferController = void 0),
                    (this.capLevelController = void 0),
                    (this.latencyController = void 0),
                    (this.levelController = void 0),
                    (this.streamController = void 0),
                    (this.audioTrackController = void 0),
                    (this.subtitleTrackController = void 0),
                    (this.emeController = void 0),
                    (this.cmcdController = void 0),
                    (this._media = null),
                    (this.url = null);
                  const r = (this.config = Object(h.mergeConfig)(t.DefaultConfig, e));
                  (this.userConfig = e),
                    Object(f.enableLogs)(r.debug),
                    (this._autoLevelCapping = -1),
                    r.progressive && Object(h.enableStreamingMode)(r);
                  const i = r.abrController,
                    d = r.bufferController,
                    v = r.capLevelController,
                    g = r.fpsController,
                    m = (this.abrController = new i(this)),
                    y = (this.bufferController = new d(this)),
                    E = (this.capLevelController = new v(this)),
                    T = new g(this),
                    b = new n.default(this),
                    S = new s.default(this),
                    L = new a.default(this),
                    A = (this.levelController = new l.default(this)),
                    D = new u.FragmentTracker(this),
                    k = (this.streamController = new c.default(this, D));
                  E.setStreamController(k), T.setStreamController(k);
                  const C = [A, k];
                  this.networkControllers = C;
                  const x = [b, S, m, y, E, T, L, D];
                  (this.audioTrackController = this.createController(r.audioTrackController, null, C)),
                    this.createController(r.audioStreamController, D, C),
                    (this.subtitleTrackController = this.createController(r.subtitleTrackController, null, C)),
                    this.createController(r.subtitleStreamController, D, C),
                    this.createController(r.timelineController, null, x),
                    (this.emeController = this.createController(r.emeController, null, x)),
                    (this.cmcdController = this.createController(r.cmcdController, null, x)),
                    (this.latencyController = this.createController(o.default, null, x)),
                    (this.coreComponents = x);
                }
                t.isSupported = function () {
                  return Object(d.isSupported)();
                };
                const e = t.prototype;
                return (
                  (e.createController = function (t, e, r) {
                    if (t) {
                      const i = e ? new t(this, e) : new t(this);
                      return r && r.push(i), i;
                    }
                    return null;
                  }),
                  (e.on = function (t, e, r) {
                    void 0 === r && (r = this), this._emitter.on(t, e, r);
                  }),
                  (e.once = function (t, e, r) {
                    void 0 === r && (r = this), this._emitter.once(t, e, r);
                  }),
                  (e.removeAllListeners = function (t) {
                    this._emitter.removeAllListeners(t);
                  }),
                  (e.off = function (t, e, r, i) {
                    void 0 === r && (r = this), this._emitter.off(t, e, r, i);
                  }),
                  (e.listeners = function (t) {
                    return this._emitter.listeners(t);
                  }),
                  (e.emit = function (t, e, r) {
                    return this._emitter.emit(t, e, r);
                  }),
                  (e.trigger = function (t, e) {
                    if (this.config.debug) return this.emit(t, t, e);
                    try {
                      return this.emit(t, t, e);
                    } catch (e) {
                      f.logger.error(
                        'An internal error happened while handling event ' +
                          t +
                          '. Error message: "' +
                          e.message +
                          '". Here is a stacktrace:',
                        e
                      ),
                        this.trigger(v.Events.ERROR, {
                          type: g.ErrorTypes.OTHER_ERROR,
                          details: g.ErrorDetails.INTERNAL_EXCEPTION,
                          fatal: !1,
                          event: t,
                          error: e,
                        });
                    }
                    return !1;
                  }),
                  (e.listenerCount = function (t) {
                    return this._emitter.listenerCount(t);
                  }),
                  (e.destroy = function () {
                    f.logger.log('destroy'),
                      this.trigger(v.Events.DESTROYING, void 0),
                      this.detachMedia(),
                      this.removeAllListeners(),
                      (this._autoLevelCapping = -1),
                      (this.url = null),
                      this.networkControllers.forEach(function (t) {
                        return t.destroy();
                      }),
                      (this.networkControllers.length = 0),
                      this.coreComponents.forEach(function (t) {
                        return t.destroy();
                      }),
                      (this.coreComponents.length = 0);
                  }),
                  (e.attachMedia = function (t) {
                    f.logger.log('attachMedia'),
                      (this._media = t),
                      this.trigger(v.Events.MEDIA_ATTACHING, { media: t });
                  }),
                  (e.detachMedia = function () {
                    f.logger.log('detachMedia'), this.trigger(v.Events.MEDIA_DETACHING, void 0), (this._media = null);
                  }),
                  (e.loadSource = function (t) {
                    this.stopLoad();
                    const e = this.media,
                      r = this.url,
                      n = (this.url = i.buildAbsoluteURL(self.location.href, t, { alwaysNormalize: !0 }));
                    f.logger.log('loadSource:' + n),
                      e &&
                        r &&
                        r !== n &&
                        this.bufferController.hasSourceTypes() &&
                        (this.detachMedia(), this.attachMedia(e)),
                      this.trigger(v.Events.MANIFEST_LOADING, { url: t });
                  }),
                  (e.startLoad = function (t) {
                    void 0 === t && (t = -1),
                      f.logger.log('startLoad(' + t + ')'),
                      this.networkControllers.forEach(function (e) {
                        e.startLoad(t);
                      });
                  }),
                  (e.stopLoad = function () {
                    f.logger.log('stopLoad'),
                      this.networkControllers.forEach(function (t) {
                        t.stopLoad();
                      });
                  }),
                  (e.swapAudioCodec = function () {
                    f.logger.log('swapAudioCodec'), this.streamController.swapAudioCodec();
                  }),
                  (e.recoverMediaError = function () {
                    f.logger.log('recoverMediaError');
                    const t = this._media;
                    this.detachMedia(), t && this.attachMedia(t);
                  }),
                  (e.removeLevel = function (t, e) {
                    void 0 === e && (e = 0), this.levelController.removeLevel(t, e);
                  }),
                  (function (t, e, r) {
                    e && m(t.prototype, e), r && m(t, r);
                  })(
                    t,
                    [
                      {
                        key: 'levels',
                        get: function () {
                          const t = this.levelController.levels;
                          return t || [];
                        },
                      },
                      {
                        key: 'currentLevel',
                        get: function () {
                          return this.streamController.currentLevel;
                        },
                        set: function (t) {
                          f.logger.log('set currentLevel:' + t),
                            (this.loadLevel = t),
                            this.abrController.clearTimer(),
                            this.streamController.immediateLevelSwitch();
                        },
                      },
                      {
                        key: 'nextLevel',
                        get: function () {
                          return this.streamController.nextLevel;
                        },
                        set: function (t) {
                          f.logger.log('set nextLevel:' + t),
                            (this.levelController.manualLevel = t),
                            this.streamController.nextLevelSwitch();
                        },
                      },
                      {
                        key: 'loadLevel',
                        get: function () {
                          return this.levelController.level;
                        },
                        set: function (t) {
                          f.logger.log('set loadLevel:' + t), (this.levelController.manualLevel = t);
                        },
                      },
                      {
                        key: 'nextLoadLevel',
                        get: function () {
                          return this.levelController.nextLoadLevel;
                        },
                        set: function (t) {
                          this.levelController.nextLoadLevel = t;
                        },
                      },
                      {
                        key: 'firstLevel',
                        get: function () {
                          return Math.max(this.levelController.firstLevel, this.minAutoLevel);
                        },
                        set: function (t) {
                          f.logger.log('set firstLevel:' + t), (this.levelController.firstLevel = t);
                        },
                      },
                      {
                        key: 'startLevel',
                        get: function () {
                          return this.levelController.startLevel;
                        },
                        set: function (t) {
                          f.logger.log('set startLevel:' + t),
                            -1 !== t && (t = Math.max(t, this.minAutoLevel)),
                            (this.levelController.startLevel = t);
                        },
                      },
                      {
                        key: 'capLevelToPlayerSize',
                        get: function () {
                          return this.config.capLevelToPlayerSize;
                        },
                        set: function (t) {
                          const e = !!t;
                          e !== this.config.capLevelToPlayerSize &&
                            (e
                              ? this.capLevelController.startCapping()
                              : (this.capLevelController.stopCapping(),
                                (this.autoLevelCapping = -1),
                                this.streamController.nextLevelSwitch()),
                            (this.config.capLevelToPlayerSize = e));
                        },
                      },
                      {
                        key: 'autoLevelCapping',
                        get: function () {
                          return this._autoLevelCapping;
                        },
                        set: function (t) {
                          this._autoLevelCapping !== t &&
                            (f.logger.log('set autoLevelCapping:' + t), (this._autoLevelCapping = t));
                        },
                      },
                      {
                        key: 'bandwidthEstimate',
                        get: function () {
                          const t = this.abrController.bwEstimator;
                          return t ? t.getEstimate() : NaN;
                        },
                      },
                      {
                        key: 'autoLevelEnabled',
                        get: function () {
                          return -1 === this.levelController.manualLevel;
                        },
                      },
                      {
                        key: 'manualLevel',
                        get: function () {
                          return this.levelController.manualLevel;
                        },
                      },
                      {
                        key: 'minAutoLevel',
                        get: function () {
                          const t = this.levels,
                            e = this.config.minAutoBitrate;
                          if (!t) return 0;
                          for (let r = t.length, i = 0; i < r; i++) if (t[i].maxBitrate > e) return i;
                          return 0;
                        },
                      },
                      {
                        key: 'maxAutoLevel',
                        get: function () {
                          const t = this.levels,
                            e = this.autoLevelCapping;
                          return -1 === e && t && t.length ? t.length - 1 : e;
                        },
                      },
                      {
                        key: 'nextAutoLevel',
                        get: function () {
                          return Math.min(
                            Math.max(this.abrController.nextAutoLevel, this.minAutoLevel),
                            this.maxAutoLevel
                          );
                        },
                        set: function (t) {
                          this.abrController.nextAutoLevel = Math.max(this.minAutoLevel, t);
                        },
                      },
                      {
                        key: 'audioTracks',
                        get: function () {
                          const t = this.audioTrackController;
                          return t ? t.audioTracks : [];
                        },
                      },
                      {
                        key: 'audioTrack',
                        get: function () {
                          const t = this.audioTrackController;
                          return t ? t.audioTrack : -1;
                        },
                        set: function (t) {
                          const e = this.audioTrackController;
                          e && (e.audioTrack = t);
                        },
                      },
                      {
                        key: 'subtitleTracks',
                        get: function () {
                          const t = this.subtitleTrackController;
                          return t ? t.subtitleTracks : [];
                        },
                      },
                      {
                        key: 'subtitleTrack',
                        get: function () {
                          const t = this.subtitleTrackController;
                          return t ? t.subtitleTrack : -1;
                        },
                        set: function (t) {
                          const e = this.subtitleTrackController;
                          e && (e.subtitleTrack = t);
                        },
                      },
                      {
                        key: 'media',
                        get: function () {
                          return this._media;
                        },
                      },
                      {
                        key: 'subtitleDisplay',
                        get: function () {
                          const t = this.subtitleTrackController;
                          return !!t && t.subtitleDisplay;
                        },
                        set: function (t) {
                          const e = this.subtitleTrackController;
                          e && (e.subtitleDisplay = t);
                        },
                      },
                      {
                        key: 'lowLatencyMode',
                        get: function () {
                          return this.config.lowLatencyMode;
                        },
                        set: function (t) {
                          this.config.lowLatencyMode = t;
                        },
                      },
                      {
                        key: 'liveSyncPosition',
                        get: function () {
                          return this.latencyController.liveSyncPosition;
                        },
                      },
                      {
                        key: 'latency',
                        get: function () {
                          return this.latencyController.latency;
                        },
                      },
                      {
                        key: 'maxLatency',
                        get: function () {
                          return this.latencyController.maxLatency;
                        },
                      },
                      {
                        key: 'targetLatency',
                        get: function () {
                          return this.latencyController.targetLatency;
                        },
                      },
                      {
                        key: 'drift',
                        get: function () {
                          return this.latencyController.drift;
                        },
                      },
                      {
                        key: 'forceStartLoad',
                        get: function () {
                          return this.streamController.forceStartLoad;
                        },
                      },
                    ],
                    [
                      {
                        key: 'version',
                        get: function () {
                          return '1.1.5';
                        },
                      },
                      {
                        key: 'Events',
                        get: function () {
                          return v.Events;
                        },
                      },
                      {
                        key: 'ErrorTypes',
                        get: function () {
                          return g.ErrorTypes;
                        },
                      },
                      {
                        key: 'ErrorDetails',
                        get: function () {
                          return g.ErrorDetails;
                        },
                      },
                      {
                        key: 'DefaultConfig',
                        get: function () {
                          return t.defaultConfig ? t.defaultConfig : h.hlsDefaultConfig;
                        },
                        set: function (e) {
                          t.defaultConfig = e;
                        },
                      },
                    ]
                  ),
                  t
                );
              })();
              y.defaultConfig = void 0;
            },
          './src/is-supported.ts':
            /*!*****************************!*\
  !*** ./src/is-supported.ts ***!
  \*****************************/
            /*! exports provided: isSupported, changeTypeSupported */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'isSupported', function () {
                  return s;
                }),
                r.d(e, 'changeTypeSupported', function () {
                  return a;
                });
              const i = r(/*! ./utils/mediasource-helper */ './src/utils/mediasource-helper.ts');
              function n() {
                return self.SourceBuffer || self.WebKitSourceBuffer;
              }
              function s() {
                const t = Object(i.getMediaSource)();
                if (!t) return !1;
                const e = n(),
                  r =
                    t &&
                    'function' == typeof t.isTypeSupported &&
                    t.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'),
                  s =
                    !e ||
                    (e.prototype &&
                      'function' == typeof e.prototype.appendBuffer &&
                      'function' == typeof e.prototype.remove);
                return !!r && !!s;
              }
              function a() {
                let t,
                  e = n();
                return (
                  'function' ==
                  typeof (null === e || void 0 === e
                    ? void 0
                    : null === (t = e.prototype) || void 0 === t
                      ? void 0
                      : t.changeType)
                );
              }
            },
          './src/loader/fragment-loader.ts':
            /*!***************************************!*\
  !*** ./src/loader/fragment-loader.ts ***!
  \***************************************/
            /*! exports provided: default, LoadError */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return c;
                }),
                r.d(e, 'LoadError', function () {
                  return f;
                });
              const i = r(/*! ./src/polyfills/number */ './src/polyfills/number.ts'),
                n = r(/*! ../errors */ './src/errors.ts');
              function s(t) {
                const e = 'function' == typeof Map ? new Map() : void 0;
                return (s = function (t) {
                  if (
                    null === t ||
                    !(function (t) {
                      return -1 !== Function.toString.call(t).indexOf('[native code]');
                    })(t)
                  )
                    return t;
                  if ('function' != typeof t) throw new TypeError('Super expression must either be null or a function');
                  if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, r);
                  }
                  function r() {
                    return a(t, arguments, l(this).constructor);
                  }
                  return (
                    (r.prototype = Object.create(t.prototype, {
                      constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 },
                    })),
                    o(r, t)
                  );
                })(t);
              }
              function a(t, e, r) {
                return (a = (function () {
                  if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ('function' == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (t) {
                    return !1;
                  }
                })()
                  ? Reflect.construct
                  : function (t, e, r) {
                      const i = [null];
                      i.push.apply(i, e);
                      const n = new (Function.bind.apply(t, i))();
                      return r && o(n, r.prototype), n;
                    }).apply(null, arguments);
              }
              function o(t, e) {
                return (o =
                  Object.setPrototypeOf ||
                  function (t, e) {
                    return (t.__proto__ = e), t;
                  })(t, e);
              }
              function l(t) {
                return (l = Object.setPrototypeOf
                  ? Object.getPrototypeOf
                  : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                    })(t);
              }
              var u = Math.pow(2, 17),
                c = (function () {
                  function t(t) {
                    (this.config = void 0), (this.loader = null), (this.partLoadTimeout = -1), (this.config = t);
                  }
                  const e = t.prototype;
                  return (
                    (e.destroy = function () {
                      this.loader && (this.loader.destroy(), (this.loader = null));
                    }),
                    (e.abort = function () {
                      this.loader && this.loader.abort();
                    }),
                    (e.load = function (t, e) {
                      const r = this,
                        i = t.url;
                      if (!i)
                        return Promise.reject(
                          new f(
                            {
                              type: n.ErrorTypes.NETWORK_ERROR,
                              details: n.ErrorDetails.FRAG_LOAD_ERROR,
                              fatal: !1,
                              frag: t,
                              networkDetails: null,
                            },
                            'Fragment does not have a ' + (i ? 'part list' : 'url')
                          )
                        );
                      this.abort();
                      const s = this.config,
                        a = s.fLoader,
                        o = s.loader;
                      return new Promise(function (i, l) {
                        r.loader && r.loader.destroy();
                        const c = (r.loader = t.loader = a ? new a(s) : new o(s)),
                          h = d(t),
                          p = {
                            timeout: s.fragLoadingTimeOut,
                            maxRetry: 0,
                            retryDelay: 0,
                            maxRetryDelay: s.fragLoadingMaxRetryTimeout,
                            highWaterMark: u,
                          };
                        (t.stats = c.stats),
                          c.load(h, p, {
                            onSuccess: function (e, n, s, a) {
                              r.resetLoader(t, c), i({ frag: t, part: null, payload: e.data, networkDetails: a });
                            },
                            onError: function (e, i, s) {
                              r.resetLoader(t, c),
                                l(
                                  new f({
                                    type: n.ErrorTypes.NETWORK_ERROR,
                                    details: n.ErrorDetails.FRAG_LOAD_ERROR,
                                    fatal: !1,
                                    frag: t,
                                    response: e,
                                    networkDetails: s,
                                  })
                                );
                            },
                            onAbort: function (e, i, s) {
                              r.resetLoader(t, c),
                                l(
                                  new f({
                                    type: n.ErrorTypes.NETWORK_ERROR,
                                    details: n.ErrorDetails.INTERNAL_ABORTED,
                                    fatal: !1,
                                    frag: t,
                                    networkDetails: s,
                                  })
                                );
                            },
                            onTimeout: function (e, i, s) {
                              r.resetLoader(t, c),
                                l(
                                  new f({
                                    type: n.ErrorTypes.NETWORK_ERROR,
                                    details: n.ErrorDetails.FRAG_LOAD_TIMEOUT,
                                    fatal: !1,
                                    frag: t,
                                    networkDetails: s,
                                  })
                                );
                            },
                            onProgress: function (r, i, n, s) {
                              e && e({ frag: t, part: null, payload: n, networkDetails: s });
                            },
                          });
                      });
                    }),
                    (e.loadPart = function (t, e, r) {
                      const i = this;
                      this.abort();
                      const s = this.config,
                        a = s.fLoader,
                        o = s.loader;
                      return new Promise(function (l, c) {
                        i.loader && i.loader.destroy();
                        const h = (i.loader = t.loader = a ? new a(s) : new o(s)),
                          p = d(t, e),
                          v = {
                            timeout: s.fragLoadingTimeOut,
                            maxRetry: 0,
                            retryDelay: 0,
                            maxRetryDelay: s.fragLoadingMaxRetryTimeout,
                            highWaterMark: u,
                          };
                        (e.stats = h.stats),
                          h.load(p, v, {
                            onSuccess: function (n, s, a, o) {
                              i.resetLoader(t, h), i.updateStatsFromPart(t, e);
                              const u = { frag: t, part: e, payload: n.data, networkDetails: o };
                              r(u), l(u);
                            },
                            onError: function (r, s, a) {
                              i.resetLoader(t, h),
                                c(
                                  new f({
                                    type: n.ErrorTypes.NETWORK_ERROR,
                                    details: n.ErrorDetails.FRAG_LOAD_ERROR,
                                    fatal: !1,
                                    frag: t,
                                    part: e,
                                    response: r,
                                    networkDetails: a,
                                  })
                                );
                            },
                            onAbort: function (r, s, a) {
                              (t.stats.aborted = e.stats.aborted),
                                i.resetLoader(t, h),
                                c(
                                  new f({
                                    type: n.ErrorTypes.NETWORK_ERROR,
                                    details: n.ErrorDetails.INTERNAL_ABORTED,
                                    fatal: !1,
                                    frag: t,
                                    part: e,
                                    networkDetails: a,
                                  })
                                );
                            },
                            onTimeout: function (r, s, a) {
                              i.resetLoader(t, h),
                                c(
                                  new f({
                                    type: n.ErrorTypes.NETWORK_ERROR,
                                    details: n.ErrorDetails.FRAG_LOAD_TIMEOUT,
                                    fatal: !1,
                                    frag: t,
                                    part: e,
                                    networkDetails: a,
                                  })
                                );
                            },
                          });
                      });
                    }),
                    (e.updateStatsFromPart = function (t, e) {
                      const r = t.stats,
                        i = e.stats,
                        n = i.total;
                      if (((r.loaded += i.loaded), n)) {
                        const s = Math.round(t.duration / e.duration),
                          a = Math.min(Math.round(r.loaded / n), s),
                          o = (s - a) * Math.round(r.loaded / a);
                        r.total = r.loaded + o;
                      } else r.total = Math.max(r.loaded, r.total);
                      const l = r.loading,
                        u = i.loading;
                      l.start ? (l.first += u.first - u.start) : ((l.start = u.start), (l.first = u.first)),
                        (l.end = u.end);
                    }),
                    (e.resetLoader = function (t, e) {
                      (t.loader = null),
                        this.loader === e && (self.clearTimeout(this.partLoadTimeout), (this.loader = null)),
                        e.destroy();
                    }),
                    t
                  );
                })();
              function d(t, e) {
                void 0 === e && (e = null);
                const r = e || t,
                  n = {
                    frag: t,
                    part: e,
                    responseType: 'arraybuffer',
                    url: r.url,
                    headers: {},
                    rangeStart: 0,
                    rangeEnd: 0,
                  },
                  s = r.byteRangeStartOffset,
                  a = r.byteRangeEndOffset;
                return (
                  Object(i.isFiniteNumber)(s) && Object(i.isFiniteNumber)(a) && ((n.rangeStart = s), (n.rangeEnd = a)),
                  n
                );
              }
              var f = (function (t) {
                function e(e) {
                  for (var r, i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++)
                    n[s - 1] = arguments[s];
                  return ((r = t.call.apply(t, [this].concat(n)) || this).data = void 0), (r.data = e), r;
                }
                return (
                  (function (t, e) {
                    (t.prototype = Object.create(e.prototype)), (t.prototype.constructor = t), o(t, e);
                  })(e, t),
                  e
                );
              })(s(Error));
            },
          './src/loader/fragment.ts':
            /*!********************************!*\
  !*** ./src/loader/fragment.ts ***!
  \********************************/
            /*! exports provided: ElementaryStreamTypes, BaseSegment, Fragment, Part */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'ElementaryStreamTypes', function () {
                  return i;
                }),
                r.d(e, 'BaseSegment', function () {
                  return h;
                }),
                r.d(e, 'Fragment', function () {
                  return p;
                }),
                r.d(e, 'Part', function () {
                  return v;
                });
              let i,
                n = r(/*! ./src/polyfills/number */ './src/polyfills/number.ts'),
                s = r(/*! url-toolkit */ './node_modules/url-toolkit/src/url-toolkit.js'),
                a = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                o = r(/*! ./level-key */ './src/loader/level-key.ts'),
                l = r(/*! ./load-stats */ './src/loader/load-stats.ts');
              function u(t, e) {
                (t.prototype = Object.create(e.prototype)), (t.prototype.constructor = t), c(t, e);
              }
              function c(t, e) {
                return (c =
                  Object.setPrototypeOf ||
                  function (t, e) {
                    return (t.__proto__ = e), t;
                  })(t, e);
              }
              function d(t, e) {
                for (let r = 0; r < e.length; r++) {
                  const i = e[r];
                  (i.enumerable = i.enumerable || !1),
                    (i.configurable = !0),
                    'value' in i && (i.writable = !0),
                    Object.defineProperty(t, i.key, i);
                }
              }
              function f(t, e, r) {
                return e && d(t.prototype, e), r && d(t, r), t;
              }
              !(function (t) {
                (t.AUDIO = 'audio'), (t.VIDEO = 'video'), (t.AUDIOVIDEO = 'audiovideo');
              })(i || (i = {}));
              var h = (function () {
                  function t(t) {
                    let e;
                    (this._byteRange = null),
                      (this._url = null),
                      (this.baseurl = void 0),
                      (this.relurl = void 0),
                      (this.elementaryStreams =
                        (((e = {})[i.AUDIO] = null), (e[i.VIDEO] = null), (e[i.AUDIOVIDEO] = null), e)),
                      (this.baseurl = t);
                  }
                  return (
                    (t.prototype.setByteRange = function (t, e) {
                      const r = t.split('@', 2),
                        i = [];
                      1 === r.length ? (i[0] = e ? e.byteRangeEndOffset : 0) : (i[0] = parseInt(r[1])),
                        (i[1] = parseInt(r[0]) + i[0]),
                        (this._byteRange = i);
                    }),
                    f(t, [
                      {
                        key: 'byteRange',
                        get: function () {
                          return this._byteRange ? this._byteRange : [];
                        },
                      },
                      {
                        key: 'byteRangeStartOffset',
                        get: function () {
                          return this.byteRange[0];
                        },
                      },
                      {
                        key: 'byteRangeEndOffset',
                        get: function () {
                          return this.byteRange[1];
                        },
                      },
                      {
                        key: 'url',
                        get: function () {
                          return (
                            !this._url &&
                              this.baseurl &&
                              this.relurl &&
                              (this._url = Object(s.buildAbsoluteURL)(this.baseurl, this.relurl, {
                                alwaysNormalize: !0,
                              })),
                            this._url || ''
                          );
                        },
                        set: function (t) {
                          this._url = t;
                        },
                      },
                    ]),
                    t
                  );
                })(),
                p = (function (t) {
                  function e(e, r) {
                    let i;
                    return (
                      ((i = t.call(this, r) || this)._decryptdata = null),
                      (i.rawProgramDateTime = null),
                      (i.programDateTime = null),
                      (i.tagList = []),
                      (i.duration = 0),
                      (i.sn = 0),
                      (i.levelkey = void 0),
                      (i.type = void 0),
                      (i.loader = null),
                      (i.level = -1),
                      (i.cc = 0),
                      (i.startPTS = void 0),
                      (i.endPTS = void 0),
                      (i.appendedPTS = void 0),
                      (i.startDTS = void 0),
                      (i.endDTS = void 0),
                      (i.start = 0),
                      (i.deltaPTS = void 0),
                      (i.maxStartPTS = void 0),
                      (i.minEndPTS = void 0),
                      (i.stats = new l.LoadStats()),
                      (i.urlId = 0),
                      (i.data = void 0),
                      (i.bitrateTest = !1),
                      (i.title = null),
                      (i.initSegment = null),
                      (i.type = e),
                      i
                    );
                  }
                  u(e, t);
                  const r = e.prototype;
                  return (
                    (r.createInitializationVector = function (t) {
                      for (var e = new Uint8Array(16), r = 12; r < 16; r++) e[r] = (t >> (8 * (15 - r))) & 255;
                      return e;
                    }),
                    (r.setDecryptDataFromLevelKey = function (t, e) {
                      let r = t;
                      return (
                        'AES-128' === (null === t || void 0 === t ? void 0 : t.method) &&
                          t.uri &&
                          !t.iv &&
                          (((r = o.LevelKey.fromURI(t.uri)).method = t.method),
                          (r.iv = this.createInitializationVector(e)),
                          (r.keyFormat = 'identity')),
                        r
                      );
                    }),
                    (r.setElementaryStreamInfo = function (t, e, r, i, n, s) {
                      void 0 === s && (s = !1);
                      const a = this.elementaryStreams,
                        o = a[t];
                      o
                        ? ((o.startPTS = Math.min(o.startPTS, e)),
                          (o.endPTS = Math.max(o.endPTS, r)),
                          (o.startDTS = Math.min(o.startDTS, i)),
                          (o.endDTS = Math.max(o.endDTS, n)))
                        : (a[t] = { startPTS: e, endPTS: r, startDTS: i, endDTS: n, partial: s });
                    }),
                    (r.clearElementaryStreamInfo = function () {
                      const t = this.elementaryStreams;
                      (t[i.AUDIO] = null), (t[i.VIDEO] = null), (t[i.AUDIOVIDEO] = null);
                    }),
                    f(e, [
                      {
                        key: 'decryptdata',
                        get: function () {
                          if (!this.levelkey && !this._decryptdata) return null;
                          if (!this._decryptdata && this.levelkey) {
                            let t = this.sn;
                            'number' != typeof t &&
                              (this.levelkey &&
                                'AES-128' === this.levelkey.method &&
                                !this.levelkey.iv &&
                                a.logger.warn(
                                  'missing IV for initialization segment with method="' +
                                    this.levelkey.method +
                                    '" - compliance issue'
                                ),
                              (t = 0)),
                              (this._decryptdata = this.setDecryptDataFromLevelKey(this.levelkey, t));
                          }
                          return this._decryptdata;
                        },
                      },
                      {
                        key: 'end',
                        get: function () {
                          return this.start + this.duration;
                        },
                      },
                      {
                        key: 'endProgramDateTime',
                        get: function () {
                          if (null === this.programDateTime) return null;
                          if (!Object(n.isFiniteNumber)(this.programDateTime)) return null;
                          const t = Object(n.isFiniteNumber)(this.duration) ? this.duration : 0;
                          return this.programDateTime + 1e3 * t;
                        },
                      },
                      {
                        key: 'encrypted',
                        get: function () {
                          let t;
                          return !(
                            null === (t = this.decryptdata) ||
                            void 0 === t ||
                            !t.keyFormat ||
                            !this.decryptdata.uri
                          );
                        },
                      },
                    ]),
                    e
                  );
                })(h),
                v = (function (t) {
                  function e(e, r, i, n, s) {
                    let a;
                    ((a = t.call(this, i) || this).fragOffset = 0),
                      (a.duration = 0),
                      (a.gap = !1),
                      (a.independent = !1),
                      (a.relurl = void 0),
                      (a.fragment = void 0),
                      (a.index = void 0),
                      (a.stats = new l.LoadStats()),
                      (a.duration = e.decimalFloatingPoint('DURATION')),
                      (a.gap = e.bool('GAP')),
                      (a.independent = e.bool('INDEPENDENT')),
                      (a.relurl = e.enumeratedString('URI')),
                      (a.fragment = r),
                      (a.index = n);
                    const o = e.enumeratedString('BYTERANGE');
                    return o && a.setByteRange(o, s), s && (a.fragOffset = s.fragOffset + s.duration), a;
                  }
                  return (
                    u(e, t),
                    f(e, [
                      {
                        key: 'start',
                        get: function () {
                          return this.fragment.start + this.fragOffset;
                        },
                      },
                      {
                        key: 'end',
                        get: function () {
                          return this.start + this.duration;
                        },
                      },
                      {
                        key: 'loaded',
                        get: function () {
                          const t = this.elementaryStreams;
                          return !!(t.audio || t.video || t.audiovideo);
                        },
                      },
                    ]),
                    e
                  );
                })(h);
            },
          './src/loader/key-loader.ts':
            /*!**********************************!*\
  !*** ./src/loader/key-loader.ts ***!
  \**********************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return a;
                });
              var i = r(/*! ../events */ './src/events.ts'),
                n = r(/*! ../errors */ './src/errors.ts'),
                s = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                a = (function () {
                  function t(t) {
                    (this.hls = void 0),
                      (this.loaders = {}),
                      (this.decryptkey = null),
                      (this.decrypturl = null),
                      (this.hls = t),
                      this._registerListeners();
                  }
                  const e = t.prototype;
                  return (
                    (e._registerListeners = function () {
                      this.hls.on(i.Events.KEY_LOADING, this.onKeyLoading, this);
                    }),
                    (e._unregisterListeners = function () {
                      this.hls.off(i.Events.KEY_LOADING, this.onKeyLoading);
                    }),
                    (e.destroy = function () {
                      for (const t in (this._unregisterListeners(), this.loaders)) {
                        const e = this.loaders[t];
                        e && e.destroy();
                      }
                      this.loaders = {};
                    }),
                    (e.onKeyLoading = function (t, e) {
                      const r = e.frag,
                        n = r.type,
                        a = this.loaders[n];
                      if (r.decryptdata) {
                        const o = r.decryptdata.uri;
                        if (o !== this.decrypturl || null === this.decryptkey) {
                          const l = this.hls.config;
                          if ((a && (s.logger.warn('abort previous key loader for type:' + n), a.abort()), !o))
                            return void s.logger.warn('key uri is falsy');
                          const u = l.loader,
                            c = (r.loader = this.loaders[n] = new u(l));
                          (this.decrypturl = o), (this.decryptkey = null);
                          const d = { url: o, frag: r, responseType: 'arraybuffer' },
                            f = {
                              timeout: l.fragLoadingTimeOut,
                              maxRetry: 0,
                              retryDelay: l.fragLoadingRetryDelay,
                              maxRetryDelay: l.fragLoadingMaxRetryTimeout,
                              highWaterMark: 0,
                            },
                            h = {
                              onSuccess: this.loadsuccess.bind(this),
                              onError: this.loaderror.bind(this),
                              onTimeout: this.loadtimeout.bind(this),
                            };
                          c.load(d, f, h);
                        } else
                          this.decryptkey &&
                            ((r.decryptdata.key = this.decryptkey), this.hls.trigger(i.Events.KEY_LOADED, { frag: r }));
                      } else s.logger.warn('Missing decryption data on fragment in onKeyLoading');
                    }),
                    (e.loadsuccess = function (t, e, r) {
                      const n = r.frag;
                      n.decryptdata
                        ? ((this.decryptkey = n.decryptdata.key = new Uint8Array(t.data)),
                          (n.loader = null),
                          delete this.loaders[n.type],
                          this.hls.trigger(i.Events.KEY_LOADED, { frag: n }))
                        : s.logger.error('after key load, decryptdata unset');
                    }),
                    (e.loaderror = function (t, e) {
                      const r = e.frag,
                        s = r.loader;
                      s && s.abort(),
                        delete this.loaders[r.type],
                        this.hls.trigger(i.Events.ERROR, {
                          type: n.ErrorTypes.NETWORK_ERROR,
                          details: n.ErrorDetails.KEY_LOAD_ERROR,
                          fatal: !1,
                          frag: r,
                          response: t,
                        });
                    }),
                    (e.loadtimeout = function (t, e) {
                      const r = e.frag,
                        s = r.loader;
                      s && s.abort(),
                        delete this.loaders[r.type],
                        this.hls.trigger(i.Events.ERROR, {
                          type: n.ErrorTypes.NETWORK_ERROR,
                          details: n.ErrorDetails.KEY_LOAD_TIMEOUT,
                          fatal: !1,
                          frag: r,
                        });
                    }),
                    t
                  );
                })();
            },
          './src/loader/level-details.ts':
            /*!*************************************!*\
  !*** ./src/loader/level-details.ts ***!
  \*************************************/
            /*! exports provided: LevelDetails */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'LevelDetails', function () {
                  return s;
                });
              const i = r(/*! ./src/polyfills/number */ './src/polyfills/number.ts');
              function n(t, e) {
                for (let r = 0; r < e.length; r++) {
                  const i = e[r];
                  (i.enumerable = i.enumerable || !1),
                    (i.configurable = !0),
                    'value' in i && (i.writable = !0),
                    Object.defineProperty(t, i.key, i);
                }
              }
              var s = (function () {
                function t(t) {
                  (this.PTSKnown = !1),
                    (this.alignedSliding = !1),
                    (this.averagetargetduration = void 0),
                    (this.endCC = 0),
                    (this.endSN = 0),
                    (this.fragments = void 0),
                    (this.fragmentHint = void 0),
                    (this.partList = null),
                    (this.live = !0),
                    (this.ageHeader = 0),
                    (this.advancedDateTime = void 0),
                    (this.updated = !0),
                    (this.advanced = !0),
                    (this.availabilityDelay = void 0),
                    (this.misses = 0),
                    (this.needSidxRanges = !1),
                    (this.startCC = 0),
                    (this.startSN = 0),
                    (this.startTimeOffset = null),
                    (this.targetduration = 0),
                    (this.totalduration = 0),
                    (this.type = null),
                    (this.url = void 0),
                    (this.m3u8 = ''),
                    (this.version = null),
                    (this.canBlockReload = !1),
                    (this.canSkipUntil = 0),
                    (this.canSkipDateRanges = !1),
                    (this.skippedSegments = 0),
                    (this.recentlyRemovedDateranges = void 0),
                    (this.partHoldBack = 0),
                    (this.holdBack = 0),
                    (this.partTarget = 0),
                    (this.preloadHint = void 0),
                    (this.renditionReports = void 0),
                    (this.tuneInGoal = 0),
                    (this.deltaUpdateFailed = void 0),
                    (this.driftStartTime = 0),
                    (this.driftEndTime = 0),
                    (this.driftStart = 0),
                    (this.driftEnd = 0),
                    (this.fragments = []),
                    (this.url = t);
                }
                return (
                  (t.prototype.reloaded = function (t) {
                    if (!t) return (this.advanced = !0), void (this.updated = !0);
                    const e = this.lastPartSn - t.lastPartSn,
                      r = this.lastPartIndex - t.lastPartIndex;
                    (this.updated = this.endSN !== t.endSN || !!r || !!e),
                      (this.advanced = this.endSN > t.endSN || e > 0 || (0 === e && r > 0)),
                      this.updated || this.advanced
                        ? (this.misses = Math.floor(0.6 * t.misses))
                        : (this.misses = t.misses + 1),
                      (this.availabilityDelay = t.availabilityDelay);
                  }),
                  (function (t, e, r) {
                    e && n(t.prototype, e), r && n(t, r);
                  })(t, [
                    {
                      key: 'hasProgramDateTime',
                      get: function () {
                        return (
                          !!this.fragments.length &&
                          Object(i.isFiniteNumber)(this.fragments[this.fragments.length - 1].programDateTime)
                        );
                      },
                    },
                    {
                      key: 'levelTargetDuration',
                      get: function () {
                        return this.averagetargetduration || this.targetduration || 10;
                      },
                    },
                    {
                      key: 'drift',
                      get: function () {
                        const t = this.driftEndTime - this.driftStartTime;
                        return t > 0 ? (1e3 * (this.driftEnd - this.driftStart)) / t : 1;
                      },
                    },
                    {
                      key: 'edge',
                      get: function () {
                        return this.partEnd || this.fragmentEnd;
                      },
                    },
                    {
                      key: 'partEnd',
                      get: function () {
                        let t;
                        return null !== (t = this.partList) && void 0 !== t && t.length
                          ? this.partList[this.partList.length - 1].end
                          : this.fragmentEnd;
                      },
                    },
                    {
                      key: 'fragmentEnd',
                      get: function () {
                        let t;
                        return null !== (t = this.fragments) && void 0 !== t && t.length
                          ? this.fragments[this.fragments.length - 1].end
                          : 0;
                      },
                    },
                    {
                      key: 'age',
                      get: function () {
                        return this.advancedDateTime ? Math.max(Date.now() - this.advancedDateTime, 0) / 1e3 : 0;
                      },
                    },
                    {
                      key: 'lastPartIndex',
                      get: function () {
                        let t;
                        return null !== (t = this.partList) && void 0 !== t && t.length
                          ? this.partList[this.partList.length - 1].index
                          : -1;
                      },
                    },
                    {
                      key: 'lastPartSn',
                      get: function () {
                        let t;
                        return null !== (t = this.partList) && void 0 !== t && t.length
                          ? this.partList[this.partList.length - 1].fragment.sn
                          : this.endSN;
                      },
                    },
                  ]),
                  t
                );
              })();
            },
          './src/loader/level-key.ts':
            /*!*********************************!*\
  !*** ./src/loader/level-key.ts ***!
  \*********************************/
            /*! exports provided: LevelKey */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'LevelKey', function () {
                  return s;
                });
              const i = r(/*! url-toolkit */ './node_modules/url-toolkit/src/url-toolkit.js');
              function n(t, e) {
                for (let r = 0; r < e.length; r++) {
                  const i = e[r];
                  (i.enumerable = i.enumerable || !1),
                    (i.configurable = !0),
                    'value' in i && (i.writable = !0),
                    Object.defineProperty(t, i.key, i);
                }
              }
              var s = (function () {
                function t(t, e) {
                  (this._uri = null),
                    (this.method = null),
                    (this.keyFormat = null),
                    (this.keyFormatVersions = null),
                    (this.keyID = null),
                    (this.key = null),
                    (this.iv = null),
                    (this._uri = e ? Object(i.buildAbsoluteURL)(t, e, { alwaysNormalize: !0 }) : t);
                }
                return (
                  (t.fromURL = function (e, r) {
                    return new t(e, r);
                  }),
                  (t.fromURI = function (e) {
                    return new t(e);
                  }),
                  (function (t, e, r) {
                    e && n(t.prototype, e), r && n(t, r);
                  })(t, [
                    {
                      key: 'uri',
                      get: function () {
                        return this._uri;
                      },
                    },
                  ]),
                  t
                );
              })();
            },
          './src/loader/load-stats.ts':
            /*!**********************************!*\
  !*** ./src/loader/load-stats.ts ***!
  \**********************************/
            /*! exports provided: LoadStats */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'LoadStats', function () {
                  return i;
                });
              var i = function () {
                (this.aborted = !1),
                  (this.loaded = 0),
                  (this.retry = 0),
                  (this.total = 0),
                  (this.chunkCount = 0),
                  (this.bwEstimate = 0),
                  (this.loading = { start: 0, first: 0, end: 0 }),
                  (this.parsing = { start: 0, end: 0 }),
                  (this.buffering = { start: 0, first: 0, end: 0 });
              };
            },
          './src/loader/m3u8-parser.ts':
            /*!***********************************!*\
  !*** ./src/loader/m3u8-parser.ts ***!
  \***********************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return g;
                });
              const i = r(/*! ./src/polyfills/number */ './src/polyfills/number.ts'),
                n = r(/*! url-toolkit */ './node_modules/url-toolkit/src/url-toolkit.js'),
                s = r(/*! ./fragment */ './src/loader/fragment.ts'),
                a = r(/*! ./level-details */ './src/loader/level-details.ts'),
                o = r(/*! ./level-key */ './src/loader/level-key.ts'),
                l = r(/*! ../utils/attr-list */ './src/utils/attr-list.ts'),
                u = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                c = r(/*! ../utils/codecs */ './src/utils/codecs.ts'),
                d =
                  /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-SESSION-DATA:([^\r\n]*)[\r\n]+/g,
                f = /#EXT-X-MEDIA:(.*)/g,
                h = new RegExp(
                  [
                    /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
                    /(?!#) *(\S[\S ]*)/.source,
                    /#EXT-X-BYTERANGE:*(.+)/.source,
                    /#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
                    /#.*/.source,
                  ].join('|'),
                  'g'
                ),
                p = new RegExp(
                  [
                    /#(EXTM3U)/.source,
                    /#EXT-X-(PLAYLIST-TYPE):(.+)/.source,
                    /#EXT-X-(MEDIA-SEQUENCE): *(\d+)/.source,
                    /#EXT-X-(SKIP):(.+)/.source,
                    /#EXT-X-(TARGETDURATION): *(\d+)/.source,
                    /#EXT-X-(KEY):(.+)/.source,
                    /#EXT-X-(START):(.+)/.source,
                    /#EXT-X-(ENDLIST)/.source,
                    /#EXT-X-(DISCONTINUITY-SEQ)UENCE: *(\d+)/.source,
                    /#EXT-X-(DIS)CONTINUITY/.source,
                    /#EXT-X-(VERSION):(\d+)/.source,
                    /#EXT-X-(MAP):(.+)/.source,
                    /#EXT-X-(SERVER-CONTROL):(.+)/.source,
                    /#EXT-X-(PART-INF):(.+)/.source,
                    /#EXT-X-(GAP)/.source,
                    /#EXT-X-(BITRATE):\s*(\d+)/.source,
                    /#EXT-X-(PART):(.+)/.source,
                    /#EXT-X-(PRELOAD-HINT):(.+)/.source,
                    /#EXT-X-(RENDITION-REPORT):(.+)/.source,
                    /(#)([^:]*):(.*)/.source,
                    /(#)(.*)(?:.*)\r?\n?/.source,
                  ].join('|')
                ),
                v = /\.(mp4|m4s|m4v|m4a)$/i;
              var g = (function () {
                function t() {}
                return (
                  (t.findGroup = function (t, e) {
                    for (let r = 0; r < t.length; r++) {
                      const i = t[r];
                      if (i.id === e) return i;
                    }
                  }),
                  (t.convertAVC1ToAVCOTI = function (t) {
                    const e = t.split('.');
                    if (e.length > 2) {
                      let r = e.shift() + '.';
                      return (
                        (r += parseInt(e.shift()).toString(16)),
                        (r += ('000' + parseInt(e.shift()).toString(16)).substr(-4))
                      );
                    }
                    return t;
                  }),
                  (t.resolve = function (t, e) {
                    return n.buildAbsoluteURL(e, t, { alwaysNormalize: !0 });
                  }),
                  (t.parseMasterPlaylist = function (e, r) {
                    let i,
                      n = [],
                      s = {},
                      a = !1;
                    for (d.lastIndex = 0; null != (i = d.exec(e)); )
                      if (i[1]) {
                        const o = new l.AttrList(i[1]),
                          u = {
                            attrs: o,
                            bitrate: o.decimalInteger('AVERAGE-BANDWIDTH') || o.decimalInteger('BANDWIDTH'),
                            name: o.NAME,
                            url: t.resolve(i[2], r),
                          },
                          c = o.decimalResolution('RESOLUTION');
                        c && ((u.width = c.width), (u.height = c.height)),
                          m(
                            (o.CODECS || '').split(/[ ,]+/).filter(function (t) {
                              return t;
                            }),
                            u
                          ),
                          u.videoCodec &&
                            -1 !== u.videoCodec.indexOf('avc1') &&
                            (u.videoCodec = t.convertAVC1ToAVCOTI(u.videoCodec)),
                          n.push(u);
                      } else if (i[3]) {
                        const f = new l.AttrList(i[3]);
                        f['DATA-ID'] && ((a = !0), (s[f['DATA-ID']] = f));
                      }
                    return { levels: n, sessionData: a ? s : null };
                  }),
                  (t.parseMasterPlaylistMedia = function (e, r, i, n) {
                    let s;
                    void 0 === n && (n = []);
                    let a = [],
                      o = 0;
                    for (f.lastIndex = 0; null !== (s = f.exec(e)); ) {
                      const u = new l.AttrList(s[1]);
                      if (u.TYPE === i) {
                        const c = {
                          attrs: u,
                          bitrate: 0,
                          id: o++,
                          groupId: u['GROUP-ID'],
                          instreamId: u['INSTREAM-ID'],
                          name: u.NAME || u.LANGUAGE || '',
                          type: i,
                          default: u.bool('DEFAULT'),
                          autoselect: u.bool('AUTOSELECT'),
                          forced: u.bool('FORCED'),
                          lang: u.LANGUAGE,
                          url: u.URI ? t.resolve(u.URI, r) : '',
                        };
                        if (n.length) {
                          const d = t.findGroup(n, c.groupId) || n[0];
                          y(c, d, 'audioCodec'), y(c, d, 'textCodec');
                        }
                        a.push(c);
                      }
                    }
                    return a;
                  }),
                  (t.parseLevelPlaylist = function (t, e, r, c, d) {
                    let f,
                      g,
                      m,
                      y = new a.LevelDetails(e),
                      T = y.fragments,
                      b = null,
                      S = 0,
                      L = 0,
                      A = 0,
                      D = 0,
                      k = null,
                      C = new s.Fragment(c, e),
                      x = -1,
                      R = !1;
                    for (h.lastIndex = 0, y.m3u8 = t; null !== (f = h.exec(t)); ) {
                      R &&
                        ((R = !1),
                        ((C = new s.Fragment(c, e)).start = A),
                        (C.sn = S),
                        (C.cc = D),
                        (C.level = r),
                        b && ((C.initSegment = b), (C.rawProgramDateTime = b.rawProgramDateTime)));
                      const w = f[1];
                      if (w) {
                        C.duration = parseFloat(w);
                        const _ = (' ' + f[2]).slice(1);
                        (C.title = _ || null), C.tagList.push(_ ? ['INF', w, _] : ['INF', w]);
                      } else if (f[3])
                        Object(i.isFiniteNumber)(C.duration) &&
                          ((C.start = A),
                          m && (C.levelkey = m),
                          (C.sn = S),
                          (C.level = r),
                          (C.cc = D),
                          (C.urlId = d),
                          T.push(C),
                          (C.relurl = (' ' + f[3]).slice(1)),
                          E(C, k),
                          (k = C),
                          (A += C.duration),
                          S++,
                          (L = 0),
                          (R = !0));
                      else if (f[4]) {
                        const I = (' ' + f[4]).slice(1);
                        k ? C.setByteRange(I, k) : C.setByteRange(I);
                      } else if (f[5])
                        (C.rawProgramDateTime = (' ' + f[5]).slice(1)),
                          C.tagList.push(['PROGRAM-DATE-TIME', C.rawProgramDateTime]),
                          -1 === x && (x = T.length);
                      else {
                        if (!(f = f[0].match(p))) {
                          u.logger.warn('No matches on slow regex match for level playlist!');
                          continue;
                        }
                        for (g = 1; g < f.length && void 0 === f[g]; g++);
                        const O = (' ' + f[g]).slice(1),
                          P = (' ' + f[g + 1]).slice(1),
                          F = f[g + 2] ? (' ' + f[g + 2]).slice(1) : '';
                        switch (O) {
                          case 'PLAYLIST-TYPE':
                            y.type = P.toUpperCase();
                            break;
                          case 'MEDIA-SEQUENCE':
                            S = y.startSN = parseInt(P);
                            break;
                          case 'SKIP':
                            var M = new l.AttrList(P),
                              N = M.decimalInteger('SKIPPED-SEGMENTS');
                            if (Object(i.isFiniteNumber)(N)) {
                              y.skippedSegments = N;
                              for (let B = N; B--; ) T.unshift(null);
                              S += N;
                            }
                            var U = M.enumeratedString('RECENTLY-REMOVED-DATERANGES');
                            U && (y.recentlyRemovedDateranges = U.split('\t'));
                            break;
                          case 'TARGETDURATION':
                            y.targetduration = parseFloat(P);
                            break;
                          case 'VERSION':
                            y.version = parseInt(P);
                            break;
                          case 'EXTM3U':
                            break;
                          case 'ENDLIST':
                            y.live = !1;
                            break;
                          case '#':
                            (P || F) && C.tagList.push(F ? [P, F] : [P]);
                            break;
                          case 'DIS':
                            D++;
                          case 'GAP':
                            C.tagList.push([O]);
                            break;
                          case 'BITRATE':
                            C.tagList.push([O, P]);
                            break;
                          case 'DISCONTINUITY-SEQ':
                            D = parseInt(P);
                            break;
                          case 'KEY':
                            var j,
                              G = new l.AttrList(P),
                              H = G.enumeratedString('METHOD'),
                              K = G.URI,
                              V = G.hexadecimalInteger('IV'),
                              q = G.enumeratedString('KEYFORMATVERSIONS'),
                              W = G.enumeratedString('KEYID'),
                              Y = null != (j = G.enumeratedString('KEYFORMAT')) ? j : 'identity';
                            if (
                              [
                                'com.apple.streamingkeydelivery',
                                'com.microsoft.playready',
                                'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed',
                                'com.widevine',
                              ].indexOf(Y) > -1
                            ) {
                              u.logger.warn('Keyformat ' + Y + ' is not supported from the manifest');
                              continue;
                            }
                            if ('identity' !== Y) continue;
                            H &&
                              ((m = o.LevelKey.fromURL(e, K)),
                              K &&
                                ['AES-128', 'SAMPLE-AES', 'SAMPLE-AES-CENC'].indexOf(H) >= 0 &&
                                ((m.method = H),
                                (m.keyFormat = Y),
                                W && (m.keyID = W),
                                q && (m.keyFormatVersions = q),
                                (m.iv = V)));
                            break;
                          case 'START':
                            var X = new l.AttrList(P).decimalFloatingPoint('TIME-OFFSET');
                            Object(i.isFiniteNumber)(X) && (y.startTimeOffset = X);
                            break;
                          case 'MAP':
                            var z = new l.AttrList(P);
                            (C.relurl = z.URI),
                              z.BYTERANGE && C.setByteRange(z.BYTERANGE),
                              (C.level = r),
                              (C.sn = 'initSegment'),
                              m && (C.levelkey = m),
                              (C.initSegment = null),
                              (b = C),
                              (R = !0);
                            break;
                          case 'SERVER-CONTROL':
                            var $ = new l.AttrList(P);
                            (y.canBlockReload = $.bool('CAN-BLOCK-RELOAD')),
                              (y.canSkipUntil = $.optionalFloat('CAN-SKIP-UNTIL', 0)),
                              (y.canSkipDateRanges = y.canSkipUntil > 0 && $.bool('CAN-SKIP-DATERANGES')),
                              (y.partHoldBack = $.optionalFloat('PART-HOLD-BACK', 0)),
                              (y.holdBack = $.optionalFloat('HOLD-BACK', 0));
                            break;
                          case 'PART-INF':
                            var Q = new l.AttrList(P);
                            y.partTarget = Q.decimalFloatingPoint('PART-TARGET');
                            break;
                          case 'PART':
                            var J = y.partList;
                            J || (J = y.partList = []);
                            var Z = L > 0 ? J[J.length - 1] : void 0,
                              tt = L++,
                              et = new s.Part(new l.AttrList(P), C, e, tt, Z);
                            J.push(et), (C.duration += et.duration);
                            break;
                          case 'PRELOAD-HINT':
                            var rt = new l.AttrList(P);
                            y.preloadHint = rt;
                            break;
                          case 'RENDITION-REPORT':
                            var it = new l.AttrList(P);
                            (y.renditionReports = y.renditionReports || []), y.renditionReports.push(it);
                            break;
                          default:
                            u.logger.warn('line parsed but not handled: ' + f);
                        }
                      }
                    }
                    k && !k.relurl
                      ? (T.pop(), (A -= k.duration), y.partList && (y.fragmentHint = k))
                      : y.partList && (E(C, k), (C.cc = D), (y.fragmentHint = C));
                    const nt = T.length,
                      st = T[0],
                      at = T[nt - 1];
                    if ((A += y.skippedSegments * y.targetduration) > 0 && nt && at) {
                      y.averagetargetduration = A / nt;
                      const ot = at.sn;
                      (y.endSN = 'initSegment' !== ot ? ot : 0),
                        st &&
                          ((y.startCC = st.cc),
                          st.initSegment ||
                            (y.fragments.every(function (t) {
                              return (
                                t.relurl &&
                                (function (t) {
                                  let e, r;
                                  return v.test(
                                    null != (e = null === (r = n.parseURL(t)) || void 0 === r ? void 0 : r.path)
                                      ? e
                                      : ''
                                  );
                                })(t.relurl)
                              );
                            }) &&
                              (u.logger.warn(
                                'MP4 fragments found but no init segment (probably no MAP, incomplete M3U8), trying to fetch SIDX'
                              ),
                              ((C = new s.Fragment(c, e)).relurl = at.relurl),
                              (C.level = r),
                              (C.sn = 'initSegment'),
                              (st.initSegment = C),
                              (y.needSidxRanges = !0))));
                    } else (y.endSN = 0), (y.startCC = 0);
                    return (
                      y.fragmentHint && (A += y.fragmentHint.duration),
                      (y.totalduration = A),
                      (y.endCC = D),
                      x > 0 &&
                        (function (t, e) {
                          for (let r = t[e], i = e; i--; ) {
                            const n = t[i];
                            if (!n) return;
                            (n.programDateTime = r.programDateTime - 1e3 * n.duration), (r = n);
                          }
                        })(T, x),
                      y
                    );
                  }),
                  t
                );
              })();
              function m(t, e) {
                ['video', 'audio', 'text'].forEach(function (r) {
                  const i = t.filter(function (t) {
                    return Object(c.isCodecType)(t, r);
                  });
                  if (i.length) {
                    const n = i.filter(function (t) {
                      return 0 === t.lastIndexOf('avc1', 0) || 0 === t.lastIndexOf('mp4a', 0);
                    });
                    (e[r + 'Codec'] = n.length > 0 ? n[0] : i[0]),
                      (t = t.filter(function (t) {
                        return -1 === i.indexOf(t);
                      }));
                  }
                }),
                  (e.unknownCodecs = t);
              }
              function y(t, e, r) {
                const i = e[r];
                i && (t[r] = i);
              }
              function E(t, e) {
                t.rawProgramDateTime
                  ? (t.programDateTime = Date.parse(t.rawProgramDateTime))
                  : null !== e && void 0 !== e && e.programDateTime && (t.programDateTime = e.endProgramDateTime),
                  Object(i.isFiniteNumber)(t.programDateTime) ||
                    ((t.programDateTime = null), (t.rawProgramDateTime = null));
              }
            },
          './src/loader/playlist-loader.ts':
            /*!***************************************!*\
  !*** ./src/loader/playlist-loader.ts ***!
  \***************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              const i = r(/*! ./src/polyfills/number */ './src/polyfills/number.ts'),
                n = r(/*! ../events */ './src/events.ts'),
                s = r(/*! ../errors */ './src/errors.ts'),
                a = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                o = r(/*! ../utils/mp4-tools */ './src/utils/mp4-tools.ts'),
                l = r(/*! ./m3u8-parser */ './src/loader/m3u8-parser.ts'),
                u = r(/*! ../types/loader */ './src/types/loader.ts'),
                c = r(/*! ../utils/attr-list */ './src/utils/attr-list.ts');
              function d(t, e) {
                let r = t.url;
                return (void 0 !== r && 0 !== r.indexOf('data:')) || (r = e.url), r;
              }
              const f = (function () {
                function t(t) {
                  (this.hls = void 0), (this.loaders = Object.create(null)), (this.hls = t), this.registerListeners();
                }
                const e = t.prototype;
                return (
                  (e.registerListeners = function () {
                    const t = this.hls;
                    t.on(n.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                      t.on(n.Events.LEVEL_LOADING, this.onLevelLoading, this),
                      t.on(n.Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this),
                      t.on(n.Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
                  }),
                  (e.unregisterListeners = function () {
                    const t = this.hls;
                    t.off(n.Events.MANIFEST_LOADING, this.onManifestLoading, this),
                      t.off(n.Events.LEVEL_LOADING, this.onLevelLoading, this),
                      t.off(n.Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this),
                      t.off(n.Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
                  }),
                  (e.createInternalLoader = function (t) {
                    const e = this.hls.config,
                      r = e.pLoader,
                      i = e.loader,
                      n = new (r || i)(e);
                    return (t.loader = n), (this.loaders[t.type] = n), n;
                  }),
                  (e.getInternalLoader = function (t) {
                    return this.loaders[t.type];
                  }),
                  (e.resetInternalLoader = function (t) {
                    this.loaders[t] && delete this.loaders[t];
                  }),
                  (e.destroyInternalLoaders = function () {
                    for (const t in this.loaders) {
                      const e = this.loaders[t];
                      e && e.destroy(), this.resetInternalLoader(t);
                    }
                  }),
                  (e.destroy = function () {
                    this.unregisterListeners(), this.destroyInternalLoaders();
                  }),
                  (e.onManifestLoading = function (t, e) {
                    const r = e.url;
                    this.load({
                      id: null,
                      groupId: null,
                      level: 0,
                      responseType: 'text',
                      type: u.PlaylistContextType.MANIFEST,
                      url: r,
                      deliveryDirectives: null,
                    });
                  }),
                  (e.onLevelLoading = function (t, e) {
                    const r = e.id,
                      i = e.level,
                      n = e.url,
                      s = e.deliveryDirectives;
                    this.load({
                      id: r,
                      groupId: null,
                      level: i,
                      responseType: 'text',
                      type: u.PlaylistContextType.LEVEL,
                      url: n,
                      deliveryDirectives: s,
                    });
                  }),
                  (e.onAudioTrackLoading = function (t, e) {
                    const r = e.id,
                      i = e.groupId,
                      n = e.url,
                      s = e.deliveryDirectives;
                    this.load({
                      id: r,
                      groupId: i,
                      level: null,
                      responseType: 'text',
                      type: u.PlaylistContextType.AUDIO_TRACK,
                      url: n,
                      deliveryDirectives: s,
                    });
                  }),
                  (e.onSubtitleTrackLoading = function (t, e) {
                    const r = e.id,
                      i = e.groupId,
                      n = e.url,
                      s = e.deliveryDirectives;
                    this.load({
                      id: r,
                      groupId: i,
                      level: null,
                      responseType: 'text',
                      type: u.PlaylistContextType.SUBTITLE_TRACK,
                      url: n,
                      deliveryDirectives: s,
                    });
                  }),
                  (e.load = function (t) {
                    let e,
                      r,
                      i,
                      n,
                      s,
                      o,
                      l = this.hls.config,
                      c = this.getInternalLoader(t);
                    if (c) {
                      const d = c.context;
                      if (d && d.url === t.url)
                        return void a.logger.trace('[playlist-loader]: playlist request ongoing');
                      a.logger.log('[playlist-loader]: aborting previous loader for type: ' + t.type), c.abort();
                    }
                    switch (t.type) {
                      case u.PlaylistContextType.MANIFEST:
                        (r = l.manifestLoadingMaxRetry),
                          (i = l.manifestLoadingTimeOut),
                          (n = l.manifestLoadingRetryDelay),
                          (s = l.manifestLoadingMaxRetryTimeout);
                        break;
                      case u.PlaylistContextType.LEVEL:
                      case u.PlaylistContextType.AUDIO_TRACK:
                      case u.PlaylistContextType.SUBTITLE_TRACK:
                        (r = 0), (i = l.levelLoadingTimeOut);
                        break;
                      default:
                        (r = l.levelLoadingMaxRetry),
                          (i = l.levelLoadingTimeOut),
                          (n = l.levelLoadingRetryDelay),
                          (s = l.levelLoadingMaxRetryTimeout);
                    }
                    if (
                      ((c = this.createInternalLoader(t)),
                      null !== (e = t.deliveryDirectives) && void 0 !== e && e.part) &&
                      (t.type === u.PlaylistContextType.LEVEL && null !== t.level
                        ? (o = this.hls.levels[t.level].details)
                        : t.type === u.PlaylistContextType.AUDIO_TRACK && null !== t.id
                          ? (o = this.hls.audioTracks[t.id].details)
                          : t.type === u.PlaylistContextType.SUBTITLE_TRACK &&
                            null !== t.id &&
                            (o = this.hls.subtitleTracks[t.id].details),
                      o)
                    ) {
                      const f = o.partTarget,
                        h = o.targetduration;
                      f && h && (i = Math.min(1e3 * Math.max(3 * f, 0.8 * h), i));
                    }
                    const p = { timeout: i, maxRetry: r, retryDelay: n, maxRetryDelay: s, highWaterMark: 0 },
                      v = {
                        onSuccess: this.loadsuccess.bind(this),
                        onError: this.loaderror.bind(this),
                        onTimeout: this.loadtimeout.bind(this),
                      };
                    c.load(t, p, v);
                  }),
                  (e.loadsuccess = function (t, e, r, i) {
                    if ((void 0 === i && (i = null), r.isSidxRequest))
                      return this.handleSidxRequest(t, r), void this.handlePlaylistLoaded(t, e, r, i);
                    this.resetInternalLoader(r.type);
                    const n = t.data;
                    0 === n.indexOf('#EXTM3U')
                      ? ((e.parsing.start = performance.now()),
                        n.indexOf('#EXTINF:') > 0 || n.indexOf('#EXT-X-TARGETDURATION:') > 0
                          ? this.handleTrackOrLevelPlaylist(t, e, r, i)
                          : this.handleMasterPlaylist(t, e, r, i))
                      : this.handleManifestParsingError(t, r, 'no EXTM3U delimiter', i);
                  }),
                  (e.loaderror = function (t, e, r) {
                    void 0 === r && (r = null), this.handleNetworkError(e, r, !1, t);
                  }),
                  (e.loadtimeout = function (t, e, r) {
                    void 0 === r && (r = null), this.handleNetworkError(e, r, !0);
                  }),
                  (e.handleMasterPlaylist = function (t, e, r, i) {
                    const s = this.hls,
                      o = t.data,
                      u = d(t, r),
                      f = l.default.parseMasterPlaylist(o, u),
                      h = f.levels,
                      p = f.sessionData;
                    if (h.length) {
                      const v = h.map(function (t) {
                          return { id: t.attrs.AUDIO, audioCodec: t.audioCodec };
                        }),
                        g = h.map(function (t) {
                          return { id: t.attrs.SUBTITLES, textCodec: t.textCodec };
                        }),
                        m = l.default.parseMasterPlaylistMedia(o, u, 'AUDIO', v),
                        y = l.default.parseMasterPlaylistMedia(o, u, 'SUBTITLES', g),
                        E = l.default.parseMasterPlaylistMedia(o, u, 'CLOSED-CAPTIONS');
                      if (m.length)
                        m.some(function (t) {
                          return !t.url;
                        }) ||
                          !h[0].audioCodec ||
                          h[0].attrs.AUDIO ||
                          (a.logger.log(
                            '[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one'
                          ),
                          m.unshift({
                            type: 'main',
                            name: 'main',
                            default: !1,
                            autoselect: !1,
                            forced: !1,
                            id: -1,
                            attrs: new c.AttrList({}),
                            bitrate: 0,
                            url: '',
                          }));
                      s.trigger(n.Events.MANIFEST_LOADED, {
                        levels: h,
                        audioTracks: m,
                        subtitles: y,
                        captions: E,
                        url: u,
                        stats: e,
                        networkDetails: i,
                        sessionData: p,
                      });
                    } else this.handleManifestParsingError(t, r, 'no level found in manifest', i);
                  }),
                  (e.handleTrackOrLevelPlaylist = function (t, e, r, a) {
                    const o = this.hls,
                      f = r.id,
                      h = r.level,
                      p = r.type,
                      v = d(t, r),
                      g = Object(i.isFiniteNumber)(f) ? f : 0,
                      m = Object(i.isFiniteNumber)(h) ? h : g,
                      y = (function (t) {
                        switch (t.type) {
                          case u.PlaylistContextType.AUDIO_TRACK:
                            return u.PlaylistLevelType.AUDIO;
                          case u.PlaylistContextType.SUBTITLE_TRACK:
                            return u.PlaylistLevelType.SUBTITLE;
                          default:
                            return u.PlaylistLevelType.MAIN;
                        }
                      })(r),
                      E = l.default.parseLevelPlaylist(t.data, v, m, y, g);
                    if (E.fragments.length) {
                      if (p === u.PlaylistContextType.MANIFEST) {
                        const T = { attrs: new c.AttrList({}), bitrate: 0, details: E, name: '', url: v };
                        o.trigger(n.Events.MANIFEST_LOADED, {
                          levels: [T],
                          audioTracks: [],
                          url: v,
                          stats: e,
                          networkDetails: a,
                          sessionData: null,
                        });
                      }
                      if (((e.parsing.end = performance.now()), E.needSidxRanges)) {
                        let b,
                          S = null === (b = E.fragments[0].initSegment) || void 0 === b ? void 0 : b.url;
                        this.load({
                          url: S,
                          isSidxRequest: !0,
                          type: p,
                          level: h,
                          levelDetails: E,
                          id: f,
                          groupId: null,
                          rangeStart: 0,
                          rangeEnd: 2048,
                          responseType: 'arraybuffer',
                          deliveryDirectives: null,
                        });
                      } else (r.levelDetails = E), this.handlePlaylistLoaded(t, e, r, a);
                    } else
                      o.trigger(n.Events.ERROR, {
                        type: s.ErrorTypes.NETWORK_ERROR,
                        details: s.ErrorDetails.LEVEL_EMPTY_ERROR,
                        fatal: !1,
                        url: v,
                        reason: 'no fragments found in level',
                        level: 'number' == typeof r.level ? r.level : void 0,
                      });
                  }),
                  (e.handleSidxRequest = function (t, e) {
                    const r = Object(o.parseSegmentIndex)(new Uint8Array(t.data));
                    if (r) {
                      const i = r.references,
                        n = e.levelDetails;
                      i.forEach(function (t, e) {
                        const i = t.info,
                          s = n.fragments[e];
                        0 === s.byteRange.length && s.setByteRange(String(1 + i.end - i.start) + '@' + String(i.start)),
                          s.initSegment && s.initSegment.setByteRange(String(r.moovEndOffset) + '@0');
                      });
                    }
                  }),
                  (e.handleManifestParsingError = function (t, e, r, i) {
                    this.hls.trigger(n.Events.ERROR, {
                      type: s.ErrorTypes.NETWORK_ERROR,
                      details: s.ErrorDetails.MANIFEST_PARSING_ERROR,
                      fatal: e.type === u.PlaylistContextType.MANIFEST,
                      url: t.url,
                      reason: r,
                      response: t,
                      context: e,
                      networkDetails: i,
                    });
                  }),
                  (e.handleNetworkError = function (t, e, r, i) {
                    void 0 === r && (r = !1),
                      a.logger.warn(
                        '[playlist-loader]: A network ' +
                          (r ? 'timeout' : 'error') +
                          ' occurred while loading ' +
                          t.type +
                          ' level: ' +
                          t.level +
                          ' id: ' +
                          t.id +
                          ' group-id: "' +
                          t.groupId +
                          '"'
                      );
                    let o = s.ErrorDetails.UNKNOWN,
                      l = !1,
                      c = this.getInternalLoader(t);
                    switch (t.type) {
                      case u.PlaylistContextType.MANIFEST:
                        (o = r ? s.ErrorDetails.MANIFEST_LOAD_TIMEOUT : s.ErrorDetails.MANIFEST_LOAD_ERROR), (l = !0);
                        break;
                      case u.PlaylistContextType.LEVEL:
                        (o = r ? s.ErrorDetails.LEVEL_LOAD_TIMEOUT : s.ErrorDetails.LEVEL_LOAD_ERROR), (l = !1);
                        break;
                      case u.PlaylistContextType.AUDIO_TRACK:
                        (o = r ? s.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT : s.ErrorDetails.AUDIO_TRACK_LOAD_ERROR),
                          (l = !1);
                        break;
                      case u.PlaylistContextType.SUBTITLE_TRACK:
                        (o = r ? s.ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT : s.ErrorDetails.SUBTITLE_LOAD_ERROR),
                          (l = !1);
                    }
                    c && this.resetInternalLoader(t.type);
                    const d = {
                      type: s.ErrorTypes.NETWORK_ERROR,
                      details: o,
                      fatal: l,
                      url: t.url,
                      loader: c,
                      context: t,
                      networkDetails: e,
                    };
                    i && (d.response = i), this.hls.trigger(n.Events.ERROR, d);
                  }),
                  (e.handlePlaylistLoaded = function (t, e, r, i) {
                    const s = r.type,
                      a = r.level,
                      o = r.id,
                      l = r.groupId,
                      c = r.loader,
                      d = r.levelDetails,
                      f = r.deliveryDirectives;
                    if (null !== d && void 0 !== d && d.targetduration) {
                      if (c)
                        switch (
                          (d.live &&
                            (c.getCacheAge && (d.ageHeader = c.getCacheAge() || 0),
                            (c.getCacheAge && !isNaN(d.ageHeader)) || (d.ageHeader = 0)),
                          s)
                        ) {
                          case u.PlaylistContextType.MANIFEST:
                          case u.PlaylistContextType.LEVEL:
                            this.hls.trigger(n.Events.LEVEL_LOADED, {
                              details: d,
                              level: a || 0,
                              id: o || 0,
                              stats: e,
                              networkDetails: i,
                              deliveryDirectives: f,
                            });
                            break;
                          case u.PlaylistContextType.AUDIO_TRACK:
                            this.hls.trigger(n.Events.AUDIO_TRACK_LOADED, {
                              details: d,
                              id: o || 0,
                              groupId: l || '',
                              stats: e,
                              networkDetails: i,
                              deliveryDirectives: f,
                            });
                            break;
                          case u.PlaylistContextType.SUBTITLE_TRACK:
                            this.hls.trigger(n.Events.SUBTITLE_TRACK_LOADED, {
                              details: d,
                              id: o || 0,
                              groupId: l || '',
                              stats: e,
                              networkDetails: i,
                              deliveryDirectives: f,
                            });
                        }
                    } else this.handleManifestParsingError(t, r, 'invalid target duration', i);
                  }),
                  t
                );
              })();
              e.default = f;
            },
          './src/polyfills/number.ts':
            /*!*********************************!*\
  !*** ./src/polyfills/number.ts ***!
  \*********************************/
            /*! exports provided: isFiniteNumber, MAX_SAFE_INTEGER */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'isFiniteNumber', function () {
                  return i;
                }),
                r.d(e, 'MAX_SAFE_INTEGER', function () {
                  return n;
                });
              var i =
                  Number.isFinite ||
                  function (t) {
                    return 'number' == typeof t && isFinite(t);
                  },
                n = Number.MAX_SAFE_INTEGER || 9007199254740991;
            },
          './src/remux/aac-helper.ts':
            /*!*********************************!*\
  !*** ./src/remux/aac-helper.ts ***!
  \*********************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              const i = (function () {
                function t() {}
                return (
                  (t.getSilentFrame = function (t, e) {
                    switch (t) {
                      case 'mp4a.40.2':
                        if (1 === e) return new Uint8Array([0, 200, 0, 128, 35, 128]);
                        if (2 === e) return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
                        if (3 === e) return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
                        if (4 === e)
                          return new Uint8Array([
                            0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56,
                          ]);
                        if (5 === e)
                          return new Uint8Array([
                            0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 56,
                          ]);
                        if (6 === e)
                          return new Uint8Array([
                            0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 0, 178, 0,
                            32, 8, 224,
                          ]);
                        break;
                      default:
                        if (1 === e)
                          return new Uint8Array([
                            1, 64, 34, 128, 163, 78, 230, 128, 186, 8, 0, 0, 0, 28, 6, 241, 193, 10, 90, 90, 90, 90, 90,
                            90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90,
                            90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94,
                          ]);
                        if (2 === e)
                          return new Uint8Array([
                            1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90,
                            90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90,
                            90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94,
                          ]);
                        if (3 === e)
                          return new Uint8Array([
                            1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90,
                            90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90,
                            90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94,
                          ]);
                    }
                  }),
                  t
                );
              })();
              e.default = i;
            },
          './src/remux/mp4-generator.ts':
            /*!************************************!*\
  !*** ./src/remux/mp4-generator.ts ***!
  \************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              const i = Math.pow(2, 32) - 1,
                n = (function () {
                  function t() {}
                  return (
                    (t.init = function () {
                      let e;
                      for (e in ((t.types = {
                        avc1: [],
                        avcC: [],
                        btrt: [],
                        dinf: [],
                        dref: [],
                        esds: [],
                        ftyp: [],
                        hdlr: [],
                        mdat: [],
                        mdhd: [],
                        mdia: [],
                        mfhd: [],
                        minf: [],
                        moof: [],
                        moov: [],
                        mp4a: [],
                        '.mp3': [],
                        mvex: [],
                        mvhd: [],
                        pasp: [],
                        sdtp: [],
                        stbl: [],
                        stco: [],
                        stsc: [],
                        stsd: [],
                        stsz: [],
                        stts: [],
                        tfdt: [],
                        tfhd: [],
                        traf: [],
                        trak: [],
                        trun: [],
                        trex: [],
                        tkhd: [],
                        vmhd: [],
                        smhd: [],
                      }),
                      t.types))
                        t.types.hasOwnProperty(e) &&
                          (t.types[e] = [e.charCodeAt(0), e.charCodeAt(1), e.charCodeAt(2), e.charCodeAt(3)]);
                      const r = new Uint8Array([
                          0, 0, 0, 0, 0, 0, 0, 0, 118, 105, 100, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 86, 105, 100,
                          101, 111, 72, 97, 110, 100, 108, 101, 114, 0,
                        ]),
                        i = new Uint8Array([
                          0, 0, 0, 0, 0, 0, 0, 0, 115, 111, 117, 110, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 83, 111, 117,
                          110, 100, 72, 97, 110, 100, 108, 101, 114, 0,
                        ]);
                      t.HDLR_TYPES = { video: r, audio: i };
                      const n = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 12, 117, 114, 108, 32, 0, 0, 0, 1]),
                        s = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]);
                      (t.STTS = t.STSC = t.STCO = s),
                        (t.STSZ = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])),
                        (t.VMHD = new Uint8Array([0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0])),
                        (t.SMHD = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0])),
                        (t.STSD = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1]));
                      const a = new Uint8Array([105, 115, 111, 109]),
                        o = new Uint8Array([97, 118, 99, 49]),
                        l = new Uint8Array([0, 0, 0, 1]);
                      (t.FTYP = t.box(t.types.ftyp, a, l, a, o)),
                        (t.DINF = t.box(t.types.dinf, t.box(t.types.dref, n)));
                    }),
                    (t.box = function (t) {
                      for (var e = 8, r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
                        i[n - 1] = arguments[n];
                      for (var s = i.length, a = s; s--; ) e += i[s].byteLength;
                      const o = new Uint8Array(e);
                      for (
                        o[0] = (e >> 24) & 255,
                          o[1] = (e >> 16) & 255,
                          o[2] = (e >> 8) & 255,
                          o[3] = 255 & e,
                          o.set(t, 4),
                          s = 0,
                          e = 8;
                        s < a;
                        s++
                      )
                        o.set(i[s], e), (e += i[s].byteLength);
                      return o;
                    }),
                    (t.hdlr = function (e) {
                      return t.box(t.types.hdlr, t.HDLR_TYPES[e]);
                    }),
                    (t.mdat = function (e) {
                      return t.box(t.types.mdat, e);
                    }),
                    (t.mdhd = function (e, r) {
                      r *= e;
                      const n = Math.floor(r / (i + 1)),
                        s = Math.floor(r % (i + 1));
                      return t.box(
                        t.types.mdhd,
                        new Uint8Array([
                          1,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          2,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          3,
                          (e >> 24) & 255,
                          (e >> 16) & 255,
                          (e >> 8) & 255,
                          255 & e,
                          n >> 24,
                          (n >> 16) & 255,
                          (n >> 8) & 255,
                          255 & n,
                          s >> 24,
                          (s >> 16) & 255,
                          (s >> 8) & 255,
                          255 & s,
                          85,
                          196,
                          0,
                          0,
                        ])
                      );
                    }),
                    (t.mdia = function (e) {
                      return t.box(t.types.mdia, t.mdhd(e.timescale, e.duration), t.hdlr(e.type), t.minf(e));
                    }),
                    (t.mfhd = function (e) {
                      return t.box(
                        t.types.mfhd,
                        new Uint8Array([0, 0, 0, 0, e >> 24, (e >> 16) & 255, (e >> 8) & 255, 255 & e])
                      );
                    }),
                    (t.minf = function (e) {
                      return 'audio' === e.type
                        ? t.box(t.types.minf, t.box(t.types.smhd, t.SMHD), t.DINF, t.stbl(e))
                        : t.box(t.types.minf, t.box(t.types.vmhd, t.VMHD), t.DINF, t.stbl(e));
                    }),
                    (t.moof = function (e, r, i) {
                      return t.box(t.types.moof, t.mfhd(e), t.traf(i, r));
                    }),
                    (t.moov = function (e) {
                      for (var r = e.length, i = []; r--; ) i[r] = t.trak(e[r]);
                      return t.box.apply(
                        null,
                        [t.types.moov, t.mvhd(e[0].timescale, e[0].duration)].concat(i).concat(t.mvex(e))
                      );
                    }),
                    (t.mvex = function (e) {
                      for (var r = e.length, i = []; r--; ) i[r] = t.trex(e[r]);
                      return t.box.apply(null, [t.types.mvex].concat(i));
                    }),
                    (t.mvhd = function (e, r) {
                      r *= e;
                      const n = Math.floor(r / (i + 1)),
                        s = Math.floor(r % (i + 1)),
                        a = new Uint8Array([
                          1,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          2,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          3,
                          (e >> 24) & 255,
                          (e >> 16) & 255,
                          (e >> 8) & 255,
                          255 & e,
                          n >> 24,
                          (n >> 16) & 255,
                          (n >> 8) & 255,
                          255 & n,
                          s >> 24,
                          (s >> 16) & 255,
                          (s >> 8) & 255,
                          255 & s,
                          0,
                          1,
                          0,
                          0,
                          1,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          1,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          1,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          64,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          255,
                          255,
                          255,
                          255,
                        ]);
                      return t.box(t.types.mvhd, a);
                    }),
                    (t.sdtp = function (e) {
                      let r,
                        i,
                        n = e.samples || [],
                        s = new Uint8Array(4 + n.length);
                      for (r = 0; r < n.length; r++)
                        (i = n[r].flags), (s[r + 4] = (i.dependsOn << 4) | (i.isDependedOn << 2) | i.hasRedundancy);
                      return t.box(t.types.sdtp, s);
                    }),
                    (t.stbl = function (e) {
                      return t.box(
                        t.types.stbl,
                        t.stsd(e),
                        t.box(t.types.stts, t.STTS),
                        t.box(t.types.stsc, t.STSC),
                        t.box(t.types.stsz, t.STSZ),
                        t.box(t.types.stco, t.STCO)
                      );
                    }),
                    (t.avc1 = function (e) {
                      let r,
                        i,
                        n,
                        s = [],
                        a = [];
                      for (r = 0; r < e.sps.length; r++)
                        (n = (i = e.sps[r]).byteLength),
                          s.push((n >>> 8) & 255),
                          s.push(255 & n),
                          (s = s.concat(Array.prototype.slice.call(i)));
                      for (r = 0; r < e.pps.length; r++)
                        (n = (i = e.pps[r]).byteLength),
                          a.push((n >>> 8) & 255),
                          a.push(255 & n),
                          (a = a.concat(Array.prototype.slice.call(i)));
                      const o = t.box(
                          t.types.avcC,
                          new Uint8Array(
                            [1, s[3], s[4], s[5], 255, 224 | e.sps.length].concat(s).concat([e.pps.length]).concat(a)
                          )
                        ),
                        l = e.width,
                        u = e.height,
                        c = e.pixelRatio[0],
                        d = e.pixelRatio[1];
                      return t.box(
                        t.types.avc1,
                        new Uint8Array([
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          1,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          (l >> 8) & 255,
                          255 & l,
                          (u >> 8) & 255,
                          255 & u,
                          0,
                          72,
                          0,
                          0,
                          0,
                          72,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          1,
                          18,
                          100,
                          97,
                          105,
                          108,
                          121,
                          109,
                          111,
                          116,
                          105,
                          111,
                          110,
                          47,
                          104,
                          108,
                          115,
                          46,
                          106,
                          115,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          24,
                          17,
                          17,
                        ]),
                        o,
                        t.box(t.types.btrt, new Uint8Array([0, 28, 156, 128, 0, 45, 198, 192, 0, 45, 198, 192])),
                        t.box(
                          t.types.pasp,
                          new Uint8Array([
                            c >> 24,
                            (c >> 16) & 255,
                            (c >> 8) & 255,
                            255 & c,
                            d >> 24,
                            (d >> 16) & 255,
                            (d >> 8) & 255,
                            255 & d,
                          ])
                        )
                      );
                    }),
                    (t.esds = function (t) {
                      const e = t.config.length;
                      return new Uint8Array(
                        [0, 0, 0, 0, 3, 23 + e, 0, 1, 0, 4, 15 + e, 64, 21, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5]
                          .concat([e])
                          .concat(t.config)
                          .concat([6, 1, 2])
                      );
                    }),
                    (t.mp4a = function (e) {
                      const r = e.samplerate;
                      return t.box(
                        t.types.mp4a,
                        new Uint8Array([
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          1,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          e.channelCount,
                          0,
                          16,
                          0,
                          0,
                          0,
                          0,
                          (r >> 8) & 255,
                          255 & r,
                          0,
                          0,
                        ]),
                        t.box(t.types.esds, t.esds(e))
                      );
                    }),
                    (t.mp3 = function (e) {
                      const r = e.samplerate;
                      return t.box(
                        t.types['.mp3'],
                        new Uint8Array([
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          1,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          e.channelCount,
                          0,
                          16,
                          0,
                          0,
                          0,
                          0,
                          (r >> 8) & 255,
                          255 & r,
                          0,
                          0,
                        ])
                      );
                    }),
                    (t.stsd = function (e) {
                      return 'audio' === e.type
                        ? e.isAAC || 'mp3' !== e.codec
                          ? t.box(t.types.stsd, t.STSD, t.mp4a(e))
                          : t.box(t.types.stsd, t.STSD, t.mp3(e))
                        : t.box(t.types.stsd, t.STSD, t.avc1(e));
                    }),
                    (t.tkhd = function (e) {
                      const r = e.id,
                        n = e.duration * e.timescale,
                        s = e.width,
                        a = e.height,
                        o = Math.floor(n / (i + 1)),
                        l = Math.floor(n % (i + 1));
                      return t.box(
                        t.types.tkhd,
                        new Uint8Array([
                          1,
                          0,
                          0,
                          7,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          2,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          3,
                          (r >> 24) & 255,
                          (r >> 16) & 255,
                          (r >> 8) & 255,
                          255 & r,
                          0,
                          0,
                          0,
                          0,
                          o >> 24,
                          (o >> 16) & 255,
                          (o >> 8) & 255,
                          255 & o,
                          l >> 24,
                          (l >> 16) & 255,
                          (l >> 8) & 255,
                          255 & l,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          1,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          1,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          64,
                          0,
                          0,
                          0,
                          (s >> 8) & 255,
                          255 & s,
                          0,
                          0,
                          (a >> 8) & 255,
                          255 & a,
                          0,
                          0,
                        ])
                      );
                    }),
                    (t.traf = function (e, r) {
                      const n = t.sdtp(e),
                        s = e.id,
                        a = Math.floor(r / (i + 1)),
                        o = Math.floor(r % (i + 1));
                      return t.box(
                        t.types.traf,
                        t.box(
                          t.types.tfhd,
                          new Uint8Array([0, 0, 0, 0, s >> 24, (s >> 16) & 255, (s >> 8) & 255, 255 & s])
                        ),
                        t.box(
                          t.types.tfdt,
                          new Uint8Array([
                            1,
                            0,
                            0,
                            0,
                            a >> 24,
                            (a >> 16) & 255,
                            (a >> 8) & 255,
                            255 & a,
                            o >> 24,
                            (o >> 16) & 255,
                            (o >> 8) & 255,
                            255 & o,
                          ])
                        ),
                        t.trun(e, n.length + 16 + 20 + 8 + 16 + 8 + 8),
                        n
                      );
                    }),
                    (t.trak = function (e) {
                      return (e.duration = e.duration || 4294967295), t.box(t.types.trak, t.tkhd(e), t.mdia(e));
                    }),
                    (t.trex = function (e) {
                      const r = e.id;
                      return t.box(
                        t.types.trex,
                        new Uint8Array([
                          0,
                          0,
                          0,
                          0,
                          r >> 24,
                          (r >> 16) & 255,
                          (r >> 8) & 255,
                          255 & r,
                          0,
                          0,
                          0,
                          1,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          1,
                          0,
                          1,
                        ])
                      );
                    }),
                    (t.trun = function (e, r) {
                      let i,
                        n,
                        s,
                        a,
                        o,
                        l,
                        u = e.samples || [],
                        c = u.length,
                        d = 12 + 16 * c,
                        f = new Uint8Array(d);
                      for (
                        r += 8 + d,
                          f.set(
                            [
                              0,
                              0,
                              15,
                              1,
                              (c >>> 24) & 255,
                              (c >>> 16) & 255,
                              (c >>> 8) & 255,
                              255 & c,
                              (r >>> 24) & 255,
                              (r >>> 16) & 255,
                              (r >>> 8) & 255,
                              255 & r,
                            ],
                            0
                          ),
                          i = 0;
                        i < c;
                        i++
                      )
                        (s = (n = u[i]).duration),
                          (a = n.size),
                          (o = n.flags),
                          (l = n.cts),
                          f.set(
                            [
                              (s >>> 24) & 255,
                              (s >>> 16) & 255,
                              (s >>> 8) & 255,
                              255 & s,
                              (a >>> 24) & 255,
                              (a >>> 16) & 255,
                              (a >>> 8) & 255,
                              255 & a,
                              (o.isLeading << 2) | o.dependsOn,
                              (o.isDependedOn << 6) | (o.hasRedundancy << 4) | (o.paddingValue << 1) | o.isNonSync,
                              61440 & o.degradPrio,
                              15 & o.degradPrio,
                              (l >>> 24) & 255,
                              (l >>> 16) & 255,
                              (l >>> 8) & 255,
                              255 & l,
                            ],
                            12 + 16 * i
                          );
                      return t.box(t.types.trun, f);
                    }),
                    (t.initSegment = function (e) {
                      t.types || t.init();
                      const r = t.moov(e),
                        i = new Uint8Array(t.FTYP.byteLength + r.byteLength);
                      return i.set(t.FTYP), i.set(r, t.FTYP.byteLength), i;
                    }),
                    t
                  );
                })();
              (n.types = void 0),
                (n.HDLR_TYPES = void 0),
                (n.STTS = void 0),
                (n.STSC = void 0),
                (n.STCO = void 0),
                (n.STSZ = void 0),
                (n.VMHD = void 0),
                (n.SMHD = void 0),
                (n.STSD = void 0),
                (n.FTYP = void 0),
                (n.DINF = void 0),
                (e.default = n);
            },
          './src/remux/mp4-remuxer.ts':
            /*!**********************************!*\
  !*** ./src/remux/mp4-remuxer.ts ***!
  \**********************************/
            /*! exports provided: default, normalizePts */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return v;
                }),
                r.d(e, 'normalizePts', function () {
                  return g;
                });
              const i = r(/*! ./src/polyfills/number */ './src/polyfills/number.ts'),
                n = r(/*! ./aac-helper */ './src/remux/aac-helper.ts'),
                s = r(/*! ./mp4-generator */ './src/remux/mp4-generator.ts'),
                a = r(/*! ../events */ './src/events.ts'),
                o = r(/*! ../errors */ './src/errors.ts'),
                l = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                u = r(/*! ../types/loader */ './src/types/loader.ts'),
                c = r(/*! ../utils/timescale-conversion */ './src/utils/timescale-conversion.ts');
              function d() {
                return (d =
                  Object.assign ||
                  function (t) {
                    for (let e = 1; e < arguments.length; e++) {
                      const r = arguments[e];
                      for (const i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
                    }
                    return t;
                  }).apply(this, arguments);
              }
              var f = null,
                h = null,
                p = !1,
                v = (function () {
                  function t(t, e, r, i) {
                    if (
                      (void 0 === i && (i = ''),
                      (this.observer = void 0),
                      (this.config = void 0),
                      (this.typeSupported = void 0),
                      (this.ISGenerated = !1),
                      (this._initPTS = void 0),
                      (this._initDTS = void 0),
                      (this.nextAvcDts = null),
                      (this.nextAudioPts = null),
                      (this.isAudioContiguous = !1),
                      (this.isVideoContiguous = !1),
                      (this.observer = t),
                      (this.config = e),
                      (this.typeSupported = r),
                      (this.ISGenerated = !1),
                      null === f)
                    ) {
                      const n = (navigator.userAgent || '').match(/Chrome\/(\d+)/i);
                      f = n ? parseInt(n[1]) : 0;
                    }
                    if (null === h) {
                      const s = navigator.userAgent.match(/Safari\/(\d+)/i);
                      h = s ? parseInt(s[1]) : 0;
                    }
                    p = (!!f && f < 75) || (!!h && h < 600);
                  }
                  const e = t.prototype;
                  return (
                    (e.destroy = function () {}),
                    (e.resetTimeStamp = function (t) {
                      l.logger.log('[mp4-remuxer]: initPTS & initDTS reset'), (this._initPTS = this._initDTS = t);
                    }),
                    (e.resetNextTimestamp = function () {
                      l.logger.log('[mp4-remuxer]: reset next timestamp'),
                        (this.isVideoContiguous = !1),
                        (this.isAudioContiguous = !1);
                    }),
                    (e.resetInitSegment = function () {
                      l.logger.log('[mp4-remuxer]: ISGenerated flag reset'), (this.ISGenerated = !1);
                    }),
                    (e.getVideoStartPts = function (t) {
                      let e = !1,
                        r = t.reduce(function (t, r) {
                          const i = r.pts - t;
                          return i < -4294967296 ? ((e = !0), g(t, r.pts)) : i > 0 ? t : r.pts;
                        }, t[0].pts);
                      return e && l.logger.debug('PTS rollover detected'), r;
                    }),
                    (e.remux = function (t, e, r, i, n, s, a, o) {
                      let c,
                        d,
                        f,
                        h,
                        p,
                        v,
                        m = n,
                        y = n,
                        E = t.pid > -1,
                        T = e.pid > -1,
                        b = e.samples.length,
                        S = t.samples.length > 0,
                        L = b > 1;
                      if (((!E || S) && (!T || L)) || this.ISGenerated || a) {
                        this.ISGenerated || (f = this.generateIS(t, e, n));
                        let A = this.isVideoContiguous,
                          D = -1;
                        if (
                          L &&
                          ((D = (function (t) {
                            for (let e = 0; e < t.length; e++) if (t[e].key) return e;
                            return -1;
                          })(e.samples)),
                          !A && this.config.forceKeyFrameOnDiscontinuity)
                        )
                          if (((v = !0), D > 0)) {
                            l.logger.warn(
                              '[mp4-remuxer]: Dropped ' +
                                D +
                                ' out of ' +
                                b +
                                ' video samples due to a missing keyframe'
                            );
                            const k = this.getVideoStartPts(e.samples);
                            (e.samples = e.samples.slice(D)),
                              (e.dropped += D),
                              (y += (e.samples[0].pts - k) / (e.timescale || 9e4));
                          } else
                            -1 === D &&
                              (l.logger.warn('[mp4-remuxer]: No keyframe found out of ' + b + ' video samples'),
                              (v = !1));
                        if (this.ISGenerated) {
                          if (S && L) {
                            const C = this.getVideoStartPts(e.samples),
                              x = (g(t.samples[0].pts, C) - C) / e.inputTimeScale;
                            (m += Math.max(0, x)), (y += Math.max(0, -x));
                          }
                          if (S) {
                            if (
                              (t.samplerate ||
                                (l.logger.warn('[mp4-remuxer]: regenerate InitSegment as audio detected'),
                                (f = this.generateIS(t, e, n))),
                              (d = this.remuxAudio(
                                t,
                                m,
                                this.isAudioContiguous,
                                s,
                                T || L || o === u.PlaylistLevelType.AUDIO ? y : void 0
                              )),
                              L)
                            ) {
                              const R = d ? d.endPTS - d.startPTS : 0;
                              e.inputTimeScale ||
                                (l.logger.warn('[mp4-remuxer]: regenerate InitSegment as video detected'),
                                (f = this.generateIS(t, e, n))),
                                (c = this.remuxVideo(e, y, A, R));
                            }
                          } else L && (c = this.remuxVideo(e, y, A, 0));
                          c && ((c.firstKeyFrame = D), (c.independent = -1 !== D));
                        }
                      }
                      return (
                        this.ISGenerated &&
                          (r.samples.length && (p = this.remuxID3(r, n)),
                          i.samples.length && (h = this.remuxText(i, n))),
                        { audio: d, video: c, initSegment: f, independent: v, text: h, id3: p }
                      );
                    }),
                    (e.generateIS = function (t, e, r) {
                      let n,
                        a,
                        o,
                        l = t.samples,
                        u = e.samples,
                        c = this.typeSupported,
                        d = {},
                        f = !Object(i.isFiniteNumber)(this._initPTS),
                        h = 'audio/mp4';
                      if (
                        (f && (n = a = 1 / 0),
                        t.config &&
                          l.length &&
                          ((t.timescale = t.samplerate),
                          t.isAAC || (c.mpeg ? ((h = 'audio/mpeg'), (t.codec = '')) : c.mp3 && (t.codec = 'mp3')),
                          (d.audio = {
                            id: 'audio',
                            container: h,
                            codec: t.codec,
                            initSegment: !t.isAAC && c.mpeg ? new Uint8Array(0) : s.default.initSegment([t]),
                            metadata: { channelCount: t.channelCount },
                          }),
                          f && ((o = t.inputTimeScale), (n = a = l[0].pts - Math.round(o * r)))),
                        e.sps &&
                          e.pps &&
                          u.length &&
                          ((e.timescale = e.inputTimeScale),
                          (d.video = {
                            id: 'main',
                            container: 'video/mp4',
                            codec: e.codec,
                            initSegment: s.default.initSegment([e]),
                            metadata: { width: e.width, height: e.height },
                          }),
                          f))
                      ) {
                        o = e.inputTimeScale;
                        const p = this.getVideoStartPts(u),
                          v = Math.round(o * r);
                        (a = Math.min(a, g(u[0].dts, p) - v)), (n = Math.min(n, p - v));
                      }
                      if (Object.keys(d).length)
                        return (
                          (this.ISGenerated = !0),
                          f && ((this._initPTS = n), (this._initDTS = a)),
                          { tracks: d, initPTS: n, timescale: o }
                        );
                    }),
                    (e.remuxVideo = function (t, e, r, i) {
                      let n,
                        u,
                        h,
                        v = t.inputTimeScale,
                        y = t.samples,
                        E = [],
                        T = y.length,
                        b = this._initPTS,
                        S = this.nextAvcDts,
                        L = 8,
                        A = Number.POSITIVE_INFINITY,
                        D = Number.NEGATIVE_INFINITY,
                        k = 0,
                        C = !1;
                      (r && null !== S) || (S = e * v - (y[0].pts - g(y[0].dts, y[0].pts)));
                      for (let x = 0; x < T; x++) {
                        const R = y[x];
                        if (((R.pts = g(R.pts - b, S)), (R.dts = g(R.dts - b, S)), R.dts > R.pts)) {
                          k = Math.max(Math.min(k, R.pts - R.dts), -18e3);
                        }
                        R.dts < y[x > 0 ? x - 1 : x].dts && (C = !0);
                      }
                      C &&
                        y.sort(function (t, e) {
                          const r = t.dts - e.dts,
                            i = t.pts - e.pts;
                          return r || i;
                        }),
                        (u = y[0].dts),
                        (h = y[y.length - 1].dts);
                      const w = Math.round((h - u) / (T - 1));
                      if (k < 0) {
                        if (k < -2 * w) {
                          l.logger.warn(
                            'PTS < DTS detected in video samples, offsetting DTS from PTS by ' +
                              Object(c.toMsFromMpegTsClock)(-w, !0) +
                              ' ms'
                          );
                          for (let _ = k, I = 0; I < T; I++)
                            (y[I].dts = _ = Math.max(_, y[I].pts - w)), (y[I].pts = Math.max(_, y[I].pts));
                        } else {
                          l.logger.warn(
                            'PTS < DTS detected in video samples, shifting DTS by ' +
                              Object(c.toMsFromMpegTsClock)(k, !0) +
                              ' ms to overcome this issue'
                          );
                          for (let O = 0; O < T; O++) y[O].dts = y[O].dts + k;
                        }
                        u = y[0].dts;
                      }
                      if (r) {
                        const P = u - S,
                          F = P > w;
                        if (F || P < -1) {
                          F
                            ? l.logger.warn(
                                'AVC: ' +
                                  Object(c.toMsFromMpegTsClock)(P, !0) +
                                  ' ms (' +
                                  P +
                                  'dts) hole between fragments detected, filling it'
                              )
                            : l.logger.warn(
                                'AVC: ' +
                                  Object(c.toMsFromMpegTsClock)(-P, !0) +
                                  ' ms (' +
                                  P +
                                  'dts) overlapping between fragments detected'
                              ),
                            (u = S);
                          const M = y[0].pts - P;
                          (y[0].dts = u),
                            (y[0].pts = M),
                            l.logger.log(
                              'Video: First PTS/DTS adjusted: ' +
                                Object(c.toMsFromMpegTsClock)(M, !0) +
                                '/' +
                                Object(c.toMsFromMpegTsClock)(u, !0) +
                                ', delta: ' +
                                Object(c.toMsFromMpegTsClock)(P, !0) +
                                ' ms'
                            );
                        }
                      }
                      p && (u = Math.max(0, u));
                      for (var N = 0, B = 0, U = 0; U < T; U++) {
                        for (var j = y[U], G = j.units, H = G.length, K = 0, V = 0; V < H; V++) K += G[V].data.length;
                        (B += K),
                          (N += H),
                          (j.length = K),
                          (j.dts = Math.max(j.dts, u)),
                          (j.pts = Math.max(j.pts, j.dts, 0)),
                          (A = Math.min(j.pts, A)),
                          (D = Math.max(j.pts, D));
                      }
                      h = y[T - 1].dts;
                      let q,
                        W = B + 4 * N + 8;
                      try {
                        q = new Uint8Array(W);
                      } catch (t) {
                        return void this.observer.emit(a.Events.ERROR, a.Events.ERROR, {
                          type: o.ErrorTypes.MUX_ERROR,
                          details: o.ErrorDetails.REMUX_ALLOC_ERROR,
                          fatal: !1,
                          bytes: W,
                          reason: 'fail allocating video mdat ' + W,
                        });
                      }
                      const Y = new DataView(q.buffer);
                      Y.setUint32(0, W), q.set(s.default.types.mdat, 4);
                      for (let X = 0; X < T; X++) {
                        for (var z = y[X], $ = z.units, Q = 0, J = 0, Z = $.length; J < Z; J++) {
                          const tt = $[J],
                            et = tt.data,
                            rt = tt.data.byteLength;
                          Y.setUint32(L, rt), (L += 4), q.set(et, L), (L += rt), (Q += 4 + rt);
                        }
                        if (X < T - 1) n = y[X + 1].dts - z.dts;
                        else {
                          const it = this.config,
                            nt = z.dts - y[X > 0 ? X - 1 : X].dts;
                          if (it.stretchShortVideoTrack && null !== this.nextAudioPts) {
                            const st = Math.floor(it.maxBufferHole * v),
                              at = (i ? A + i * v : this.nextAudioPts) - z.pts;
                            at > st
                              ? ((n = at - nt) < 0 && (n = nt),
                                l.logger.log(
                                  '[mp4-remuxer]: It is approximately ' +
                                    at / 90 +
                                    ' ms to the next segment; using duration ' +
                                    n / 90 +
                                    ' ms for the last video frame.'
                                ))
                              : (n = nt);
                          } else n = nt;
                        }
                        const ot = Math.round(z.pts - z.dts);
                        E.push(new m(z.key, n, Q, ot));
                      }
                      if (E.length && f && f < 70) {
                        const lt = E[0].flags;
                        (lt.dependsOn = 2), (lt.isNonSync = 0);
                      }
                      console.assert(void 0 !== n, 'mp4SampleDuration must be computed'),
                        (this.nextAvcDts = S = h + n),
                        (this.isVideoContiguous = !0);
                      const ut = {
                        data1: s.default.moof(t.sequenceNumber++, u, d({}, t, { samples: E })),
                        data2: q,
                        startPTS: A / v,
                        endPTS: (D + n) / v,
                        startDTS: u / v,
                        endDTS: S / v,
                        type: 'video',
                        hasAudio: !1,
                        hasVideo: !0,
                        nb: E.length,
                        dropped: t.dropped,
                      };
                      return (
                        (t.samples = []), (t.dropped = 0), console.assert(q.length, 'MDAT length must not be zero'), ut
                      );
                    }),
                    (e.remuxAudio = function (t, e, r, i, u) {
                      let c = t.inputTimeScale,
                        f = c / (t.samplerate ? t.samplerate : c),
                        h = t.isAAC ? 1024 : 1152,
                        p = h * f,
                        v = this._initPTS,
                        y = !t.isAAC && this.typeSupported.mpeg,
                        E = [],
                        T = t.samples,
                        b = y ? 0 : 8,
                        S = this.nextAudioPts || -1,
                        L = e * c;
                      if (
                        ((this.isAudioContiguous = r =
                          r ||
                          (T.length &&
                            S > 0 &&
                            ((i && Math.abs(L - S) < 9e3) || Math.abs(g(T[0].pts - v, L) - S) < 20 * p))),
                        T.forEach(function (t) {
                          t.pts = g(t.pts - v, L);
                        }),
                        !r || S < 0)
                      ) {
                        if (
                          !(T = T.filter(function (t) {
                            return t.pts >= 0;
                          })).length
                        )
                          return;
                        S = 0 === u ? 0 : i ? Math.max(0, L) : T[0].pts;
                      }
                      if (t.isAAC)
                        for (
                          let A = void 0 !== u, D = this.config.maxAudioFramesDrift, k = 0, C = S;
                          k < T.length;
                          k++
                        ) {
                          const x = T[k],
                            R = x.pts,
                            w = R - C,
                            _ = Math.abs((1e3 * w) / c);
                          if (w <= -D * p && A)
                            0 === k &&
                              (l.logger.warn(
                                'Audio frame @ ' +
                                  (R / c).toFixed(3) +
                                  's overlaps nextAudioPts by ' +
                                  Math.round((1e3 * w) / c) +
                                  ' ms.'
                              ),
                              (this.nextAudioPts = S = C = R));
                          else if (w >= D * p && _ < 1e4 && A) {
                            let I = Math.round(w / p);
                            (C = R - I * p) < 0 && (I--, (C += p)),
                              0 === k && (this.nextAudioPts = S = C),
                              l.logger.warn(
                                '[mp4-remuxer]: Injecting ' +
                                  I +
                                  ' audio frame @ ' +
                                  (C / c).toFixed(3) +
                                  's due to ' +
                                  Math.round((1e3 * w) / c) +
                                  ' ms gap.'
                              );
                            for (let O = 0; O < I; O++) {
                              let P = Math.max(C, 0),
                                F = n.default.getSilentFrame(t.manifestCodec || t.codec, t.channelCount);
                              F ||
                                (l.logger.log(
                                  '[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead.'
                                ),
                                (F = x.unit.subarray())),
                                T.splice(k, 0, { unit: F, pts: P }),
                                (C += p),
                                k++;
                            }
                          }
                          (x.pts = C), (C += p);
                        }
                      for (var M, N = null, B = null, U = 0, j = T.length; j--; ) U += T[j].unit.byteLength;
                      for (let G = 0, H = T.length; G < H; G++) {
                        let K = T[G],
                          V = K.unit,
                          q = K.pts;
                        if (null !== B) {
                          E[G - 1].duration = Math.round((q - B) / f);
                        } else {
                          if ((r && t.isAAC && (q = S), (N = q), !(U > 0))) return;
                          U += b;
                          try {
                            M = new Uint8Array(U);
                          } catch (t) {
                            return void this.observer.emit(a.Events.ERROR, a.Events.ERROR, {
                              type: o.ErrorTypes.MUX_ERROR,
                              details: o.ErrorDetails.REMUX_ALLOC_ERROR,
                              fatal: !1,
                              bytes: U,
                              reason: 'fail allocating audio mdat ' + U,
                            });
                          }
                          y || (new DataView(M.buffer).setUint32(0, U), M.set(s.default.types.mdat, 4));
                        }
                        M.set(V, b);
                        const W = V.byteLength;
                        (b += W), E.push(new m(!0, h, W, 0)), (B = q);
                      }
                      const Y = E.length;
                      if (Y) {
                        const X = E[E.length - 1];
                        this.nextAudioPts = S = B + f * X.duration;
                        const z = y
                          ? new Uint8Array(0)
                          : s.default.moof(t.sequenceNumber++, N / f, d({}, t, { samples: E }));
                        t.samples = [];
                        const $ = N / c,
                          Q = S / c,
                          J = {
                            data1: z,
                            data2: M,
                            startPTS: $,
                            endPTS: Q,
                            startDTS: $,
                            endDTS: Q,
                            type: 'audio',
                            hasAudio: !0,
                            hasVideo: !1,
                            nb: Y,
                          };
                        return (
                          (this.isAudioContiguous = !0), console.assert(M.length, 'MDAT length must not be zero'), J
                        );
                      }
                    }),
                    (e.remuxEmptyAudio = function (t, e, r, i) {
                      const s = t.inputTimeScale,
                        a = s / (t.samplerate ? t.samplerate : s),
                        o = this.nextAudioPts,
                        u = (null !== o ? o : i.startDTS * s) + this._initDTS,
                        c = i.endDTS * s + this._initDTS,
                        d = 1024 * a,
                        f = Math.ceil((c - u) / d),
                        h = n.default.getSilentFrame(t.manifestCodec || t.codec, t.channelCount);
                      if ((l.logger.warn('[mp4-remuxer]: remux empty Audio'), h)) {
                        for (var p = [], v = 0; v < f; v++) {
                          const g = u + v * d;
                          p.push({ unit: h, pts: g, dts: g });
                        }
                        return (t.samples = p), this.remuxAudio(t, e, r, !1);
                      }
                      l.logger.trace(
                        '[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec'
                      );
                    }),
                    (e.remuxID3 = function (t, e) {
                      const r = t.samples.length;
                      if (r) {
                        for (let i = t.inputTimeScale, n = this._initPTS, s = this._initDTS, a = 0; a < r; a++) {
                          const o = t.samples[a];
                          (o.pts = g(o.pts - n, e * i) / i), (o.dts = g(o.dts - s, e * i) / i);
                        }
                        const l = t.samples;
                        return (t.samples = []), { samples: l };
                      }
                    }),
                    (e.remuxText = function (t, e) {
                      const r = t.samples.length;
                      if (r) {
                        for (let i = t.inputTimeScale, n = this._initPTS, s = 0; s < r; s++) {
                          const a = t.samples[s];
                          a.pts = g(a.pts - n, e * i) / i;
                        }
                        t.samples.sort(function (t, e) {
                          return t.pts - e.pts;
                        });
                        const o = t.samples;
                        return (t.samples = []), { samples: o };
                      }
                    }),
                    t
                  );
                })();
              function g(t, e) {
                let r;
                if (null === e) return t;
                for (r = e < t ? -8589934592 : 8589934592; Math.abs(t - e) > 4294967296; ) t += r;
                return t;
              }
              var m = function (t, e, r, i) {
                  (this.size = void 0),
                    (this.duration = void 0),
                    (this.cts = void 0),
                    (this.flags = void 0),
                    (this.duration = e),
                    (this.size = r),
                    (this.cts = i),
                    (this.flags = new y(t));
                },
                y = function (t) {
                  (this.isLeading = 0),
                    (this.isDependedOn = 0),
                    (this.hasRedundancy = 0),
                    (this.degradPrio = 0),
                    (this.dependsOn = 1),
                    (this.isNonSync = 1),
                    (this.dependsOn = t ? 2 : 1),
                    (this.isNonSync = t ? 0 : 1);
                };
            },
          './src/remux/passthrough-remuxer.ts':
            /*!******************************************!*\
  !*** ./src/remux/passthrough-remuxer.ts ***!
  \******************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              var i = r(/*! ./src/polyfills/number */ './src/polyfills/number.ts'),
                n = r(/*! ../utils/mp4-tools */ './src/utils/mp4-tools.ts'),
                s = r(/*! ../loader/fragment */ './src/loader/fragment.ts'),
                a = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                o = (function () {
                  function t() {
                    (this.emitInitSegment = !1),
                      (this.audioCodec = void 0),
                      (this.videoCodec = void 0),
                      (this.initData = void 0),
                      (this.initPTS = void 0),
                      (this.initTracks = void 0),
                      (this.lastEndDTS = null);
                  }
                  const e = t.prototype;
                  return (
                    (e.destroy = function () {}),
                    (e.resetTimeStamp = function (t) {
                      (this.initPTS = t), (this.lastEndDTS = null);
                    }),
                    (e.resetNextTimestamp = function () {
                      this.lastEndDTS = null;
                    }),
                    (e.resetInitSegment = function (t, e, r) {
                      (this.audioCodec = e),
                        (this.videoCodec = r),
                        this.generateInitSegment(t),
                        (this.emitInitSegment = !0);
                    }),
                    (e.generateInitSegment = function (t) {
                      let e = this.audioCodec,
                        r = this.videoCodec;
                      if (!t || !t.byteLength) return (this.initTracks = void 0), void (this.initData = void 0);
                      const i = (this.initData = Object(n.parseInitSegment)(t));
                      e || (e = u(i.audio, s.ElementaryStreamTypes.AUDIO)),
                        r || (r = u(i.video, s.ElementaryStreamTypes.VIDEO));
                      const o = {};
                      i.audio && i.video
                        ? (o.audiovideo = { container: 'video/mp4', codec: e + ',' + r, initSegment: t, id: 'main' })
                        : i.audio
                          ? (o.audio = { container: 'audio/mp4', codec: e, initSegment: t, id: 'audio' })
                          : i.video
                            ? (o.video = { container: 'video/mp4', codec: r, initSegment: t, id: 'main' })
                            : a.logger.warn(
                                '[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes.'
                              ),
                        (this.initTracks = o);
                    }),
                    (e.remux = function (t, e, r, s, o) {
                      let u = this.initPTS,
                        c = this.lastEndDTS,
                        d = { audio: void 0, video: void 0, text: s, id3: r, initSegment: void 0 };
                      Object(i.isFiniteNumber)(c) || (c = this.lastEndDTS = o || 0);
                      const f = e.samples;
                      if (!f || !f.length) return d;
                      let h = { initPTS: void 0, timescale: 1 },
                        p = this.initData;
                      if (((p && p.length) || (this.generateInitSegment(f), (p = this.initData)), !p || !p.length))
                        return a.logger.warn('[passthrough-remuxer.ts]: Failed to generate initSegment.'), d;
                      this.emitInitSegment && ((h.tracks = this.initTracks), (this.emitInitSegment = !1)),
                        Object(i.isFiniteNumber)(u) || (this.initPTS = h.initPTS = u = l(p, f, c));
                      const v = Object(n.getDuration)(f, p),
                        g = c,
                        m = v + g;
                      Object(n.offsetStartDTS)(p, f, u),
                        v > 0
                          ? (this.lastEndDTS = m)
                          : (a.logger.warn('Duration parsed from mp4 should be greater than zero'),
                            this.resetNextTimestamp());
                      let y = !!p.audio,
                        E = !!p.video,
                        T = '';
                      y && (T += 'audio'), E && (T += 'video');
                      const b = {
                        data1: f,
                        startPTS: g,
                        startDTS: g,
                        endPTS: m,
                        endDTS: m,
                        type: T,
                        hasAudio: y,
                        hasVideo: E,
                        nb: 1,
                        dropped: 0,
                      };
                      return (
                        (d.audio = 'audio' === b.type ? b : void 0),
                        (d.video = 'audio' !== b.type ? b : void 0),
                        (d.text = s),
                        (d.id3 = r),
                        (d.initSegment = h),
                        d
                      );
                    }),
                    t
                  );
                })(),
                l = function (t, e, r) {
                  return Object(n.getStartDTS)(t, e) - r;
                };
              function u(t, e) {
                const r = null === t || void 0 === t ? void 0 : t.codec;
                return r && r.length > 4
                  ? r
                  : 'hvc1' === r
                    ? 'hvc1.1.c.L120.90'
                    : 'av01' === r
                      ? 'av01.0.04M.08'
                      : 'avc1' === r || e === s.ElementaryStreamTypes.VIDEO
                        ? 'avc1.42e01e'
                        : 'mp4a.40.5';
              }
              e.default = o;
            },
          './src/task-loop.ts':
            /*!**************************!*\
  !*** ./src/task-loop.ts ***!
  \**************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return i;
                });
              var i = (function () {
                function t() {
                  (this._boundTick = void 0),
                    (this._tickTimer = null),
                    (this._tickInterval = null),
                    (this._tickCallCount = 0),
                    (this._boundTick = this.tick.bind(this));
                }
                const e = t.prototype;
                return (
                  (e.destroy = function () {
                    this.onHandlerDestroying(), this.onHandlerDestroyed();
                  }),
                  (e.onHandlerDestroying = function () {
                    this.clearNextTick(), this.clearInterval();
                  }),
                  (e.onHandlerDestroyed = function () {}),
                  (e.hasInterval = function () {
                    return !!this._tickInterval;
                  }),
                  (e.hasNextTick = function () {
                    return !!this._tickTimer;
                  }),
                  (e.setInterval = function (t) {
                    return !this._tickInterval && ((this._tickInterval = self.setInterval(this._boundTick, t)), !0);
                  }),
                  (e.clearInterval = function () {
                    return (
                      !!this._tickInterval && (self.clearInterval(this._tickInterval), (this._tickInterval = null), !0)
                    );
                  }),
                  (e.clearNextTick = function () {
                    return !!this._tickTimer && (self.clearTimeout(this._tickTimer), (this._tickTimer = null), !0);
                  }),
                  (e.tick = function () {
                    this._tickCallCount++,
                      1 === this._tickCallCount &&
                        (this.doTick(), this._tickCallCount > 1 && this.tickImmediate(), (this._tickCallCount = 0));
                  }),
                  (e.tickImmediate = function () {
                    this.clearNextTick(), (this._tickTimer = self.setTimeout(this._boundTick, 0));
                  }),
                  (e.doTick = function () {}),
                  t
                );
              })();
            },
          './src/types/cmcd.ts':
            /*!***************************!*\
  !*** ./src/types/cmcd.ts ***!
  \***************************/
            /*! exports provided: CMCDVersion, CMCDObjectType, CMCDStreamingFormat, CMCDStreamType */ function (
              t,
              e,
              r
            ) {
              'use strict';
              r.r(e),
                r.d(e, 'CMCDVersion', function () {
                  return a;
                }),
                r.d(e, 'CMCDObjectType', function () {
                  return i;
                }),
                r.d(e, 'CMCDStreamingFormat', function () {
                  return n;
                }),
                r.d(e, 'CMCDStreamType', function () {
                  return s;
                });
              var i,
                n,
                s,
                a = 1;
              !(function (t) {
                (t.MANIFEST = 'm'),
                  (t.AUDIO = 'a'),
                  (t.VIDEO = 'v'),
                  (t.MUXED = 'av'),
                  (t.INIT = 'i'),
                  (t.CAPTION = 'c'),
                  (t.TIMED_TEXT = 'tt'),
                  (t.KEY = 'k'),
                  (t.OTHER = 'o');
              })(i || (i = {})),
                (function (t) {
                  (t.DASH = 'd'), (t.HLS = 'h'), (t.SMOOTH = 's'), (t.OTHER = 'o');
                })(n || (n = {})),
                (function (t) {
                  (t.VOD = 'v'), (t.LIVE = 'l');
                })(s || (s = {}));
            },
          './src/types/level.ts':
            /*!****************************!*\
  !*** ./src/types/level.ts ***!
  \****************************/
            /*! exports provided: HlsSkip, getSkipValue, HlsUrlParameters, Level */ function (t, e, r) {
              'use strict';
              function i(t, e) {
                for (let r = 0; r < e.length; r++) {
                  const i = e[r];
                  (i.enumerable = i.enumerable || !1),
                    (i.configurable = !0),
                    'value' in i && (i.writable = !0),
                    Object.defineProperty(t, i.key, i);
                }
              }
              let n;
              function s(t, e) {
                const r = t.canSkipUntil,
                  i = t.canSkipDateRanges,
                  s = t.endSN;
                return r && (void 0 !== e ? e - s : 0) < r ? (i ? n.v2 : n.Yes) : n.No;
              }
              r.r(e),
                r.d(e, 'HlsSkip', function () {
                  return n;
                }),
                r.d(e, 'getSkipValue', function () {
                  return s;
                }),
                r.d(e, 'HlsUrlParameters', function () {
                  return a;
                }),
                r.d(e, 'Level', function () {
                  return o;
                }),
                (function (t) {
                  (t.No = ''), (t.Yes = 'YES'), (t.v2 = 'v2');
                })(n || (n = {}));
              var a = (function () {
                  function t(t, e, r) {
                    (this.msn = void 0),
                      (this.part = void 0),
                      (this.skip = void 0),
                      (this.msn = t),
                      (this.part = e),
                      (this.skip = r);
                  }
                  return (
                    (t.prototype.addDirectives = function (t) {
                      const e = new self.URL(t);
                      return (
                        void 0 !== this.msn && e.searchParams.set('_HLS_msn', this.msn.toString()),
                        void 0 !== this.part && e.searchParams.set('_HLS_part', this.part.toString()),
                        this.skip && e.searchParams.set('_HLS_skip', this.skip),
                        e.toString()
                      );
                    }),
                    t
                  );
                })(),
                o = (function () {
                  function t(t) {
                    (this.attrs = void 0),
                      (this.audioCodec = void 0),
                      (this.bitrate = void 0),
                      (this.codecSet = void 0),
                      (this.height = void 0),
                      (this.id = void 0),
                      (this.name = void 0),
                      (this.videoCodec = void 0),
                      (this.width = void 0),
                      (this.unknownCodecs = void 0),
                      (this.audioGroupIds = void 0),
                      (this.details = void 0),
                      (this.fragmentError = 0),
                      (this.loadError = 0),
                      (this.loaded = void 0),
                      (this.realBitrate = 0),
                      (this.textGroupIds = void 0),
                      (this.url = void 0),
                      (this._urlId = 0),
                      (this.url = [t.url]),
                      (this.attrs = t.attrs),
                      (this.bitrate = t.bitrate),
                      t.details && (this.details = t.details),
                      (this.id = t.id || 0),
                      (this.name = t.name),
                      (this.width = t.width || 0),
                      (this.height = t.height || 0),
                      (this.audioCodec = t.audioCodec),
                      (this.videoCodec = t.videoCodec),
                      (this.unknownCodecs = t.unknownCodecs),
                      (this.codecSet = [t.videoCodec, t.audioCodec]
                        .filter(function (t) {
                          return t;
                        })
                        .join(',')
                        .replace(/\.[^.,]+/g, ''));
                  }
                  return (
                    (function (t, e, r) {
                      e && i(t.prototype, e), r && i(t, r);
                    })(t, [
                      {
                        key: 'maxBitrate',
                        get: function () {
                          return Math.max(this.realBitrate, this.bitrate);
                        },
                      },
                      {
                        key: 'uri',
                        get: function () {
                          return this.url[this._urlId] || '';
                        },
                      },
                      {
                        key: 'urlId',
                        get: function () {
                          return this._urlId;
                        },
                        set: function (t) {
                          const e = t % this.url.length;
                          this._urlId !== e && ((this.details = void 0), (this._urlId = e));
                        },
                      },
                    ]),
                    t
                  );
                })();
            },
          './src/types/loader.ts':
            /*!*****************************!*\
  !*** ./src/types/loader.ts ***!
  \*****************************/
            /*! exports provided: PlaylistContextType, PlaylistLevelType */ function (t, e, r) {
              'use strict';
              let i, n;
              r.r(e),
                r.d(e, 'PlaylistContextType', function () {
                  return i;
                }),
                r.d(e, 'PlaylistLevelType', function () {
                  return n;
                }),
                (function (t) {
                  (t.MANIFEST = 'manifest'),
                    (t.LEVEL = 'level'),
                    (t.AUDIO_TRACK = 'audioTrack'),
                    (t.SUBTITLE_TRACK = 'subtitleTrack');
                })(i || (i = {})),
                (function (t) {
                  (t.MAIN = 'main'), (t.AUDIO = 'audio'), (t.SUBTITLE = 'subtitle');
                })(n || (n = {}));
            },
          './src/types/transmuxer.ts':
            /*!*********************************!*\
  !*** ./src/types/transmuxer.ts ***!
  \*********************************/
            /*! exports provided: ChunkMetadata */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'ChunkMetadata', function () {
                  return i;
                });
              var i = function (t, e, r, i, n, s) {
                void 0 === i && (i = 0),
                  void 0 === n && (n = -1),
                  void 0 === s && (s = !1),
                  (this.level = void 0),
                  (this.sn = void 0),
                  (this.part = void 0),
                  (this.id = void 0),
                  (this.size = void 0),
                  (this.partial = void 0),
                  (this.transmuxing = { start: 0, executeStart: 0, executeEnd: 0, end: 0 }),
                  (this.buffering = {
                    audio: { start: 0, executeStart: 0, executeEnd: 0, end: 0 },
                    video: { start: 0, executeStart: 0, executeEnd: 0, end: 0 },
                    audiovideo: { start: 0, executeStart: 0, executeEnd: 0, end: 0 },
                  }),
                  (this.level = t),
                  (this.sn = e),
                  (this.id = r),
                  (this.size = i),
                  (this.part = n),
                  (this.partial = s);
              };
            },
          './src/utils/attr-list.ts':
            /*!********************************!*\
  !*** ./src/utils/attr-list.ts ***!
  \********************************/
            /*! exports provided: AttrList */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'AttrList', function () {
                  return s;
                });
              var i = /^(\d+)x(\d+)$/,
                n = /\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g,
                s = (function () {
                  function t(e) {
                    for (const r in ('string' == typeof e && (e = t.parseAttrList(e)), e))
                      e.hasOwnProperty(r) && (this[r] = e[r]);
                  }
                  const e = t.prototype;
                  return (
                    (e.decimalInteger = function (t) {
                      const e = parseInt(this[t], 10);
                      return e > Number.MAX_SAFE_INTEGER ? 1 / 0 : e;
                    }),
                    (e.hexadecimalInteger = function (t) {
                      if (this[t]) {
                        let e = (this[t] || '0x').slice(2);
                        e = (1 & e.length ? '0' : '') + e;
                        for (var r = new Uint8Array(e.length / 2), i = 0; i < e.length / 2; i++)
                          r[i] = parseInt(e.slice(2 * i, 2 * i + 2), 16);
                        return r;
                      }
                      return null;
                    }),
                    (e.hexadecimalIntegerAsNumber = function (t) {
                      const e = parseInt(this[t], 16);
                      return e > Number.MAX_SAFE_INTEGER ? 1 / 0 : e;
                    }),
                    (e.decimalFloatingPoint = function (t) {
                      return parseFloat(this[t]);
                    }),
                    (e.optionalFloat = function (t, e) {
                      const r = this[t];
                      return r ? parseFloat(r) : e;
                    }),
                    (e.enumeratedString = function (t) {
                      return this[t];
                    }),
                    (e.bool = function (t) {
                      return 'YES' === this[t];
                    }),
                    (e.decimalResolution = function (t) {
                      const e = i.exec(this[t]);
                      if (null !== e) return { width: parseInt(e[1], 10), height: parseInt(e[2], 10) };
                    }),
                    (t.parseAttrList = function (t) {
                      let e,
                        r = {};
                      for (n.lastIndex = 0; null !== (e = n.exec(t)); ) {
                        let i = e[2];
                        0 === i.indexOf('"') && i.lastIndexOf('"') === i.length - 1 && (i = i.slice(1, -1)),
                          (r[e[1]] = i);
                      }
                      return r;
                    }),
                    t
                  );
                })();
            },
          './src/utils/binary-search.ts':
            /*!************************************!*\
  !*** ./src/utils/binary-search.ts ***!
  \************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              e.default = {
                search: function (t, e) {
                  for (let r = 0, i = t.length - 1, n = null, s = null; r <= i; ) {
                    const a = e((s = t[(n = ((r + i) / 2) | 0)]));
                    if (a > 0) r = n + 1;
                    else {
                      if (!(a < 0)) return s;
                      i = n - 1;
                    }
                  }
                  return null;
                },
              };
            },
          './src/utils/buffer-helper.ts':
            /*!************************************!*\
  !*** ./src/utils/buffer-helper.ts ***!
  \************************************/
            /*! exports provided: BufferHelper */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'BufferHelper', function () {
                  return s;
                });
              var i = r(/*! ./logger */ './src/utils/logger.ts'),
                n = {
                  length: 0,
                  start: function () {
                    return 0;
                  },
                  end: function () {
                    return 0;
                  },
                },
                s = (function () {
                  function t() {}
                  return (
                    (t.isBuffered = function (e, r) {
                      try {
                        if (e)
                          for (let i = t.getBuffered(e), n = 0; n < i.length; n++)
                            if (r >= i.start(n) && r <= i.end(n)) return !0;
                      } catch (t) {}
                      return !1;
                    }),
                    (t.bufferInfo = function (e, r, i) {
                      try {
                        if (e) {
                          let n,
                            s = t.getBuffered(e),
                            a = [];
                          for (n = 0; n < s.length; n++) a.push({ start: s.start(n), end: s.end(n) });
                          return this.bufferedInfo(a, r, i);
                        }
                      } catch (t) {}
                      return { len: 0, start: r, end: r, nextStart: void 0 };
                    }),
                    (t.bufferedInfo = function (t, e, r) {
                      (e = Math.max(0, e)),
                        t.sort(function (t, e) {
                          const r = t.start - e.start;
                          return r || e.end - t.end;
                        });
                      let i = [];
                      if (r)
                        for (let n = 0; n < t.length; n++) {
                          const s = i.length;
                          if (s) {
                            const a = i[s - 1].end;
                            t[n].start - a < r ? t[n].end > a && (i[s - 1].end = t[n].end) : i.push(t[n]);
                          } else i.push(t[n]);
                        }
                      else i = t;
                      for (var o, l = 0, u = e, c = e, d = 0; d < i.length; d++) {
                        const f = i[d].start,
                          h = i[d].end;
                        if (e + r >= f && e < h) (u = f), (l = (c = h) - e);
                        else if (e + r < f) {
                          o = f;
                          break;
                        }
                      }
                      return { len: l, start: u || 0, end: c || 0, nextStart: o };
                    }),
                    (t.getBuffered = function (t) {
                      try {
                        return t.buffered;
                      } catch (t) {
                        return i.logger.log('failed to get media.buffered', t), n;
                      }
                    }),
                    t
                  );
                })();
            },
          './src/utils/cea-608-parser.ts':
            /*!*************************************!*\
  !*** ./src/utils/cea-608-parser.ts ***!
  \*************************************/
            /*! exports provided: Row, CaptionScreen, default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'Row', function () {
                  return y;
                }),
                r.d(e, 'CaptionScreen', function () {
                  return E;
                });
              let i,
                n = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                s = {
                  42: 225,
                  92: 233,
                  94: 237,
                  95: 243,
                  96: 250,
                  123: 231,
                  124: 247,
                  125: 209,
                  126: 241,
                  127: 9608,
                  128: 174,
                  129: 176,
                  130: 189,
                  131: 191,
                  132: 8482,
                  133: 162,
                  134: 163,
                  135: 9834,
                  136: 224,
                  137: 32,
                  138: 232,
                  139: 226,
                  140: 234,
                  141: 238,
                  142: 244,
                  143: 251,
                  144: 193,
                  145: 201,
                  146: 211,
                  147: 218,
                  148: 220,
                  149: 252,
                  150: 8216,
                  151: 161,
                  152: 42,
                  153: 8217,
                  154: 9473,
                  155: 169,
                  156: 8480,
                  157: 8226,
                  158: 8220,
                  159: 8221,
                  160: 192,
                  161: 194,
                  162: 199,
                  163: 200,
                  164: 202,
                  165: 203,
                  166: 235,
                  167: 206,
                  168: 207,
                  169: 239,
                  170: 212,
                  171: 217,
                  172: 249,
                  173: 219,
                  174: 171,
                  175: 187,
                  176: 195,
                  177: 227,
                  178: 205,
                  179: 204,
                  180: 236,
                  181: 210,
                  182: 242,
                  183: 213,
                  184: 245,
                  185: 123,
                  186: 125,
                  187: 92,
                  188: 94,
                  189: 95,
                  190: 124,
                  191: 8764,
                  192: 196,
                  193: 228,
                  194: 214,
                  195: 246,
                  196: 223,
                  197: 165,
                  198: 164,
                  199: 9475,
                  200: 197,
                  201: 229,
                  202: 216,
                  203: 248,
                  204: 9487,
                  205: 9491,
                  206: 9495,
                  207: 9499,
                },
                a = function (t) {
                  let e = t;
                  return s.hasOwnProperty(t) && (e = s[t]), String.fromCharCode(e);
                },
                o = 15,
                l = 100,
                u = { 17: 1, 18: 3, 21: 5, 22: 7, 23: 9, 16: 11, 19: 12, 20: 14 },
                c = { 17: 2, 18: 4, 21: 6, 22: 8, 23: 10, 19: 13, 20: 15 },
                d = { 25: 1, 26: 3, 29: 5, 30: 7, 31: 9, 24: 11, 27: 12, 28: 14 },
                f = { 25: 2, 26: 4, 29: 6, 30: 8, 31: 10, 27: 13, 28: 15 },
                h = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'black', 'transparent'];
              !(function (t) {
                (t[(t.ERROR = 0)] = 'ERROR'),
                  (t[(t.TEXT = 1)] = 'TEXT'),
                  (t[(t.WARNING = 2)] = 'WARNING'),
                  (t[(t.INFO = 2)] = 'INFO'),
                  (t[(t.DEBUG = 3)] = 'DEBUG'),
                  (t[(t.DATA = 3)] = 'DATA');
              })(i || (i = {}));
              var p = (function () {
                  function t() {
                    (this.time = null), (this.verboseLevel = i.ERROR);
                  }
                  return (
                    (t.prototype.log = function (t, e) {
                      this.verboseLevel >= t && n.logger.log(this.time + ' [' + t + '] ' + e);
                    }),
                    t
                  );
                })(),
                v = function (t) {
                  for (var e = [], r = 0; r < t.length; r++) e.push(t[r].toString(16));
                  return e;
                },
                g = (function () {
                  function t(t, e, r, i, n) {
                    (this.foreground = void 0),
                      (this.underline = void 0),
                      (this.italics = void 0),
                      (this.background = void 0),
                      (this.flash = void 0),
                      (this.foreground = t || 'white'),
                      (this.underline = e || !1),
                      (this.italics = r || !1),
                      (this.background = i || 'black'),
                      (this.flash = n || !1);
                  }
                  const e = t.prototype;
                  return (
                    (e.reset = function () {
                      (this.foreground = 'white'),
                        (this.underline = !1),
                        (this.italics = !1),
                        (this.background = 'black'),
                        (this.flash = !1);
                    }),
                    (e.setStyles = function (t) {
                      for (
                        let e = ['foreground', 'underline', 'italics', 'background', 'flash'], r = 0;
                        r < e.length;
                        r++
                      ) {
                        const i = e[r];
                        t.hasOwnProperty(i) && (this[i] = t[i]);
                      }
                    }),
                    (e.isDefault = function () {
                      return (
                        'white' === this.foreground &&
                        !this.underline &&
                        !this.italics &&
                        'black' === this.background &&
                        !this.flash
                      );
                    }),
                    (e.equals = function (t) {
                      return (
                        this.foreground === t.foreground &&
                        this.underline === t.underline &&
                        this.italics === t.italics &&
                        this.background === t.background &&
                        this.flash === t.flash
                      );
                    }),
                    (e.copy = function (t) {
                      (this.foreground = t.foreground),
                        (this.underline = t.underline),
                        (this.italics = t.italics),
                        (this.background = t.background),
                        (this.flash = t.flash);
                    }),
                    (e.toString = function () {
                      return (
                        'color=' +
                        this.foreground +
                        ', underline=' +
                        this.underline +
                        ', italics=' +
                        this.italics +
                        ', background=' +
                        this.background +
                        ', flash=' +
                        this.flash
                      );
                    }),
                    t
                  );
                })(),
                m = (function () {
                  function t(t, e, r, i, n, s) {
                    (this.uchar = void 0),
                      (this.penState = void 0),
                      (this.uchar = t || ' '),
                      (this.penState = new g(e, r, i, n, s));
                  }
                  const e = t.prototype;
                  return (
                    (e.reset = function () {
                      (this.uchar = ' '), this.penState.reset();
                    }),
                    (e.setChar = function (t, e) {
                      (this.uchar = t), this.penState.copy(e);
                    }),
                    (e.setPenState = function (t) {
                      this.penState.copy(t);
                    }),
                    (e.equals = function (t) {
                      return this.uchar === t.uchar && this.penState.equals(t.penState);
                    }),
                    (e.copy = function (t) {
                      (this.uchar = t.uchar), this.penState.copy(t.penState);
                    }),
                    (e.isEmpty = function () {
                      return ' ' === this.uchar && this.penState.isDefault();
                    }),
                    t
                  );
                })(),
                y = (function () {
                  function t(t) {
                    (this.chars = void 0),
                      (this.pos = void 0),
                      (this.currPenState = void 0),
                      (this.cueStartTime = void 0),
                      (this.logger = void 0),
                      (this.chars = []);
                    for (let e = 0; e < l; e++) this.chars.push(new m());
                    (this.logger = t), (this.pos = 0), (this.currPenState = new g());
                  }
                  const e = t.prototype;
                  return (
                    (e.equals = function (t) {
                      for (var e = !0, r = 0; r < l; r++)
                        if (!this.chars[r].equals(t.chars[r])) {
                          e = !1;
                          break;
                        }
                      return e;
                    }),
                    (e.copy = function (t) {
                      for (let e = 0; e < l; e++) this.chars[e].copy(t.chars[e]);
                    }),
                    (e.isEmpty = function () {
                      for (var t = !0, e = 0; e < l; e++)
                        if (!this.chars[e].isEmpty()) {
                          t = !1;
                          break;
                        }
                      return t;
                    }),
                    (e.setCursor = function (t) {
                      this.pos !== t && (this.pos = t),
                        this.pos < 0
                          ? (this.logger.log(i.DEBUG, 'Negative cursor position ' + this.pos), (this.pos = 0))
                          : this.pos > l &&
                            (this.logger.log(i.DEBUG, 'Too large cursor position ' + this.pos), (this.pos = l));
                    }),
                    (e.moveCursor = function (t) {
                      const e = this.pos + t;
                      if (t > 1)
                        for (let r = this.pos + 1; r < e + 1; r++) this.chars[r].setPenState(this.currPenState);
                      this.setCursor(e);
                    }),
                    (e.backSpace = function () {
                      this.moveCursor(-1), this.chars[this.pos].setChar(' ', this.currPenState);
                    }),
                    (e.insertChar = function (t) {
                      t >= 144 && this.backSpace();
                      const e = a(t);
                      this.pos >= l
                        ? this.logger.log(
                            i.ERROR,
                            'Cannot insert ' +
                              t.toString(16) +
                              ' (' +
                              e +
                              ') at position ' +
                              this.pos +
                              '. Skipping it!'
                          )
                        : (this.chars[this.pos].setChar(e, this.currPenState), this.moveCursor(1));
                    }),
                    (e.clearFromPos = function (t) {
                      let e;
                      for (e = t; e < l; e++) this.chars[e].reset();
                    }),
                    (e.clear = function () {
                      this.clearFromPos(0), (this.pos = 0), this.currPenState.reset();
                    }),
                    (e.clearToEndOfRow = function () {
                      this.clearFromPos(this.pos);
                    }),
                    (e.getTextString = function () {
                      for (var t = [], e = !0, r = 0; r < l; r++) {
                        const i = this.chars[r].uchar;
                        ' ' !== i && (e = !1), t.push(i);
                      }
                      return e ? '' : t.join('');
                    }),
                    (e.setPenStyles = function (t) {
                      this.currPenState.setStyles(t), this.chars[this.pos].setPenState(this.currPenState);
                    }),
                    t
                  );
                })(),
                E = (function () {
                  function t(t) {
                    (this.rows = void 0),
                      (this.currRow = void 0),
                      (this.nrRollUpRows = void 0),
                      (this.lastOutputScreen = void 0),
                      (this.logger = void 0),
                      (this.rows = []);
                    for (let e = 0; e < o; e++) this.rows.push(new y(t));
                    (this.logger = t),
                      (this.currRow = o - 1),
                      (this.nrRollUpRows = null),
                      (this.lastOutputScreen = null),
                      this.reset();
                  }
                  const e = t.prototype;
                  return (
                    (e.reset = function () {
                      for (let t = 0; t < o; t++) this.rows[t].clear();
                      this.currRow = o - 1;
                    }),
                    (e.equals = function (t) {
                      for (var e = !0, r = 0; r < o; r++)
                        if (!this.rows[r].equals(t.rows[r])) {
                          e = !1;
                          break;
                        }
                      return e;
                    }),
                    (e.copy = function (t) {
                      for (let e = 0; e < o; e++) this.rows[e].copy(t.rows[e]);
                    }),
                    (e.isEmpty = function () {
                      for (var t = !0, e = 0; e < o; e++)
                        if (!this.rows[e].isEmpty()) {
                          t = !1;
                          break;
                        }
                      return t;
                    }),
                    (e.backSpace = function () {
                      this.rows[this.currRow].backSpace();
                    }),
                    (e.clearToEndOfRow = function () {
                      this.rows[this.currRow].clearToEndOfRow();
                    }),
                    (e.insertChar = function (t) {
                      this.rows[this.currRow].insertChar(t);
                    }),
                    (e.setPen = function (t) {
                      this.rows[this.currRow].setPenStyles(t);
                    }),
                    (e.moveCursor = function (t) {
                      this.rows[this.currRow].moveCursor(t);
                    }),
                    (e.setCursor = function (t) {
                      this.logger.log(i.INFO, 'setCursor: ' + t), this.rows[this.currRow].setCursor(t);
                    }),
                    (e.setPAC = function (t) {
                      this.logger.log(i.INFO, 'pacData = ' + JSON.stringify(t));
                      let e = t.row - 1;
                      if (
                        (this.nrRollUpRows && e < this.nrRollUpRows - 1 && (e = this.nrRollUpRows - 1),
                        this.nrRollUpRows && this.currRow !== e)
                      ) {
                        for (let r = 0; r < o; r++) this.rows[r].clear();
                        const n = this.currRow + 1 - this.nrRollUpRows,
                          s = this.lastOutputScreen;
                        if (s) {
                          const a = s.rows[n].cueStartTime,
                            l = this.logger.time;
                          if (a && null !== l && a < l)
                            for (let u = 0; u < this.nrRollUpRows; u++)
                              this.rows[e - this.nrRollUpRows + u + 1].copy(s.rows[n + u]);
                        }
                      }
                      this.currRow = e;
                      const c = this.rows[this.currRow];
                      if (null !== t.indent) {
                        const d = t.indent,
                          f = Math.max(d - 1, 0);
                        c.setCursor(t.indent), (t.color = c.chars[f].penState.foreground);
                      }
                      const h = {
                        foreground: t.color,
                        underline: t.underline,
                        italics: t.italics,
                        background: 'black',
                        flash: !1,
                      };
                      this.setPen(h);
                    }),
                    (e.setBkgData = function (t) {
                      this.logger.log(i.INFO, 'bkgData = ' + JSON.stringify(t)),
                        this.backSpace(),
                        this.setPen(t),
                        this.insertChar(32);
                    }),
                    (e.setRollUpRows = function (t) {
                      this.nrRollUpRows = t;
                    }),
                    (e.rollUp = function () {
                      if (null !== this.nrRollUpRows) {
                        this.logger.log(i.TEXT, this.getDisplayText());
                        const t = this.currRow + 1 - this.nrRollUpRows,
                          e = this.rows.splice(t, 1)[0];
                        e.clear(), this.rows.splice(this.currRow, 0, e), this.logger.log(i.INFO, 'Rolling up');
                      } else this.logger.log(i.DEBUG, 'roll_up but nrRollUpRows not set yet');
                    }),
                    (e.getDisplayText = function (t) {
                      t = t || !1;
                      for (var e = [], r = '', i = -1, n = 0; n < o; n++) {
                        const s = this.rows[n].getTextString();
                        s && ((i = n + 1), t ? e.push('Row ' + i + ": '" + s + "'") : e.push(s.trim()));
                      }
                      return e.length > 0 && (r = t ? '[' + e.join(' | ') + ']' : e.join('\n')), r;
                    }),
                    (e.getTextAndFormat = function () {
                      return this.rows;
                    }),
                    t
                  );
                })(),
                T = (function () {
                  function t(t, e, r) {
                    (this.chNr = void 0),
                      (this.outputFilter = void 0),
                      (this.mode = void 0),
                      (this.verbose = void 0),
                      (this.displayedMemory = void 0),
                      (this.nonDisplayedMemory = void 0),
                      (this.lastOutputScreen = void 0),
                      (this.currRollUpRow = void 0),
                      (this.writeScreen = void 0),
                      (this.cueStartTime = void 0),
                      (this.logger = void 0),
                      (this.chNr = t),
                      (this.outputFilter = e),
                      (this.mode = null),
                      (this.verbose = 0),
                      (this.displayedMemory = new E(r)),
                      (this.nonDisplayedMemory = new E(r)),
                      (this.lastOutputScreen = new E(r)),
                      (this.currRollUpRow = this.displayedMemory.rows[o - 1]),
                      (this.writeScreen = this.displayedMemory),
                      (this.mode = null),
                      (this.cueStartTime = null),
                      (this.logger = r);
                  }
                  const e = t.prototype;
                  return (
                    (e.reset = function () {
                      (this.mode = null),
                        this.displayedMemory.reset(),
                        this.nonDisplayedMemory.reset(),
                        this.lastOutputScreen.reset(),
                        this.outputFilter.reset(),
                        (this.currRollUpRow = this.displayedMemory.rows[o - 1]),
                        (this.writeScreen = this.displayedMemory),
                        (this.mode = null),
                        (this.cueStartTime = null);
                    }),
                    (e.getHandler = function () {
                      return this.outputFilter;
                    }),
                    (e.setHandler = function (t) {
                      this.outputFilter = t;
                    }),
                    (e.setPAC = function (t) {
                      this.writeScreen.setPAC(t);
                    }),
                    (e.setBkgData = function (t) {
                      this.writeScreen.setBkgData(t);
                    }),
                    (e.setMode = function (t) {
                      t !== this.mode &&
                        ((this.mode = t),
                        this.logger.log(i.INFO, 'MODE=' + t),
                        'MODE_POP-ON' === this.mode
                          ? (this.writeScreen = this.nonDisplayedMemory)
                          : ((this.writeScreen = this.displayedMemory), this.writeScreen.reset()),
                        'MODE_ROLL-UP' !== this.mode &&
                          ((this.displayedMemory.nrRollUpRows = null), (this.nonDisplayedMemory.nrRollUpRows = null)),
                        (this.mode = t));
                    }),
                    (e.insertChars = function (t) {
                      for (let e = 0; e < t.length; e++) this.writeScreen.insertChar(t[e]);
                      const r = this.writeScreen === this.displayedMemory ? 'DISP' : 'NON_DISP';
                      this.logger.log(i.INFO, r + ': ' + this.writeScreen.getDisplayText(!0)),
                        ('MODE_PAINT-ON' !== this.mode && 'MODE_ROLL-UP' !== this.mode) ||
                          (this.logger.log(i.TEXT, 'DISPLAYED: ' + this.displayedMemory.getDisplayText(!0)),
                          this.outputDataUpdate());
                    }),
                    (e.ccRCL = function () {
                      this.logger.log(i.INFO, 'RCL - Resume Caption Loading'), this.setMode('MODE_POP-ON');
                    }),
                    (e.ccBS = function () {
                      this.logger.log(i.INFO, 'BS - BackSpace'),
                        'MODE_TEXT' !== this.mode &&
                          (this.writeScreen.backSpace(),
                          this.writeScreen === this.displayedMemory && this.outputDataUpdate());
                    }),
                    (e.ccAOF = function () {}),
                    (e.ccAON = function () {}),
                    (e.ccDER = function () {
                      this.logger.log(i.INFO, 'DER- Delete to End of Row'),
                        this.writeScreen.clearToEndOfRow(),
                        this.outputDataUpdate();
                    }),
                    (e.ccRU = function (t) {
                      this.logger.log(i.INFO, 'RU(' + t + ') - Roll Up'),
                        (this.writeScreen = this.displayedMemory),
                        this.setMode('MODE_ROLL-UP'),
                        this.writeScreen.setRollUpRows(t);
                    }),
                    (e.ccFON = function () {
                      this.logger.log(i.INFO, 'FON - Flash On'), this.writeScreen.setPen({ flash: !0 });
                    }),
                    (e.ccRDC = function () {
                      this.logger.log(i.INFO, 'RDC - Resume Direct Captioning'), this.setMode('MODE_PAINT-ON');
                    }),
                    (e.ccTR = function () {
                      this.logger.log(i.INFO, 'TR'), this.setMode('MODE_TEXT');
                    }),
                    (e.ccRTD = function () {
                      this.logger.log(i.INFO, 'RTD'), this.setMode('MODE_TEXT');
                    }),
                    (e.ccEDM = function () {
                      this.logger.log(i.INFO, 'EDM - Erase Displayed Memory'),
                        this.displayedMemory.reset(),
                        this.outputDataUpdate(!0);
                    }),
                    (e.ccCR = function () {
                      this.logger.log(i.INFO, 'CR - Carriage Return'),
                        this.writeScreen.rollUp(),
                        this.outputDataUpdate(!0);
                    }),
                    (e.ccENM = function () {
                      this.logger.log(i.INFO, 'ENM - Erase Non-displayed Memory'), this.nonDisplayedMemory.reset();
                    }),
                    (e.ccEOC = function () {
                      if ((this.logger.log(i.INFO, 'EOC - End Of Caption'), 'MODE_POP-ON' === this.mode)) {
                        const t = this.displayedMemory;
                        (this.displayedMemory = this.nonDisplayedMemory),
                          (this.nonDisplayedMemory = t),
                          (this.writeScreen = this.nonDisplayedMemory),
                          this.logger.log(i.TEXT, 'DISP: ' + this.displayedMemory.getDisplayText());
                      }
                      this.outputDataUpdate(!0);
                    }),
                    (e.ccTO = function (t) {
                      this.logger.log(i.INFO, 'TO(' + t + ') - Tab Offset'), this.writeScreen.moveCursor(t);
                    }),
                    (e.ccMIDROW = function (t) {
                      const e = { flash: !1 };
                      if (((e.underline = t % 2 == 1), (e.italics = t >= 46), e.italics)) e.foreground = 'white';
                      else {
                        const r = Math.floor(t / 2) - 16;
                        e.foreground = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta'][r];
                      }
                      this.logger.log(i.INFO, 'MIDROW: ' + JSON.stringify(e)), this.writeScreen.setPen(e);
                    }),
                    (e.outputDataUpdate = function (t) {
                      void 0 === t && (t = !1);
                      const e = this.logger.time;
                      null !== e &&
                        this.outputFilter &&
                        (null !== this.cueStartTime || this.displayedMemory.isEmpty()
                          ? this.displayedMemory.equals(this.lastOutputScreen) ||
                            (this.outputFilter.newCue(this.cueStartTime, e, this.lastOutputScreen),
                            t && this.outputFilter.dispatchCue && this.outputFilter.dispatchCue(),
                            (this.cueStartTime = this.displayedMemory.isEmpty() ? null : e))
                          : (this.cueStartTime = e),
                        this.lastOutputScreen.copy(this.displayedMemory));
                    }),
                    (e.cueSplitAtTime = function (t) {
                      this.outputFilter &&
                        (this.displayedMemory.isEmpty() ||
                          (this.outputFilter.newCue &&
                            this.outputFilter.newCue(this.cueStartTime, t, this.displayedMemory),
                          (this.cueStartTime = t)));
                    }),
                    t
                  );
                })(),
                b = (function () {
                  function t(t, e, r) {
                    (this.channels = void 0),
                      (this.currentChannel = 0),
                      (this.cmdHistory = void 0),
                      (this.logger = void 0);
                    const i = new p();
                    (this.channels = [null, new T(t, e, i), new T(t + 1, r, i)]),
                      (this.cmdHistory = { a: null, b: null }),
                      (this.logger = i);
                  }
                  const e = t.prototype;
                  return (
                    (e.getHandler = function (t) {
                      return this.channels[t].getHandler();
                    }),
                    (e.setHandler = function (t, e) {
                      this.channels[t].setHandler(e);
                    }),
                    (e.addData = function (t, e) {
                      let r,
                        n,
                        s,
                        a = !1;
                      this.logger.time = t;
                      for (let o = 0; o < e.length; o += 2)
                        if (((n = 127 & e[o]), (s = 127 & e[o + 1]), 0 !== n || 0 !== s)) {
                          if (
                            (this.logger.log(i.DATA, '[' + v([e[o], e[o + 1]]) + '] -> (' + v([n, s]) + ')'),
                            (r = this.parseCmd(n, s)) || (r = this.parseMidrow(n, s)),
                            r || (r = this.parsePAC(n, s)),
                            r || (r = this.parseBackgroundAttributes(n, s)),
                            !r && (a = this.parseChars(n, s)))
                          ) {
                            const l = this.currentChannel;
                            if (l && l > 0) this.channels[l].insertChars(a);
                            else this.logger.log(i.WARNING, 'No channel found yet. TEXT-MODE?');
                          }
                          r ||
                            a ||
                            this.logger.log(
                              i.WARNING,
                              "Couldn't parse cleaned data " + v([n, s]) + ' orig: ' + v([e[o], e[o + 1]])
                            );
                        }
                    }),
                    (e.parseCmd = function (t, e) {
                      const r = this.cmdHistory;
                      if (
                        !((20 === t || 28 === t || 21 === t || 29 === t) && e >= 32 && e <= 47) &&
                        !((23 === t || 31 === t) && e >= 33 && e <= 35)
                      )
                        return !1;
                      if (L(t, e, r))
                        return (
                          S(null, null, r),
                          this.logger.log(i.DEBUG, 'Repeated command (' + v([t, e]) + ') is dropped'),
                          !0
                        );
                      const n = 20 === t || 21 === t || 23 === t ? 1 : 2,
                        s = this.channels[n];
                      return (
                        20 === t || 21 === t || 28 === t || 29 === t
                          ? 32 === e
                            ? s.ccRCL()
                            : 33 === e
                              ? s.ccBS()
                              : 34 === e
                                ? s.ccAOF()
                                : 35 === e
                                  ? s.ccAON()
                                  : 36 === e
                                    ? s.ccDER()
                                    : 37 === e
                                      ? s.ccRU(2)
                                      : 38 === e
                                        ? s.ccRU(3)
                                        : 39 === e
                                          ? s.ccRU(4)
                                          : 40 === e
                                            ? s.ccFON()
                                            : 41 === e
                                              ? s.ccRDC()
                                              : 42 === e
                                                ? s.ccTR()
                                                : 43 === e
                                                  ? s.ccRTD()
                                                  : 44 === e
                                                    ? s.ccEDM()
                                                    : 45 === e
                                                      ? s.ccCR()
                                                      : 46 === e
                                                        ? s.ccENM()
                                                        : 47 === e && s.ccEOC()
                          : s.ccTO(e - 32),
                        S(t, e, r),
                        (this.currentChannel = n),
                        !0
                      );
                    }),
                    (e.parseMidrow = function (t, e) {
                      let r = 0;
                      if ((17 === t || 25 === t) && e >= 32 && e <= 47) {
                        if ((r = 17 === t ? 1 : 2) !== this.currentChannel)
                          return this.logger.log(i.ERROR, 'Mismatch channel in midrow parsing'), !1;
                        const n = this.channels[r];
                        return !!n && (n.ccMIDROW(e), this.logger.log(i.DEBUG, 'MIDROW (' + v([t, e]) + ')'), !0);
                      }
                      return !1;
                    }),
                    (e.parsePAC = function (t, e) {
                      let r,
                        i = this.cmdHistory;
                      if (
                        !(((t >= 17 && t <= 23) || (t >= 25 && t <= 31)) && e >= 64 && e <= 127) &&
                        !((16 === t || 24 === t) && e >= 64 && e <= 95)
                      )
                        return !1;
                      if (L(t, e, i)) return S(null, null, i), !0;
                      const n = t <= 23 ? 1 : 2;
                      r = e >= 64 && e <= 95 ? (1 === n ? u[t] : d[t]) : 1 === n ? c[t] : f[t];
                      const s = this.channels[n];
                      return !!s && (s.setPAC(this.interpretPAC(r, e)), S(t, e, i), (this.currentChannel = n), !0);
                    }),
                    (e.interpretPAC = function (t, e) {
                      let r,
                        i = { color: null, italics: !1, indent: null, underline: !1, row: t };
                      return (
                        (r = e > 95 ? e - 96 : e - 64),
                        (i.underline = 1 == (1 & r)),
                        r <= 13
                          ? (i.color = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'white'][
                              Math.floor(r / 2)
                            ])
                          : r <= 15
                            ? ((i.italics = !0), (i.color = 'white'))
                            : (i.indent = 4 * Math.floor((r - 16) / 2)),
                        i
                      );
                    }),
                    (e.parseChars = function (t, e) {
                      let r,
                        n,
                        s = null,
                        o = null;
                      (t >= 25 ? ((r = 2), (o = t - 8)) : ((r = 1), (o = t)), o >= 17 && o <= 19)
                        ? ((n = 17 === o ? e + 80 : 18 === o ? e + 112 : e + 144),
                          this.logger.log(i.INFO, "Special char '" + a(n) + "' in channel " + r),
                          (s = [n]))
                        : t >= 32 && t <= 127 && (s = 0 === e ? [t] : [t, e]);
                      if (s) {
                        const l = v(s);
                        this.logger.log(i.DEBUG, 'Char codes =  ' + l.join(',')), S(t, e, this.cmdHistory);
                      }
                      return s;
                    }),
                    (e.parseBackgroundAttributes = function (t, e) {
                      let r;
                      if (
                        !((16 === t || 24 === t) && e >= 32 && e <= 47) &&
                        !((23 === t || 31 === t) && e >= 45 && e <= 47)
                      )
                        return !1;
                      const i = {};
                      16 === t || 24 === t
                        ? ((r = Math.floor((e - 32) / 2)),
                          (i.background = h[r]),
                          e % 2 == 1 && (i.background = i.background + '_semi'))
                        : 45 === e
                          ? (i.background = 'transparent')
                          : ((i.foreground = 'black'), 47 === e && (i.underline = !0));
                      const n = t <= 23 ? 1 : 2;
                      return this.channels[n].setBkgData(i), S(t, e, this.cmdHistory), !0;
                    }),
                    (e.reset = function () {
                      for (let t = 0; t < Object.keys(this.channels).length; t++) {
                        const e = this.channels[t];
                        e && e.reset();
                      }
                      this.cmdHistory = { a: null, b: null };
                    }),
                    (e.cueSplitAtTime = function (t) {
                      for (let e = 0; e < this.channels.length; e++) {
                        const r = this.channels[e];
                        r && r.cueSplitAtTime(t);
                      }
                    }),
                    t
                  );
                })();
              function S(t, e, r) {
                (r.a = t), (r.b = e);
              }
              function L(t, e, r) {
                return r.a === t && r.b === e;
              }
              e.default = b;
            },
          './src/utils/codecs.ts':
            /*!*****************************!*\
  !*** ./src/utils/codecs.ts ***!
  \*****************************/
            /*! exports provided: isCodecType, isCodecSupportedInMp4 */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'isCodecType', function () {
                  return n;
                }),
                r.d(e, 'isCodecSupportedInMp4', function () {
                  return s;
                });
              const i = {
                audio: {
                  a3ds: !0,
                  'ac-3': !0,
                  'ac-4': !0,
                  alac: !0,
                  alaw: !0,
                  dra1: !0,
                  'dts+': !0,
                  'dts-': !0,
                  dtsc: !0,
                  dtse: !0,
                  dtsh: !0,
                  'ec-3': !0,
                  enca: !0,
                  g719: !0,
                  g726: !0,
                  m4ae: !0,
                  mha1: !0,
                  mha2: !0,
                  mhm1: !0,
                  mhm2: !0,
                  mlpa: !0,
                  mp4a: !0,
                  'raw ': !0,
                  Opus: !0,
                  samr: !0,
                  sawb: !0,
                  sawp: !0,
                  sevc: !0,
                  sqcp: !0,
                  ssmv: !0,
                  twos: !0,
                  ulaw: !0,
                },
                video: {
                  avc1: !0,
                  avc2: !0,
                  avc3: !0,
                  avc4: !0,
                  avcp: !0,
                  av01: !0,
                  drac: !0,
                  dvav: !0,
                  dvhe: !0,
                  encv: !0,
                  hev1: !0,
                  hvc1: !0,
                  mjp2: !0,
                  mp4v: !0,
                  mvc1: !0,
                  mvc2: !0,
                  mvc3: !0,
                  mvc4: !0,
                  resv: !0,
                  rv60: !0,
                  s263: !0,
                  svc1: !0,
                  svc2: !0,
                  'vc-1': !0,
                  vp08: !0,
                  vp09: !0,
                },
                text: { stpp: !0, wvtt: !0 },
              };
              function n(t, e) {
                const r = i[e];
                return !!r && !0 === r[t.slice(0, 4)];
              }
              function s(t, e) {
                return MediaSource.isTypeSupported((e || 'video') + '/mp4;codecs="' + t + '"');
              }
            },
          './src/utils/cues.ts':
            /*!***************************!*\
  !*** ./src/utils/cues.ts ***!
  \***************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              const i = r(/*! ./vttparser */ './src/utils/vttparser.ts'),
                n = r(/*! ./webvtt-parser */ './src/utils/webvtt-parser.ts'),
                s = r(/*! ./texttrack-utils */ './src/utils/texttrack-utils.ts'),
                a = /\s/,
                o = {
                  newCue: function (t, e, r, o) {
                    for (var l, u, c, d, f, h = [], p = self.VTTCue || self.TextTrackCue, v = 0; v < o.rows.length; v++)
                      if (((c = !0), (d = 0), (f = ''), !(l = o.rows[v]).isEmpty())) {
                        for (let g = 0; g < l.chars.length; g++)
                          a.test(l.chars[g].uchar) && c ? d++ : ((f += l.chars[g].uchar), (c = !1));
                        (l.cueStartTime = e), e === r && (r += 1e-4), d >= 16 ? d-- : d++;
                        const m = Object(i.fixLineBreaks)(f.trim()),
                          y = Object(n.generateCueId)(e, r, m);
                        (t && t.cues && t.cues.getCueById(y)) ||
                          (((u = new p(e, r, m)).id = y),
                          (u.line = v + 1),
                          (u.align = 'left'),
                          (u.position = 10 + Math.min(80, 10 * Math.floor((8 * d) / 32))),
                          h.push(u));
                      }
                    return (
                      t &&
                        h.length &&
                        (h.sort(function (t, e) {
                          return 'auto' === t.line || 'auto' === e.line
                            ? 0
                            : t.line > 8 && e.line > 8
                              ? e.line - t.line
                              : t.line - e.line;
                        }),
                        h.forEach(function (e) {
                          return Object(s.addCueToTrack)(t, e);
                        })),
                      h
                    );
                  },
                };
              e.default = o;
            },
          './src/utils/discontinuities.ts':
            /*!**************************************!*\
  !*** ./src/utils/discontinuities.ts ***!
  \**************************************/
            /*! exports provided: findFirstFragWithCC, shouldAlignOnDiscontinuities, findDiscontinuousReferenceFrag, adjustSlidingStart, alignStream, alignPDT, alignFragmentByPDTDelta, alignMediaPlaylistByPDT */ function (
              t,
              e,
              r
            ) {
              'use strict';
              r.r(e),
                r.d(e, 'findFirstFragWithCC', function () {
                  return a;
                }),
                r.d(e, 'shouldAlignOnDiscontinuities', function () {
                  return o;
                }),
                r.d(e, 'findDiscontinuousReferenceFrag', function () {
                  return l;
                }),
                r.d(e, 'adjustSlidingStart', function () {
                  return c;
                }),
                r.d(e, 'alignStream', function () {
                  return d;
                }),
                r.d(e, 'alignPDT', function () {
                  return f;
                }),
                r.d(e, 'alignFragmentByPDTDelta', function () {
                  return h;
                }),
                r.d(e, 'alignMediaPlaylistByPDT', function () {
                  return p;
                });
              const i = r(/*! ./src/polyfills/number */ './src/polyfills/number.ts'),
                n = r(/*! ./logger */ './src/utils/logger.ts'),
                s = r(/*! ../controller/level-helper */ './src/controller/level-helper.ts');
              function a(t, e) {
                for (var r = null, i = 0, n = t.length; i < n; i++) {
                  const s = t[i];
                  if (s && s.cc === e) {
                    r = s;
                    break;
                  }
                }
                return r;
              }
              function o(t, e, r) {
                return !(!e.details || !(r.endCC > r.startCC || (t && t.cc < r.startCC)));
              }
              function l(t, e) {
                const r = t.fragments,
                  i = e.fragments;
                if (i.length && r.length) {
                  const s = a(r, i[0].cc);
                  if (s && (!s || s.startPTS)) return s;
                  n.logger.log('No frag in previous level to align on');
                } else n.logger.log('No fragments to align');
              }
              function u(t, e) {
                if (t) {
                  const r = t.start + e;
                  (t.start = t.startPTS = r), (t.endPTS = r + t.duration);
                }
              }
              function c(t, e) {
                for (let r = e.fragments, i = 0, n = r.length; i < n; i++) u(r[i], t);
                e.fragmentHint && u(e.fragmentHint, t), (e.alignedSliding = !0);
              }
              function d(t, e, r) {
                e &&
                  (!(function (t, e, r) {
                    if (o(t, r, e)) {
                      const s = l(r.details, e);
                      s &&
                        Object(i.isFiniteNumber)(s.start) &&
                        (n.logger.log(
                          'Adjusting PTS using last level due to CC increase within current level ' + e.url
                        ),
                        c(s.start, e));
                    }
                  })(t, r, e),
                  !r.alignedSliding && e.details && f(r, e.details),
                  r.alignedSliding || !e.details || r.skippedSegments || Object(s.adjustSliding)(e.details, r));
              }
              function f(t, e) {
                if (e.fragments.length && t.hasProgramDateTime && e.hasProgramDateTime) {
                  const r = e.fragments[0].programDateTime,
                    s = t.fragments[0].programDateTime,
                    a = (s - r) / 1e3 + e.fragments[0].start;
                  a &&
                    Object(i.isFiniteNumber)(a) &&
                    (n.logger.log(
                      'Adjusting PTS using programDateTime delta ' +
                        (s - r) +
                        'ms, sliding:' +
                        a.toFixed(3) +
                        ' ' +
                        t.url +
                        ' '
                    ),
                    c(a, t));
                }
              }
              function h(t, e) {
                const r = t.programDateTime;
                if (r) {
                  const i = (r - e) / 1e3;
                  (t.start = t.startPTS = i), (t.endPTS = i + t.duration);
                }
              }
              function p(t, e) {
                if (e.fragments.length && t.hasProgramDateTime && e.hasProgramDateTime) {
                  const r = e.fragments[0].programDateTime - 1e3 * e.fragments[0].start;
                  t.fragments.forEach(function (t) {
                    h(t, r);
                  }),
                    t.fragmentHint && h(t.fragmentHint, r),
                    (t.alignedSliding = !0);
                }
              }
            },
          './src/utils/ewma-bandwidth-estimator.ts':
            /*!***********************************************!*\
  !*** ./src/utils/ewma-bandwidth-estimator.ts ***!
  \***********************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              const i = r(/*! ../utils/ewma */ './src/utils/ewma.ts'),
                n = (function () {
                  function t(t, e, r) {
                    (this.defaultEstimate_ = void 0),
                      (this.minWeight_ = void 0),
                      (this.minDelayMs_ = void 0),
                      (this.slow_ = void 0),
                      (this.fast_ = void 0),
                      (this.defaultEstimate_ = r),
                      (this.minWeight_ = 0.001),
                      (this.minDelayMs_ = 50),
                      (this.slow_ = new i.default(t)),
                      (this.fast_ = new i.default(e));
                  }
                  const e = t.prototype;
                  return (
                    (e.update = function (t, e) {
                      const r = this.slow_,
                        n = this.fast_;
                      this.slow_.halfLife !== t && (this.slow_ = new i.default(t, r.getEstimate(), r.getTotalWeight())),
                        this.fast_.halfLife !== e &&
                          (this.fast_ = new i.default(e, n.getEstimate(), n.getTotalWeight()));
                    }),
                    (e.sample = function (t, e) {
                      const r = (t = Math.max(t, this.minDelayMs_)) / 1e3,
                        i = (8 * e) / r;
                      this.fast_.sample(r, i), this.slow_.sample(r, i);
                    }),
                    (e.canEstimate = function () {
                      const t = this.fast_;
                      return t && t.getTotalWeight() >= this.minWeight_;
                    }),
                    (e.getEstimate = function () {
                      return this.canEstimate()
                        ? Math.min(this.fast_.getEstimate(), this.slow_.getEstimate())
                        : this.defaultEstimate_;
                    }),
                    (e.destroy = function () {}),
                    t
                  );
                })();
              e.default = n;
            },
          './src/utils/ewma.ts':
            /*!***************************!*\
  !*** ./src/utils/ewma.ts ***!
  \***************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              const i = (function () {
                function t(t, e, r) {
                  void 0 === e && (e = 0),
                    void 0 === r && (r = 0),
                    (this.halfLife = void 0),
                    (this.alpha_ = void 0),
                    (this.estimate_ = void 0),
                    (this.totalWeight_ = void 0),
                    (this.halfLife = t),
                    (this.alpha_ = t ? Math.exp(Math.log(0.5) / t) : 0),
                    (this.estimate_ = e),
                    (this.totalWeight_ = r);
                }
                const e = t.prototype;
                return (
                  (e.sample = function (t, e) {
                    const r = Math.pow(this.alpha_, t);
                    (this.estimate_ = e * (1 - r) + r * this.estimate_), (this.totalWeight_ += t);
                  }),
                  (e.getTotalWeight = function () {
                    return this.totalWeight_;
                  }),
                  (e.getEstimate = function () {
                    if (this.alpha_) {
                      const t = 1 - Math.pow(this.alpha_, this.totalWeight_);
                      if (t) return this.estimate_ / t;
                    }
                    return this.estimate_;
                  }),
                  t
                );
              })();
              e.default = i;
            },
          './src/utils/fetch-loader.ts':
            /*!***********************************!*\
  !*** ./src/utils/fetch-loader.ts ***!
  \***********************************/
            /*! exports provided: fetchSupported, default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'fetchSupported', function () {
                  return d;
                });
              const i = r(/*! ./src/polyfills/number */ './src/polyfills/number.ts'),
                n = r(/*! ../loader/load-stats */ './src/loader/load-stats.ts'),
                s = r(/*! ../demux/chunk-cache */ './src/demux/chunk-cache.ts');
              function a(t) {
                const e = 'function' == typeof Map ? new Map() : void 0;
                return (a = function (t) {
                  if (
                    null === t ||
                    !(function (t) {
                      return -1 !== Function.toString.call(t).indexOf('[native code]');
                    })(t)
                  )
                    return t;
                  if ('function' != typeof t) throw new TypeError('Super expression must either be null or a function');
                  if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, r);
                  }
                  function r() {
                    return o(t, arguments, u(this).constructor);
                  }
                  return (
                    (r.prototype = Object.create(t.prototype, {
                      constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 },
                    })),
                    l(r, t)
                  );
                })(t);
              }
              function o(t, e, r) {
                return (o = (function () {
                  if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ('function' == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (t) {
                    return !1;
                  }
                })()
                  ? Reflect.construct
                  : function (t, e, r) {
                      const i = [null];
                      i.push.apply(i, e);
                      const n = new (Function.bind.apply(t, i))();
                      return r && l(n, r.prototype), n;
                    }).apply(null, arguments);
              }
              function l(t, e) {
                return (l =
                  Object.setPrototypeOf ||
                  function (t, e) {
                    return (t.__proto__ = e), t;
                  })(t, e);
              }
              function u(t) {
                return (u = Object.setPrototypeOf
                  ? Object.getPrototypeOf
                  : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                    })(t);
              }
              function c() {
                return (c =
                  Object.assign ||
                  function (t) {
                    for (let e = 1; e < arguments.length; e++) {
                      const r = arguments[e];
                      for (const i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
                    }
                    return t;
                  }).apply(this, arguments);
              }
              function d() {
                if (self.fetch && self.AbortController && self.ReadableStream && self.Request)
                  try {
                    return new self.ReadableStream({}), !0;
                  } catch (t) {}
                return !1;
              }
              const f = (function () {
                function t(t) {
                  (this.fetchSetup = void 0),
                    (this.requestTimeout = void 0),
                    (this.request = void 0),
                    (this.response = void 0),
                    (this.controller = void 0),
                    (this.context = void 0),
                    (this.config = null),
                    (this.callbacks = null),
                    (this.stats = void 0),
                    (this.loader = null),
                    (this.fetchSetup = t.fetchSetup || h),
                    (this.controller = new self.AbortController()),
                    (this.stats = new n.LoadStats());
                }
                const e = t.prototype;
                return (
                  (e.destroy = function () {
                    (this.loader = this.callbacks = null), this.abortInternal();
                  }),
                  (e.abortInternal = function () {
                    const t = this.response;
                    (t && t.ok) || ((this.stats.aborted = !0), this.controller.abort());
                  }),
                  (e.abort = function () {
                    let t;
                    this.abortInternal(),
                      null !== (t = this.callbacks) &&
                        void 0 !== t &&
                        t.onAbort &&
                        this.callbacks.onAbort(this.stats, this.context, this.response);
                  }),
                  (e.load = function (t, e, r) {
                    const n = this,
                      s = this.stats;
                    if (s.loading.start) throw new Error('Loader can only be used once.');
                    s.loading.start = self.performance.now();
                    const a = (function (t, e) {
                        const r = {
                          method: 'GET',
                          mode: 'cors',
                          credentials: 'same-origin',
                          signal: e,
                          headers: new self.Headers(c({}, t.headers)),
                        };
                        t.rangeEnd && r.headers.set('Range', 'bytes=' + t.rangeStart + '-' + String(t.rangeEnd - 1));
                        return r;
                      })(t, this.controller.signal),
                      o = r.onProgress,
                      l = 'arraybuffer' === t.responseType,
                      u = l ? 'byteLength' : 'length';
                    (this.context = t),
                      (this.config = e),
                      (this.callbacks = r),
                      (this.request = this.fetchSetup(t, a)),
                      self.clearTimeout(this.requestTimeout),
                      (this.requestTimeout = self.setTimeout(function () {
                        n.abortInternal(), r.onTimeout(s, t, n.response);
                      }, e.timeout)),
                      self
                        .fetch(this.request)
                        .then(function (r) {
                          if (((n.response = n.loader = r), !r.ok)) {
                            const a = r.status,
                              u = r.statusText;
                            throw new p(u || 'fetch, bad network response', a, r);
                          }
                          return (
                            (s.loading.first = Math.max(self.performance.now(), s.loading.start)),
                            (s.total = parseInt(r.headers.get('Content-Length') || '0')),
                            o && Object(i.isFiniteNumber)(e.highWaterMark)
                              ? n.loadProgressively(r, s, t, e.highWaterMark, o)
                              : l
                                ? r.arrayBuffer()
                                : r.text()
                          );
                        })
                        .then(function (a) {
                          const l = n.response;
                          self.clearTimeout(n.requestTimeout),
                            (s.loading.end = Math.max(self.performance.now(), s.loading.first)),
                            (s.loaded = s.total = a[u]);
                          const c = { url: l.url, data: a };
                          o && !Object(i.isFiniteNumber)(e.highWaterMark) && o(s, t, a, l), r.onSuccess(c, s, t, l);
                        })
                        .catch(function (e) {
                          if ((self.clearTimeout(n.requestTimeout), !s.aborted)) {
                            const i = e.code || 0;
                            r.onError({ code: i, text: e.message }, t, e.details);
                          }
                        });
                  }),
                  (e.getCacheAge = function () {
                    let t = null;
                    if (this.response) {
                      const e = this.response.headers.get('age');
                      t = e ? parseFloat(e) : null;
                    }
                    return t;
                  }),
                  (e.loadProgressively = function (t, e, r, i, n) {
                    void 0 === i && (i = 0);
                    const a = new s.default(),
                      o = t.body.getReader();
                    return (function s() {
                      return o
                        .read()
                        .then(function (o) {
                          if (o.done) return a.dataLength && n(e, r, a.flush(), t), Promise.resolve(new ArrayBuffer(0));
                          const l = o.value,
                            u = l.length;
                          return (
                            (e.loaded += u),
                            u < i || a.dataLength
                              ? (a.push(l), a.dataLength >= i && n(e, r, a.flush(), t))
                              : n(e, r, l, t),
                            s()
                          );
                        })
                        .catch(function () {
                          return Promise.reject();
                        });
                    })();
                  }),
                  t
                );
              })();
              function h(t, e) {
                return new self.Request(t.url, e);
              }
              var p = (function (t) {
                function e(e, r, i) {
                  let n;
                  return (
                    ((n = t.call(this, e) || this).code = void 0),
                    (n.details = void 0),
                    (n.code = r),
                    (n.details = i),
                    n
                  );
                }
                return (
                  (function (t, e) {
                    (t.prototype = Object.create(e.prototype)), (t.prototype.constructor = t), l(t, e);
                  })(e, t),
                  e
                );
              })(a(Error));
              e.default = f;
            },
          './src/utils/imsc1-ttml-parser.ts':
            /*!****************************************!*\
  !*** ./src/utils/imsc1-ttml-parser.ts ***!
  \****************************************/
            /*! exports provided: IMSC1_CODEC, parseIMSC1 */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'IMSC1_CODEC', function () {
                  return c;
                }),
                r.d(e, 'parseIMSC1', function () {
                  return p;
                });
              const i = r(/*! ./mp4-tools */ './src/utils/mp4-tools.ts'),
                n = r(/*! ./vttparser */ './src/utils/vttparser.ts'),
                s = r(/*! ./vttcue */ './src/utils/vttcue.ts'),
                a = r(/*! ../demux/id3 */ './src/demux/id3.ts'),
                o = r(/*! ./timescale-conversion */ './src/utils/timescale-conversion.ts'),
                l = r(/*! ./webvtt-parser */ './src/utils/webvtt-parser.ts');
              function u() {
                return (u =
                  Object.assign ||
                  function (t) {
                    for (let e = 1; e < arguments.length; e++) {
                      const r = arguments[e];
                      for (const i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
                    }
                    return t;
                  }).apply(this, arguments);
              }
              var c = 'stpp.ttml.im1t',
                d = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/,
                f = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/,
                h = { left: 'start', center: 'center', right: 'end', start: 'start', end: 'end' };
              function p(t, e, r, n, c) {
                const d = Object(i.findBox)(new Uint8Array(t), ['mdat']);
                if (0 !== d.length) {
                  const f = d[0],
                    p = Object(a.utf8ArrayToStr)(new Uint8Array(t, f.start, f.end - f.start)),
                    T = Object(o.toTimescaleFromScale)(e, 1, r);
                  try {
                    n(
                      (function (t, e) {
                        const r = new DOMParser().parseFromString(t, 'text/xml').getElementsByTagName('tt')[0];
                        if (!r) throw new Error('Invalid ttml');
                        const i = { frameRate: 30, subFrameRate: 1, frameRateMultiplier: 0, tickRate: 0 },
                          n = Object.keys(i).reduce(function (t, e) {
                            return (t[e] = r.getAttribute('ttp:' + e) || i[e]), t;
                          }, {}),
                          a = 'preserve' !== r.getAttribute('xml:space'),
                          o = g(v(r, 'styling', 'style')),
                          c = g(v(r, 'layout', 'region')),
                          d = v(r, 'body', '[begin]');
                        return [].map
                          .call(d, function (t) {
                            const r = (function t(e, r) {
                              return [].slice.call(e.childNodes).reduce(function (e, i, n) {
                                let s;
                                return 'br' === i.nodeName && n
                                  ? e + '\n'
                                  : null !== (s = i.childNodes) && void 0 !== s && s.length
                                    ? t(i, r)
                                    : r
                                      ? e + i.textContent.trim().replace(/\s+/g, ' ')
                                      : e + i.textContent;
                              }, '');
                            })(t, a);
                            if (!r || !t.hasAttribute('begin')) return null;
                            let i = E(t.getAttribute('begin'), n),
                              d = E(t.getAttribute('dur'), n),
                              f = E(t.getAttribute('end'), n);
                            if (null === i) throw y(t);
                            if (null === f) {
                              if (null === d) throw y(t);
                              f = i + d;
                            }
                            const p = new s.default(i - e, f - e, r);
                            p.id = Object(l.generateCueId)(p.startTime, p.endTime, p.text);
                            const v = c[t.getAttribute('region')],
                              g = o[t.getAttribute('style')];
                            (p.position = 10), (p.size = 80);
                            const T = (function (t, e) {
                                const r = 'http://www.w3.org/ns/ttml#styling';
                                return [
                                  'displayAlign',
                                  'textAlign',
                                  'color',
                                  'backgroundColor',
                                  'fontSize',
                                  'fontFamily',
                                ].reduce(function (i, n) {
                                  const s = m(e, r, n) || m(t, r, n);
                                  return s && (i[n] = s), i;
                                }, {});
                              })(v, g),
                              b = T.textAlign;
                            if (b) {
                              const S = h[b];
                              S && (p.lineAlign = S), (p.align = b);
                            }
                            return u(p, T), p;
                          })
                          .filter(function (t) {
                            return null !== t;
                          });
                      })(p, T)
                    );
                  } catch (t) {
                    c(t);
                  }
                } else c(new Error('Could not parse IMSC1 mdat'));
              }
              function v(t, e, r) {
                const i = t.getElementsByTagName(e)[0];
                return i ? [].slice.call(i.querySelectorAll(r)) : [];
              }
              function g(t) {
                return t.reduce(function (t, e) {
                  const r = e.getAttribute('xml:id');
                  return r && (t[r] = e), t;
                }, {});
              }
              function m(t, e, r) {
                return t.hasAttributeNS(e, r) ? t.getAttributeNS(e, r) : null;
              }
              function y(t) {
                return new Error('Could not parse ttml timestamp ' + t);
              }
              function E(t, e) {
                if (!t) return null;
                let r = Object(n.parseTimeStamp)(t);
                return (
                  null === r &&
                    (d.test(t)
                      ? (r = (function (t, e) {
                          const r = d.exec(t),
                            i = (0 | r[4]) + (0 | r[5]) / e.subFrameRate;
                          return 3600 * (0 | r[1]) + 60 * (0 | r[2]) + (0 | r[3]) + i / e.frameRate;
                        })(t, e))
                      : f.test(t) &&
                        (r = (function (t, e) {
                          const r = f.exec(t),
                            i = Number(r[1]);
                          switch (r[2]) {
                            case 'h':
                              return 3600 * i;
                            case 'm':
                              return 60 * i;
                            case 'ms':
                              return 1e3 * i;
                            case 'f':
                              return i / e.frameRate;
                            case 't':
                              return i / e.tickRate;
                          }
                          return i;
                        })(t, e))),
                  r
                );
              }
            },
          './src/utils/logger.ts':
            /*!*****************************!*\
  !*** ./src/utils/logger.ts ***!
  \*****************************/
            /*! exports provided: enableLogs, logger */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'enableLogs', function () {
                  return o;
                }),
                r.d(e, 'logger', function () {
                  return l;
                });
              let i = function () {},
                n = { trace: i, debug: i, log: i, warn: i, info: i, error: i },
                s = n;
              function a(t) {
                for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)
                  r[n - 1] = arguments[n];
                r.forEach(function (e) {
                  s[e] = t[e]
                    ? t[e].bind(t)
                    : (function (t) {
                        const e = self.console[t];
                        return e ? e.bind(self.console, '[' + t + '] >') : i;
                      })(e);
                });
              }
              function o(t) {
                if ((self.console && !0 === t) || 'object' == typeof t) {
                  a(t, 'debug', 'log', 'info', 'warn', 'error');
                  try {
                    s.log();
                  } catch (t) {
                    s = n;
                  }
                } else s = n;
              }
              var l = n;
            },
          './src/utils/mediakeys-helper.ts':
            /*!***************************************!*\
  !*** ./src/utils/mediakeys-helper.ts ***!
  \***************************************/
            /*! exports provided: KeySystems, requestMediaKeySystemAccess */ function (t, e, r) {
              'use strict';
              let i;
              r.r(e),
                r.d(e, 'KeySystems', function () {
                  return i;
                }),
                r.d(e, 'requestMediaKeySystemAccess', function () {
                  return n;
                }),
                (function (t) {
                  (t.WIDEVINE = 'com.widevine.alpha'), (t.PLAYREADY = 'com.microsoft.playready');
                })(i || (i = {}));
              var n =
                'undefined' != typeof self && self.navigator && self.navigator.requestMediaKeySystemAccess
                  ? self.navigator.requestMediaKeySystemAccess.bind(self.navigator)
                  : null;
            },
          './src/utils/mediasource-helper.ts':
            /*!*****************************************!*\
  !*** ./src/utils/mediasource-helper.ts ***!
  \*****************************************/
            /*! exports provided: getMediaSource */ function (t, e, r) {
              'use strict';
              function i() {
                return self.MediaSource || self.WebKitMediaSource;
              }
              r.r(e),
                r.d(e, 'getMediaSource', function () {
                  return i;
                });
            },
          './src/utils/mp4-tools.ts':
            /*!********************************!*\
  !*** ./src/utils/mp4-tools.ts ***!
  \********************************/
            /*! exports provided: bin2str, readUint16, readUint32, writeUint32, findBox, parseSegmentIndex, parseInitSegment, getStartDTS, getDuration, computeRawDurationFromSamples, offsetStartDTS, segmentValidRange, appendUint8Array */ function (
              t,
              e,
              r
            ) {
              'use strict';
              r.r(e),
                r.d(e, 'bin2str', function () {
                  return o;
                }),
                r.d(e, 'readUint16', function () {
                  return l;
                }),
                r.d(e, 'readUint32', function () {
                  return u;
                }),
                r.d(e, 'writeUint32', function () {
                  return c;
                }),
                r.d(e, 'findBox', function () {
                  return d;
                }),
                r.d(e, 'parseSegmentIndex', function () {
                  return f;
                }),
                r.d(e, 'parseInitSegment', function () {
                  return h;
                }),
                r.d(e, 'getStartDTS', function () {
                  return p;
                }),
                r.d(e, 'getDuration', function () {
                  return v;
                }),
                r.d(e, 'computeRawDurationFromSamples', function () {
                  return g;
                }),
                r.d(e, 'offsetStartDTS', function () {
                  return m;
                }),
                r.d(e, 'segmentValidRange', function () {
                  return y;
                }),
                r.d(e, 'appendUint8Array', function () {
                  return E;
                });
              const i = r(/*! ./typed-array */ './src/utils/typed-array.ts'),
                n = r(/*! ../loader/fragment */ './src/loader/fragment.ts'),
                s = Math.pow(2, 32) - 1,
                a = [].push;
              function o(t) {
                return String.fromCharCode.apply(null, t);
              }
              function l(t, e) {
                'data' in t && ((e += t.start), (t = t.data));
                const r = (t[e] << 8) | t[e + 1];
                return r < 0 ? 65536 + r : r;
              }
              function u(t, e) {
                'data' in t && ((e += t.start), (t = t.data));
                const r = (t[e] << 24) | (t[e + 1] << 16) | (t[e + 2] << 8) | t[e + 3];
                return r < 0 ? 4294967296 + r : r;
              }
              function c(t, e, r) {
                'data' in t && ((e += t.start), (t = t.data)),
                  (t[e] = r >> 24),
                  (t[e + 1] = (r >> 16) & 255),
                  (t[e + 2] = (r >> 8) & 255),
                  (t[e + 3] = 255 & r);
              }
              function d(t, e) {
                let r,
                  i,
                  n,
                  s = [];
                if (!e.length) return s;
                'data' in t ? ((r = t.data), (i = t.start), (n = t.end)) : ((i = 0), (n = (r = t).byteLength));
                for (let l = i; l < n; ) {
                  const c = u(r, l),
                    f = o(r.subarray(l + 4, l + 8)),
                    h = c > 1 ? l + c : n;
                  if (f === e[0])
                    if (1 === e.length) s.push({ data: r, start: l + 8, end: h });
                    else {
                      const p = d({ data: r, start: l + 8, end: h }, e.slice(1));
                      p.length && a.apply(s, p);
                    }
                  l = h;
                }
                return s;
              }
              function f(t) {
                const e = d(t, ['moov'])[0],
                  r = e ? e.end : null,
                  i = d(t, ['sidx']);
                if (!i || !i[0]) return null;
                let n = [],
                  s = i[0],
                  a = s.data[0],
                  o = 0 === a ? 8 : 16,
                  c = u(s, o);
                o += 4;
                (o += 0 === a ? 8 : 16), (o += 2);
                let f = s.end + 0,
                  h = l(s, o);
                o += 2;
                for (let p = 0; p < h; p++) {
                  let v = o,
                    g = u(s, v);
                  v += 4;
                  const m = 2147483647 & g;
                  if (1 === (2147483648 & g) >>> 31)
                    return console.warn('SIDX has hierarchical references (not supported)'), null;
                  const y = u(s, v);
                  (v += 4),
                    n.push({
                      referenceSize: m,
                      subsegmentDuration: y,
                      info: { duration: y / c, start: f, end: f + m - 1 },
                    }),
                    (f += m),
                    (o = v += 4);
                }
                return {
                  earliestPresentationTime: 0,
                  timescale: c,
                  version: a,
                  referencesCount: h,
                  references: n,
                  moovEndOffset: r,
                };
              }
              function h(t) {
                for (var e = [], r = d(t, ['moov', 'trak']), i = 0; i < r.length; i++) {
                  const s = r[i],
                    a = d(s, ['tkhd'])[0];
                  if (a) {
                    let l = a.data[a.start],
                      c = 0 === l ? 12 : 20,
                      f = u(a, c),
                      h = d(s, ['mdia', 'mdhd'])[0];
                    if (h) {
                      const p = u(h, (c = 0 === (l = h.data[h.start]) ? 12 : 20)),
                        v = d(s, ['mdia', 'hdlr'])[0];
                      if (v) {
                        const g = o(v.data.subarray(v.start + 8, v.start + 12)),
                          m = { soun: n.ElementaryStreamTypes.AUDIO, vide: n.ElementaryStreamTypes.VIDEO }[g];
                        if (m) {
                          let y = d(s, ['mdia', 'minf', 'stbl', 'stsd'])[0],
                            E = void 0;
                          y && (E = o(y.data.subarray(y.start + 12, y.start + 16))),
                            (e[f] = { timescale: p, type: m }),
                            (e[m] = { timescale: p, id: f, codec: E });
                        }
                      }
                    }
                  }
                }
                return (
                  d(t, ['moov', 'mvex', 'trex']).forEach(function (t) {
                    const r = u(t, 4),
                      i = e[r];
                    i && (i.default = { duration: u(t, 12), flags: u(t, 20) });
                  }),
                  e
                );
              }
              function p(t, e) {
                return (
                  d(e, ['moof', 'traf']).reduce(function (e, r) {
                    const i = d(r, ['tfdt'])[0],
                      n = i.data[i.start],
                      s = d(r, ['tfhd']).reduce(function (e, r) {
                        const s = u(r, 4),
                          a = t[s];
                        if (a) {
                          let o = u(i, 4);
                          1 === n && ((o *= Math.pow(2, 32)), (o += u(i, 8)));
                          const l = o / (a.timescale || 9e4);
                          if (isFinite(l) && (null === e || l < e)) return l;
                        }
                        return e;
                      }, null);
                    return null !== s && isFinite(s) && (null === e || s < e) ? s : e;
                  }, null) || 0
                );
              }
              function v(t, e) {
                for (var r = 0, i = 0, s = 0, a = d(t, ['moof', 'traf']), o = 0; o < a.length; o++) {
                  const l = a[o],
                    c = d(l, ['tfhd'])[0],
                    h = e[u(c, 4)];
                  if (h) {
                    let p = h.default,
                      v = u(c, 0) | (null === p || void 0 === p ? void 0 : p.flags),
                      m = null === p || void 0 === p ? void 0 : p.duration;
                    8 & v && (m = u(c, 2 & v ? 12 : 8));
                    for (let y = h.timescale || 9e4, E = d(l, ['trun']), T = 0; T < E.length; T++) {
                      if (!(r = g(E[T])) && m) r = m * u(E[T], 4);
                      h.type === n.ElementaryStreamTypes.VIDEO
                        ? (i += r / y)
                        : h.type === n.ElementaryStreamTypes.AUDIO && (s += r / y);
                    }
                  }
                }
                if (0 === i && 0 === s) {
                  const b = f(t);
                  if (null !== b && void 0 !== b && b.references)
                    return b.references.reduce(function (t, e) {
                      return t + e.info.duration || 0;
                    }, 0);
                }
                return i || s;
              }
              function g(t) {
                let e = u(t, 0),
                  r = 8;
                1 & e && (r += 4), 4 & e && (r += 4);
                for (var i = 0, n = u(t, 4), s = 0; s < n; s++) {
                  if (256 & e) (i += u(t, r)), (r += 4);
                  512 & e && (r += 4), 1024 & e && (r += 4), 2048 & e && (r += 4);
                }
                return i;
              }
              function m(t, e, r) {
                d(e, ['moof', 'traf']).forEach(function (e) {
                  d(e, ['tfhd']).forEach(function (i) {
                    const n = u(i, 4),
                      a = t[n];
                    if (a) {
                      const o = a.timescale || 9e4;
                      d(e, ['tfdt']).forEach(function (t) {
                        let e = t.data[t.start],
                          i = u(t, 4);
                        if (0 === e) c(t, 4, i - r * o);
                        else {
                          (i *= Math.pow(2, 32)), (i += u(t, 8)), (i -= r * o), (i = Math.max(i, 0));
                          const n = Math.floor(i / (s + 1)),
                            a = Math.floor(i % (s + 1));
                          c(t, 4, n), c(t, 8, a);
                        }
                      });
                    }
                  });
                });
              }
              function y(t) {
                const e = { valid: null, remainder: null },
                  r = d(t, ['moof']);
                if (!r) return e;
                if (r.length < 2) return (e.remainder = t), e;
                const n = r[r.length - 1];
                return (
                  (e.valid = Object(i.sliceUint8)(t, 0, n.start - 8)),
                  (e.remainder = Object(i.sliceUint8)(t, n.start - 8)),
                  e
                );
              }
              function E(t, e) {
                const r = new Uint8Array(t.length + e.length);
                return r.set(t), r.set(e, t.length), r;
              }
            },
          './src/utils/output-filter.ts':
            /*!************************************!*\
  !*** ./src/utils/output-filter.ts ***!
  \************************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'default', function () {
                  return i;
                });
              var i = (function () {
                function t(t, e) {
                  (this.timelineController = void 0),
                    (this.cueRanges = []),
                    (this.trackName = void 0),
                    (this.startTime = null),
                    (this.endTime = null),
                    (this.screen = null),
                    (this.timelineController = t),
                    (this.trackName = e);
                }
                const e = t.prototype;
                return (
                  (e.dispatchCue = function () {
                    null !== this.startTime &&
                      (this.timelineController.addCues(
                        this.trackName,
                        this.startTime,
                        this.endTime,
                        this.screen,
                        this.cueRanges
                      ),
                      (this.startTime = null));
                  }),
                  (e.newCue = function (t, e, r) {
                    (null === this.startTime || this.startTime > t) && (this.startTime = t),
                      (this.endTime = e),
                      (this.screen = r),
                      this.timelineController.createCaptionsTrack(this.trackName);
                  }),
                  (e.reset = function () {
                    (this.cueRanges = []), (this.startTime = null);
                  }),
                  t
                );
              })();
            },
          './src/utils/texttrack-utils.ts':
            /*!**************************************!*\
  !*** ./src/utils/texttrack-utils.ts ***!
  \**************************************/
            /*! exports provided: sendAddTrackEvent, addCueToTrack, clearCurrentCues, removeCuesInRange, getCuesInRange */ function (
              t,
              e,
              r
            ) {
              'use strict';
              r.r(e),
                r.d(e, 'sendAddTrackEvent', function () {
                  return n;
                }),
                r.d(e, 'addCueToTrack', function () {
                  return s;
                }),
                r.d(e, 'clearCurrentCues', function () {
                  return a;
                }),
                r.d(e, 'removeCuesInRange', function () {
                  return o;
                }),
                r.d(e, 'getCuesInRange', function () {
                  return l;
                });
              const i = r(/*! ./logger */ './src/utils/logger.ts');
              function n(t, e) {
                let r;
                try {
                  r = new Event('addtrack');
                } catch (t) {
                  (r = document.createEvent('Event')).initEvent('addtrack', !1, !1);
                }
                (r.track = t), e.dispatchEvent(r);
              }
              function s(t, e) {
                const r = t.mode;
                if (('disabled' === r && (t.mode = 'hidden'), t.cues && !t.cues.getCueById(e.id)))
                  try {
                    if ((t.addCue(e), !t.cues.getCueById(e.id))) throw new Error('addCue is failed for: ' + e);
                  } catch (r) {
                    i.logger.debug('[texttrack-utils]: ' + r);
                    const n = new self.TextTrackCue(e.startTime, e.endTime, e.text);
                    (n.id = e.id), t.addCue(n);
                  }
                'disabled' === r && (t.mode = r);
              }
              function a(t) {
                const e = t.mode;
                if (('disabled' === e && (t.mode = 'hidden'), t.cues))
                  for (let r = t.cues.length; r--; ) t.removeCue(t.cues[r]);
                'disabled' === e && (t.mode = e);
              }
              function o(t, e, r) {
                const i = t.mode;
                if (('disabled' === i && (t.mode = 'hidden'), t.cues && t.cues.length > 0))
                  for (let n = l(t.cues, e, r), s = 0; s < n.length; s++) t.removeCue(n[s]);
                'disabled' === i && (t.mode = i);
              }
              function l(t, e, r) {
                const i = [],
                  n = (function (t, e) {
                    if (e < t[0].startTime) return 0;
                    const r = t.length - 1;
                    if (e > t[r].endTime) return -1;
                    for (var i = 0, n = r; i <= n; ) {
                      const s = Math.floor((n + i) / 2);
                      if (e < t[s].startTime) n = s - 1;
                      else {
                        if (!(e > t[s].startTime && i < r)) return s;
                        i = s + 1;
                      }
                    }
                    return t[i].startTime - e < e - t[n].startTime ? i : n;
                  })(t, e);
                if (n > -1)
                  for (let s = n, a = t.length; s < a; s++) {
                    const o = t[s];
                    if (o.startTime >= e && o.endTime <= r) i.push(o);
                    else if (o.startTime > r) return i;
                  }
                return i;
              }
            },
          './src/utils/time-ranges.ts':
            /*!**********************************!*\
  !*** ./src/utils/time-ranges.ts ***!
  \**********************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              e.default = {
                toString: function (t) {
                  for (var e = '', r = t.length, i = 0; i < r; i++)
                    e += '[' + t.start(i).toFixed(3) + ',' + t.end(i).toFixed(3) + ']';
                  return e;
                },
              };
            },
          './src/utils/timescale-conversion.ts':
            /*!*******************************************!*\
  !*** ./src/utils/timescale-conversion.ts ***!
  \*******************************************/
            /*! exports provided: toTimescaleFromBase, toTimescaleFromScale, toMsFromMpegTsClock, toMpegTsClockFromTimescale */ function (
              t,
              e,
              r
            ) {
              'use strict';
              r.r(e),
                r.d(e, 'toTimescaleFromBase', function () {
                  return n;
                }),
                r.d(e, 'toTimescaleFromScale', function () {
                  return s;
                }),
                r.d(e, 'toMsFromMpegTsClock', function () {
                  return a;
                }),
                r.d(e, 'toMpegTsClockFromTimescale', function () {
                  return o;
                });
              const i = 9e4;
              function n(t, e, r, i) {
                void 0 === r && (r = 1), void 0 === i && (i = !1);
                const n = t * e * r;
                return i ? Math.round(n) : n;
              }
              function s(t, e, r, i) {
                return void 0 === r && (r = 1), void 0 === i && (i = !1), n(t, e, 1 / r, i);
              }
              function a(t, e) {
                return void 0 === e && (e = !1), n(t, 1e3, 1 / i, e);
              }
              function o(t, e) {
                return void 0 === e && (e = 1), n(t, i, 1 / e);
              }
            },
          './src/utils/typed-array.ts':
            /*!**********************************!*\
  !*** ./src/utils/typed-array.ts ***!
  \**********************************/
            /*! exports provided: sliceUint8 */ function (t, e, r) {
              'use strict';
              function i(t, e, r) {
                return Uint8Array.prototype.slice ? t.slice(e, r) : new Uint8Array(Array.prototype.slice.call(t, e, r));
              }
              r.r(e),
                r.d(e, 'sliceUint8', function () {
                  return i;
                });
            },
          './src/utils/vttcue.ts':
            /*!*****************************!*\
  !*** ./src/utils/vttcue.ts ***!
  \*****************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e),
                (e.default = (function () {
                  if ('undefined' != typeof self && self.VTTCue) return self.VTTCue;
                  const t = ['', 'lr', 'rl'],
                    e = ['start', 'middle', 'end', 'left', 'right'];
                  function r(t, e) {
                    if ('string' != typeof e) return !1;
                    if (!Array.isArray(t)) return !1;
                    const r = e.toLowerCase();
                    return !!~t.indexOf(r) && r;
                  }
                  function i(t) {
                    return r(e, t);
                  }
                  function n(t) {
                    for (let e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++)
                      r[i - 1] = arguments[i];
                    for (let n = 1; n < arguments.length; n++) {
                      const s = arguments[n];
                      for (const a in s) t[a] = s[a];
                    }
                    return t;
                  }
                  function s(e, s, a) {
                    const o = this,
                      l = { enumerable: !0 };
                    o.hasBeenReset = !1;
                    let u = '',
                      c = !1,
                      d = e,
                      f = s,
                      h = a,
                      p = null,
                      v = '',
                      g = !0,
                      m = 'auto',
                      y = 'start',
                      E = 50,
                      T = 'middle',
                      b = 50,
                      S = 'middle';
                    Object.defineProperty(
                      o,
                      'id',
                      n({}, l, {
                        get: function () {
                          return u;
                        },
                        set: function (t) {
                          u = '' + t;
                        },
                      })
                    ),
                      Object.defineProperty(
                        o,
                        'pauseOnExit',
                        n({}, l, {
                          get: function () {
                            return c;
                          },
                          set: function (t) {
                            c = !!t;
                          },
                        })
                      ),
                      Object.defineProperty(
                        o,
                        'startTime',
                        n({}, l, {
                          get: function () {
                            return d;
                          },
                          set: function (t) {
                            if ('number' != typeof t) throw new TypeError('Start time must be set to a number.');
                            (d = t), (this.hasBeenReset = !0);
                          },
                        })
                      ),
                      Object.defineProperty(
                        o,
                        'endTime',
                        n({}, l, {
                          get: function () {
                            return f;
                          },
                          set: function (t) {
                            if ('number' != typeof t) throw new TypeError('End time must be set to a number.');
                            (f = t), (this.hasBeenReset = !0);
                          },
                        })
                      ),
                      Object.defineProperty(
                        o,
                        'text',
                        n({}, l, {
                          get: function () {
                            return h;
                          },
                          set: function (t) {
                            (h = '' + t), (this.hasBeenReset = !0);
                          },
                        })
                      ),
                      Object.defineProperty(
                        o,
                        'region',
                        n({}, l, {
                          get: function () {
                            return p;
                          },
                          set: function (t) {
                            (p = t), (this.hasBeenReset = !0);
                          },
                        })
                      ),
                      Object.defineProperty(
                        o,
                        'vertical',
                        n({}, l, {
                          get: function () {
                            return v;
                          },
                          set: function (e) {
                            const i = (function (e) {
                              return r(t, e);
                            })(e);
                            if (!1 === i) throw new SyntaxError('An invalid or illegal string was specified.');
                            (v = i), (this.hasBeenReset = !0);
                          },
                        })
                      ),
                      Object.defineProperty(
                        o,
                        'snapToLines',
                        n({}, l, {
                          get: function () {
                            return g;
                          },
                          set: function (t) {
                            (g = !!t), (this.hasBeenReset = !0);
                          },
                        })
                      ),
                      Object.defineProperty(
                        o,
                        'line',
                        n({}, l, {
                          get: function () {
                            return m;
                          },
                          set: function (t) {
                            if ('number' != typeof t && 'auto' !== t)
                              throw new SyntaxError('An invalid number or illegal string was specified.');
                            (m = t), (this.hasBeenReset = !0);
                          },
                        })
                      ),
                      Object.defineProperty(
                        o,
                        'lineAlign',
                        n({}, l, {
                          get: function () {
                            return y;
                          },
                          set: function (t) {
                            const e = i(t);
                            if (!e) throw new SyntaxError('An invalid or illegal string was specified.');
                            (y = e), (this.hasBeenReset = !0);
                          },
                        })
                      ),
                      Object.defineProperty(
                        o,
                        'position',
                        n({}, l, {
                          get: function () {
                            return E;
                          },
                          set: function (t) {
                            if (t < 0 || t > 100) throw new Error('Position must be between 0 and 100.');
                            (E = t), (this.hasBeenReset = !0);
                          },
                        })
                      ),
                      Object.defineProperty(
                        o,
                        'positionAlign',
                        n({}, l, {
                          get: function () {
                            return T;
                          },
                          set: function (t) {
                            const e = i(t);
                            if (!e) throw new SyntaxError('An invalid or illegal string was specified.');
                            (T = e), (this.hasBeenReset = !0);
                          },
                        })
                      ),
                      Object.defineProperty(
                        o,
                        'size',
                        n({}, l, {
                          get: function () {
                            return b;
                          },
                          set: function (t) {
                            if (t < 0 || t > 100) throw new Error('Size must be between 0 and 100.');
                            (b = t), (this.hasBeenReset = !0);
                          },
                        })
                      ),
                      Object.defineProperty(
                        o,
                        'align',
                        n({}, l, {
                          get: function () {
                            return S;
                          },
                          set: function (t) {
                            const e = i(t);
                            if (!e) throw new SyntaxError('An invalid or illegal string was specified.');
                            (S = e), (this.hasBeenReset = !0);
                          },
                        })
                      ),
                      (o.displayState = void 0);
                  }
                  return (
                    (s.prototype.getCueAsHTML = function () {
                      return self.WebVTT.convertCueToDOMTree(self, this.text);
                    }),
                    s
                  );
                })());
            },
          './src/utils/vttparser.ts':
            /*!********************************!*\
  !*** ./src/utils/vttparser.ts ***!
  \********************************/
            /*! exports provided: parseTimeStamp, fixLineBreaks, VTTParser */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'parseTimeStamp', function () {
                  return s;
                }),
                r.d(e, 'fixLineBreaks', function () {
                  return d;
                }),
                r.d(e, 'VTTParser', function () {
                  return f;
                });
              const i = r(/*! ./vttcue */ './src/utils/vttcue.ts'),
                n = (function () {
                  function t() {}
                  return (
                    (t.prototype.decode = function (t, e) {
                      if (!t) return '';
                      if ('string' != typeof t) throw new Error('Error - expected string data.');
                      return decodeURIComponent(encodeURIComponent(t));
                    }),
                    t
                  );
                })();
              function s(t) {
                function e(t, e, r, i) {
                  return 3600 * (0 | t) + 60 * (0 | e) + (0 | r) + parseFloat(i || 0);
                }
                const r = t.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
                return r ? (parseFloat(r[2]) > 59 ? e(r[2], r[3], 0, r[4]) : e(r[1], r[2], r[3], r[4])) : null;
              }
              const a = (function () {
                function t() {
                  this.values = Object.create(null);
                }
                const e = t.prototype;
                return (
                  (e.set = function (t, e) {
                    this.get(t) || '' === e || (this.values[t] = e);
                  }),
                  (e.get = function (t, e, r) {
                    return r ? (this.has(t) ? this.values[t] : e[r]) : this.has(t) ? this.values[t] : e;
                  }),
                  (e.has = function (t) {
                    return t in this.values;
                  }),
                  (e.alt = function (t, e, r) {
                    for (let i = 0; i < r.length; ++i)
                      if (e === r[i]) {
                        this.set(t, e);
                        break;
                      }
                  }),
                  (e.integer = function (t, e) {
                    /^-?\d+$/.test(e) && this.set(t, parseInt(e, 10));
                  }),
                  (e.percent = function (t, e) {
                    if (/^([\d]{1,3})(\.[\d]*)?%$/.test(e)) {
                      const r = parseFloat(e);
                      if (r >= 0 && r <= 100) return this.set(t, r), !0;
                    }
                    return !1;
                  }),
                  t
                );
              })();
              function o(t, e, r, i) {
                const n = i ? t.split(i) : [t];
                for (const s in n)
                  if ('string' == typeof n[s]) {
                    const a = n[s].split(r);
                    if (2 === a.length) e(a[0], a[1]);
                  }
              }
              const l = new i.default(0, 0, ''),
                u = 'middle' === l.align ? 'middle' : 'center';
              function c(t, e, r) {
                const i = t;
                function n() {
                  const e = s(t);
                  if (null === e) throw new Error('Malformed timestamp: ' + i);
                  return (t = t.replace(/^[^\sa-zA-Z-]+/, '')), e;
                }
                function c() {
                  t = t.replace(/^\s+/, '');
                }
                if ((c(), (e.startTime = n()), c(), '--\x3e' !== t.substr(0, 3)))
                  throw new Error("Malformed time stamp (time stamps must be separated by '--\x3e'): " + i);
                (t = t.substr(3)),
                  c(),
                  (e.endTime = n()),
                  c(),
                  (function (t, e) {
                    const i = new a();
                    o(
                      t,
                      function (t, e) {
                        let n;
                        switch (t) {
                          case 'region':
                            for (let s = r.length - 1; s >= 0; s--)
                              if (r[s].id === e) {
                                i.set(t, r[s].region);
                                break;
                              }
                            break;
                          case 'vertical':
                            i.alt(t, e, ['rl', 'lr']);
                            break;
                          case 'line':
                            (n = e.split(',')),
                              i.integer(t, n[0]),
                              i.percent(t, n[0]) && i.set('snapToLines', !1),
                              i.alt(t, n[0], ['auto']),
                              2 === n.length && i.alt('lineAlign', n[1], ['start', u, 'end']);
                            break;
                          case 'position':
                            (n = e.split(',')),
                              i.percent(t, n[0]),
                              2 === n.length &&
                                i.alt('positionAlign', n[1], ['start', u, 'end', 'line-left', 'line-right', 'auto']);
                            break;
                          case 'size':
                            i.percent(t, e);
                            break;
                          case 'align':
                            i.alt(t, e, ['start', u, 'end', 'left', 'right']);
                        }
                      },
                      /:/,
                      /\s/
                    ),
                      (e.region = i.get('region', null)),
                      (e.vertical = i.get('vertical', ''));
                    let n = i.get('line', 'auto');
                    'auto' === n && -1 === l.line && (n = -1),
                      (e.line = n),
                      (e.lineAlign = i.get('lineAlign', 'start')),
                      (e.snapToLines = i.get('snapToLines', !0)),
                      (e.size = i.get('size', 100)),
                      (e.align = i.get('align', u));
                    let s = i.get('position', 'auto');
                    'auto' === s &&
                      50 === l.position &&
                      (s =
                        'start' === e.align || 'left' === e.align
                          ? 0
                          : 'end' === e.align || 'right' === e.align
                            ? 100
                            : 50),
                      (e.position = s);
                  })(t, e);
              }
              function d(t) {
                return t.replace(/<br(?: \/)?>/gi, '\n');
              }
              var f = (function () {
                function t() {
                  (this.state = 'INITIAL'),
                    (this.buffer = ''),
                    (this.decoder = new n()),
                    (this.regionList = []),
                    (this.cue = null),
                    (this.oncue = void 0),
                    (this.onparsingerror = void 0),
                    (this.onflush = void 0);
                }
                const e = t.prototype;
                return (
                  (e.parse = function (t) {
                    const e = this;
                    function r() {
                      let t = e.buffer,
                        r = 0;
                      for (t = d(t); r < t.length && '\r' !== t[r] && '\n' !== t[r]; ) ++r;
                      const i = t.substr(0, r);
                      return '\r' === t[r] && ++r, '\n' === t[r] && ++r, (e.buffer = t.substr(r)), i;
                    }
                    function n(t) {
                      o(t, function (t, e) {}, /:/);
                    }
                    t && (e.buffer += e.decoder.decode(t, { stream: !0 }));
                    try {
                      let s = '';
                      if ('INITIAL' === e.state) {
                        if (!/\r\n|\n/.test(e.buffer)) return this;
                        const a = (s = r()).match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
                        if (!a || !a[0]) throw new Error('Malformed WebVTT signature.');
                        e.state = 'HEADER';
                      }
                      for (let l = !1; e.buffer; ) {
                        if (!/\r\n|\n/.test(e.buffer)) return this;
                        switch ((l ? (l = !1) : (s = r()), e.state)) {
                          case 'HEADER':
                            /:/.test(s) ? n(s) : s || (e.state = 'ID');
                            continue;
                          case 'NOTE':
                            s || (e.state = 'ID');
                            continue;
                          case 'ID':
                            if (/^NOTE($|[ \t])/.test(s)) {
                              e.state = 'NOTE';
                              break;
                            }
                            if (!s) continue;
                            if (((e.cue = new i.default(0, 0, '')), (e.state = 'CUE'), -1 === s.indexOf('--\x3e'))) {
                              e.cue.id = s;
                              continue;
                            }
                          case 'CUE':
                            if (!e.cue) {
                              e.state = 'BADCUE';
                              continue;
                            }
                            try {
                              c(s, e.cue, e.regionList);
                            } catch (t) {
                              (e.cue = null), (e.state = 'BADCUE');
                              continue;
                            }
                            e.state = 'CUETEXT';
                            continue;
                          case 'CUETEXT':
                            var u = -1 !== s.indexOf('--\x3e');
                            if (!s || (u && (l = !0))) {
                              e.oncue && e.cue && e.oncue(e.cue), (e.cue = null), (e.state = 'ID');
                              continue;
                            }
                            if (null === e.cue) continue;
                            e.cue.text && (e.cue.text += '\n'), (e.cue.text += s);
                            continue;
                          case 'BADCUE':
                            s || (e.state = 'ID');
                        }
                      }
                    } catch (t) {
                      'CUETEXT' === e.state && e.cue && e.oncue && e.oncue(e.cue),
                        (e.cue = null),
                        (e.state = 'INITIAL' === e.state ? 'BADWEBVTT' : 'BADCUE');
                    }
                    return this;
                  }),
                  (e.flush = function () {
                    try {
                      if (
                        ((this.cue || 'HEADER' === this.state) && ((this.buffer += '\n\n'), this.parse()),
                        'INITIAL' === this.state || 'BADWEBVTT' === this.state)
                      )
                        throw new Error('Malformed WebVTT signature.');
                    } catch (t) {
                      this.onparsingerror && this.onparsingerror(t);
                    }
                    return this.onflush && this.onflush(), this;
                  }),
                  t
                );
              })();
            },
          './src/utils/webvtt-parser.ts':
            /*!************************************!*\
  !*** ./src/utils/webvtt-parser.ts ***!
  \************************************/
            /*! exports provided: generateCueId, parseWebVTT */ function (t, e, r) {
              'use strict';
              r.r(e),
                r.d(e, 'generateCueId', function () {
                  return f;
                }),
                r.d(e, 'parseWebVTT', function () {
                  return p;
                });
              const i = r(/*! ./src/polyfills/number */ './src/polyfills/number.ts'),
                n = r(/*! ./vttparser */ './src/utils/vttparser.ts'),
                s = r(/*! ../demux/id3 */ './src/demux/id3.ts'),
                a = r(/*! ./timescale-conversion */ './src/utils/timescale-conversion.ts'),
                o = r(/*! ../remux/mp4-remuxer */ './src/remux/mp4-remuxer.ts'),
                l = /\r\n|\n\r|\n|\r/g,
                u = function (t, e, r) {
                  return void 0 === r && (r = 0), t.substr(r, e.length) === e;
                },
                c = function (t) {
                  let e = parseInt(t.substr(-3)),
                    r = parseInt(t.substr(-6, 2)),
                    n = parseInt(t.substr(-9, 2)),
                    s = t.length > 9 ? parseInt(t.substr(0, t.indexOf(':'))) : 0;
                  if (
                    !(
                      Object(i.isFiniteNumber)(e) &&
                      Object(i.isFiniteNumber)(r) &&
                      Object(i.isFiniteNumber)(n) &&
                      Object(i.isFiniteNumber)(s)
                    )
                  )
                    throw Error('Malformed X-TIMESTAMP-MAP: Local:' + t);
                  return (e += 1e3 * r), (e += 6e4 * n), (e += 36e5 * s);
                },
                d = function (t) {
                  for (var e = 5381, r = t.length; r; ) e = (33 * e) ^ t.charCodeAt(--r);
                  return (e >>> 0).toString();
                };
              function f(t, e, r) {
                return d(t.toString()) + d(e.toString()) + d(r);
              }
              const h = function (t, e, r) {
                let i = t[e],
                  n = t[i.prevCC];
                if (!n || (!n.new && i.new)) return (t.ccOffset = t.presentationOffset = i.start), void (i.new = !1);
                for (; null !== (s = n) && void 0 !== s && s.new; ) {
                  var s;
                  (t.ccOffset += i.start - n.start), (i.new = !1), (n = t[(i = n).prevCC]);
                }
                t.presentationOffset = r;
              };
              function p(t, e, r, i, d, p, v, g) {
                let m,
                  y = new n.VTTParser(),
                  E = Object(s.utf8ArrayToStr)(new Uint8Array(t)).trim().replace(l, '\n').split('\n'),
                  T = [],
                  b = Object(a.toMpegTsClockFromTimescale)(e, r),
                  S = '00:00.000',
                  L = 0,
                  A = 0,
                  D = !0,
                  k = !1;
                (y.oncue = function (t) {
                  let e = i[d],
                    r = i.ccOffset,
                    n = (L - b) / 9e4;
                  if (
                    (null !== e && void 0 !== e && e.new && (void 0 !== A ? (r = i.ccOffset = e.start) : h(i, d, n)),
                    n && (r = n - i.presentationOffset),
                    k)
                  ) {
                    const s = t.endTime - t.startTime,
                      a = Object(o.normalizePts)(9e4 * (t.startTime + r - A), 9e4 * p) / 9e4;
                    (t.startTime = a), (t.endTime = a + s);
                  }
                  const l = t.text.trim();
                  (t.text = decodeURIComponent(encodeURIComponent(l))),
                    t.id || (t.id = f(t.startTime, t.endTime, l)),
                    t.endTime > 0 && T.push(t);
                }),
                  (y.onparsingerror = function (t) {
                    m = t;
                  }),
                  (y.onflush = function () {
                    m ? g(m) : v(T);
                  }),
                  E.forEach(function (t) {
                    if (D) {
                      if (u(t, 'X-TIMESTAMP-MAP=')) {
                        (D = !1),
                          (k = !0),
                          t
                            .substr(16)
                            .split(',')
                            .forEach(function (t) {
                              u(t, 'LOCAL:') ? (S = t.substr(6)) : u(t, 'MPEGTS:') && (L = parseInt(t.substr(7)));
                            });
                        try {
                          A = c(S) / 1e3;
                        } catch (t) {
                          (k = !1), (m = t);
                        }
                        return;
                      }
                      '' === t && (D = !1);
                    }
                    y.parse(t + '\n');
                  }),
                  y.flush();
              }
            },
          './src/utils/xhr-loader.ts':
            /*!*********************************!*\
  !*** ./src/utils/xhr-loader.ts ***!
  \*********************************/
            /*! exports provided: default */ function (t, e, r) {
              'use strict';
              r.r(e);
              const i = r(/*! ../utils/logger */ './src/utils/logger.ts'),
                n = r(/*! ../loader/load-stats */ './src/loader/load-stats.ts'),
                s = /^age:\s*[\d.]+\s*$/m,
                a = (function () {
                  function t(t) {
                    (this.xhrSetup = void 0),
                      (this.requestTimeout = void 0),
                      (this.retryTimeout = void 0),
                      (this.retryDelay = void 0),
                      (this.config = null),
                      (this.callbacks = null),
                      (this.context = void 0),
                      (this.loader = null),
                      (this.stats = void 0),
                      (this.xhrSetup = t ? t.xhrSetup : null),
                      (this.stats = new n.LoadStats()),
                      (this.retryDelay = 0);
                  }
                  const e = t.prototype;
                  return (
                    (e.destroy = function () {
                      (this.callbacks = null), this.abortInternal(), (this.loader = null), (this.config = null);
                    }),
                    (e.abortInternal = function () {
                      const t = this.loader;
                      self.clearTimeout(this.requestTimeout),
                        self.clearTimeout(this.retryTimeout),
                        t &&
                          ((t.onreadystatechange = null),
                          (t.onprogress = null),
                          4 !== t.readyState && ((this.stats.aborted = !0), t.abort()));
                    }),
                    (e.abort = function () {
                      let t;
                      this.abortInternal(),
                        null !== (t = this.callbacks) &&
                          void 0 !== t &&
                          t.onAbort &&
                          this.callbacks.onAbort(this.stats, this.context, this.loader);
                    }),
                    (e.load = function (t, e, r) {
                      if (this.stats.loading.start) throw new Error('Loader can only be used once.');
                      (this.stats.loading.start = self.performance.now()),
                        (this.context = t),
                        (this.config = e),
                        (this.callbacks = r),
                        (this.retryDelay = e.retryDelay),
                        this.loadInternal();
                    }),
                    (e.loadInternal = function () {
                      const t = this.config,
                        e = this.context;
                      if (t) {
                        const r = (this.loader = new self.XMLHttpRequest()),
                          i = this.stats;
                        (i.loading.first = 0), (i.loaded = 0);
                        const n = this.xhrSetup;
                        try {
                          if (n)
                            try {
                              n(r, e.url);
                            } catch (t) {
                              r.open('GET', e.url, !0), n(r, e.url);
                            }
                          r.readyState || r.open('GET', e.url, !0);
                          const s = this.context.headers;
                          if (s) for (const a in s) r.setRequestHeader(a, s[a]);
                        } catch (t) {
                          return void this.callbacks.onError({ code: r.status, text: t.message }, e, r);
                        }
                        e.rangeEnd && r.setRequestHeader('Range', 'bytes=' + e.rangeStart + '-' + (e.rangeEnd - 1)),
                          (r.onreadystatechange = this.readystatechange.bind(this)),
                          (r.onprogress = this.loadprogress.bind(this)),
                          (r.responseType = e.responseType),
                          self.clearTimeout(this.requestTimeout),
                          (this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), t.timeout)),
                          r.send();
                      }
                    }),
                    (e.readystatechange = function () {
                      const t = this.context,
                        e = this.loader,
                        r = this.stats;
                      if (t && e) {
                        const n = e.readyState,
                          s = this.config;
                        if (!r.aborted && n >= 2)
                          if (
                            (self.clearTimeout(this.requestTimeout),
                            0 === r.loading.first &&
                              (r.loading.first = Math.max(self.performance.now(), r.loading.start)),
                            4 === n)
                          ) {
                            (e.onreadystatechange = null), (e.onprogress = null);
                            const a = e.status;
                            if (a >= 200 && a < 300) {
                              let o, l;
                              if (
                                ((r.loading.end = Math.max(self.performance.now(), r.loading.first)),
                                (l =
                                  'arraybuffer' === t.responseType
                                    ? (o = e.response).byteLength
                                    : (o = e.responseText).length),
                                (r.loaded = r.total = l),
                                !this.callbacks)
                              )
                                return;
                              const u = this.callbacks.onProgress;
                              if ((u && u(r, t, o, e), !this.callbacks)) return;
                              const c = { url: e.responseURL, data: o };
                              this.callbacks.onSuccess(c, r, t, e);
                            } else
                              r.retry >= s.maxRetry || (a >= 400 && a < 499)
                                ? (i.logger.error(a + ' while loading ' + t.url),
                                  this.callbacks.onError({ code: a, text: e.statusText }, t, e))
                                : (i.logger.warn(
                                    a + ' while loading ' + t.url + ', retrying in ' + this.retryDelay + '...'
                                  ),
                                  this.abortInternal(),
                                  (this.loader = null),
                                  self.clearTimeout(this.retryTimeout),
                                  (this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay)),
                                  (this.retryDelay = Math.min(2 * this.retryDelay, s.maxRetryDelay)),
                                  r.retry++);
                          } else
                            self.clearTimeout(this.requestTimeout),
                              (this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), s.timeout));
                      }
                    }),
                    (e.loadtimeout = function () {
                      i.logger.warn('timeout while loading ' + this.context.url);
                      const t = this.callbacks;
                      t && (this.abortInternal(), t.onTimeout(this.stats, this.context, this.loader));
                    }),
                    (e.loadprogress = function (t) {
                      const e = this.stats;
                      (e.loaded = t.loaded), t.lengthComputable && (e.total = t.total);
                    }),
                    (e.getCacheAge = function () {
                      let t = null;
                      if (this.loader && s.test(this.loader.getAllResponseHeaders())) {
                        const e = this.loader.getResponseHeader('age');
                        t = e ? parseFloat(e) : null;
                      }
                      return t;
                    }),
                    t
                  );
                })();
              e.default = a;
            },
        }).default;
      });
  },
  function (t, e, r) {
    let i, n;
    /*!
     * JavaScript Cookie v2.2.0
     * https://github.com/js-cookie/js-cookie
     *
     * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
     * Released under the MIT license
     */ !(function (s) {
      if (
        (void 0 === (n = 'function' == typeof (i = s) ? i.call(e, r, e, t) : i) || (t.exports = n),
        !0,
        (t.exports = s()),
        !!0)
      ) {
        const a = window.Cookies,
          o = (window.Cookies = s());
        o.noConflict = function () {
          return (window.Cookies = a), o;
        };
      }
    })(function () {
      function t() {
        for (var t = 0, e = {}; t < arguments.length; t++) {
          const r = arguments[t];
          for (const i in r) e[i] = r[i];
        }
        return e;
      }
      return (function e(r) {
        function i(e, n, s) {
          let a;
          if ('undefined' != typeof document) {
            if (arguments.length > 1) {
              if ('number' == typeof (s = t({ path: '/' }, i.defaults, s)).expires) {
                const o = new Date();
                o.setMilliseconds(o.getMilliseconds() + 864e5 * s.expires), (s.expires = o);
              }
              s.expires = s.expires ? s.expires.toUTCString() : '';
              try {
                (a = JSON.stringify(n)), /^[\{\[]/.test(a) && (n = a);
              } catch (t) {}
              (n = r.write
                ? r.write(n, e)
                : encodeURIComponent(String(n)).replace(
                    /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                    decodeURIComponent
                  )),
                (e = (e = (e = encodeURIComponent(String(e))).replace(
                  /%(23|24|26|2B|5E|60|7C)/g,
                  decodeURIComponent
                )).replace(/[\(\)]/g, escape));
              let l = '';
              for (const u in s) s[u] && ((l += '; ' + u), !0 !== s[u] && (l += '=' + s[u]));
              return (document.cookie = e + '=' + n + l);
            }
            e || (a = {});
            for (
              let c = document.cookie ? document.cookie.split('; ') : [], d = /(%[0-9A-Z]{2})+/g, f = 0;
              f < c.length;
              f++
            ) {
              let h = c[f].split('='),
                p = h.slice(1).join('=');
              this.json || '"' !== p.charAt(0) || (p = p.slice(1, -1));
              try {
                const v = h[0].replace(d, decodeURIComponent);
                if (((p = r.read ? r.read(p, v) : r(p, v) || p.replace(d, decodeURIComponent)), this.json))
                  try {
                    p = JSON.parse(p);
                  } catch (t) {}
                if (e === v) {
                  a = p;
                  break;
                }
                e || (a[v] = p);
              } catch (t) {}
            }
            return a;
          }
        }
        return (
          (i.set = i),
          (i.get = function (t) {
            return i.call(i, t);
          }),
          (i.getJSON = function () {
            return i.apply({ json: !0 }, [].slice.call(arguments));
          }),
          (i.defaults = {}),
          (i.remove = function (e, r) {
            i(e, '', t(r, { expires: -1 }));
          }),
          (i.withConverter = e),
          i
        );
      })(function () {});
    });
  },
]);
